export const countryData = {
  "AD": {
    "flag": "",
    "name": "Andorra",
    "officialName": "Principality of Andorra",
    "countryCode": "+376",
    "isoAlpha2": "AD",
    "isoAlpha3": "AND",
    "numericCode": "020",
    "firstLanguage": "ca",
    "otherLanguages": [
      "es",
      "fr",
      "pt"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary co-principality",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Co-Prince",
          "name": "President of France"
        },
        {
          "title": "Co-Prince",
          "name": "Bishop of Urgell"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 79034,
    "area": {
      "value": 468,
      "unit": "km"
    },
    "capital": "Andorra la Vella",
    "gdp": {
      "nominal": "3.66 billion USD",
      "perCapita": "46,686 USD"
    },
    "dialingCode": "+376",
    "internetTLD": ".ad",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "110",
      "ambulance": "116"
    },
    "holidays": [
      "Constitution Day (March 14)",
      "Our Lady of Meritxell Day (September 8)"
    ],
    "nationalAnimal": "Chamois",
    "nationalDish": "Escudella",
    "tourismHighlights": [
      "Vallnord Ski Resort",
      "Caldea Spa",
      "Casa de la Vall",
      "Madriu-Perafita-Claror Valley (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Tobacco products",
      "Furniture",
      "Electronics"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Energy"
    ],
    "lifeExpectancy": 83.5,
    "literacyRate": 100,
    "climate": "Temperate with snowy winters and mild summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "None",
        "Protestant",
        "Islam"
      ]
    },
    "neighborCountries": [
      "France",
      "Spain"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Has no official army; defense is the responsibility of France and Spain.",
      "One of the smallest countries in the world by land area and population.",
      "Has one of the highest life expectancies in the world."
    ]
  },
  "AG": {
    "flag": "",
    "name": "Antigua and Barbuda",
    "officialName": "Antigua and Barbuda",
    "countryCode": "+1-268",
    "isoAlpha2": "AG",
    "isoAlpha3": "ATG",
    "numericCode": "028",
    "firstLanguage": "en",
    "otherLanguages": [
      "ant"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Parliamentary democracy and constitutional monarchy",
      "politicalLean": "Center-Left",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Sir Rodney Williams"
        },
        {
          "title": "Prime Minister",
          "name": "Gaston Browne"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 97928,
    "area": {
      "value": 442,
      "unit": "km"
    },
    "capital": "Saint John's",
    "gdp": {
      "nominal": "1.74 billion USD",
      "perCapita": "17,948 USD"
    },
    "dialingCode": "+1-268",
    "internetTLD": ".ag",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Antigua and Barbuda Independence Day (November 1)",
      "Emancipation Day (August 1)"
    ],
    "nationalAnimal": "Frigatebird",
    "nationalDish": "Fungee and Pepperpot",
    "tourismHighlights": [
      "Nelson's Dockyard",
      "Antigua Carnival",
      "Half Moon Bay",
      "St. John's Cathedral"
    ],
    "majorExports": [
      "Textiles",
      "Food",
      "Rum"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuels"
    ],
    "lifeExpectancy": 76.2,
    "literacyRate": 99.6,
    "climate": "Tropical marine, with a wet season from May to November",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Hinduism",
        "Rastafarianism"
      ]
    },
    "neighborCountries": [
      "Antigua and Barbuda is an island nation, with no land borders."
    ],
    "visaRequirement": "Visa-free for many countries, including EU and UK citizens.",
    "notableFacts": [
      "Known for its reef-studded coastlines and beautiful beaches.",
      "The country is made up of two main islands and several smaller ones.",
      "Antigua has a beach for every day of the year, boasting 365 beaches."
    ]
  },
  "AF": {
    "flag": "",
    "name": "Afghanistan",
    "officialName": "Islamic Republic of Afghanistan",
    "countryCode": "+93",
    "isoAlpha2": "AF",
    "isoAlpha3": "AFG",
    "numericCode": "004",
    "firstLanguage": "ps",
    "otherLanguages": [
      "da",
      "uz",
      "tk"
    ],
    "currency": {
      "code": "AFN",
      "symbol": "",
      "name": "Afghan Afghani"
    },
    "government": {
      "type": "Islamic Republic",
      "politicalLean": "Islamist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Hezb-e Islami"
        }
      ]
    },
    "timeZone": {
      "name": "Afghanistan Time (AFT)",
      "offset": "+04:30",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southern Asia",
    "population": 41033256,
    "area": {
      "value": 652230,
      "unit": "km"
    },
    "capital": "Kabul",
    "gdp": {
      "nominal": "84.76 billion USD",
      "perCapita": "2,066 USD"
    },
    "dialingCode": "+93",
    "internetTLD": ".af",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "119",
      "fire": "115",
      "police": "100",
      "ambulance": "191"
    },
    "holidays": [
      "Independence Day (August 19)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Snow Leopard",
    "nationalDish": "Kabuli Pulao",
    "tourismHighlights": [
      "Bamyan Buddhas (UNESCO World Heritage Site)",
      "Minaret of Jam",
      "The Great Wall of Afghanistan",
      "Band-e Amir National Park"
    ],
    "majorExports": [
      "Fruits and Nuts",
      "Saffron",
      "Carpets"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 64.8,
    "literacyRate": 37.2,
    "climate": "Continental; arid with extreme temperature variations",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Hinduism",
        "Sikhism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Pakistan",
      "Iran",
      "Turkmenistan",
      "Uzbekistan",
      "Tajikistan"
    ],
    "visaRequirement": "Visa required for most nationalities",
    "notableFacts": [
      "Home to some of the oldest civilizations in the world, including the ancient city of Balkh.",
      "A significant producer of opium, which poses a challenge for governance and international relations.",
      "Diverse geography ranging from mountains to fertile plains."
    ]
  },
  "AE": {
    "flag": "",
    "name": "United Arab Emirates",
    "officialName": "United Arab Emirates",
    "countryCode": "+971",
    "isoAlpha2": "AE",
    "isoAlpha3": "ARE",
    "numericCode": "784",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en",
      "fr",
      "hi",
      "ur"
    ],
    "currency": {
      "code": "AED",
      "symbol": ".",
      "name": "United Arab Emirates Dirham"
    },
    "government": {
      "type": "Federal absolute monarchy",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Mohammed bin Zayed Al Nahyan"
        },
        {
          "title": "Prime Minister",
          "name": "Mohammed bin Rashid Al Maktoum"
        }
      ]
    },
    "timeZone": {
      "name": "Gulf Standard Time (GST)",
      "offset": "+04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 9890400,
    "area": {
      "value": 83600,
      "unit": "km"
    },
    "capital": "Abu Dhabi",
    "gdp": {
      "nominal": "501 billion USD",
      "perCapita": "50,100 USD"
    },
    "dialingCode": "+971",
    "internetTLD": ".ae",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "999",
      "fire": "997",
      "police": "999",
      "ambulance": "998"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Eid al-Fitr (date varies)",
      "Eid al-Adha (date varies)",
      "National Day (December 2)"
    ],
    "nationalAnimal": "Falcon",
    "nationalDish": "Al Harees",
    "tourismHighlights": [
      "Burj Khalifa",
      "Sheikh Zayed Grand Mosque",
      "The Louvre Abu Dhabi",
      "Dubai Mall",
      "Ferrari World Abu Dhabi"
    ],
    "majorExports": [
      "Crude petroleum",
      "Natural gas",
      "Gold"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Gold"
    ],
    "lifeExpectancy": 78.8,
    "literacyRate": 94,
    "climate": "Desert climate with extremely hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Hinduism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Saudi Arabia",
      "Oman"
    ],
    "visaRequirement": "Visa required for many nationalities; visa on arrival for some",
    "notableFacts": [
      "Home to the world's tallest building, Burj Khalifa.",
      "Consists of seven emirates: Abu Dhabi, Dubai, Sharjah, Ajman, Umm Al-Quwain, Fujairah, and Ras Al Khaimah.",
      "Has a large expatriate population, making up around 80% of its residents."
    ]
  },
  "AI": {
    "flag": "",
    "name": "Anguilla",
    "officialName": "Anguilla",
    "countryCode": "+1-264",
    "isoAlpha2": "AI",
    "isoAlpha3": "AIA",
    "numericCode": "660",
    "firstLanguage": "en",
    "otherLanguages": [
      "ai",
      "fr"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Overseas Territory of the United Kingdom",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Appointed by the Queen of the United Kingdom"
        },
        {
          "title": "Premier",
          "name": "Elected by the Anguillian people"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Caribbean",
    "subregion": "North America",
    "population": 15000,
    "area": {
      "value": 91,
      "unit": "km"
    },
    "capital": "The Valley",
    "gdp": {
      "nominal": "353 million USD",
      "perCapita": "23,533 USD"
    },
    "dialingCode": "+1-264",
    "internetTLD": ".ai",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Emancipation Day (August 1)",
      "Anguilla Day (May 30)"
    ],
    "nationalAnimal": "Silver Palm",
    "nationalDish": "Goat Water",
    "tourismHighlights": [
      "Shoal Bay",
      "Sandy Ground",
      "Anguilla's beaches and resorts",
      "Historic sites like the Old Prison"
    ],
    "majorExports": [
      "Fish",
      "Lobster",
      "Construction services"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 80.5,
    "literacyRate": 96.5,
    "climate": "Tropical, moderated by northeastern trade winds",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Baha'i",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Saint Martin",
      "Saint Barthélemy"
    ],
    "visaRequirement": "No visa required for many countries, visitors check with local authorities.",
    "notableFacts": [
      "Known for its stunning beaches and luxury resorts.",
      "Economy heavily reliant on tourism.",
      "Home to a unique blend of Caribbean culture and British heritage."
    ]
  },
  "AO": {
    "flag": "",
    "name": "Angola",
    "officialName": "Republic of Angola",
    "countryCode": "+244",
    "isoAlpha2": "AO",
    "isoAlpha3": "AGO",
    "numericCode": "024",
    "firstLanguage": "pt",
    "otherLanguages": [
      "kg",
      "uxi",
      "bvo"
    ],
    "currency": {
      "code": "AOA",
      "symbol": "Kz",
      "name": "Kwanza"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "João Lourenço"
        },
        {
          "title": "Vice President",
          "name": "Bornito de Sousa"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Sub-Saharan Africa",
    "population": 32866272,
    "area": {
      "value": 1246700,
      "unit": "km"
    },
    "capital": "Luanda",
    "gdp": {
      "nominal": "66.49 billion USD",
      "perCapita": "1,915 USD"
    },
    "dialingCode": "+244",
    "internetTLD": ".ao",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "113",
      "fire": "115",
      "police": "112",
      "ambulance": "222 320 520"
    },
    "holidays": [
      "Independence Day (November 11)",
      "Peace Day (April 4)"
    ],
    "nationalAnimal": "Giant sable antelope",
    "nationalDish": "Moqueca",
    "tourismHighlights": [
      "Kwando-Kubango Province",
      "Luanda",
      "Kissama National Park",
      "Namibe Desert"
    ],
    "majorExports": [
      "Crude oil",
      "Diamonds",
      "Coffee"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Vehicles"
    ],
    "lifeExpectancy": 61.2,
    "literacyRate": 71.1,
    "climate": "Tropical with dry and wet seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Namibia",
      "Zambia",
      "Democratic Republic of the Congo"
    ],
    "visaRequirement": "Visa required for most travelers; eVisa available for some nationalities.",
    "notableFacts": [
      "Home to diverse ecosystems and wildlife including endemic species.",
      "Rich in natural resources, particularly oil and diamonds.",
      "Has a complex history influenced by colonialism and civil war."
    ]
  },
  "AM": {
    "flag": "",
    "name": "Armenia",
    "officialName": "Republic of Armenia",
    "countryCode": "+374",
    "isoAlpha2": "AM",
    "isoAlpha3": "ARM",
    "numericCode": "051",
    "firstLanguage": "hy",
    "otherLanguages": [
      "ru",
      "en"
    ],
    "currency": {
      "code": "AMD",
      "symbol": "",
      "name": "Armenian Dram"
    },
    "government": {
      "type": "Unitary parliamentary republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Vahagn Kh achaturyan"
        },
        {
          "title": "Prime Minister",
          "name": "Nikol Pashinyan"
        }
      ]
    },
    "timeZone": {
      "name": "Armenia Time (AMT)",
      "offset": "+04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 2963243,
    "area": {
      "value": 29743,
      "unit": "km"
    },
    "capital": "Yerevan",
    "gdp": {
      "nominal": "13.22 billion USD",
      "perCapita": "4,453 USD"
    },
    "dialingCode": "+374",
    "internetTLD": ".am",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Independence Day (September 21)",
      "Victory and Peace Day (May 9)"
    ],
    "nationalAnimal": "Golden Eagle",
    "nationalDish": "Khorovats (Armenian BBQ)",
    "tourismHighlights": [
      "Geghard Monastery (UNESCO World Heritage Site)",
      "Lake Sevan",
      "Ararat Mountain",
      "History Museum of Armenia"
    ],
    "majorExports": [
      "Minerals",
      "Food products",
      "Textiles"
    ],
    "majorImports": [
      "Machinery",
      "Fuel",
      "Food"
    ],
    "lifeExpectancy": 75.1,
    "literacyRate": 99.8,
    "climate": "Continental with hot summers and cold winters",
    "religions": {
      "predominant": "Armenian Apostolic Church",
      "others": [
        "Other Christian denominations",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Turkey",
      "Georgia",
      "Azerbaijan",
      "Iran"
    ],
    "visaRequirement": "Visa-free travel for many countries; e-Visa available for others.",
    "notableFacts": [
      "Armenia was the first country to adopt Christianity as its state religion in the early 4th century.",
      "Home to ancient monasteries and churches, some dating back to the 4th century.",
      "Recognized as a nation in 1991 after the collapse of the Soviet Union."
    ]
  },
  "AR": {
    "flag": "",
    "name": "Argentina",
    "officialName": "Argentine Republic",
    "countryCode": "+54",
    "isoAlpha2": "AR",
    "isoAlpha3": "ARG",
    "numericCode": "032",
    "firstLanguage": "es",
    "otherLanguages": [
      "en",
      "it",
      "de",
      "qu"
    ],
    "currency": {
      "code": "ARS",
      "symbol": "$",
      "name": "Argentine Peso"
    },
    "government": {
      "type": "Federal presidential constitutional republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Current President (as of 2023)"
        }
      ]
    },
    "timeZone": {
      "name": "Argentina Time (ART)",
      "offset": "-03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 45663112,
    "area": {
      "value": 2780400,
      "unit": "km"
    },
    "capital": "Buenos Aires",
    "gdp": {
      "nominal": "644.14 billion USD",
      "perCapita": "14,097 USD"
    },
    "dialingCode": "+54",
    "internetTLD": ".ar",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "100",
      "police": "101",
      "ambulance": "107"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Mardi Gras (variable date)",
      "Day of the Malvinas (April 2)",
      "Labor Day (May 1)",
      "May Revolution Day (May 25)",
      "Independence Day (July 9)",
      "Cultural Diversity Day (October 12)",
      "National Sovereignty Day (November 20)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Rufous Hornero",
    "nationalDish": "Asado",
    "tourismHighlights": [
      "Iguazu Falls",
      "Los Glaciares National Park",
      "Buenos Aires",
      "Tigre Delta",
      "Wine regions in Mendoza"
    ],
    "majorExports": [
      "Soybeans",
      "Beef",
      "Corn",
      "Automobiles"
    ],
    "majorImports": [
      "Machinery",
      "Electronics",
      "Petroleum",
      "Chemical products"
    ],
    "lifeExpectancy": 76,
    "literacyRate": 99,
    "climate": "Varied; tropical in the north, arid in the southeast, and cold in the south",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Jewish",
        "Evangelical",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Brazil",
      "Paraguay",
      "Bolivia",
      "Chile",
      "Uruguay"
    ],
    "visaRequirement": "No visa required for many countries; others may require visa",
    "notableFacts": [
      "Eighth largest country in the world by area.",
      "Home to the tango dance and music.",
      "One of the leading wine producers in the world."
    ]
  },
  "AL": {
    "flag": "",
    "name": "Albania",
    "officialName": "Republic of Albania",
    "countryCode": "+355",
    "isoAlpha2": "AL",
    "isoAlpha3": "ALB",
    "numericCode": "008",
    "firstLanguage": "sq",
    "otherLanguages": [
      "en",
      "it"
    ],
    "currency": {
      "code": "ALL",
      "symbol": "L",
      "name": "Albanian Lek"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Center-Right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Bajram Begaj"
        },
        {
          "title": "Prime Minister",
          "name": "Edi Rama"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 2880917,
    "area": {
      "value": 28748,
      "unit": "km"
    },
    "capital": "Tirana",
    "gdp": {
      "nominal": "15.89 billion USD",
      "perCapita": "5,513 USD"
    },
    "dialingCode": "+355",
    "internetTLD": ".al",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "128",
      "police": "129",
      "ambulance": "127"
    },
    "holidays": [
      "Independence Day (November 28)",
      "Revolution Day (November 29)"
    ],
    "nationalAnimal": "Golden Eagle",
    "nationalDish": "Fërgesë",
    "tourismHighlights": [
      "Kyllä Valley",
      "Butrint National Park (UNESCO World Heritage Site)",
      "The Albanian Riviera",
      "Gjirokastër (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Textiles",
      "Footwear",
      "Aluminum"
    ],
    "majorImports": [
      "Minerals",
      "Machinery",
      "Food and live animals"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 98.7,
    "climate": "Mediterranean climate, with hot, dry summers and mild, wet winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Roman Catholic",
        "Eastern Orthodox"
      ]
    },
    "neighborCountries": [
      "Montenegro",
      "Kosovo",
      "North Macedonia",
      "Greece"
    ],
    "visaRequirement": "No visa required for Schengen zone countries and many others",
    "notableFacts": [
      "Home to the ancient city of Butrint, a UNESCO World Heritage site.",
      "Albania is known for its stunning coastlines along the Adriatic and Ionian Seas.",
      "It has a rich and diverse history influenced by various civilizations."
    ]
  },
  "AQ": {
    "flag": "",
    "name": "Antarctica",
    "officialName": "Not applicable (territory managed under an international treaty)",
    "countryCode": "+672",
    "isoAlpha2": "AQ",
    "isoAlpha3": "ATA",
    "numericCode": "010",
    "firstLanguage": "",
    "otherLanguages": [],
    "currency": {
      "code": "N/A",
      "symbol": "N/A",
      "name": "N/A"
    },
    "government": {
      "type": "No official government; governed by the Antarctic Treaty System",
      "politicalLean": "N/A",
      "headsOfState": []
    },
    "timeZone": {
      "name": "Various time zones depending on research stations",
      "offset": "Varies",
      "dst": "Yes (in some research stations)"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Antarctica",
    "subregion": "N/A",
    "population": 1000,
    "area": {
      "value": 14000000,
      "unit": "km"
    },
    "capital": "N/A",
    "gdp": {
      "nominal": "N/A",
      "perCapita": "N/A"
    },
    "dialingCode": "+672",
    "internetTLD": ".aq",
    "drivingSide": "N/A",
    "emergencyNumbers": {
      "general": "N/A",
      "fire": "N/A",
      "police": "N/A",
      "ambulance": "N/A"
    },
    "holidays": [
      "Antarctic Treaty Day (December 1)"
    ],
    "nationalAnimal": "Emperor Penguin",
    "nationalDish": "N/A",
    "tourismHighlights": [
      "South Pole",
      "Ross Ice Shelf",
      "Antarctic Peninsula",
      "Palmer Station"
    ],
    "majorExports": [
      "N/A"
    ],
    "majorImports": [
      "Supplies for research stations"
    ],
    "lifeExpectancy": "N/A",
    "literacyRate": "N/A",
    "climate": "Polar climate with harsh conditions",
    "religions": {
      "predominant": "N/A",
      "others": []
    },
    "neighborCountries": [],
    "visaRequirement": "N/A; no permanent residents and access regulated by treaties",
    "notableFacts": [
      "The only continent without a native human population.",
      "Governed by the Antarctic Treaty which prohibits military activity and mineral mining.",
      "Home to the largest desert in the world due to its extreme dryness."
    ]
  },
  "AS": {
    "flag": "",
    "name": "American Samoa",
    "officialName": "Territory of American Samoa",
    "countryCode": "+1-684",
    "isoAlpha2": "AS",
    "isoAlpha3": "ASM",
    "numericCode": "016",
    "firstLanguage": "sm",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Unincorporated territory of the United States",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Lolo Moliga"
        }
      ]
    },
    "timeZone": {
      "name": "UTC-11:00",
      "offset": "-11:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 55191,
    "area": {
      "value": 199,
      "unit": "km"
    },
    "capital": "Pago Pago",
    "gdp": {
      "nominal": "0.63 billion USD",
      "perCapita": "11,400 USD"
    },
    "dialingCode": "+1-684",
    "internetTLD": ".as",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "American Samoa Flag Day (April 17)",
      "Independence Day (July 4)",
      "Thanksgiving Day (Fourth Thursday in November)"
    ],
    "nationalAnimal": "Green Turtle",
    "nationalDish": "Palusami",
    "tourismHighlights": [
      "National Park of American Samoa",
      "To Sua Ocean Trench",
      "Aunu'u Island",
      "Manua Islands"
    ],
    "majorExports": [
      "Fish",
      "Coconut products",
      "Tuna"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Machinery"
    ],
    "lifeExpectancy": 73.1,
    "literacyRate": 99,
    "climate": "Tropical, with a wet season from November to March",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Samoan Traditional Religion",
        "Buddhism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (only territorial waters)"
    ],
    "visaRequirement": "No visa required for U.S. citizens; others may require a visa.",
    "notableFacts": [
      "American Samoa is the only U.S. territory south of the equator.",
      "Home to the only national park in the United States that is located entirely in the Southern Hemisphere.",
      "Samoan culture is a dominant influence on the territory's lifestyle."
    ]
  },
  "AX": {
    "flag": "",
    "name": "Åland Islands",
    "officialName": "Åland Islands",
    "countryCode": "+358-18",
    "isoAlpha2": "AX",
    "isoAlpha3": "ALA",
    "numericCode": "248",
    "firstLanguage": "sv",
    "otherLanguages": [
      "fi",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Autonomous region of Finland",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Head of the Government of Åland Islands"
        },
        {
          "title": "President of Finland",
          "name": "Sauli Niinistö"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 29910,
    "area": {
      "value": 1580,
      "unit": "km"
    },
    "capital": "Mariehamn",
    "gdp": {
      "nominal": "1.4 billion EUR",
      "perCapita": "47,000 EUR"
    },
    "dialingCode": "+358-18",
    "internetTLD": ".ax",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "Midsummer Day (June)",
      "Åland Independence Day (June 9)"
    ],
    "nationalAnimal": "Eurasian Beaver",
    "nationalDish": "Åland Pancakes",
    "tourismHighlights": [
      "Mariehamn Maritime Museum",
      "Viking Village in Jomala",
      "Korsö Lighthouse",
      "Käringsund Resort"
    ],
    "majorExports": [
      "Fish products",
      "Shipbuilding materials",
      "Textiles"
    ],
    "majorImports": [
      "Machinery",
      "Food products",
      "Consumer goods"
    ],
    "lifeExpectancy": 84.1,
    "literacyRate": 100,
    "climate": "Maritime climate with mild winters and cool summers",
    "religions": {
      "predominant": "Lutheran Christian",
      "others": [
        "None",
        "Orthodox Christian",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Finland",
      "Sweden"
    ],
    "visaRequirement": "Part of the Schengen Area; no visa required for Schengen citizens.",
    "notableFacts": [
      "Åland Islands is a demilitarized zone with no military presence.",
      "It has its own parliament and official flag.",
      "Known for its archipelago and rich maritime heritage."
    ]
  },
  "AW": {
    "flag": "",
    "name": "Aruba",
    "officialName": "Aruba",
    "countryCode": "+297",
    "isoAlpha2": "AW",
    "isoAlpha3": "ABW",
    "numericCode": "533",
    "firstLanguage": "nl",
    "otherLanguages": [
      "pap",
      "es",
      "en"
    ],
    "currency": {
      "code": "AWG",
      "symbol": "",
      "name": "Aruban Florin"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Moderate",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Governor of Aruba"
        },
        {
          "title": "Prime Minister",
          "name": "Prime Minister of Aruba"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 106766,
    "area": {
      "value": 179,
      "unit": "km"
    },
    "capital": "Oranjestad",
    "gdp": {
      "nominal": "3.01 billion USD",
      "perCapita": "28,270 USD"
    },
    "dialingCode": "+297",
    "internetTLD": ".aw",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "199",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Día di Betico Croes (January 25)",
      "Carnival (variable dates)",
      "Aruba Flag Day (March 18)",
      "King's Day (April 27)",
      "National Anthem and Flag Day (September 18)"
    ],
    "nationalAnimal": "Ostrich",
    "nationalDish": "Keshi Yena",
    "tourismHighlights": [
      "Eagle Beach",
      "Palm Beach",
      "Arikok National Park",
      "Natural Pool"
    ],
    "majorExports": [
      "Liqueurs",
      "Aloe Vera",
      "Tourism services"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Construction materials"
    ],
    "lifeExpectancy": 75.2,
    "literacyRate": 93.7,
    "climate": "Tropical marine, warm and humid",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Methodist",
        "Evangelical"
      ]
    },
    "neighborCountries": [
      "Curaçao",
      "Bonaire"
    ],
    "visaRequirement": "No visa required for many nationalities, including US and EU citizens",
    "notableFacts": [
      "Has beaches consistently ranked among the best in the world.",
      "Is known for its vibrant culture and music.",
      "Has a high standard of living relative to other Caribbean nations."
    ]
  },
  "AT": {
    "flag": "",
    "name": "Austria",
    "officialName": "Republic of Austria",
    "countryCode": "+43",
    "isoAlpha2": "AT",
    "isoAlpha3": "AUT",
    "numericCode": "040",
    "firstLanguage": "de",
    "otherLanguages": [
      "sl",
      "hr",
      "hu"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Federal parliamentary republic",
      "politicalLean": "Social-democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Alexander Van der Bellen"
        },
        {
          "title": "Chancellor",
          "name": "Karl Nehammer"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 8917205,
    "area": {
      "value": 83879,
      "unit": "km"
    },
    "capital": "Vienna",
    "gdp": {
      "nominal": "455.9 billion USD",
      "perCapita": "51,182 USD"
    },
    "dialingCode": "+43",
    "internetTLD": ".at",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "122",
      "police": "133",
      "ambulance": "144"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "National Day (October 26)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Brown Bear",
    "nationalDish": "Wiener Schnitzel",
    "tourismHighlights": [
      "Schönbrunn Palace",
      "St. Stephen's Cathedral",
      "Vienna State Opera",
      "Salzburg's Historic Centre (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Machinery",
      "Automobiles",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Machinery",
      "Chemicals",
      "Oil and Gas"
    ],
    "lifeExpectancy": 81.4,
    "literacyRate": 99,
    "climate": "Temperate with four distinct seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Orthodox"
      ]
    },
    "neighborCountries": [
      "Germany",
      "Czech Republic",
      "Slovakia",
      "Hungary",
      "Slovenia",
      "Italy",
      "Switzerland",
      "Liechtenstein"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Austria is known for its cultural contributions, especially in classical music.",
      "It is the only landlocked country in the European Union besides Luxembourg.",
      "The Vienna Philharmonic is considered one of the finest orchestras in the world."
    ]
  },
  "AU": {
    "flag": "",
    "name": "Australia",
    "officialName": "Commonwealth of Australia",
    "countryCode": "+61",
    "isoAlpha2": "AU",
    "isoAlpha3": "AUS",
    "numericCode": "036",
    "firstLanguage": "en",
    "otherLanguages": [
      "zh",
      "ar",
      "vi",
      "el",
      "fr",
      "it"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Federal parliamentary constitutional monarchy",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "King",
          "name": "King Charles III"
        },
        {
          "title": "Prime Minister",
          "name": "Anthony Albanese"
        }
      ]
    },
    "timeZone": {
      "name": "Australian Eastern Standard Time (AEST)",
      "offset": "+10:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "population": 25687041,
    "area": {
      "value": 7692024,
      "unit": "km"
    },
    "capital": "Canberra",
    "gdp": {
      "nominal": "1.77 trillion USD",
      "perCapita": "68,000 USD"
    },
    "dialingCode": "+61",
    "internetTLD": ".au",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "000",
      "police": "000",
      "ambulance": "000"
    },
    "holidays": [
      "Australia Day (January 26)",
      "ANZAC Day (April 25)",
      "Labour Day (First Monday in October)"
    ],
    "nationalAnimal": "Red Kangaroo",
    "nationalDish": "Vegemite on toast",
    "tourismHighlights": [
      "Great Barrier Reef",
      "Sydney Opera House",
      "Uluru-Kata Tjuta National Park",
      "Daintree Rainforest"
    ],
    "majorExports": [
      "Iron ore",
      "Coal",
      "Gold",
      "Natural gas"
    ],
    "majorImports": [
      "Cars",
      "Crude petroleum",
      "Telecommunications equipment"
    ],
    "lifeExpectancy": 83.3,
    "literacyRate": 99,
    "climate": "Varied, ranging from tropical in the north to temperate in the south",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Buddhism",
        "Hinduism",
        "None"
      ]
    },
    "neighborCountries": [
      "Indonesia",
      "Papua New Guinea",
      "New Zealand"
    ],
    "visaRequirement": "Visa required for most foreign visitors",
    "notableFacts": [
      "Is the sixth-largest country in the world by total area.",
      "Home to unique wildlife, including kangaroos and koalas.",
      "Has a diverse cultural heritage influenced by British colonization and indigenous cultures."
    ]
  },
  "BF": {
    "flag": "",
    "name": "Burkina Faso",
    "officialName": "Burkina Faso",
    "countryCode": "+226",
    "isoAlpha2": "BF",
    "isoAlpha3": "BFA",
    "numericCode": "854",
    "firstLanguage": "fr",
    "otherLanguages": [
      "moro",
      "dioula",
      "fufulde"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "",
      "name": "West African CFA franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ibrahim Traoré"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 22257340,
    "area": {
      "value": 272967,
      "unit": "km"
    },
    "capital": "Ouagadougou",
    "gdp": {
      "nominal": "18.21 billion USD",
      "perCapita": "818 USD"
    },
    "dialingCode": "+226",
    "internetTLD": ".bf",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Independence Day (August 5)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "African Lion",
    "nationalDish": "Tô",
    "tourismHighlights": [
      "Namané Lake",
      "Bobo Dioulasso",
      "Sindou Peaks",
      "Gorom-Gorom Market"
    ],
    "majorExports": [
      "Gold",
      "Cotton",
      "Livestock"
    ],
    "majorImports": [
      "Petroleum products",
      "Food",
      "Machinery"
    ],
    "lifeExpectancy": 61.9,
    "literacyRate": 30.4,
    "climate": "Tropical with a dry season and a wet season",
    "religions": {
      "predominant": "Traditional African religions",
      "others": [
        "Islam",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "Mali",
      "Niger",
      "Benin",
      "Togo",
      "Ghana"
    ],
    "visaRequirement": "Visa required for most foreign nationals",
    "notableFacts": [
      "Burkina Faso is landlocked and known for its cultural diversity.",
      "It has a high rate of annual festivals celebrating arts and culture.",
      "Burkina Faso is one of the leading producers of cotton in Africa."
    ]
  },
  "AZ": {
    "flag": "",
    "name": "Azerbaijan",
    "officialName": "Republic of Azerbaijan",
    "countryCode": "+994",
    "isoAlpha2": "AZ",
    "isoAlpha3": "AZE",
    "numericCode": "031",
    "firstLanguage": "az",
    "otherLanguages": [
      "ru",
      "en"
    ],
    "currency": {
      "code": "AZN",
      "symbol": "",
      "name": "Azerbaijani Manat"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ilham Aliyev"
        }
      ]
    },
    "timeZone": {
      "name": "Azerbaijan Time (AZT)",
      "offset": "+04:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 10139177,
    "area": {
      "value": 86600,
      "unit": "km"
    },
    "capital": "Baku",
    "gdp": {
      "nominal": "48.57 billion USD",
      "perCapita": "4,786 USD"
    },
    "dialingCode": "+994",
    "internetTLD": ".az",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "State Independence Day (October 18)",
      "Republic Day (May 28)",
      "National Revival Day (November 17)"
    ],
    "nationalAnimal": "Karabakh Horse",
    "nationalDish": "Plov (Pilaf)",
    "tourismHighlights": [
      "Flame Towers",
      "Gobustan National Park (UNESCO World Heritage Site)",
      "Old City (Icherisheher)",
      "Sheki Khan's Palace"
    ],
    "majorExports": [
      "Oil and gas",
      "Petrochemicals",
      "Cotton"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Chemical products"
    ],
    "lifeExpectancy": 75.1,
    "literacyRate": 99.8,
    "climate": "Semi-arid, with hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Georgia",
      "Armenia",
      "Iran",
      "Turkey"
    ],
    "visaRequirement": "e-Visa available for many nationalities",
    "notableFacts": [
      "Home to the first oil well in the world.",
      "Has a unique cultural heritage and is known for its rich history.",
      "Hosts the Formula 1 Azerbaijan Grand Prix in Baku."
    ]
  },
  "BB": {
    "flag": "",
    "name": "Barbados",
    "officialName": "Barbados",
    "countryCode": "+1-246",
    "isoAlpha2": "BB",
    "isoAlpha3": "BRB",
    "numericCode": "052",
    "firstLanguage": "en",
    "otherLanguages": [
      "Bajan"
    ],
    "currency": {
      "code": "BBD",
      "symbol": "$",
      "name": "Barbadian Dollar"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Center-left",
      "headsOfState": [
        {
          "title": "Prime Minister",
          "name": "Mia Mottley"
        },
        {
          "title": "Governor-General",
          "name": "Dame Sandra Mason"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 287375,
    "area": {
      "value": 430,
      "unit": "km"
    },
    "capital": "Bridgetown",
    "gdp": {
      "nominal": "5.06 billion USD",
      "perCapita": "17,626 USD"
    },
    "dialingCode": "+1-246",
    "internetTLD": ".bb",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "211",
      "fire": "311",
      "police": "211",
      "ambulance": "511"
    },
    "holidays": [
      "National Heroes Day (April, 1st Monday)",
      "Crop Over Festival (July - August)"
    ],
    "nationalAnimal": "Red-billed Tropicbird",
    "nationalDish": "Cou-Cou and Flying Fish",
    "tourismHighlights": [
      "Carlisle Bay",
      "Harrison's Cave",
      "Oistins Fish Fry",
      "Bathsheba Beach"
    ],
    "majorExports": [
      "Sugar and molasses",
      "Rum",
      "Clothing"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Chemicals"
    ],
    "lifeExpectancy": 79.1,
    "literacyRate": 99.7,
    "climate": "Tropical, with a wet season from June to November",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Rastafarianism",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "None; island nation"
    ],
    "visaRequirement": "No visa required for most countries, including EU and USA",
    "notableFacts": [
      "One of the first Caribbean islands to gain independence from the UK in 1966.",
      "Known for its beaches and botanical gardens.",
      "Home to the world's oldest rum distillery, Mount Gay Rum."
    ]
  },
  "BD": {
    "flag": "",
    "name": "Bangladesh",
    "officialName": "People's Republic of Bangladesh",
    "countryCode": "+880",
    "isoAlpha2": "BD",
    "isoAlpha3": "BGD",
    "numericCode": "050",
    "firstLanguage": "bn",
    "otherLanguages": [
      "en",
      "hi",
      "ur"
    ],
    "currency": {
      "code": "BDT",
      "symbol": "",
      "name": "Bangladeshi Taka"
    },
    "government": {
      "type": "Unitary parliamentary constitutional republic",
      "politicalLean": "Majority parliamentary system",
      "headsOfState": [
        {
          "title": "President",
          "name": "Mohammed Shahabuddin"
        },
        {
          "title": "Prime Minister",
          "name": "Sheikh Hasina"
        }
      ]
    },
    "timeZone": {
      "name": "Bangladesh Standard Time (BST)",
      "offset": "+06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southern Asia",
    "population": 166303498,
    "area": {
      "value": 147570,
      "unit": "km"
    },
    "capital": "Dhaka",
    "gdp": {
      "nominal": "416 billion USD",
      "perCapita": "2,507 USD"
    },
    "dialingCode": "+880",
    "internetTLD": ".bd",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "113",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (March 26)",
      "Bengali New Year (April 14)",
      "Victory Day (December 16)"
    ],
    "nationalAnimal": "Bengal Tiger",
    "nationalDish": "Hilsa Fish Curry",
    "tourismHighlights": [
      "Sundarbans Mangrove Forest",
      "Cox's Bazar",
      "Srimangal Tea Gardens",
      "Historical Sites of Paharpur and Mahasthangarh"
    ],
    "majorExports": [
      "Textiles and garments",
      "Leather goods",
      "Jute products"
    ],
    "majorImports": [
      "Machinery",
      "Food grains",
      "Crude petroleum"
    ],
    "lifeExpectancy": 72.6,
    "literacyRate": 74.9,
    "climate": "Tropical monsoon climate",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Hinduism",
        "Buddhism",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "India",
      "Myanmar"
    ],
    "visaRequirement": "Visa required for most travelers, but some countries have special arrangements.",
    "notableFacts": [
      "One of the most densely populated countries in the world.",
      "Home to the world's largest river delta: the Sundarbans.",
      "Renowned for its rich cultural heritage and natural beauty."
    ]
  },
  "BE": {
    "flag": "",
    "name": "Belgium",
    "officialName": "Kingdom of Belgium",
    "countryCode": "+32",
    "isoAlpha2": "BE",
    "isoAlpha3": "BEL",
    "numericCode": "056",
    "firstLanguage": "nl",
    "otherLanguages": [
      "fr",
      "de"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Federal parliamentary constitutional monarchy",
      "politicalLean": "Varies by region",
      "headsOfState": [
        {
          "title": "King",
          "name": "Alexander"
        },
        {
          "title": "Prime Minister",
          "name": "Alexander De Croo"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 11589623,
    "area": {
      "value": 30528,
      "unit": "km"
    },
    "capital": "Brussels",
    "gdp": {
      "nominal": "558 billion USD",
      "perCapita": "48,767 USD"
    },
    "dialingCode": "+32",
    "internetTLD": ".be",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "100",
      "police": "101",
      "ambulance": "100"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Easter Monday",
      "Labour Day (May 1)",
      "National Day (July 21)",
      "Assumption of Mary (August 15)",
      "All Saints' Day (November 1)",
      "Armistice Day (November 11)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Lion",
    "nationalDish": "Moules-frites (Mussels and Fries)",
    "tourismHighlights": [
      "Brussels Atomium",
      "Grand Place, Brussels",
      "Battlefields of Belgium",
      "Canals of Bruges",
      "Antwerp Cathedral"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Chemicals",
      "Cars",
      "Diamonds"
    ],
    "majorImports": [
      "Machinery and equipment",
      "Chemicals",
      "Mineral fuels",
      "Food"
    ],
    "lifeExpectancy": 81.5,
    "literacyRate": 99,
    "climate": "Temperate maritime with mild winters and cool summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Atheism"
      ]
    },
    "neighborCountries": [
      "France",
      "Germany",
      "Luxembourg",
      "Netherlands"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Home to the headquarters of the European Union and NATO.",
      "Famous for its chocolates, waffles, and beers.",
      "Has three official languages: Dutch, French, and German."
    ]
  },
  "BH": {
    "flag": "",
    "name": "Bahrain",
    "officialName": "Kingdom of Bahrain",
    "countryCode": "+973",
    "isoAlpha2": "BH",
    "isoAlpha3": "BHR",
    "numericCode": "048",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "BHD",
      "symbol": ".",
      "name": "Bahraini Dinar"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Monarchy",
      "headsOfState": [
        {
          "title": "King",
          "name": "Hamad bin Isa Al Khalifa"
        }
      ]
    },
    "timeZone": {
      "name": "Arabian Standard Time (AST)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 1780000,
    "area": {
      "value": 765,
      "unit": "km"
    },
    "capital": "Manama",
    "gdp": {
      "nominal": "38.57 billion USD",
      "perCapita": "21,500 USD"
    },
    "dialingCode": "+973",
    "internetTLD": ".bh",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Independence Day (August 15)",
      "Bahrain National Day (December 16)"
    ],
    "nationalAnimal": "Falcon",
    "nationalDish": "Machboos",
    "tourismHighlights": [
      "Bahrain Fort (Qal'at al-Bahrain)",
      "Bahrain National Museum",
      "The Tree of Life",
      "Dilmun Burial Mounds (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Petroleum products",
      "Aluminum",
      "Ceramics"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Chemicals"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 99,
    "climate": "Hot desert climate with mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Saudi Arabia"
    ],
    "visaRequirement": "Visa required for many countries; specific regulations apply depending on nationality.",
    "notableFacts": [
      "Bahrain is an archipelago of 33 islands.",
      "It is considered one of the financial hubs of the Middle East.",
      "Bahrain was the first country in the Persian Gulf to discover oil."
    ]
  },
  "BI": {
    "flag": "",
    "name": "Burundi",
    "officialName": "Republic of Burundi",
    "countryCode": "+257",
    "isoAlpha2": "BI",
    "isoAlpha3": "BDI",
    "numericCode": "108",
    "firstLanguage": "rn",
    "otherLanguages": [
      "fr",
      "en"
    ],
    "currency": {
      "code": "BIF",
      "symbol": "Fr",
      "name": "Burundian franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Single-party dominant",
      "headsOfState": [
        {
          "title": "President",
          "name": "Évariste Ndayishimiye"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 12114538,
    "area": {
      "value": 27834,
      "unit": "km"
    },
    "capital": "Gitega",
    "gdp": {
      "nominal": "3.07 billion USD",
      "perCapita": "253 USD"
    },
    "dialingCode": "+257",
    "internetTLD": ".bi",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "117",
      "fire": "118",
      "police": "119",
      "ambulance": "121"
    },
    "holidays": [
      "Independence Day (July 1)",
      "Revolution Day (November 1)"
    ],
    "nationalAnimal": "African Lion",
    "nationalDish": "Boko",
    "tourismHighlights": [
      "Lake Tanganyika",
      "Kibira National Park",
      "Rusizi National Park",
      "Gitega National Museum"
    ],
    "majorExports": [
      "Coffee",
      "Tea",
      "Cotton"
    ],
    "majorImports": [
      "Food products",
      "Machinery",
      "Petroleum products"
    ],
    "lifeExpectancy": 60.2,
    "literacyRate": 85,
    "climate": "Tropical with a wet season and a dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Rwanda",
      "Tanzania",
      "Democratic Republic of the Congo"
    ],
    "visaRequirement": "Visa required for most foreign nationals, with some exceptions",
    "notableFacts": [
      "Burundi is one of the poorest countries in the world.",
      "It is known for its vibrant culture and traditional music.",
      "The country's flag features a red cross on a green background with white stars representing the ethnic groups."
    ]
  },
  "BM": {
    "flag": "",
    "name": "Bermuda",
    "officialName": "Bermuda",
    "countryCode": "+1-441",
    "isoAlpha2": "BM",
    "isoAlpha3": "BMU",
    "numericCode": "032",
    "firstLanguage": "en",
    "otherLanguages": [
      "pt"
    ],
    "currency": {
      "code": "BMD",
      "symbol": "$",
      "name": "Bermudian Dollar"
    },
    "government": {
      "type": "Parliamentary representative democratic dependency",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Rena Lalgie"
        },
        {
          "title": "Premier",
          "name": "David Burt"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 61954,
    "area": {
      "value": 54,
      "unit": "km"
    },
    "capital": "Hamilton",
    "gdp": {
      "nominal": "6.62 billion USD",
      "perCapita": "106,898 USD"
    },
    "dialingCode": "+1-441",
    "internetTLD": ".bm",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Good Friday",
      "Victoria Day (Queen Victoria's Birthday)",
      "Emancipation Day",
      "Somers Day",
      "National Heroes Day"
    ],
    "nationalAnimal": "Bermuda petrel (Cahow)",
    "nationalDish": "Bermudian fish chowder",
    "tourismHighlights": [
      "Horseshoe Bay Beach",
      "St. George's Historic Town (UNESCO World Heritage Site)",
      "Bermuda Aquarium, Museum and Zoo",
      "Royal Naval Dockyard"
    ],
    "majorExports": [
      "Bermudian services",
      "Reinsurance",
      "Legal services"
    ],
    "majorImports": [
      "Fuel",
      "Food",
      "Consumer goods"
    ],
    "lifeExpectancy": 81.5,
    "literacyRate": 99,
    "climate": "Subtropical with mild winters and warm summers",
    "religions": {
      "predominant": "Christian",
      "others": [
        "Hindu",
        "Muslim",
        "None"
      ]
    },
    "neighborCountries": [],
    "visaRequirement": "No visa required for most countries, including EU and Commonwealth countries",
    "notableFacts": [
      "Bermuda is renowned for its pink sand beaches.",
      "It has one of the highest per capita incomes in the world.",
      "Bermuda consists of around 138 islands."
    ]
  },
  "BG": {
    "flag": "",
    "name": "Bulgaria",
    "officialName": "Republic of Bulgaria",
    "countryCode": "+359",
    "isoAlpha2": "BG",
    "isoAlpha3": "BGR",
    "numericCode": "100",
    "firstLanguage": "bg",
    "otherLanguages": [
      "en",
      "tr",
      "mk"
    ],
    "currency": {
      "code": "BGN",
      "symbol": "",
      "name": "Bulgarian Lev"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Rumen Radev"
        },
        {
          "title": "Prime Minister",
          "name": "Galab Donev"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "population": 6951482,
    "area": {
      "value": 110994,
      "unit": "km"
    },
    "capital": "Sofia",
    "gdp": {
      "nominal": "73.33 billion USD",
      "perCapita": "10,600 USD"
    },
    "dialingCode": "+359",
    "internetTLD": ".bg",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "160",
      "police": "166",
      "ambulance": "150"
    },
    "holidays": [
      "Liberation Day (March 3)",
      "Saint George's Day (May 6)",
      "Independence Day (September 22)"
    ],
    "nationalAnimal": "Lion",
    "nationalDish": "Shopska salad",
    "tourismHighlights": [
      "Rila Monastery (UNESCO World Heritage Site)",
      "Plovdiv Old Town",
      "Varna Beach",
      "Seven Rila Lakes"
    ],
    "majorExports": [
      "Clothing",
      "Machinery",
      "Fuels"
    ],
    "majorImports": [
      "Machinery",
      "Mineral fuels",
      "Food"
    ],
    "lifeExpectancy": 75.6,
    "literacyRate": 98.4,
    "climate": "Temperate continental with four distinct seasons",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Islam",
        "Protestant",
        "Roman Catholic"
      ]
    },
    "neighborCountries": [
      "Romania",
      "Serbia",
      "North Macedonia",
      "Greece",
      "Turkey"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "The Cyrillic alphabet was developed in the First Bulgarian Empire.",
      "Home to the UNESCO-listed Rila Monastery, one of the largest and most important monasteries in Bulgaria.",
      "Bulgaria is one of the oldest countries in Europe, with a rich history and culture."
    ]
  },
  "BJ": {
    "flag": "",
    "name": "Benin",
    "officialName": "Republic of Benin",
    "countryCode": "+229",
    "isoAlpha2": "BJ",
    "isoAlpha3": "BEN",
    "numericCode": "204",
    "firstLanguage": "fr",
    "otherLanguages": [
      "fon",
      "yor",
      "bariba"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "CFA",
      "name": "West African CFA franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Patrice Talon"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Western Africa",
    "population": 12123200,
    "area": {
      "value": 11295,
      "unit": "km"
    },
    "capital": "Porto-Novo",
    "gdp": {
      "nominal": "14.27 billion USD",
      "perCapita": "1,256 USD"
    },
    "dialingCode": "+229",
    "internetTLD": ".bj",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "118",
      "fire": "111",
      "police": "117",
      "ambulance": "120"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (August 1)",
      "National Day (October 1)"
    ],
    "nationalAnimal": "African Grey Parrot",
    "nationalDish": "Pâté de maïs",
    "tourismHighlights": [
      "Ouidah Museum of History",
      "Pendjari National Park",
      "Ganvie (Venice of Africa)",
      "The Temple of the Python"
    ],
    "majorExports": [
      "Cotton",
      "Cashew nuts",
      "Pineapple"
    ],
    "majorImports": [
      "Food",
      "Petroleum products",
      "Machinery"
    ],
    "lifeExpectancy": 61,
    "literacyRate": 42.4,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Vodun",
        "Atheism"
      ]
    },
    "neighborCountries": [
      "Togo",
      "Nigeria",
      "Burkina Faso"
    ],
    "visaRequirement": "Visa required for most travelers; e-Visa available.",
    "notableFacts": [
      "Known as the birthplace of the Vodun religion.",
      "Benin was once called Dahomey.",
      "Home to the largest number of species of fauna and flora in the West African region."
    ]
  },
  "BN": {
    "flag": "",
    "name": "Brunei Darussalam",
    "officialName": "Nation of Brunei, Abode of Peace",
    "countryCode": "+673",
    "isoAlpha2": "BN",
    "isoAlpha3": "BRN",
    "numericCode": "096",
    "firstLanguage": "ms",
    "otherLanguages": [
      "en",
      "zh"
    ],
    "currency": {
      "code": "BND",
      "symbol": "$",
      "name": "Brunei Dollar"
    },
    "government": {
      "type": "Absolute monarchy",
      "politicalLean": "Sultanate",
      "headsOfState": [
        {
          "title": "Sultan",
          "name": "Hassanal Bolkiah"
        }
      ]
    },
    "timeZone": {
      "name": "Brunei Time (BNT)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 453000,
    "area": {
      "value": 5765,
      "unit": "km"
    },
    "capital": "Bandar Seri Begawan",
    "gdp": {
      "nominal": "13.26 billion USD",
      "perCapita": "29,326 USD"
    },
    "dialingCode": "+673",
    "internetTLD": ".bn",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "995",
      "police": "993",
      "ambulance": "991"
    },
    "holidays": [
      "Hari Raya Aidilfitri",
      "National Day (February 23)",
      "Sultan's Birthday (July 15)"
    ],
    "nationalAnimal": "White-bellied Sea Eagle",
    "nationalDish": "Nasi Katok",
    "tourismHighlights": [
      "Ulu Temburong National Park",
      "Omar Ali Saifuddien Mosque",
      "Jewel of the Sultan",
      "Kampong Ayer (Water Village)"
    ],
    "majorExports": [
      "Oil",
      "Natural gas",
      "Crude rubber"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Chemical products"
    ],
    "lifeExpectancy": 77.1,
    "literacyRate": 97.2,
    "climate": "Tropical rainforest climate",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Buddhism",
        "Christianity",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Malaysia"
    ],
    "visaRequirement": "Visa-free for several countries; visa required for others.",
    "notableFacts": [
      "Brunei is one of the wealthiest countries in the world per capita.",
      "It has the highest percentage of protected rainforest in the world.",
      "Brunei's economy is heavily dependent on its oil and gas production."
    ]
  },
  "BS": {
    "flag": "",
    "name": "Bahamas",
    "officialName": "Commonwealth of The Bahamas",
    "countryCode": "+1-242",
    "isoAlpha2": "BS",
    "isoAlpha3": "BHS",
    "numericCode": "044",
    "firstLanguage": "en",
    "otherLanguages": [
      "ht"
    ],
    "currency": {
      "code": "BSD",
      "symbol": "$",
      "name": "Bahamian Dollar"
    },
    "government": {
      "type": "Parliamentary constitutional monarchy",
      "politicalLean": "Centre-right",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Cornelius A. Smith"
        },
        {
          "title": "Prime Minister",
          "name": "Philip Davis"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern Standard Time (EST)",
      "offset": "-05:00",
      "dst": "Yes"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 400516,
    "area": {
      "value": 13878,
      "unit": "km"
    },
    "capital": "Nassau",
    "gdp": {
      "nominal": "13.58 billion USD",
      "perCapita": "33,861 USD"
    },
    "dialingCode": "+1-242",
    "internetTLD": ".bs",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "919",
      "police": "919",
      "ambulance": "919"
    },
    "holidays": [
      "Independence Day (July 10)",
      "National Heroes Day (Second Monday in October)",
      "Christmas Day (December 25)",
      "Junkanoo (Boxing Day, December 26)"
    ],
    "nationalAnimal": "Flamingo",
    "nationalDish": "Rock Lobsters",
    "tourismHighlights": [
      "Nassau Paradise Island",
      "Exuma Cays Land and Sea Park",
      "The Great Blue Hole",
      "Atlantis Resort"
    ],
    "majorExports": [
      "Rum",
      "Electronic equipment",
      "Clothing"
    ],
    "majorImports": [
      "Food",
      "Fuels",
      "Machinery"
    ],
    "lifeExpectancy": 73.5,
    "literacyRate": 95.6,
    "climate": "Tropical with a wet season and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Bahá'í",
        "Hinduism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "United States (Cuba)",
      "Cuba"
    ],
    "visaRequirement": "No visa required for most countries, visa on arrival for others",
    "notableFacts": [
      "Known for its stunning beaches and clear waters.",
      "One of the highest per capita income levels in the Caribbean.",
      "The Bahamas is an archipelago consisting of 700 islands."
    ]
  },
  "BO": {
    "flag": "",
    "name": "Bolivia (Plurinational State of)",
    "officialName": "Plurinational State of Bolivia",
    "countryCode": "+591",
    "isoAlpha2": "BO",
    "isoAlpha3": "BOL",
    "numericCode": "068",
    "firstLanguage": "es",
    "otherLanguages": [
      "ay",
      "qu",
      "gn"
    ],
    "currency": {
      "code": "BOB",
      "symbol": "Bs",
      "name": "Bolivian Boliviano"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Left-wing",
      "headsOfState": [
        {
          "title": "President",
          "name": "Luis Arce"
        },
        {
          "title": "Vice President",
          "name": "David Choquehuanca"
        }
      ]
    },
    "timeZone": {
      "name": "Bolivia Time (BOT)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "South America",
    "subregion": "Andean",
    "population": 11673021,
    "area": {
      "value": 1098581,
      "unit": "km"
    },
    "capital": "Sucre",
    "administrativeCapital": "La Paz",
    "gdp": {
      "nominal": "43.30 billion USD",
      "perCapita": "3,706 USD"
    },
    "dialingCode": "+591",
    "internetTLD": ".bo",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "110",
      "fire": "119",
      "police": "110",
      "ambulance": "118"
    },
    "holidays": [
      "Independence Day (August 6)",
      "All Souls' Day (November 2)",
      "Carnival (Date varies)"
    ],
    "nationalAnimal": "Llama",
    "nationalDish": "Salteña",
    "tourismHighlights": [
      "Salar de Uyuni",
      "Lake Titicaca",
      "Madidi National Park",
      "Tiwanaku (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Natural gas",
      "Minerals",
      "Soybeans"
    ],
    "majorImports": [
      "Machinery",
      "Electric equipment",
      "Vehicles"
    ],
    "lifeExpectancy": 71.4,
    "literacyRate": 92.5,
    "climate": "Varies from tropical to cold mountain climate",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Indigenous beliefs",
        "Protestant"
      ]
    },
    "neighborCountries": [
      "Brazil",
      "Paraguay",
      "Argentina",
      "Chile",
      "Peru"
    ],
    "visaRequirement": "Visa required for many countries, but some enjoy visa-free access.",
    "notableFacts": [
      "Has the highest percentage of indigenous people in South America.",
      "Contains the world's largest salt flat, Salar de Uyuni.",
      "Lake Titicaca is the highest navigable lake in the world."
    ]
  },
  "BR": {
    "flag": "",
    "name": "Brazil",
    "officialName": "Federative Republic of Brazil",
    "countryCode": "+55",
    "isoAlpha2": "BR",
    "isoAlpha3": "BRA",
    "numericCode": "076",
    "firstLanguage": "pt",
    "otherLanguages": [
      "es",
      "en",
      "fr",
      "it"
    ],
    "currency": {
      "code": "BRL",
      "symbol": "R$",
      "name": "Brazilian Real"
    },
    "government": {
      "type": "Federal presidential constitutional republic",
      "politicalLean": "Varies by administration",
      "headsOfState": [
        {
          "title": "President",
          "name": "Luiz Inácio Lula da Silva"
        }
      ]
    },
    "timeZone": {
      "name": "Brasilia Time (BRT)",
      "offset": "-03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 213993437,
    "area": {
      "value": 8515767,
      "unit": "km"
    },
    "capital": "Brasília",
    "gdp": {
      "nominal": "2.05 trillion USD",
      "perCapita": "9,547 USD"
    },
    "dialingCode": "+55",
    "internetTLD": ".br",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "190",
      "fire": "193",
      "police": "190",
      "ambulance": "192"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (September 7)",
      "Tiradentes Day (April 21)",
      "Proclamation of the Republic (November 15)"
    ],
    "nationalAnimal": "Jaguar",
    "nationalDish": "Feijoada",
    "tourismHighlights": [
      "Christ the Redeemer",
      "Iguazu Falls",
      "Amazon Rainforest",
      "Copacabana Beach"
    ],
    "majorExports": [
      "Soybeans",
      "Iron ore",
      "Automobiles",
      "Coffee"
    ],
    "majorImports": [
      "Machinery",
      "Electronics",
      "Chemical products"
    ],
    "lifeExpectancy": 75.6,
    "literacyRate": 93.2,
    "climate": "Tropical, with a diverse range depending on the region",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Spiritism",
        "Umbanda",
        "Candomblé"
      ]
    },
    "neighborCountries": [
      "Argentina",
      "Bolivia",
      "Colombia",
      "Guyana",
      "Paraguay",
      "Peru",
      "Suriname",
      "Uruguay",
      "Venezuela"
    ],
    "visaRequirement": "Visa required for some nationalities, varies by purpose of travel",
    "notableFacts": [
      "Fifth largest country in the world by both area and population.",
      "Home to the Amazon Rainforest, the largest tropical rainforest on Earth.",
      "Known for its diverse culture, including music, dance, and festivals such as Carnival."
    ]
  },
  "BQ": {
    "flag": "",
    "name": "Bonaire, Sint Eustatius and Saba",
    "officialName": "Caribbean Netherlands",
    "countryCode": "+599",
    "isoAlpha2": "BQ",
    "isoAlpha3": "BES",
    "numericCode": "535",
    "firstLanguage": "nl",
    "otherLanguages": [
      "pap",
      "en"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Special municipality of the Netherlands",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Currently vacant"
        },
        {
          "title": "King",
          "name": "King of the Netherlands"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD-MM-YYYY",
    "timeFormat": "12-hour",
    "region": "Caribbean",
    "subregion": "Latin America",
    "population": 20600,
    "area": {
      "value": 294,
      "unit": "km"
    },
    "capital": "Kralendijk",
    "gdp": {
      "nominal": "200 million USD",
      "perCapita": "9,000 USD"
    },
    "dialingCode": "+599",
    "internetTLD": ".bq",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "115",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Carnival (February)",
      "King's Day (April 27)",
      "Dia di Ropa (first Friday of September)"
    ],
    "nationalAnimal": "Iguana",
    "nationalDish": "Stobá",
    "tourismHighlights": [
      "Diving at Bonaire National Marine Park",
      "Washington Slagbaai National Park",
      "Saba Lacepine",
      "Oranjestad (Statia's capital)"
    ],
    "majorExports": [
      "Tourism services",
      "Salt",
      "Fish"
    ],
    "majorImports": [
      "Food",
      "Construction materials",
      "Fuel"
    ],
    "lifeExpectancy": 78.4,
    "literacyRate": 99,
    "climate": "Tropical, warm and humid year-round with a dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Hinduism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (autonomous territories in the Caribbean)"
    ],
    "visaRequirement": "No visa required for EU/Schengen Area citizens and many others",
    "notableFacts": [
      "Part of the special municipalities of the Netherlands.",
      "Known for its coral reefs and marine biodiversity.",
      "Saba is home to the highest point in the Dutch Kingdom."
    ]
  },
  "BT": {
    "flag": "",
    "name": "Bhutan",
    "officialName": "Kingdom of Bhutan",
    "countryCode": "+975",
    "isoAlpha2": "BT",
    "isoAlpha3": "BTN",
    "numericCode": "064",
    "firstLanguage": "dz",
    "otherLanguages": [
      "ne",
      "en"
    ],
    "currency": {
      "code": "BTN",
      "symbol": "Nu.",
      "name": "Ngultrum"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "King",
          "name": "Jigme Khesar Namgyel Wangchuck"
        }
      ]
    },
    "timeZone": {
      "name": "Bhutan Time (BTT)",
      "offset": "+06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "South Asia",
    "population": 771608,
    "area": {
      "value": 38394,
      "unit": "km"
    },
    "capital": "Thimphu",
    "gdp": {
      "nominal": "2.38 billion USD",
      "perCapita": "3,086 USD"
    },
    "dialingCode": "+975",
    "internetTLD": ".bt",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "113",
      "fire": "110",
      "police": "113",
      "ambulance": "112"
    },
    "holidays": [
      "National Day (December 17)",
      "Buddha Purnima",
      "Tshechu (varies by district)"
    ],
    "nationalAnimal": "Takin",
    "nationalDish": "Ema Datshi",
    "tourismHighlights": [
      "Tiger's Nest Monastery",
      "Paro Valley",
      "Thimphu Dzong",
      "Bumthang Valley"
    ],
    "majorExports": [
      "Hydropower",
      "Cardamom",
      "Handicrafts"
    ],
    "majorImports": [
      "Petroleum products",
      "Consumer goods",
      "Machinery"
    ],
    "lifeExpectancy": 72.3,
    "literacyRate": 71.4,
    "climate": "Varies from subtropical in the south to temperate in the central regions and alpine in the north",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Hinduism",
        "Bon"
      ]
    },
    "neighborCountries": [
      "China",
      "India"
    ],
    "visaRequirement": "Tourist visa required for most nationalities; some are exempt.",
    "notableFacts": [
      "Known for its unique measure of Gross National Happiness (GNH).",
      "One of the last remaining Buddhist kingdoms in the world.",
      "Banned the use of plastic bags and prioritizes environmental conservation."
    ]
  },
  "CA": {
    "flag": "",
    "name": "Canada",
    "officialName": "Canada",
    "countryCode": "+1",
    "isoAlpha2": "CA",
    "isoAlpha3": "CAN",
    "numericCode": "124",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr"
    ],
    "currency": {
      "code": "CAD",
      "symbol": "$",
      "name": "Canadian Dollar"
    },
    "government": {
      "type": "Parliamentary democracy and constitutional monarchy",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "Monarch",
          "name": "King Charles III"
        },
        {
          "title": "Prime Minister",
          "name": "Justin Trudeau"
        }
      ]
    },
    "timeZone": {
      "name": "Multiple Time Zones",
      "offset": [
        "-08:00",
        "-07:00",
        "-06:00",
        "-05:00",
        "-04:00"
      ],
      "dst": "Yes"
    },
    "dateFormat": "YYYY-MM-DD",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Northern America",
    "population": 38958000,
    "area": {
      "value": 9984670,
      "unit": "km"
    },
    "capital": "Ottawa",
    "gdp": {
      "nominal": "2.14 trillion USD",
      "perCapita": "54,100 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".ca",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Canada Day (July 1)",
      "Thanksgiving (second Monday in October)",
      "Christmas (December 25)",
      "Victoria Day (Monday preceding May 25)"
    ],
    "nationalAnimal": "Beaver",
    "nationalDish": "Poutine",
    "tourismHighlights": [
      "Niagara Falls",
      "Banff National Park",
      "Old Quebec (UNESCO World Heritage Site)",
      "CN Tower"
    ],
    "majorExports": [
      "Automobiles",
      "Petroleum",
      "Natural gas",
      "Wood products"
    ],
    "majorImports": [
      "Automobiles",
      "Electronics",
      "Machinery",
      "Consumer goods"
    ],
    "lifeExpectancy": 82.3,
    "literacyRate": 99,
    "climate": "Varies from coastal to continental; generally cold winters and warm summers",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Islam",
        "Hinduism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "United States"
    ],
    "visaRequirement": "Visa required for some countries; ETA required for certain foreign travelers",
    "notableFacts": [
      "Canada is the second-largest country in the world by land area.",
      "It has the longest coastline of any country, stretching over 202,080 kilometers.",
      "Canada is known for its multicultural society and is home to a large immigrant population."
    ]
  },
  "BY": {
    "flag": "",
    "name": "Belarus",
    "officialName": "Republic of Belarus",
    "countryCode": "+375",
    "isoAlpha2": "BY",
    "isoAlpha3": "BLR",
    "numericCode": "112",
    "firstLanguage": "be",
    "otherLanguages": [
      "ru"
    ],
    "currency": {
      "code": "BYN",
      "symbol": "Br",
      "name": "Belarusian Ruble"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Alexander Lukashenko"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "population": 9449323,
    "area": {
      "value": 207600,
      "unit": "km"
    },
    "capital": "Minsk",
    "gdp": {
      "nominal": "64.43 billion USD",
      "perCapita": "6,817 USD"
    },
    "dialingCode": "+375",
    "internetTLD": ".by",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Independence Day (July 3)",
      "St. Valentine's Day (February 14)"
    ],
    "nationalAnimal": "European Bison",
    "nationalDish": "Draniki",
    "tourismHighlights": [
      "Brest Hero-Fortress",
      "Mir Castle",
      "Nesvizh Castle",
      "Belovezhskaya Pushcha National Park (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Machinery",
      "Textiles",
      "Fertilizers"
    ],
    "majorImports": [
      "Mineral products",
      "Machinery",
      "Food"
    ],
    "lifeExpectancy": 75.5,
    "literacyRate": 99.8,
    "climate": "Continental, with cold winters and warm summers",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Roman Catholic",
        "Protestant",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Latvia",
      "Lithuania",
      "Poland",
      "Ukraine",
      "Russia"
    ],
    "visaRequirement": "Visa required for many countries, including USA and EU states",
    "notableFacts": [
      "Known for its rich history, particularly from the Grand Duchy of Lithuania.",
      "Has a well-preserved Soviet-era infrastructure.",
      "Famous for its forests and national parks, hosting diverse wildlife."
    ]
  },
  "BW": {
    "flag": "",
    "name": "Botswana",
    "officialName": "Republic of Botswana",
    "countryCode": "+267",
    "isoAlpha2": "BW",
    "isoAlpha3": "BWA",
    "numericCode": "072",
    "firstLanguage": "en",
    "otherLanguages": [
      "tswana",
      "kalanga",
      "skaranga",
      "deaf sign language"
    ],
    "currency": {
      "code": "BWP",
      "symbol": "P",
      "name": "Botswana Pula"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Mokgweetsi Masisi"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Southern Africa",
    "population": 2291688,
    "area": {
      "value": 581730,
      "unit": "km"
    },
    "capital": "Gaborone",
    "gdp": {
      "nominal": "19.28 billion USD",
      "perCapita": "8,188 USD"
    },
    "dialingCode": "+267",
    "internetTLD": ".bw",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "993",
      "police": "999",
      "ambulance": "997"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (September 30)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "African Fish Eagle",
    "nationalDish": "Seswaa",
    "tourismHighlights": [
      "Okavango Delta (UNESCO World Heritage Site)",
      "Chobe National Park",
      "Moremi Game Reserve",
      "Tsodilo Hills (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Diamonds",
      "Copper",
      "Nickel",
      "Beef"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Transport equipment"
    ],
    "lifeExpectancy": 69.7,
    "literacyRate": 88.5,
    "climate": "Semi-arid with a dry season and a rainy season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Namibia",
      "South Africa",
      "Zambia"
    ],
    "visaRequirement": "Visa-free for many nationalities, including EU, USA, and Commonwealth countries.",
    "notableFacts": [
      "Botswana is one of the world's largest producers of diamonds.",
      "It is known for its stable political environment and economic growth.",
      "The country has a high rate of wildlife and conservation areas."
    ]
  },
  "BZ": {
    "flag": "",
    "name": "Belize",
    "officialName": "Belize",
    "countryCode": "+501",
    "isoAlpha2": "BZ",
    "isoAlpha3": "BLZ",
    "numericCode": "084",
    "firstLanguage": "en",
    "otherLanguages": [
      "es",
      "kreol"
    ],
    "currency": {
      "code": "BZD",
      "symbol": "$",
      "name": "Belize Dollar"
    },
    "government": {
      "type": "Parliamentary democracy and constitutional monarchy",
      "politicalLean": "Center-left",
      "headsOfState": [
        {
          "title": "Queen",
          "name": "Elizabeth II"
        },
        {
          "title": "Prime Minister",
          "name": "John Briceño"
        }
      ]
    },
    "timeZone": {
      "name": "Central Standard Time (CST)",
      "offset": "-06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Central America",
    "population": 419199,
    "area": {
      "value": 22966,
      "unit": "km"
    },
    "capital": "Belmopan",
    "gdp": {
      "nominal": "2.01 billion USD",
      "perCapita": "4,850 USD"
    },
    "dialingCode": "+501",
    "internetTLD": ".bz",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "90",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (September 21)",
      "Garifuna Settlement Day (November 19)"
    ],
    "nationalAnimal": "Jaguar",
    "nationalDish": "Rice and Beans",
    "tourismHighlights": [
      "Blue Hole National Park",
      "Great Barrier Reef",
      "Mayan Ruins of Tikal",
      "Ambergris Caye"
    ],
    "majorExports": [
      "Sugar",
      "Bananas",
      "Garment",
      "Crude Petroleum"
    ],
    "majorImports": [
      "Fuel",
      "Machinery",
      "Food products"
    ],
    "lifeExpectancy": 74.5,
    "literacyRate": 77.9,
    "climate": "Tropical; rainy season from June to November",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Maya beliefs",
        "Buddhism",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Mexico",
      "Guatemala"
    ],
    "visaRequirement": "Visa required for some nationalities; others can enter visa-free for up to 30 days.",
    "notableFacts": [
      "Belize is the only country in Central America where English is the official language.",
      "Home to the second-longest barrier reef in the world.",
      "Has the largest population of jaguars in Central America."
    ]
  },
  "CC": {
    "flag": "",
    "name": "Cocos (Keeling) Islands",
    "officialName": "Territory of Cocos (Keeling) Islands",
    "countryCode": "+6189162",
    "isoAlpha2": "CC",
    "isoAlpha3": "CCK",
    "numericCode": "166",
    "firstLanguage": "en",
    "otherLanguages": [
      "ms"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "A$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Territory of Australia",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Governor-General of Australia"
        }
      ]
    },
    "timeZone": {
      "name": "Cocos Islands Time (CCT)",
      "offset": "+06:30",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "population": 600,
    "area": {
      "value": 14,
      "unit": "km"
    },
    "capital": "West Island",
    "gdp": {
      "nominal": "Not publicly available",
      "perCapita": "Not publicly available"
    },
    "dialingCode": "+6189162",
    "internetTLD": ".cc",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "000",
      "fire": "000",
      "police": "000",
      "ambulance": "000"
    },
    "holidays": [
      "Cocos Day (November 18)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Coconut Crab",
    "nationalDish": "Cocos Curry",
    "tourismHighlights": [
      "Coconut Palm Beach",
      "Hiking the Island Trails",
      "Snorkeling in the Atoll"
    ],
    "majorExports": [
      "Coconuts",
      "Copra"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Clothing"
    ],
    "lifeExpectancy": 80.1,
    "literacyRate": 99,
    "climate": "Tropical with a wet season and a dry season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "None"
      ]
    },
    "neighborCountries": [
      "Australia"
    ],
    "visaRequirement": "No visa required for Australian citizens; various visa requirements apply to others",
    "notableFacts": [
      "Part of Australia but has its own unique culture and traditions.",
      "Known for its beautiful beaches and marine life.",
      "Limited access to amenities; most supplies are imported."
    ]
  },
  "CH": {
    "flag": "",
    "name": "Switzerland",
    "officialName": "Swiss Confederation",
    "countryCode": "+41",
    "isoAlpha2": "CH",
    "isoAlpha3": "CHE",
    "numericCode": "756",
    "firstLanguage": "de",
    "otherLanguages": [
      "fr",
      "it",
      "rm"
    ],
    "currency": {
      "code": "CHF",
      "symbol": "Fr",
      "name": "Swiss Franc"
    },
    "government": {
      "type": "Federal semi-direct democracy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "President of the Swiss Confederation",
          "name": "Alain Berset"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 8710000,
    "area": {
      "value": 41285,
      "unit": "km"
    },
    "capital": "Bern",
    "gdp": {
      "nominal": "824.7 billion USD",
      "perCapita": "94,696 USD"
    },
    "dialingCode": "+41",
    "internetTLD": ".ch",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "117",
      "ambulance": "144"
    },
    "holidays": [
      "Swiss National Day (August 1)",
      "Federal Day of Thanksgiving (third Sunday in September)"
    ],
    "nationalAnimal": "Cow",
    "nationalDish": "Fondue",
    "tourismHighlights": [
      "The Matterhorn",
      "Lake Geneva",
      "Jungfrau Region",
      "Interlaken"
    ],
    "majorExports": [
      "Pharmaceuticals",
      "Machinery",
      "Chemicals"
    ],
    "majorImports": [
      "Machinery",
      "Metals",
      "Textiles"
    ],
    "lifeExpectancy": 83.6,
    "literacyRate": 99,
    "climate": "Varies from temperate in the plains to alpine in the mountains",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Buddhism",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "France",
      "Germany",
      "Italy",
      "Austria",
      "Liechtenstein"
    ],
    "visaRequirement": "No visa required for Schengen Area countries and many others",
    "notableFacts": [
      "Home to numerous international organizations, including the Red Cross.",
      "Known for its neutrality and non-involvement in military conflicts.",
      "Has a high standard of living and is often ranked among the best countries to live in."
    ]
  },
  "CF": {
    "flag": "",
    "name": "Central African Republic",
    "officialName": "Central African Republic",
    "countryCode": "+236",
    "isoAlpha2": "CF",
    "isoAlpha3": "CAF",
    "numericCode": "140",
    "firstLanguage": "sg",
    "otherLanguages": [
      "fr",
      "en"
    ],
    "currency": {
      "code": "XAF",
      "symbol": "FCFA",
      "name": "Central African CFA franc"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Faustin-Archange Touadéra"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 5496064,
    "area": {
      "value": 622984,
      "unit": "km"
    },
    "capital": "Bangui",
    "gdp": {
      "nominal": "2.34 billion USD",
      "perCapita": "426 USD"
    },
    "dialingCode": "+236",
    "internetTLD": ".cf",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "117",
      "fire": "No specific number",
      "police": "116",
      "ambulance": "No specific number"
    },
    "holidays": [
      "Independence Day (August 13)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "African Elephant",
    "nationalDish": "Cassava and Groundnut Stew",
    "tourismHighlights": [
      "Boga Falls",
      "Manovo-Gounda St. Floris National Park (UNESCO World Heritage Site)",
      "Dzanga-Sangha Reserve",
      "Boali Waterfalls"
    ],
    "majorExports": [
      "Diamonds",
      "Timber",
      "Cotton"
    ],
    "majorImports": [
      "Food products",
      "Machinery",
      "Fuels"
    ],
    "lifeExpectancy": 53.7,
    "literacyRate": 37.4,
    "climate": "Tropical with distinct wet and dry seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Indigenous beliefs",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Cameroon",
      "Republic of the Congo",
      "Democratic Republic of the Congo",
      "South Sudan",
      "Chad"
    ],
    "visaRequirement": "Visa required for most countries",
    "notableFacts": [
      "Rich in natural resources, especially diamonds and timber.",
      "Has been affected by civil conflict and instability in recent decades.",
      "Home to numerous ethnic groups and a rich cultural heritage."
    ]
  },
  "CD": {
    "flag": "",
    "name": "Congo",
    "officialName": "Democratic Republic of the Congo",
    "countryCode": "+243",
    "isoAlpha2": "CD",
    "isoAlpha3": "COD",
    "numericCode": "180",
    "firstLanguage": "fr",
    "otherLanguages": [
      "ln",
      "sw",
      "kg"
    ],
    "currency": {
      "code": "CDF",
      "symbol": "FC",
      "name": "Congolese Franc"
    },
    "government": {
      "type": "Semi-presidential republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Félix Tshisekedi"
        },
        {
          "title": "Prime Minister",
          "name": "Jean-Michel Lokolo"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 102262000,
    "area": {
      "value": 2344858,
      "unit": "km"
    },
    "capital": "Kinshasa",
    "gdp": {
      "nominal": "50.7 billion USD",
      "perCapita": "491 USD"
    },
    "dialingCode": "+243",
    "internetTLD": ".cd",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "117",
      "ambulance": "121"
    },
    "holidays": [
      "Independence Day (June 30)",
      "Revolution Day (January 16)"
    ],
    "nationalAnimal": "Lecuma",
    "nationalDish": "Saka Saka",
    "tourismHighlights": [
      "Virunga National Park",
      "Okapi Wildlife Reserve (UNESCO World Heritage Site)",
      "Kisangani Falls",
      "Lake Tanganyika"
    ],
    "majorExports": [
      "Cobalt",
      "Copper",
      "Diamonds"
    ],
    "majorImports": [
      "Textiles",
      "Food",
      "Machinery"
    ],
    "lifeExpectancy": 60.5,
    "literacyRate": 77,
    "climate": "Tropical; two rainy seasons and a dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Kimbanguism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Angola",
      "Republic of the Congo",
      "Central African Republic",
      "South Sudan",
      "Uganda",
      "Rwanda",
      "Burundi"
    ],
    "visaRequirement": "Visa required for most foreign nationals.",
    "notableFacts": [
      "Home to the Congo River, the second longest river in Africa.",
      "Has vast mineral wealth, particularly in cobalt and diamond reserves.",
      "Experiences significant biodiversity with various species unique to the region."
    ]
  },
  "CG": {
    "flag": "",
    "name": "Congo",
    "officialName": "Republic of the Congo",
    "countryCode": "+242",
    "isoAlpha2": "CG",
    "isoAlpha3": "COG",
    "numericCode": "178",
    "firstLanguage": "fr",
    "otherLanguages": [
      "lingala",
      "kituba",
      "english"
    ],
    "currency": {
      "code": "CFA",
      "symbol": "CFA",
      "name": "Central African CFA franc"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Denis Sassou Nguesso"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 5500000,
    "area": {
      "value": 342000,
      "unit": "km"
    },
    "capital": "Brazzaville",
    "gdp": {
      "nominal": "11.80 billion USD",
      "perCapita": "2,140 USD"
    },
    "dialingCode": "+242",
    "internetTLD": ".cg",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "117",
      "fire": "118",
      "police": "116",
      "ambulance": "119"
    },
    "holidays": [
      "Independence Day (August 15)",
      "International Women's Day (March 8)"
    ],
    "nationalAnimal": "African Grey Parrot",
    "nationalDish": "Saka Saka",
    "tourismHighlights": [
      "Nouabalé-Ndoki National Park",
      "Odzala-Kokoua National Park",
      "Mikongo Lodge",
      "Bacongo Market"
    ],
    "majorExports": [
      "Oil",
      "Timber",
      "Minerals"
    ],
    "majorImports": [
      "Machinery",
      "Food products",
      "Pharmaceuticals"
    ],
    "lifeExpectancy": 64.2,
    "literacyRate": 79.5,
    "climate": "Tropical; with a wet season from November to April",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Traditional African religions",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Gabon",
      "Cameroon",
      "Central African Republic",
      "Democratic Republic of the Congo"
    ],
    "visaRequirement": "Visa required for most travelers; e-visa options available.",
    "notableFacts": [
      "Home to a rich variety of wildlife and forests, including gorillas.",
      "Renowned for its diverse cultures and ethnicities, with over 60 ethnic groups.",
      "The Congo River is the second longest river in Africa."
    ]
  },
  "CK": {
    "flag": "",
    "name": "Cook Islands",
    "officialName": "Cook Islands",
    "countryCode": "+682",
    "isoAlpha2": "CK",
    "isoAlpha3": "COK",
    "numericCode": "184",
    "firstLanguage": "en",
    "otherLanguages": [
      "rn"
    ],
    "currency": {
      "code": "NZD",
      "symbol": "$",
      "name": "New Zealand Dollar"
    },
    "government": {
      "type": "Parliamentary democracy in free association with New Zealand",
      "politicalLean": "Center-Left",
      "headsOfState": [
        {
          "title": "Queen",
          "name": "King Charles III"
        },
        {
          "title": "Prime Minister",
          "name": "Mark Brown"
        }
      ]
    },
    "timeZone": {
      "name": "Cook Island Time (CKT)",
      "offset": "-10:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 17564,
    "area": {
      "value": 236,
      "unit": "km"
    },
    "capital": "Avarua",
    "gdp": {
      "nominal": "0.23 billion USD",
      "perCapita": "13,080 USD"
    },
    "dialingCode": "+682",
    "internetTLD": ".ck",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "111",
      "police": "999",
      "ambulance": "111"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Cook Islands Constitution Day (August 4)"
    ],
    "nationalAnimal": "Takahe",
    "nationalDish": "Ika Mata",
    "tourismHighlights": [
      "Rarotonga",
      "Aitutaki Lagoon",
      "Muri Beach",
      "Te Vara Nui Village"
    ],
    "majorExports": [
      "Copra",
      "Marine products",
      "Pearls"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Machinery"
    ],
    "lifeExpectancy": 76.9,
    "literacyRate": 90,
    "climate": "Tropical with a wet season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Bahá'í",
        "Société de Mission",
        "Maori religious practices"
      ]
    },
    "neighborCountries": [
      "New Zealand"
    ],
    "visaRequirement": "No visa required for most countries",
    "notableFacts": [
      "Self-governing in free association with New Zealand since 1965.",
      "Renowned for its stunning turquoise lagoons and coral reefs.",
      "The Cook Islands have a high level of autonomy while relying on New Zealand for defense."
    ]
  },
  "CI": {
    "flag": "",
    "name": "Côte D'Ivoire",
    "officialName": "Republic of Côte d'Ivoire",
    "countryCode": "+225",
    "isoAlpha2": "CI",
    "isoAlpha3": "CIV",
    "numericCode": "384",
    "firstLanguage": "fr",
    "otherLanguages": [
      "baoulé",
      "bété",
      "anyin",
      "dan",
      "krou",
      "jula"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "",
      "name": "West African CFA Franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Alassane Ouattara"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Western Africa",
    "population": 26378000,
    "area": {
      "value": 322463,
      "unit": "km"
    },
    "capital": "Yamoussoukro",
    "gdp": {
      "nominal": "70.99 billion USD",
      "perCapita": "2,688 USD"
    },
    "dialingCode": "+225",
    "internetTLD": ".ci",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "20"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (August 7)",
      "Fête de la Musique (June 21)"
    ],
    "nationalAnimal": "African elephant",
    "nationalDish": "Fufu and soup",
    "tourismHighlights": [
      "Basilee National Park",
      "Assinie Beach",
      "Cocody Market",
      "Ebrié Lagoon"
    ],
    "majorExports": [
      "Cocoa beans",
      "Cashew nuts",
      "Oil palm",
      "Rubber"
    ],
    "majorImports": [
      "Food products",
      "Petroleum",
      "Capital goods"
    ],
    "lifeExpectancy": 57.7,
    "literacyRate": 77.2,
    "climate": "Tropical; wet and dry seasons",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Ghana",
      "Burkina Faso",
      "Mali",
      "Liberia",
      "Guinea"
    ],
    "visaRequirement": "Visa required for most countries except for ECOWAS nations and a few others",
    "notableFacts": [
      "World's largest producer of cocoa.",
      "Home to a diverse array of ethnic groups and languages.",
      "Has experienced significant political changes since gaining independence from France in 1960."
    ]
  },
  "CM": {
    "flag": "",
    "name": "Cameroon",
    "officialName": "Republic of Cameroon",
    "countryCode": "+237",
    "isoAlpha2": "CM",
    "isoAlpha3": "CMR",
    "numericCode": "120",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "ful",
      "pcm",
      "es"
    ],
    "currency": {
      "code": "XAF",
      "symbol": "FCFA",
      "name": "Central African CFA franc"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Paul Biya"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 29910331,
    "area": {
      "value": 475442,
      "unit": "km"
    },
    "capital": "Yaoundé",
    "gdp": {
      "nominal": "45.64 billion USD",
      "perCapita": "1,525 USD"
    },
    "dialingCode": "+237",
    "internetTLD": ".cm",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "117",
      "ambulance": "n/a"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "International Women's Day (March 8)",
      "Labour Day (May 1)",
      "Ascension Day (date varies)",
      "Eid al-Fitr (date varies)",
      "Independence Day (January 1)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "African Grey Parrot",
    "nationalDish": "Ndole",
    "tourismHighlights": [
      "Mount Cameroon",
      "Waza National Park",
      "Kribi Beaches",
      "Dja Faunal Reserve (UNESCO World Heritage Site)",
      "Limbe Botanic Garden"
    ],
    "majorExports": [
      "Crude petroleum",
      "Cocoa beans",
      "Timber",
      "Cotton"
    ],
    "majorImports": [
      "Rice",
      "Cement",
      "Machinery",
      "Food products"
    ],
    "lifeExpectancy": 59.5,
    "literacyRate": 77.1,
    "climate": "Tropical; varies with topography",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Nigeria",
      "Chad",
      "Central African Republic",
      "Republic of the Congo",
      "Equatorial Guinea"
    ],
    "visaRequirement": "Visa required for most foreign nationals.",
    "notableFacts": [
      "Known as 'Africa in miniature' due to its diversity in cultural and geographical features.",
      "Home to over 250 indigenous languages.",
      "Rich in natural resources, including oil, timber, and minerals."
    ]
  },
  "CL": {
    "flag": "",
    "name": "Chile",
    "officialName": "Republic of Chile",
    "countryCode": "+56",
    "isoAlpha2": "CL",
    "isoAlpha3": "CHL",
    "numericCode": "152",
    "firstLanguage": "es",
    "otherLanguages": [
      "mapudungun",
      "quechua"
    ],
    "currency": {
      "code": "CLP",
      "symbol": "$",
      "name": "Chilean Peso"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Center-Left to Left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Gabriel Boric"
        }
      ]
    },
    "timeZone": {
      "name": "Chile Standard Time (CLT)",
      "offset": "-03:00",
      "dst": "Yes"
    },
    "dateFormat": "DD-MM-YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 19116201,
    "area": {
      "value": 756102,
      "unit": "km"
    },
    "capital": "Santiago",
    "gdp": {
      "nominal": "482.12 billion USD",
      "perCapita": "25,198 USD"
    },
    "dialingCode": "+56",
    "internetTLD": ".cl",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "133",
      "fire": "132",
      "police": "134",
      "ambulance": "131"
    },
    "holidays": [
      "Independence Day (September 18)",
      "National Day of Indigenous Peoples (June 24)",
      "All Saints' Day (November 1)"
    ],
    "nationalAnimal": "Andean Condor",
    "nationalDish": "Pastel de Choclo",
    "tourismHighlights": [
      "Easter Island (Rapa Nui)",
      "Atacama Desert",
      "Torres del Paine National Park",
      "Santiago's Plaza de Armas"
    ],
    "majorExports": [
      "Copper",
      "Fruit",
      "Fishmeal"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum",
      "Vehicles"
    ],
    "lifeExpectancy": 80.7,
    "literacyRate": 96.4,
    "climate": "Varies from desert in the north to temperate in the central region and tundra in the south",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Evangelical",
        "Atheist/Agnostic",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Argentina",
      "Bolivia",
      "Peru"
    ],
    "visaRequirement": "Visa required for some countries; visa-free for many others, including EU and US citizens.",
    "notableFacts": [
      "Chile is home to the world's largest pool located at the San Alfonso del Mar resort.",
      "Has one of the longest north-south stretches of any country in the world.",
      "Renowned for its wine production, particularly in the Central Valley."
    ]
  },
  "CN": {
    "flag": "",
    "name": "China",
    "officialName": "People's Republic of China",
    "countryCode": "+86",
    "isoAlpha2": "CN",
    "isoAlpha3": "CHN",
    "numericCode": "156",
    "firstLanguage": "zh",
    "otherLanguages": [
      "zh-yue",
      "zh-wuu",
      "zh-min",
      "zh-hak",
      " minority languages such as Tibetan, Uighur"
    ],
    "currency": {
      "code": "CNY",
      "symbol": "",
      "name": "Renminbi"
    },
    "government": {
      "type": "Single-party socialist republic",
      "politicalLean": "Communist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Xi Jinping"
        }
      ]
    },
    "timeZone": {
      "name": "China Standard Time (CST)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "YYYY-MM-DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "East Asia",
    "population": 1411778724,
    "area": {
      "value": 9600000,
      "unit": "km"
    },
    "capital": "Beijing",
    "gdp": {
      "nominal": "17.73 trillion USD",
      "perCapita": "12,556 USD"
    },
    "dialingCode": "+86",
    "internetTLD": ".cn",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "110",
      "fire": "119",
      "police": "110",
      "ambulance": "120"
    },
    "holidays": [
      "Chinese New Year",
      "National Day (October 1)",
      "Mid-Autumn Festival"
    ],
    "nationalAnimal": "Giant Panda",
    "nationalDish": "Peking Duck",
    "tourismHighlights": [
      "Great Wall of China",
      "Forbidden City",
      "Terracotta Army",
      "Zhangjiajie National Forest Park"
    ],
    "majorExports": [
      "Electronics",
      "Machinery",
      "Furniture",
      "Clothing"
    ],
    "majorImports": [
      "Electrical machinery",
      "Crude oil",
      "Iron ore",
      "Soybeans"
    ],
    "lifeExpectancy": 77.9,
    "literacyRate": 96.8,
    "climate": "Varies by region, generally temperate with four distinct seasons",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Taoism",
        "Christianity",
        "Islam",
        "Folk religions"
      ]
    },
    "neighborCountries": [
      "India",
      "Russia",
      "Pakistan",
      "Nepal",
      "Mongolia",
      "Vietnam",
      "Laos",
      "North Korea",
      "Kazakhstan",
      "Tajikistan",
      "Kyrgyzstan",
      "Afghanistan",
      "Bhutan",
      "Myanmar"
    ],
    "visaRequirement": "Visa required for most foreigners, visa-free access for certain countries.",
    "notableFacts": [
      "The most populous country in the world.",
      "Home to one of the world's oldest civilizations.",
      "Houses the world's highest mountain, Mount Everest."
    ]
  },
  "CV": {
    "flag": "",
    "name": "Cape Verde",
    "officialName": "Republic of Cabo Verde",
    "countryCode": "+238",
    "isoAlpha2": "CV",
    "isoAlpha3": "CPV",
    "numericCode": "132",
    "firstLanguage": "pt",
    "otherLanguages": [
      "cr",
      "en"
    ],
    "currency": {
      "code": "CVE",
      "symbol": "$",
      "name": "Cape Verdean Escudo"
    },
    "government": {
      "type": "Presidential representative democratic republic",
      "politicalLean": "Multi-party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "José Maria Neves"
        }
      ]
    },
    "timeZone": {
      "name": "Cape Verde Time (CVT)",
      "offset": "-01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Western Africa",
    "population": 550000,
    "area": {
      "value": 4033,
      "unit": "km"
    },
    "capital": "Praia",
    "gdp": {
      "nominal": "2.0 billion USD",
      "perCapita": "3,600 USD"
    },
    "dialingCode": "+238",
    "internetTLD": ".cv",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "131",
      "fire": "132",
      "police": "133",
      "ambulance": "134"
    },
    "holidays": [
      "Islands Day (January 13)",
      "Independence Day (July 5)"
    ],
    "nationalAnimal": "Cabo Verdean Black-billed Cuckoo",
    "nationalDish": "Cachupa",
    "tourismHighlights": [
      "Sal Island",
      "Santiago Island",
      "Boa Vista Island",
      "Fogo Volcano"
    ],
    "majorExports": [
      "Fish",
      "Footwear",
      "Agricultural products"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuels"
    ],
    "lifeExpectancy": 73.5,
    "literacyRate": 90.7,
    "climate": "Tropical dry, with a distinct rainy season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "African traditional religions",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (island country)"
    ],
    "visaRequirement": "Visa required for some nationalities; visa on arrival available for others.",
    "notableFacts": [
      "An archipelago consisting of 10 volcanic islands and several smaller islets.",
      "Known for its Creole culture and vibrant music scene.",
      "Has a stable democracy and is one of the most developed countries in West Africa."
    ]
  },
  "CR": {
    "flag": "",
    "name": "Costa Rica",
    "officialName": "Republic of Costa Rica",
    "countryCode": "+506",
    "isoAlpha2": "CR",
    "isoAlpha3": "CRI",
    "numericCode": "188",
    "firstLanguage": "es",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "CRC",
      "symbol": "",
      "name": "Costa Rican Colón"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Rodrigo Chaves Robles"
        }
      ]
    },
    "timeZone": {
      "name": "Central Standard Time (CST)",
      "offset": "-06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Central America",
    "population": 5128584,
    "area": {
      "value": 51100,
      "unit": "km"
    },
    "capital": "San José",
    "gdp": {
      "nominal": "62.98 billion USD",
      "perCapita": "12,253 USD"
    },
    "dialingCode": "+506",
    "internetTLD": ".cr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "118",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Day of the Juan Santamaría (April 11)",
      "Labor Day (May 1)",
      "Independence Day (September 15)"
    ],
    "nationalAnimal": "Yigüirro (Clay-colored Thrush)",
    "nationalDish": "Gallo Pinto",
    "tourismHighlights": [
      "Arenal Volcano",
      "Monteverde Cloud Forest",
      "Manuel Antonio National Park",
      "Tortuguero National Park"
    ],
    "majorExports": [
      "Bananas",
      "Pineapple",
      "Coffee",
      "Medical Devices"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum",
      "Food",
      "Chemicals"
    ],
    "lifeExpectancy": 81.5,
    "literacyRate": 97.8,
    "climate": "Tropical with a dry season and a wet season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Atheism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Nicaragua",
      "Panama"
    ],
    "visaRequirement": "No visa required for many nationalities for stays of up to 90 days",
    "notableFacts": [
      "One of the most biodiverse countries in the world.",
      "Has no standing army since 1949.",
      "Known for its commitment to environmental sustainability."
    ]
  },
  "CO": {
    "flag": "",
    "name": "Colombia",
    "officialName": "Republic of Colombia",
    "countryCode": "+57",
    "isoAlpha2": "CO",
    "isoAlpha3": "COL",
    "numericCode": "170",
    "firstLanguage": "es",
    "otherLanguages": [
      "Wayuu",
      "Palenquero",
      "Emberá"
    ],
    "currency": {
      "code": "COP",
      "symbol": "$",
      "name": "Colombian Peso"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Gustavo Petro"
        }
      ]
    },
    "timeZone": {
      "name": "Colombia Time (COT)",
      "offset": "-05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 50882891,
    "area": {
      "value": 1141748,
      "unit": "km"
    },
    "capital": "Bogotá",
    "gdp": {
      "nominal": "400.38 billion USD",
      "perCapita": "7,850 USD"
    },
    "dialingCode": "+57",
    "internetTLD": ".co",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "123",
      "fire": "119",
      "police": "123",
      "ambulance": "125"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (July 20)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Condor",
    "nationalDish": "Bandeja Paisa",
    "tourismHighlights": [
      "Cartagena's Historic Walled City",
      "Tayrona National Natural Park",
      "Coffee Cultural Landscape",
      "San Basilio de Palenque (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Petroleum",
      "Coffee",
      "Emeralds"
    ],
    "majorImports": [
      "Machinery",
      "Consumer goods",
      "Chemicals"
    ],
    "lifeExpectancy": 77.3,
    "literacyRate": 94.7,
    "climate": "Varied; tropical along the coast and cooler in the highlands",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Indigenous beliefs",
        "Others"
      ]
    },
    "neighborCountries": [
      "Venezuela",
      "Brazil",
      "Peru",
      "Ecuador",
      "Panama"
    ],
    "visaRequirement": "Visa required for some countries; no visa required for several Latin American nations.",
    "notableFacts": [
      "One of the world's largest producers of coffee and flowers.",
      "Home to the Amazon rainforest and the Andes mountains.",
      "Celebrated for its diverse culture and music, including Cumbia and Vallenato."
    ]
  },
  "CU": {
    "flag": "",
    "name": "Cuba",
    "officialName": "Republic of Cuba",
    "countryCode": "+53",
    "isoAlpha2": "CU",
    "isoAlpha3": "CUB",
    "numericCode": "192",
    "firstLanguage": "es",
    "otherLanguages": [
      "en",
      "fr",
      "ht"
    ],
    "currency": {
      "code": "CUP",
      "symbol": "",
      "name": "Cuban Peso"
    },
    "government": {
      "type": "Socialist state",
      "politicalLean": "Communist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Miguel Díaz-Canel"
        }
      ]
    },
    "timeZone": {
      "name": "Cuba Standard Time (CST)",
      "offset": "-05:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 11333483,
    "area": {
      "value": 109884,
      "unit": "km"
    },
    "capital": "Havana",
    "gdp": {
      "nominal": "100.02 billion USD",
      "perCapita": "8,834 USD"
    },
    "dialingCode": "+53",
    "internetTLD": ".cu",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "105",
      "police": "106",
      "ambulance": "104"
    },
    "holidays": [
      "Triumph of the Revolution Day (January 1)",
      "International Workers' Day (May 1)",
      "Revolution Day (July 26)"
    ],
    "nationalAnimal": "Cuban Trogon",
    "nationalDish": "Ropa Vieja",
    "tourismHighlights": [
      "Old Havana (UNESCO World Heritage Site)",
      "Varadero Beach",
      "Viñales Valley (UNESCO World Heritage Site)",
      "Cayo Coco"
    ],
    "majorExports": [
      "Tobacco",
      "Nickel",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Petroleum",
      "Food",
      "Machinery"
    ],
    "lifeExpectancy": 79.5,
    "literacyRate": 99.8,
    "climate": "Tropical; moderated by trade winds, with a dry season from November to April",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Santería",
        "None"
      ]
    },
    "neighborCountries": [
      "United States (via the Florida Strait)",
      "Bahamas",
      "Jamaica"
    ],
    "visaRequirement": "Visa required for most nationalities",
    "notableFacts": [
      "Cuba has a high literacy rate and free healthcare system.",
      "The country is known for its classic cars due to the U.S. embargo.",
      "Cuban cigars are regarded as some of the best in the world."
    ]
  },
  "CW": {
    "flag": "",
    "name": "Curaçao",
    "officialName": "Country of Curaçao",
    "countryCode": "+5999",
    "isoAlpha2": "CW",
    "isoAlpha3": "CUW",
    "numericCode": "531",
    "firstLanguage": "nl",
    "otherLanguages": [
      "pap",
      "es",
      "en"
    ],
    "currency": {
      "code": "ANG",
      "symbol": "",
      "name": "Netherlands Antillean Guilder"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Centrist",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Gabriele M. M. M. Wilhelmina"
        },
        {
          "title": "Prime Minister",
          "name": "Eugene Rhuggenaath"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD-MM-YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 164000,
    "area": {
      "value": 444,
      "unit": "km"
    },
    "capital": "Willemstad",
    "gdp": {
      "nominal": "3.13 billion USD",
      "perCapita": "19,083 USD"
    },
    "dialingCode": "+5999",
    "internetTLD": ".cw",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "912",
      "police": "911",
      "ambulance": "913"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Carnival (February)",
      "King's Day (April 27)",
      "Emancipation Day (July 1)",
      "Day of the Dead (November 2)"
    ],
    "nationalAnimal": "Tropical Bird",
    "nationalDish": "Keshi Yena",
    "tourismHighlights": [
      "Willemstad (UNESCO World Heritage Site)",
      "Christoffel National Park",
      "Shete Boka National Park",
      "Klein Curaçao"
    ],
    "majorExports": [
      "Oil products",
      "Beverages",
      "Electronics"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 81.5,
    "literacyRate": 98.5,
    "climate": "Tropical savanna climate with a dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Rastafari",
        "Hinduism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Bonaire",
      "Sint Eustatius",
      "Saba"
    ],
    "visaRequirement": "Visa-free for many countries including EU and USA",
    "notableFacts": [
      "Part of the Kingdom of the Netherlands.",
      "Known for its vibrant culture and colorful architecture.",
      "Home to some of the best diving spots in the Caribbean."
    ]
  },
  "CX": {
    "flag": "",
    "name": "Christmas Island",
    "officialName": "Territory of Christmas Island",
    "countryCode": "+6189164",
    "isoAlpha2": "CX",
    "isoAlpha3": "CXR",
    "numericCode": "162",
    "firstLanguage": "en",
    "otherLanguages": [
      "zh",
      "mal"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Territory of Australia",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Governor-General of Australia"
        }
      ]
    },
    "timeZone": {
      "name": "Christmas Island Time (CXT)",
      "offset": "+07:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "population": 2078,
    "area": {
      "value": 135,
      "unit": "km"
    },
    "capital": "Flying Fish Cove",
    "gdp": {
      "nominal": "N/A",
      "perCapita": "N/A"
    },
    "dialingCode": "+618",
    "internetTLD": ".cx",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "000",
      "fire": "000",
      "police": "000",
      "ambulance": "000"
    },
    "holidays": [
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "Red Crab",
    "nationalDish": "Fish and Chips",
    "tourismHighlights": [
      "Christmas Island National Park",
      "The Blowholes",
      "Anson Bay",
      "Hiking trails"
    ],
    "majorExports": [
      "Phosphate rock",
      "Coconut products",
      "Tourism services"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 95,
    "climate": "Tropical rainforest climate, with distinct wet and dry seasons",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Buddhism",
        "Islam",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Indonesia (approximately 360 km away)"
    ],
    "visaRequirement": "Visa required for most travelers depending on nationality",
    "notableFacts": [
      "Famous for its annual crab migration.",
      "Part of Australia since 1957.",
      "Home to unique flora and fauna, including several endemic species."
    ]
  },
  "DJ": {
    "flag": "",
    "name": "Djibouti",
    "officialName": "Republic of Djibouti",
    "countryCode": "+253",
    "isoAlpha2": "DJ",
    "isoAlpha3": "DJI",
    "numericCode": "262",
    "firstLanguage": "fr",
    "otherLanguages": [
      "ar",
      "so"
    ],
    "currency": {
      "code": "DJF",
      "symbol": "Fdj",
      "name": "Djiboutian Franc"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ismaïl Omar Guelleh"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 88356,
    "area": {
      "value": 23200,
      "unit": "km"
    },
    "capital": "Djibouti",
    "gdp": {
      "nominal": "3.50 billion USD",
      "perCapita": "39,500 USD"
    },
    "dialingCode": "+253",
    "internetTLD": ".dj",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "18",
      "fire": "18",
      "police": "17",
      "ambulance": "18"
    },
    "holidays": [
      "Independence Day (June 27)",
      "Labour Day (May 1)"
    ],
    "nationalAnimal": "Camel",
    "nationalDish": "Laha Hurtin",
    "tourismHighlights": [
      "Lake Assal",
      "Goda Mountains",
      "Djibouti's beaches and marine life",
      "Day Forest National Park"
    ],
    "majorExports": [
      "Salt",
      "Livestock",
      "Fish"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 67.5,
    "literacyRate": 69,
    "climate": "Desert climate, hot and dry",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Ethnic religions"
      ]
    },
    "neighborCountries": [
      "Eritrea",
      "Ethiopia",
      "Somalia"
    ],
    "visaRequirement": "Visa required for most nationalities; on arrival for some",
    "notableFacts": [
      "Strategic location at the entrance of the Red Sea, important for shipping routes.",
      "Home to several military bases from various countries.",
      "Renowned for its diverse marine life and underwater experiences."
    ]
  },
  "CY": {
    "flag": "",
    "name": "Cyprus",
    "officialName": "Republic of Cyprus",
    "countryCode": "+357",
    "isoAlpha2": "CY",
    "isoAlpha3": "CYP",
    "numericCode": "196",
    "firstLanguage": "el",
    "otherLanguages": [
      "tr",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Center-right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nicos Christodoulides"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 1207359,
    "area": {
      "value": 9251,
      "unit": "km"
    },
    "capital": "Nicosia",
    "gdp": {
      "nominal": "24.40 billion USD",
      "perCapita": "20,560 USD"
    },
    "dialingCode": "+357",
    "internetTLD": ".cy",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "199",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "Independence Day (October 1)",
      "Greek Orthodox Easter Monday",
      "Turkish Republic Day (October 29)"
    ],
    "nationalAnimal": "Cyprus Mouflon",
    "nationalDish": "Souvla",
    "tourismHighlights": [
      "Paphos Archaeological Park (UNESCO World Heritage Site)",
      "Aphrodite's Rock",
      "Kyrenia Castle",
      "Troodos Mountains"
    ],
    "majorExports": [
      "Pharmaceuticals",
      "Citrus fruits",
      "Clothes",
      "Footwear"
    ],
    "majorImports": [
      "Mineral fuels",
      "Machinery",
      "Transport equipment",
      "Foodstuffs"
    ],
    "lifeExpectancy": 82.8,
    "literacyRate": 99.1,
    "climate": "Mediterranean with dry summers and mild winters",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Islam",
        "Maronite",
        "Roman Catholic"
      ]
    },
    "neighborCountries": [
      "None (island country)"
    ],
    "visaRequirement": "Visa-free travel for EU citizens; various visa requirements for others",
    "notableFacts": [
      "The island has been divided since 1974 into the southern Republic of Cyprus and the northern Turkish Republic of Northern Cyprus.",
      "Home to ancient ruins and significant archaeological sites.",
      "Known for its production of Halloumi cheese."
    ]
  },
  "CZ": {
    "flag": "",
    "name": "Czech Republic",
    "officialName": "Czech Republic",
    "countryCode": "+420",
    "isoAlpha2": "CZ",
    "isoAlpha3": "CZE",
    "numericCode": "203",
    "firstLanguage": "cs",
    "otherLanguages": [
      "en",
      "de",
      "sk"
    ],
    "currency": {
      "code": "CZK",
      "symbol": "Kč",
      "name": "Czech Koruna"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Petr Pavel"
        },
        {
          "title": "Prime Minister",
          "name": "Petr Fiala"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Central Europe",
    "population": 10708981,
    "area": {
      "value": 78865,
      "unit": "km"
    },
    "capital": "Prague",
    "gdp": {
      "nominal": "400 billion USD",
      "perCapita": "37,430 USD"
    },
    "dialingCode": "+420",
    "internetTLD": ".cz",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "150",
      "police": "158",
      "ambulance": "155"
    },
    "holidays": [
      "Struggle for Freedom and Democracy Day (November 17)",
      "Czech Statehood Day (September 28)"
    ],
    "nationalAnimal": "Double-tailed Lion",
    "nationalDish": "Svíčková",
    "tourismHighlights": [
      "Prague Castle",
      "Charles Bridge",
      "Old Town Square",
      "Český Krumlov"
    ],
    "majorExports": [
      "Automobiles",
      "Machinery",
      "Electronics"
    ],
    "majorImports": [
      "Machinery",
      "Electronics",
      "Vehicles"
    ],
    "lifeExpectancy": 79.4,
    "literacyRate": 99,
    "climate": "Temperate continental climate",
    "religions": {
      "predominant": "Atheist",
      "others": [
        "Roman Catholic",
        "Protestant",
        "Orthodox"
      ]
    },
    "neighborCountries": [
      "Germany",
      "Poland",
      "Austria",
      "Slovakia"
    ],
    "visaRequirement": "Schengen Area visa applies; EU citizens do not require a visa.",
    "notableFacts": [
      "Famous for its castles and rich history.",
      "Home to the original pilsner beer.",
      "Prague is known as the 'City of a Hundred Spires'."
    ]
  },
  "DE": {
    "flag": "",
    "name": "Germany",
    "officialName": "Federal Republic of Germany",
    "countryCode": "+49",
    "isoAlpha2": "DE",
    "isoAlpha3": "DEU",
    "numericCode": "276",
    "firstLanguage": "de",
    "otherLanguages": [
      "en",
      "fr",
      "tr",
      "it"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Federal parliamentary republic",
      "politicalLean": "Centre-left",
      "headsOfState": [
        {
          "title": "Chancellor",
          "name": "Olaf Scholz"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 83783942,
    "area": {
      "value": 357582,
      "unit": "km"
    },
    "capital": "Berlin",
    "gdp": {
      "nominal": "4.84 trillion USD",
      "perCapita": "57,702 USD"
    },
    "dialingCode": "+49",
    "internetTLD": ".de",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "110",
      "ambulance": "112"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "German Unity Day (October 3)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "Bundesadler (Federal Eagle)",
    "nationalDish": "Sauerbraten",
    "tourismHighlights": [
      "Brandenburg Gate in Berlin",
      "Neuschwanstein Castle",
      "Cologne Cathedral",
      "The Romantic Road"
    ],
    "majorExports": [
      "Vehicles",
      "Machinery",
      "Chemicals"
    ],
    "majorImports": [
      "Machinery",
      "Electronics",
      "Oil"
    ],
    "lifeExpectancy": 81,
    "literacyRate": 99,
    "climate": "Temperate seasonal climate with moderate to heavy rainfall",
    "religions": {
      "predominant": "Christianity (Protestant and Catholic)",
      "others": [
        "Islam",
        "Buddhism",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Denmark",
      "Poland",
      "Czech Republic",
      "Austria",
      "Switzerland",
      "France",
      "Luxembourg",
      "Belgium",
      "Netherlands"
    ],
    "visaRequirement": "Schengen visa required for non-EU countries",
    "notableFacts": [
      "Germany is the largest economy in Europe.",
      "Home to over 2,000 castles.",
      "Famous for its beer culture, particularly during Oktoberfest."
    ]
  },
  "DO": {
    "flag": "",
    "name": "Dominican Republic",
    "officialName": "Dominican Republic",
    "countryCode": "+1",
    "isoAlpha2": "DO",
    "isoAlpha3": "DOM",
    "numericCode": "214",
    "firstLanguage": "es",
    "otherLanguages": [],
    "currency": {
      "code": "DOP",
      "symbol": "",
      "name": "Dominican Peso"
    },
    "government": {
      "type": "Unitary Presidential Constitutional Republic",
      "politicalLean": "Center-Left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Luis Abinader"
        }
      ]
    },
    "timeZone": {
      "name": "Dominican Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 10958078,
    "area": {
      "value": 48671,
      "unit": "km"
    },
    "capital": "Santo Domingo",
    "gdp": {
      "nominal": "89.77 billion USD",
      "perCapita": "8,189 USD"
    },
    "dialingCode": "+1-809",
    "internetTLD": ".do",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "119",
      "police": "100",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (February 27)",
      "Dominican Restoration Day (August 16)"
    ],
    "nationalAnimal": "Cigua Palmera",
    "nationalDish": "La Bandera (rice, red beans, and meat)",
    "tourismHighlights": [
      "Punta Cana",
      "Santo Domingo Colonial Zone (UNESCO World Heritage Site)",
      "Samana Bay",
      "Los Tres Ojos National Park"
    ],
    "majorExports": [
      "Medical instruments",
      "Electronics",
      "Sugar",
      "Tobacco"
    ],
    "majorImports": [
      "Food",
      "Manufactured goods",
      "Petroleum products"
    ],
    "lifeExpectancy": 74.3,
    "literacyRate": 93,
    "climate": "Tropical maritime climate",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Atheism",
        "Other"
      ]
    },
    "neighborCountries": [
      "Haiti"
    ],
    "visaRequirement": "Visa not required for many nationalities; a tourist card is needed for others",
    "notableFacts": [
      "The Dominican Republic shares the island of Hispaniola with Haiti.",
      "It is known for its beaches, resorts, and golf courses.",
      "It has the oldest permanent European settlement in the Americas, Santo Domingo."
    ]
  },
  "DM": {
    "flag": "",
    "name": "Dominica",
    "officialName": "Commonwealth of Dominica",
    "countryCode": "+1",
    "isoAlpha2": "DM",
    "isoAlpha3": "DMA",
    "numericCode": "206",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "kreol"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Social Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Roosevelt Skerrit"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 71986,
    "area": {
      "value": 751,
      "unit": "km"
    },
    "capital": "Roseau",
    "gdp": {
      "nominal": "1.16 billion USD",
      "perCapita": "16,111 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".dm",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "999",
      "ambulance": "911"
    },
    "holidays": [
      "Dominica Day (November 3)",
      "World Creole Music Festival (Last weekend of October)"
    ],
    "nationalAnimal": "Sisserou Parrot",
    "nationalDish": "Mountain Chicken (Fried Frog)",
    "tourismHighlights": [
      "Morne Trois Pitons National Park (UNESCO World Heritage Site)",
      "Boiling Lake",
      "Trafalgar Falls",
      "Roseau Market"
    ],
    "majorExports": [
      "Bananas",
      "Cocoa",
      "Fresh vegetables"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 94.3,
    "climate": "Tropical, with a wet season from June to November",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Pentecostal",
        "Anglican",
        "Baptist"
      ]
    },
    "neighborCountries": [
      "Martinique",
      "Guadeloupe"
    ],
    "visaRequirement": "Visa required for some countries; no visa for many Caribbean nations.",
    "notableFacts": [
      "Known as the 'Nature Island' for its extensive tropical rainforests.",
      "Home to the second-largest hot spring in the world, Boiling Lake.",
      "Has a rich history of indigenous Kalinago culture."
    ]
  },
  "DZ": {
    "flag": "",
    "name": "Algeria",
    "officialName": "People's Democratic Republic of Algeria",
    "countryCode": "+213",
    "isoAlpha2": "DZ",
    "isoAlpha3": "DZA",
    "numericCode": "012",
    "firstLanguage": "ar",
    "otherLanguages": [
      "fr",
      "ber"
    ],
    "currency": {
      "code": "DZD",
      "symbol": ".",
      "name": "Algerian Dinar"
    },
    "government": {
      "type": "Republic",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Abdelmadjid Tebboune"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Northern Africa",
    "population": 43851044,
    "area": {
      "value": 2381741,
      "unit": "km"
    },
    "capital": "Algiers",
    "gdp": {
      "nominal": "202.5 billion USD",
      "perCapita": "4,626 USD"
    },
    "dialingCode": "+213",
    "internetTLD": ".dz",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "14",
      "fire": "102",
      "police": "17",
      "ambulance": "143"
    },
    "holidays": [
      "Revolution Day (November 1)",
      "Independence Day (July 5)"
    ],
    "nationalAnimal": "Fennec Fox",
    "nationalDish": "Couscous",
    "tourismHighlights": [
      "M'zab Valley (UNESCO World Heritage Site)",
      "The Sahara Desert",
      "Kasbah of Algiers (UNESCO World Heritage Site)",
      "Timgad Roman ruins"
    ],
    "majorExports": [
      "Natural gas",
      "Crude oil",
      "Petrochemicals"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Pharmaceuticals"
    ],
    "lifeExpectancy": 76.3,
    "literacyRate": 81.4,
    "climate": "Varies from arid to Mediterranean, with mild, wet winters and hot, dry summers",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Tunisia",
      "Libya",
      "Niger",
      "Mali",
      "Mauritania",
      "Western Sahara",
      "Morocco"
    ],
    "visaRequirement": "Visa required for most foreign travelers.",
    "notableFacts": [
      "Largest country in Africa and the 10th largest country in the world.",
      "Home to a significant portion of the Sahara Desert.",
      "Rich in hydrocarbons, Algeria is a major natural gas supplier to Europe."
    ]
  },
  "EC": {
    "flag": "",
    "name": "Ecuador",
    "officialName": "Republic of Ecuador",
    "countryCode": "+593",
    "isoAlpha2": "EC",
    "isoAlpha3": "ECU",
    "numericCode": "218",
    "firstLanguage": "es",
    "otherLanguages": [
      "qu",
      "sh"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Guillermo Lasso"
        }
      ]
    },
    "timeZone": {
      "name": "Ecuador Time (ECT)",
      "offset": "-05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "South America",
    "subregion": "Western South America",
    "population": 17643060,
    "area": {
      "value": 276841,
      "unit": "km"
    },
    "capital": "Quito",
    "gdp": {
      "nominal": "108.44 billion USD",
      "perCapita": "6,135 USD"
    },
    "dialingCode": "+593",
    "internetTLD": ".ec",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "102",
      "police": "101",
      "ambulance": "171"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (August 10)",
      "Day of the Dead (November 2)"
    ],
    "nationalAnimal": "Giant Galápagos Tortoise",
    "nationalDish": "Ceviche",
    "tourismHighlights": [
      "Galápagos Islands",
      "Amazon Rainforest",
      "Mitad del Mundo (Middle of the World)",
      "Old Town of Quito (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Crude oil",
      "Bananas",
      "Shrimp",
      "Cocoa"
    ],
    "majorImports": [
      "Machinery",
      "Consumer goods",
      "Vehicles"
    ],
    "lifeExpectancy": 77.3,
    "literacyRate": 94,
    "climate": "Varied; tropical along the coast, temperate in the highlands, and cold in the Amazon rainforest",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Evangelical Protestant",
        "Indigenous beliefs",
        "Other Christian denominations"
      ]
    },
    "neighborCountries": [
      "Colombia",
      "Peru"
    ],
    "visaRequirement": "Visa-free for many countries, including EU and US citizens",
    "notableFacts": [
      "Home to the famous Galápagos Islands, known for their biodiversity.",
      "The equatorial line runs through Ecuador, resulting in diverse ecosystems.",
      "Ecuador was the first country to recognize the rights of nature in its constitution."
    ]
  },
  "DK": {
    "flag": "",
    "name": "Denmark",
    "officialName": "Kingdom of Denmark",
    "countryCode": "+45",
    "isoAlpha2": "DK",
    "isoAlpha3": "DNK",
    "numericCode": "208",
    "firstLanguage": "da",
    "otherLanguages": [
      "en",
      "de"
    ],
    "currency": {
      "code": "DKK",
      "symbol": "kr",
      "name": "Danish Krone"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Social Democracy",
      "headsOfState": [
        {
          "title": "Monarch",
          "name": "Margrethe II"
        },
        {
          "title": "Prime Minister",
          "name": "Mette Frederiksen"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 5818553,
    "area": {
      "value": 43094,
      "unit": "km"
    },
    "capital": "Copenhagen",
    "gdp": {
      "nominal": "400.52 billion USD",
      "perCapita": "68,800 USD"
    },
    "dialingCode": "+45",
    "internetTLD": ".dk",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "114",
      "ambulance": "112"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Maundy Thursday",
      "Easter Sunday",
      "Labor Day (May 1)",
      "Constitution Day (June 5)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "Mute Swan",
    "nationalDish": "Smørrebrød",
    "tourismHighlights": [
      "Tivoli Gardens",
      "Nyhavn",
      "The Little Mermaid",
      "Rosenborg Castle",
      "Legoland Billund"
    ],
    "majorExports": [
      "Pharmaceuticals",
      "Machinery",
      "Food products"
    ],
    "majorImports": [
      "Machinery",
      "Chemicals",
      "Vehicles"
    ],
    "lifeExpectancy": 81.3,
    "literacyRate": 99,
    "climate": "Temperate maritime climate, with mild winters and cool summers",
    "religions": {
      "predominant": "Folk Church (Lutheran Christianity)",
      "others": [
        "None",
        "Islam",
        "Other Christian denominations"
      ]
    },
    "neighborCountries": [
      "Germany"
    ],
    "visaRequirement": "Part of the Schengen Area; no visa required for Schengen Area countries.",
    "notableFacts": [
      "Denmark consistently ranks high in global happiness and quality of life indices.",
      "One of the world's leading countries in renewable energy.",
      "The Lego Group was founded in Denmark in 1932."
    ]
  },
  "EH": {
    "flag": "",
    "name": "Western Sahara",
    "officialName": "Sahrawi Arab Democratic Republic (SADR)",
    "countryCode": "+212",
    "isoAlpha2": "EH",
    "isoAlpha3": "ESH",
    "numericCode": "732",
    "firstLanguage": "ar",
    "otherLanguages": [
      "es"
    ],
    "currency": {
      "code": "MAD",
      "symbol": "..",
      "name": "Moroccan Dirham"
    },
    "government": {
      "type": "Partially recognized state",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Brahim Ghali"
        }
      ]
    },
    "timeZone": {
      "name": "Western European Time (WET)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Northern Africa",
    "population": 500000,
    "area": {
      "value": 266000,
      "unit": "km"
    },
    "capital": "El Aaiún (claimed)",
    "gdp": {
      "nominal": "N/A",
      "perCapita": "N/A"
    },
    "dialingCode": "+212",
    "internetTLD": ".eh",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "N/A",
      "police": "N/A",
      "ambulance": "N/A"
    },
    "holidays": [
      "Independence Day (February 28)",
      "Revolution Day (October 20)"
    ],
    "nationalAnimal": "Barbary sheep",
    "nationalDish": "Couscous",
    "tourismHighlights": [
      "Paradise Beach",
      "Dunes of Merzouga",
      "Lagouira Beach",
      "Historic sites in Smara"
    ],
    "majorExports": [
      "Phosphate",
      "Fishing products"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Consumer goods"
    ],
    "lifeExpectancy": 67,
    "literacyRate": 68,
    "climate": "Arid desert climate with hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "None",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "Morocco",
      "Algeria"
    ],
    "visaRequirement": "Visa required for most non-African countries",
    "notableFacts": [
      "Disputed territory claimed by both Morocco and the Sahrawi Arab Democratic Republic.",
      "Economy primarily dependent on fishing and phosphate mining.",
      "Home to the world's largest desert, the Sahara."
    ]
  },
  "ER": {
    "flag": "",
    "name": "Eritrea",
    "officialName": "State of Eritrea",
    "countryCode": "+291",
    "isoAlpha2": "ER",
    "isoAlpha3": "ERI",
    "numericCode": "232",
    "firstLanguage": "ti",
    "otherLanguages": [
      "ar",
      "en",
      "tig"
    ],
    "currency": {
      "code": "ERN",
      "symbol": "Nakfa",
      "name": "Nakfa"
    },
    "government": {
      "type": "One-party presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Isaias Afwerki"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 3546000,
    "area": {
      "value": 117600,
      "unit": "km"
    },
    "capital": "Asmara",
    "gdp": {
      "nominal": "2.2 billion USD",
      "perCapita": "620 USD"
    },
    "dialingCode": "+291",
    "internetTLD": ".er",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "944",
      "police": "933",
      "ambulance": "910"
    },
    "holidays": [
      "Independence Day (May 24)",
      "Revolution Day (September 1)"
    ],
    "nationalAnimal": "Eritrean Hamster",
    "nationalDish": "Zigni",
    "tourismHighlights": [
      "Asmara (UNESCO World Heritage Site)",
      "Massawa",
      "Dahlak Archipelago",
      "Nakfa Battle Site"
    ],
    "majorExports": [
      "Gold",
      "Textiles",
      "Livestock"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Petroleum products"
    ],
    "lifeExpectancy": 67,
    "literacyRate": 80,
    "climate": "Hot and arid in the lowlands, temperate in the highlands",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Sudan",
      "Ethiopia",
      "Djibouti"
    ],
    "visaRequirement": "Visa required for all travelers except Djibouti citizens",
    "notableFacts": [
      "Eritrea gained independence from Ethiopia in 1993 after a 30-year war.",
      "Asmara is known for its well-preserved Italian architecture.",
      "Eritrea has a national service system that often requires long-term service from citizens."
    ]
  },
  "EG": {
    "flag": "",
    "name": "Egypt",
    "officialName": "Arab Republic of Egypt",
    "countryCode": "+20",
    "isoAlpha2": "EG",
    "isoAlpha3": "EGY",
    "numericCode": "818",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en",
      "fr"
    ],
    "currency": {
      "code": "EGP",
      "symbol": "..",
      "name": "Egyptian Pound"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Semi-presidential",
      "headsOfState": [
        {
          "title": "President",
          "name": "Abdel Fattah al-Sisi"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Northern Africa",
    "population": 104124440,
    "area": {
      "value": 1002450,
      "unit": "km"
    },
    "capital": "Cairo",
    "gdp": {
      "nominal": "404 billion USD",
      "perCapita": "3,872 USD"
    },
    "dialingCode": "+20",
    "internetTLD": ".eg",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "123",
      "fire": "180",
      "police": "122",
      "ambulance": "123"
    },
    "holidays": [
      "Revolution Day (January 25)",
      "Labor Day (May 1)",
      "Revolution Day (July 23),",
      "Egyptian Independence Day (February 28)"
    ],
    "nationalAnimal": "Steppe Eagle",
    "nationalDish": "Koshari",
    "tourismHighlights": [
      "Pyramids of Giza",
      "Luxor Temple",
      "Karnak Temple",
      "Valley of the Kings"
    ],
    "majorExports": [
      "Crude petroleum",
      "Textiles",
      "Tourism",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Chemicals",
      "Vehicles"
    ],
    "lifeExpectancy": 73,
    "literacyRate": 75,
    "climate": "Desert climate with hot dry summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Judaism",
        "Baha'i"
      ]
    },
    "neighborCountries": [
      "Libya",
      "Sudan",
      "Israel"
    ],
    "visaRequirement": "Visa required for most travelers, with exceptions for certain countries.",
    "notableFacts": [
      "Home to one of the world's oldest civilizations.",
      "Has the longest river in the world, the Nile.",
      "Known for its ancient monuments and archaeological sites."
    ]
  },
  "ES": {
    "flag": "",
    "name": "Spain",
    "officialName": "Kingdom of Spain",
    "countryCode": "+34",
    "isoAlpha2": "ES",
    "isoAlpha3": "ESP",
    "numericCode": "724",
    "firstLanguage": "es",
    "otherLanguages": [
      "ca",
      "gl",
      "eu",
      "oc"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary constitutional monarchy",
      "politicalLean": "Varies by region",
      "headsOfState": [
        {
          "title": "King",
          "name": "Felipe VI"
        },
        {
          "title": "Prime Minister",
          "name": "Pedro Sánchez"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 47450795,
    "area": {
      "value": 505992,
      "unit": "km"
    },
    "capital": "Madrid",
    "gdp": {
      "nominal": "1.47 trillion USD",
      "perCapita": "31,194 USD"
    },
    "dialingCode": "+34",
    "internetTLD": ".es",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "080",
      "police": "091",
      "ambulance": "061"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Epiphany (January 6)",
      "Labor Day (May 1)",
      "National Day (October 12)",
      "Assumption of Mary (August 15)",
      "All Saints' Day (November 1)"
    ],
    "nationalAnimal": "Spanish Bull",
    "nationalDish": "Paella",
    "tourismHighlights": [
      "Sagrada Família in Barcelona",
      "Alhambra in Granada",
      "The beaches of Costa del Sol",
      "Park Güell in Barcelona"
    ],
    "majorExports": [
      "Machinery",
      "Automobiles",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery",
      "Fuels",
      "Chemical products"
    ],
    "lifeExpectancy": 83.4,
    "literacyRate": 98.3,
    "climate": "Varies; Mediterranean in the coastal areas, continental in the interior",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "France",
      "Portugal",
      "Andorra"
    ],
    "visaRequirement": "Schengen visa required for non-EU countries",
    "notableFacts": [
      "Home to one of the oldest universities in the world, the University of Salamanca.",
      "Known for its diverse culture, heritage, and international festivals.",
      "Houses the only desert in Europe, the Tabernas Desert."
    ]
  },
  "EE": {
    "flag": "",
    "name": "Estonia",
    "officialName": "Republic of Estonia",
    "countryCode": "+372",
    "isoAlpha2": "EE",
    "isoAlpha3": "EST",
    "numericCode": "233",
    "firstLanguage": "et",
    "otherLanguages": [
      "ru",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Center-right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Alar Karis"
        },
        {
          "title": "Prime Minister",
          "name": "Kaja Kallas"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 1326535,
    "area": {
      "value": 45227,
      "unit": "km"
    },
    "capital": "Tallinn",
    "gdp": {
      "nominal": "38.23 billion USD",
      "perCapita": "28,759 USD"
    },
    "dialingCode": "+372",
    "internetTLD": ".ee",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "Independence Day (February 24)",
      "Victory Day (June 23)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "European Brown Bear",
    "nationalDish": "Kohuke",
    "tourismHighlights": [
      "Tallinn Old Town (UNESCO World Heritage Site)",
      "Lahemaa National Park",
      "Piranha Estonia",
      "Kuressaare Castle"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Mineral products",
      "Agricultural products"
    ],
    "majorImports": [
      "Mineral products",
      "Machinery and equipment",
      "Transport vehicles"
    ],
    "lifeExpectancy": 78.9,
    "literacyRate": 99.8,
    "climate": "Temperate, with warm summers and cold winters",
    "religions": {
      "predominant": "Non-religious",
      "others": [
        "Eastern Orthodox",
        "Lutheran"
      ]
    },
    "neighborCountries": [
      "Latvia",
      "Russia"
    ],
    "visaRequirement": "Schengen visa required for many nationalities",
    "notableFacts": [
      "One of the most digitally advanced countries in the world.",
      "Home to the e-Residency program.",
      "Features a vast number of islands and is known for its nature reserves."
    ]
  },
  "FK": {
    "flag": "",
    "name": "Falkland Islands (Malvinas)",
    "officialName": "Falkland Islands",
    "countryCode": "+500",
    "isoAlpha2": "FK",
    "isoAlpha3": "FLK",
    "numericCode": "238",
    "firstLanguage": "en",
    "otherLanguages": [
      "es"
    ],
    "currency": {
      "code": "FKP",
      "symbol": "",
      "name": "Falkland Islands pound"
    },
    "government": {
      "type": "Overseas territory of the United Kingdom",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Appointed by the British Monarch"
        }
      ]
    },
    "timeZone": {
      "name": "Falkland Islands Time (FKT)",
      "offset": "-03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "South America",
    "subregion": "South America",
    "population": 3480,
    "area": {
      "value": 12100,
      "unit": "km"
    },
    "capital": "Stanley",
    "gdp": {
      "nominal": "225 million USD",
      "perCapita": "64,500 USD"
    },
    "dialingCode": "+500",
    "internetTLD": ".fk",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Liberation Day (June 14)",
      "Remembrance Day (November 11)"
    ],
    "nationalAnimal": "Black-browed albatross",
    "nationalDish": "Falklands lamb",
    "tourismHighlights": [
      "Wildlife watching",
      "Marlowe Cove",
      "Gypsy Cove",
      "Port Stanley"
    ],
    "majorExports": [
      "Fish and seafood",
      "Wool",
      "Tourism"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Fuel"
    ],
    "lifeExpectancy": 81.5,
    "literacyRate": 99,
    "climate": "Temperate maritime climate with cool summers and mild winters",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Buddhism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (disputed with Argentina)"
    ],
    "visaRequirement": "Visa not required for many countries; check local regulations.",
    "notableFacts": [
      "The Falkland Islands saw a major conflict between the UK and Argentina in 1982.",
      "Home to a rich variety of wildlife, including seals, penguins, and birds.",
      "Economy primarily based on fishing, tourism, and sheep farming."
    ]
  },
  "FI": {
    "flag": "",
    "name": "Finland",
    "officialName": "Republic of Finland",
    "countryCode": "+358",
    "isoAlpha2": "FI",
    "isoAlpha3": "FIN",
    "numericCode": "246",
    "firstLanguage": "fi",
    "otherLanguages": [
      "sv",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Centre-left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Sauli Niinistö"
        },
        {
          "title": "Prime Minister",
          "name": "Petteri Orpo"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 5540720,
    "area": {
      "value": 338424,
      "unit": "km"
    },
    "capital": "Helsinki",
    "gdp": {
      "nominal": "303 billion USD",
      "perCapita": "54,024 USD"
    },
    "dialingCode": "+358",
    "internetTLD": ".fi",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (December 6)"
    ],
    "nationalAnimal": "Saimaa ringed seal",
    "nationalDish": "Karjalanpiirakka (Karelian pasties)",
    "tourismHighlights": [
      "Helsinki Cathedral",
      "Lapland (Northern Lights)",
      "Suomenlinna Fortress",
      "Santa Claus Village"
    ],
    "majorExports": [
      "Machinery",
      "Electronics",
      "Paper products"
    ],
    "majorImports": [
      "Mineral fuels",
      "Machinery",
      "Vehicles"
    ],
    "lifeExpectancy": 81.8,
    "literacyRate": 100,
    "climate": "Cold temperate climate with distinct seasons",
    "religions": {
      "predominant": "Lutheran Christianity",
      "others": [
        "Orthodox Christianity",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Sweden",
      "Norway",
      "Russia"
    ],
    "visaRequirement": "Schengen visa required for certain countries",
    "notableFacts": [
      "Ranked as one of the best countries for education in the world.",
      "Home to the original Santa Claus village.",
      "One of the happiest countries in the world according to happiness reports."
    ]
  },
  "FM": {
    "flag": "",
    "name": "Micronesia",
    "officialName": "Federated States of Micronesia",
    "countryCode": "+691",
    "isoAlpha2": "FM",
    "isoAlpha3": "FSM",
    "numericCode": "583",
    "firstLanguage": "en",
    "otherLanguages": [
      "fm",
      "pon",
      "kos",
      "chu"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Federal presidential constitutional republic",
      "politicalLean": "Moderate",
      "headsOfState": [
        {
          "title": "President",
          "name": "David W. Panuelo"
        }
      ]
    },
    "timeZone": {
      "name": "Chamorro Standard Time (ChST)",
      "offset": "+10:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Micronesia",
    "population": 104000,
    "area": {
      "value": 702,
      "unit": "km"
    },
    "capital": "Palikir",
    "gdp": {
      "nominal": "0.35 billion USD",
      "perCapita": "3,365 USD"
    },
    "dialingCode": "+691",
    "internetTLD": ".fm",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (November 3)",
      "Thanksgiving (November 4 Tuesday)",
      "Christmas (December 25)"
    ],
    "nationalAnimal": "Hawksbill Turtle",
    "nationalDish": "Taro",
    "tourismHighlights": [
      "Yap Island",
      "Ngulu Atoll",
      "Pohnpei State's waterfalls",
      "Truk lagoon shipwrecks"
    ],
    "majorExports": [
      "Fish",
      "Copra",
      "Seaweed"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 78.7,
    "literacyRate": 94,
    "climate": "Tropical marine climate; humid and warm all year round",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Roman Catholic",
        "Protestant",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Nauru",
      "Palau",
      "Marshall Islands"
    ],
    "visaRequirement": "Visa-free for many Pacific nations; visa required for others",
    "notableFacts": [
      "Consists of four states: Yap, Chuuk, Pohnpei, and Kosrae.",
      "Home to some of the best dive sites in the world.",
      "Micronesia was a strategic location during World War II."
    ]
  },
  "FJ": {
    "flag": "",
    "name": "Fiji",
    "officialName": "Republic of Fiji",
    "countryCode": "+679",
    "isoAlpha2": "FJ",
    "isoAlpha3": "FJI",
    "numericCode": "242",
    "firstLanguage": "fj",
    "otherLanguages": [
      "en",
      "hi",
      "ur"
    ],
    "currency": {
      "code": "FJD",
      "symbol": "FJ$",
      "name": "Fijian Dollar"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Various",
      "headsOfState": [
        {
          "title": "President",
          "name": "Wiliame Maivalili Katonivere"
        },
        {
          "title": "Prime Minister",
          "name": "Sitiveni Rabuka"
        }
      ]
    },
    "timeZone": {
      "name": "Fiji Time (FJT)",
      "offset": "+12:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Melanesia",
    "population": 896444,
    "area": {
      "value": 18274,
      "unit": "km"
    },
    "capital": "Suva",
    "gdp": {
      "nominal": "5.58 billion USD",
      "perCapita": "6,218 USD"
    },
    "dialingCode": "+679",
    "internetTLD": ".fj",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "910",
      "police": "917",
      "ambulance": "918"
    },
    "holidays": [
      "Fiji Day (October 10)",
      "Diwali (date varies)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Fiji Banded Iguana",
    "nationalDish": "Kokoda",
    "tourismHighlights": [
      "Great Astrolabe Reef",
      "Bula Festival in Nadi",
      "Mamanuca and Yasawa Islands",
      "Sigatoka Sand Dunes National Park"
    ],
    "majorExports": [
      "Sugar",
      "Fish",
      "Clothing"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Transportation equipment"
    ],
    "lifeExpectancy": 67.7,
    "literacyRate": 93.7,
    "climate": "Tropical marine climate with warm temperatures year-round",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Islam",
        "Sikhism"
      ]
    },
    "neighborCountries": [
      "Tuvalu",
      "Tonga",
      "Vanuatu"
    ],
    "visaRequirement": "Visa-free for many countries, including some Pacific Islands, NZ, Australia, and select others",
    "notableFacts": [
      "Fiji consists of over 300 islands, with about 100 inhabited.",
      "Home to the largest coffee plantation in the South Pacific.",
      "Fiji is known for its coral reefs and diverse marine life."
    ]
  },
  "ET": {
    "flag": "",
    "name": "Ethiopia",
    "officialName": "Federal Democratic Republic of Ethiopia",
    "countryCode": "+251",
    "isoAlpha2": "ET",
    "isoAlpha3": "ETH",
    "numericCode": "231",
    "firstLanguage": "am",
    "otherLanguages": [
      "en",
      "om",
      "ti",
      "so"
    ],
    "currency": {
      "code": "ETB",
      "symbol": "Br",
      "name": "Ethiopian Birr"
    },
    "government": {
      "type": "Federal parliamentary republic",
      "politicalLean": "Ethiopian People's Revolutionary Democratic Front",
      "headsOfState": [
        {
          "title": "Prime Minister",
          "name": "Abiy Ahmed"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "East Africa",
    "population": 120000000,
    "area": {
      "value": 1104300,
      "unit": "km"
    },
    "capital": "Addis Ababa",
    "gdp": {
      "nominal": "111.26 billion USD",
      "perCapita": "925 USD"
    },
    "dialingCode": "+251",
    "internetTLD": ".et",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "999",
      "police": "991",
      "ambulance": "993"
    },
    "holidays": [
      "Enkutatash (New Year, September 11)",
      "Meskel (Finding of the True Cross, September 27)"
    ],
    "nationalAnimal": "Lion of Judah",
    "nationalDish": "Injera",
    "tourismHighlights": [
      "Rock-Hewn Churches of Lalibela (UNESCO World Heritage Site)",
      "Simien Mountains National Park",
      "Gonder Castles",
      "Omo Valley tribes"
    ],
    "majorExports": [
      "Coffee",
      "Oilseeds",
      "Gold"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Vehicles"
    ],
    "lifeExpectancy": 67.6,
    "literacyRate": 51.8,
    "climate": "Varies from tropical monsoon in the highlands to arid in the lowlands",
    "religions": {
      "predominant": "Ethiopian Orthodox Christianity",
      "others": [
        "Islam",
        "Protestant Christianity",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Eritrea",
      "Djibouti",
      "Somalia",
      "Sudan",
      "South Sudan"
    ],
    "visaRequirement": "Visa required for most nationalities, available on arrival for some countries",
    "notableFacts": [
      "Ethiopia is one of the oldest nations in the world with a rich history dating back thousands of years.",
      "It's the only African country that was never colonized, except for a brief Italian occupation.",
      "Home to the ancient civilizations such as Aksum and the birthplace of coffee."
    ]
  },
  "GA": {
    "flag": "",
    "name": "Gabon",
    "officialName": "Gabonese Republic",
    "countryCode": "+241",
    "isoAlpha2": "GA",
    "isoAlpha3": "GAB",
    "numericCode": "266",
    "firstLanguage": "fr",
    "otherLanguages": [
      "pg",
      "es"
    ],
    "currency": {
      "code": "XAF",
      "symbol": "FCFA",
      "name": "CFA franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Central",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ali Bongo Ondimba"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 2265830,
    "area": {
      "value": 267668,
      "unit": "km"
    },
    "capital": "Libreville",
    "gdp": {
      "nominal": "17.66 billion USD",
      "perCapita": "7,797 USD"
    },
    "dialingCode": "+241",
    "internetTLD": ".ga",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "170",
      "fire": "118",
      "police": "147",
      "ambulance": "144"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (August 16)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "African Forest Elephant",
    "nationalDish": "Poulet Nyanga",
    "tourismHighlights": [
      "Loango National Park",
      "Ivindo National Park",
      "GambaPokola Road",
      "Ogooué River"
    ],
    "majorExports": [
      "Oil",
      "Manganese",
      "Timber",
      "Uranium"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Transport equipment"
    ],
    "lifeExpectancy": 67.5,
    "literacyRate": 83,
    "climate": "Tropical, with a rainy season from October to May",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Traditional African religions",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Equatorial Guinea",
      "Cameroon",
      "Republic of the Congo"
    ],
    "visaRequirement": "Visa required for most non-African countries",
    "notableFacts": [
      "Home to one of the largest rainforests in the world.",
      "Rich in natural resources, including oil and minerals.",
      "Has significant biodiversity, including unique species of wildlife."
    ]
  },
  "FO": {
    "flag": "",
    "name": "Faroe Islands",
    "officialName": "Faroe Islands",
    "countryCode": "+298",
    "isoAlpha2": "FO",
    "isoAlpha3": "FRO",
    "numericCode": "234",
    "firstLanguage": "fo",
    "otherLanguages": [
      "da",
      "en"
    ],
    "currency": {
      "code": "DKK",
      "symbol": "kr",
      "name": "Danish Krone"
    },
    "government": {
      "type": "Parliamentary democracy and autonomous territory within the Kingdom of Denmark",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "Prime Minister",
          "name": "Regin av Reyni"
        },
        {
          "title": "Monarch",
          "name": "Margrethe II"
        }
      ]
    },
    "timeZone": {
      "name": "Western European Time (WET)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 52859,
    "area": {
      "value": 1399,
      "unit": "km"
    },
    "capital": "Tórshavn",
    "gdp": {
      "nominal": "2.03 billion USD",
      "perCapita": "38,425 USD"
    },
    "dialingCode": "+298",
    "internetTLD": ".fo",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "113",
      "police": "114",
      "ambulance": "112"
    },
    "holidays": [
      "National Flag Day (April 25)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Sheep",
    "nationalDish": "Skerpikjøt (Fermented lamb)",
    "tourismHighlights": [
      "Lake Sørvágsvatn",
      "Tindhólmur",
      "Gásadalur Waterfall",
      "The Bird Cliffs of Vestmanna"
    ],
    "majorExports": [
      "Fish",
      "Seafood products",
      "Machinery"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Consumer goods"
    ],
    "lifeExpectancy": 81.4,
    "literacyRate": 100,
    "climate": "Oceanic, with mild winters and cool summers",
    "religions": {
      "predominant": "Lutheran Christianity",
      "others": [
        "None",
        "Catholicism",
        "Evangelical Free Church"
      ]
    },
    "neighborCountries": [
      "Denmark",
      "Iceland"
    ],
    "visaRequirement": "Visa not required for EU citizens and many others; Schengen rules apply.",
    "notableFacts": [
      "Strong fishing industry serves as the backbone of the economy.",
      "Home to one of the most impressive networks of tunnels and bridges connecting the islands.",
      "Cultural heritage strongly influenced by Nordic history and traditions."
    ]
  },
  "GD": {
    "flag": "",
    "name": "Grenada",
    "officialName": "Grenada",
    "countryCode": "+1",
    "isoAlpha2": "GD",
    "isoAlpha3": "GRD",
    "numericCode": "308",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Parliamentary democracy and constitutional monarchy",
      "politicalLean": "Social democratic",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Dame Cécile La Grenade"
        },
        {
          "title": "Prime Minister",
          "name": "Dickon Mitchell"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 112523,
    "area": {
      "value": 344,
      "unit": "km"
    },
    "capital": "St. George's",
    "gdp": {
      "nominal": "1.17 billion USD",
      "perCapita": "10,411 USD"
    },
    "dialingCode": "+1-473",
    "internetTLD": ".gd",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (February 7)",
      "Emancipation Day (August 1)",
      "Thanksgiving Day (October 25)"
    ],
    "nationalAnimal": "Grenada Dove",
    "nationalDish": "Oil Down",
    "tourismHighlights": [
      "Grand Anse Beach",
      "St. George's Fort",
      "Underwater Sculpture Park",
      "Carriacou and Petite Martinique"
    ],
    "majorExports": [
      "Nutmeg",
      "Cocoa",
      "Bananas"
    ],
    "majorImports": [
      "Machinery and transportation equipment",
      "Food and live animals",
      "Chemicals"
    ],
    "lifeExpectancy": 77.1,
    "literacyRate": 98.7,
    "climate": "Tropical; moderated by trade winds",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Saint Vincent and the Grenadines",
      "Barbados (via the Grenadine Islands)"
    ],
    "visaRequirement": "Visa-free entry for many countries, visa required for others",
    "notableFacts": [
      "Known as the 'Spice Isle' for its production of nutmeg and mace.",
      "Home to the first underwater sculpture park in the Caribbean.",
      "Has a vibrant cultural heritage influenced by Africa, Europe, and the Caribbean."
    ]
  },
  "FR": {
    "flag": "",
    "name": "France",
    "officialName": "French Republic",
    "countryCode": "+33",
    "isoAlpha2": "FR",
    "isoAlpha3": "FRA",
    "numericCode": "250",
    "firstLanguage": "fr",
    "otherLanguages": [
      "en",
      "de",
      "es",
      "it"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Unitary semi-presidential constitutional republic",
      "politicalLean": "Moderate",
      "headsOfState": [
        {
          "title": "President",
          "name": "Emmanuel Macron"
        },
        {
          "title": "Prime Minister",
          "name": "Élisabeth Borne"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 65273511,
    "area": {
      "value": 551695,
      "unit": "km"
    },
    "capital": "Paris",
    "gdp": {
      "nominal": "2.78 trillion USD",
      "perCapita": "42,330 USD"
    },
    "dialingCode": "+33",
    "internetTLD": ".fr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Bastille Day (July 14)",
      "Armistice Day (November 11)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Gallic Rooster",
    "nationalDish": "Coq au Vin",
    "tourismHighlights": [
      "Eiffel Tower",
      "Louvre Museum",
      "Mont Saint-Michel",
      "Versailles Palace"
    ],
    "majorExports": [
      "Aircraft and spacecraft",
      "Pharmaceuticals",
      "Automobiles",
      "Wine"
    ],
    "majorImports": [
      "Crude petroleum",
      "Cars",
      "Electronic equipment",
      "Machinery"
    ],
    "lifeExpectancy": 82.5,
    "literacyRate": 99,
    "climate": "Varies by region; generally temperate with four distinct seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Islam",
        "Protestantism",
        "Judaism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Belgium",
      "Luxembourg",
      "Germany",
      "Switzerland",
      "Italy",
      "Spain",
      "Monaco",
      "Andorra"
    ],
    "visaRequirement": "Schengen visa required for non-EU passport holders",
    "notableFacts": [
      "Home to the Eiffel Tower, one of the most recognizable landmarks in the world.",
      "France is known for its rich cultural heritage, including art, fashion, and cuisine.",
      "It is the largest country in the European Union by area."
    ]
  },
  "GB": {
    "flag": "",
    "name": "United Kingdom",
    "officialName": "United Kingdom of Great Britain and Northern Ireland",
    "countryCode": "+44",
    "isoAlpha2": "GB",
    "isoAlpha3": "GBR",
    "numericCode": "826",
    "firstLanguage": "en",
    "otherLanguages": [
      "cy",
      "ga",
      "sc"
    ],
    "currency": {
      "code": "GBP",
      "symbol": "",
      "name": "British Pound Sterling"
    },
    "government": {
      "type": "Constitutional monarchy and parliamentary democracy",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "Monarch",
          "name": "King Charles III"
        },
        {
          "title": "Prime Minister",
          "name": "Rishi Sunak"
        }
      ]
    },
    "timeZone": {
      "name": "Greenwich Mean Time (GMT)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 67081000,
    "area": {
      "value": 243610,
      "unit": "km"
    },
    "capital": "London",
    "gdp": {
      "nominal": "3.13 trillion USD",
      "perCapita": "46,800 USD"
    },
    "dialingCode": "+44",
    "internetTLD": ".uk",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Easter Monday (date varies)",
      "May Day (first Monday in May)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "Lion",
    "nationalDish": "Fish and Chips",
    "tourismHighlights": [
      "The British Museum",
      "Tower of London",
      "Buckingham Palace",
      "Stonehenge",
      "Lake District National Park"
    ],
    "majorExports": [
      "Machinery",
      "Vehicles",
      "Pharmaceuticals",
      "Financial services"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Oil",
      "Electrical machinery"
    ],
    "lifeExpectancy": 81.2,
    "literacyRate": 99,
    "climate": "Temperate maritime with mild temperatures and moderate rainfall",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Hinduism",
        "Judaism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Ireland"
    ],
    "visaRequirement": "Visa required for some countries; varies based on nationality and purpose of visit.",
    "notableFacts": [
      "Home to some of the world's leading universities and cultural institutions.",
      "The UK has a rich history of influence in global politics, culture, and economy.",
      "The British monarchy is one of the oldest in the world."
    ]
  },
  "GI": {
    "flag": "",
    "name": "Gibraltar",
    "officialName": "British Overseas Territory of Gibraltar",
    "countryCode": "+350",
    "isoAlpha2": "GI",
    "isoAlpha3": "GIB",
    "numericCode": "292",
    "firstLanguage": "en",
    "otherLanguages": [
      "es",
      "lan"
    ],
    "currency": {
      "code": "GIP",
      "symbol": "",
      "name": "Gibraltar Pound"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "British",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Sir David Steele"
        },
        {
          "title": "Chief Minister",
          "name": "Fabian Picardo"
        }
      ]
    },
    "timeZone": {
      "name": "British Summer Time (BST)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 33844,
    "area": {
      "value": 6.7,
      "unit": "km"
    },
    "capital": "Gibraltar",
    "gdp": {
      "nominal": "2.8 billion USD",
      "perCapita": "82,953 USD"
    },
    "dialingCode": "+350",
    "internetTLD": ".gi",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "190",
      "police": "199",
      "ambulance": "190"
    },
    "holidays": [
      "National Day (September 10)",
      "Queen's Birthday (Second Saturday in June)"
    ],
    "nationalAnimal": "Barbary macaque",
    "nationalDish": "Calentita",
    "tourismHighlights": [
      "The Rock of Gibraltar",
      "St. Michael's Cave",
      "The Great Siege Tunnels",
      "The Gibraltar Nature Reserve"
    ],
    "majorExports": [
      "Clothing",
      "Cigarettes",
      "Electronic equipment"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Fuel"
    ],
    "lifeExpectancy": 81.3,
    "literacyRate": 99,
    "climate": "Mediterranean with mild winters and hot summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Jewish"
      ]
    },
    "neighborCountries": [
      "Spain"
    ],
    "visaRequirement": "Visa not required for EU citizens and many other nationalities",
    "notableFacts": [
      "Strategically located at the entrance of the Mediterranean Sea.",
      "Home to the only wild monkeys in Europe.",
      "Exports mainly consist of services, notably online gaming and financial services."
    ]
  },
  "GF": {
    "flag": "",
    "name": "French Guiana",
    "officialName": "Region of French Guiana",
    "countryCode": "+594",
    "isoAlpha2": "GF",
    "isoAlpha3": "GUF",
    "numericCode": "254",
    "firstLanguage": "fr",
    "otherLanguages": [
      "devanagari",
      "Portuguese",
      "Haitian Creole",
      "Indigenous languages"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Overseas region and department of France",
      "politicalLean": "Leftist",
      "headsOfState": [
        {
          "title": "President of France",
          "name": "Emmanuel Macron"
        },
        {
          "title": "Prefect",
          "name": "Marc Del Grande"
        }
      ]
    },
    "timeZone": {
      "name": "French Guiana Time (GFT)",
      "offset": "-03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 300000,
    "area": {
      "value": 83534,
      "unit": "km"
    },
    "capital": "Cayenne",
    "gdp": {
      "nominal": "4.8 billion USD",
      "perCapita": "16,000 USD"
    },
    "dialingCode": "+594",
    "internetTLD": ".guy",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "15",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Dibongu Day (January 1)",
      "Carnival (February)",
      "Abolition of Slavery Day (May 10)",
      "National Day (July 14)"
    ],
    "nationalAnimal": "Jaguar",
    "nationalDish": "Bouillon d'awara",
    "tourismHighlights": [
      "Cayenne",
      "Devil's Island",
      "Tumuc-Humac Mountains",
      "Îles du Salut"
    ],
    "majorExports": [
      "Gold",
      "Fish",
      "Timber"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Petroleum products"
    ],
    "lifeExpectancy": 73,
    "literacyRate": 85,
    "climate": "Tropical rainforest climate",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Indigenous beliefs",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Brazil",
      "Suriname"
    ],
    "visaRequirement": "Visa not required for citizens of the EU or countries with bilateral agreements with France",
    "notableFacts": [
      "Largest region of France, located in South America.",
      "Home to the Guiana Space Centre, a major French and European spaceport.",
      "Features rich biodiversity including unique flora and fauna."
    ]
  },
  "GG": {
    "flag": "",
    "name": "Guernsey",
    "officialName": "Bailiwick of Guernsey",
    "countryCode": "+44",
    "isoAlpha2": "GG",
    "isoAlpha3": "GGY",
    "numericCode": "831",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "gu"
    ],
    "currency": {
      "code": "GGP",
      "symbol": "",
      "name": "Guernsey Pound"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Monarch",
          "name": "King Charles III"
        },
        {
          "title": "Lieutenant Governor",
          "name": "Vice Admiral Sir Ian Corder"
        }
      ]
    },
    "timeZone": {
      "name": "Guernsey Standard Time (GMT)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 63163,
    "area": {
      "value": 78,
      "unit": "km"
    },
    "capital": "St. Peter Port",
    "gdp": {
      "nominal": "3.2 billion USD",
      "perCapita": "51,065 USD"
    },
    "dialingCode": "+44",
    "internetTLD": ".gg",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Liberation Day (May 9)",
      "Bailiff's Day (March 27)"
    ],
    "nationalAnimal": "Guernsey Cow",
    "nationalDish": "Guernsey Bean Jar",
    "tourismHighlights": [
      "Castle Cornet",
      "St. Martin's Church",
      "La Vallette Bathing Pools",
      "The Little Chapel"
    ],
    "majorExports": [
      "Guernsey cows and dairy products",
      "Clothing",
      "Electronic equipment"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 83.1,
    "literacyRate": 99.5,
    "climate": "Oceanic, mild winters and cool summers",
    "religions": {
      "predominant": "Anglican",
      "others": [
        "Roman Catholic",
        "Methodist",
        "Baptist",
        "Other Christian denominations"
      ]
    },
    "neighborCountries": [
      "None (located in the English Channel, near France)"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Guernsey has its own unique legal system and currency.",
      "It is one of the few places in the world where the English Language is the only official language.",
      "The island is known for its beautiful coastline and rich history."
    ]
  },
  "GH": {
    "flag": "",
    "name": "Ghana",
    "officialName": "Republic of Ghana",
    "countryCode": "+233",
    "isoAlpha2": "GH",
    "isoAlpha3": "GHA",
    "numericCode": "288",
    "firstLanguage": "en",
    "otherLanguages": [
      "ak",
      "tw",
      "ee",
      "ha"
    ],
    "currency": {
      "code": "GHS",
      "symbol": "",
      "name": "Ghanaian Cedi"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nana Addo Dankwa Akufo-Addo"
        },
        {
          "title": "Vice President",
          "name": "Mahamudu Bawumia"
        }
      ]
    },
    "timeZone": {
      "name": "Ghana Mean Time (GMT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 31072940,
    "area": {
      "value": 238533,
      "unit": "km"
    },
    "capital": "Accra",
    "gdp": {
      "nominal": "74.26 billion USD",
      "perCapita": "2,387 USD"
    },
    "dialingCode": "+233",
    "internetTLD": ".gh",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "192",
      "police": "191",
      "ambulance": "193"
    },
    "holidays": [
      "Independence Day (March 6)",
      "Eid al-Fitr",
      "Eid al-Adha",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "African eagle",
    "nationalDish": "Jollof Rice",
    "tourismHighlights": [
      "Cape Coast Castle",
      "Kakum National Park",
      "Mole National Park",
      "Elmina Castle"
    ],
    "majorExports": [
      "Gold",
      "Cocoa",
      "Crude oil"
    ],
    "majorImports": [
      "Machinery",
      "Fuels",
      "Foodstuffs"
    ],
    "lifeExpectancy": 64.5,
    "literacyRate": 79,
    "climate": "Tropical",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Cote d'Ivoire",
      "Burkina Faso",
      "Togo"
    ],
    "visaRequirement": "Visa required for many nationalities; visa on arrival available for some.",
    "notableFacts": [
      "The first country in sub-Saharan Africa to gain independence from colonial rule in 1957.",
      "Known for its rich culture and history, particularly in the area of cocoa production.",
      "Hosts the annual Chale Wote Street Art Festival in Accra."
    ]
  },
  "GE": {
    "flag": "",
    "name": "Georgia",
    "officialName": "Democratic Republic of Georgia",
    "countryCode": "+995",
    "isoAlpha2": "GE",
    "isoAlpha3": "GEO",
    "numericCode": "268",
    "firstLanguage": "ka",
    "otherLanguages": [
      "ru",
      "en"
    ],
    "currency": {
      "code": "GEL",
      "symbol": "",
      "name": "Georgian Lari"
    },
    "government": {
      "type": "Unitary parliamentary republic",
      "politicalLean": "Pro-European",
      "headsOfState": [
        {
          "title": "President",
          "name": "Salome Zourabichvili"
        },
        {
          "title": "Prime Minister",
          "name": "Irakli Garibashvili"
        }
      ]
    },
    "timeZone": {
      "name": "Georgia Standard Time (GET)",
      "offset": "+04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 3989167,
    "area": {
      "value": 69700,
      "unit": "km"
    },
    "capital": "Tbilisi",
    "gdp": {
      "nominal": "17.54 billion USD",
      "perCapita": "4,401 USD"
    },
    "dialingCode": "+995",
    "internetTLD": ".ge",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "Independence Day (May 26)",
      "Saint George's Day (November 23)"
    ],
    "nationalAnimal": "Common Wolf",
    "nationalDish": "Khinkali",
    "tourismHighlights": [
      "Old Tbilisi",
      "Uplistsikhe Cave Town",
      "Kazbegi National Park",
      "Vardzia Monastery"
    ],
    "majorExports": [
      "Wine",
      "Minerals",
      "Citrus fruits"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Food"
    ],
    "lifeExpectancy": 77.4,
    "literacyRate": 99.8,
    "climate": "Varies by region: humid subtropical along the Black Sea coast; continental inland.",
    "religions": {
      "predominant": "Georgian Orthodox",
      "others": [
        "Islam",
        "Catholicism",
        "Protestantism"
      ]
    },
    "neighborCountries": [
      "Russia",
      "Azerbaijan",
      "Armenia",
      "Turkey"
    ],
    "visaRequirement": "Visa-free for several countries, including EU and US; e-Visa available for others.",
    "notableFacts": [
      "Known for its ancient winemaking traditions dating back over 8000 years.",
      "Home to diverse landscapes, including mountains, beaches, and historic cities.",
      "Georgia is claimed by the Russian Federation to be part of its territory, leading to regional tensions."
    ]
  },
  "GL": {
    "flag": "",
    "name": "Greenland",
    "officialName": "Greenland",
    "countryCode": "+299",
    "isoAlpha2": "GL",
    "isoAlpha3": "GRL",
    "numericCode": "304",
    "firstLanguage": "kl",
    "otherLanguages": [
      "da"
    ],
    "currency": {
      "code": "DKK",
      "symbol": "kr",
      "name": "Danish Krone"
    },
    "government": {
      "type": "Parliamentary democracy within a constitutional monarchy",
      "politicalLean": "Social Democratic",
      "headsOfState": [
        {
          "title": "Queen",
          "name": "Margrethe II of Denmark"
        },
        {
          "title": "Prime Minister",
          "name": "Múte Bourup Egede"
        }
      ]
    },
    "timeZone": {
      "name": "Greenland Time (GLT)",
      "offset": "-03:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "North America",
    "subregion": "Northern America",
    "population": 56381,
    "area": {
      "value": 2166086,
      "unit": "km"
    },
    "capital": "Nuuk",
    "gdp": {
      "nominal": "2.58 billion USD",
      "perCapita": "45,800 USD"
    },
    "dialingCode": "+299",
    "internetTLD": ".gl",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "114",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "National Day (June 21)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Musk Ox",
    "nationalDish": "Mattak (whale skin with blubber)",
    "tourismHighlights": [
      "Northern Lights",
      "Ilulissat Icefjord (UNESCO World Heritage Site)",
      "Greenland National Museum",
      "Takakkat Museum"
    ],
    "majorExports": [
      "Fish",
      "Seafood",
      "Minerals"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Electronic equipment"
    ],
    "lifeExpectancy": 72.6,
    "literacyRate": 100,
    "climate": "Arctic, with cold and dry winters and cool summers",
    "religions": {
      "predominant": "Evangelical Lutheran",
      "others": [
        "Indigenous beliefs",
        "Roman Catholic"
      ]
    },
    "neighborCountries": [
      "Denmark"
    ],
    "visaRequirement": "No visa required for EU countries and some other countries",
    "notableFacts": [
      "Largest island in the world.",
      "Only 15% of the land is permanently inhabited.",
      "Has one of the largest temperatures ranges in the world due to its geography."
    ]
  },
  "GN": {
    "flag": "",
    "name": "Guinea",
    "officialName": "Republic of Guinea",
    "countryCode": "+224",
    "isoAlpha2": "GN",
    "isoAlpha3": "GIN",
    "numericCode": "324",
    "firstLanguage": "fr",
    "otherLanguages": [
      "man",
      "sos",
      "pwn",
      "ful"
    ],
    "currency": {
      "code": "GNF",
      "symbol": "FG",
      "name": "Guinean franc"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Multi-party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "Maman Sidikou"
        }
      ]
    },
    "timeZone": {
      "name": "Guinea Time (GMT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Western Africa",
    "population": 13132795,
    "area": {
      "value": 245857,
      "unit": "km"
    },
    "capital": "Conakry",
    "gdp": {
      "nominal": "13.52 billion USD",
      "perCapita": "1,029 USD"
    },
    "dialingCode": "+224",
    "internetTLD": ".gn",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "116",
      "ambulance": "115"
    },
    "holidays": [
      "National Day (October 2)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "African Grey Parrot",
    "nationalDish": "Rice and fish",
    "tourismHighlights": [
      "Fouta Djallon region",
      "Conakry Grand Mosque",
      "Mount Nimba Strict Nature Reserve (UNESCO World Heritage Site)",
      "Kankan"
    ],
    "majorExports": [
      "Bauxite",
      "Gold",
      "Diamonds"
    ],
    "majorImports": [
      "Foodstuffs",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 60.8,
    "literacyRate": 79.1,
    "climate": "Tropical; humid with a dry season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Guinea-Bissau",
      "Senegal",
      "Mali",
      "Ivory Coast",
      "Liberia",
      "Sierra Leone"
    ],
    "visaRequirement": "Visa required for most foreign nationalities",
    "notableFacts": [
      "Home to one of the world's largest reserves of bauxite.",
      "Has a rich cultural heritage including a variety of traditional music and dance.",
      "Infamous for its political instability since gaining independence from France in 1958."
    ]
  },
  "GM": {
    "flag": "",
    "name": "Gambia",
    "officialName": "Republic of The Gambia",
    "countryCode": "+220",
    "isoAlpha2": "GM",
    "isoAlpha3": "GMB",
    "numericCode": "270",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "wo",
      "mnk",
      "pul"
    ],
    "currency": {
      "code": "GMD",
      "symbol": "D",
      "name": "Gambian Dalasi"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Multi-party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "Adama Barrow"
        }
      ]
    },
    "timeZone": {
      "name": "Greenwich Mean Time (GMT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 2416661,
    "area": {
      "value": 11300,
      "unit": "km"
    },
    "capital": "Banjul",
    "gdp": {
      "nominal": "1.72 billion USD",
      "perCapita": "711 USD"
    },
    "dialingCode": "+220",
    "internetTLD": ".gm",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "117",
      "police": "119",
      "ambulance": "118"
    },
    "holidays": [
      "Independence Day (February 18)",
      "Christmas Day (December 25)",
      "Eid al-Fitr (date varies)",
      "Eid al-Adha (date varies)"
    ],
    "nationalAnimal": "Green Vervet Monkey",
    "nationalDish": "Benachin (Jollof rice)",
    "tourismHighlights": [
      "Kachikally Crocodile Pool",
      "Kunta Kinteh Island",
      "Abuko Nature Reserve",
      "Banjul Market"
    ],
    "majorExports": [
      "Groundnuts",
      "Fish",
      "Cotton"
    ],
    "majorImports": [
      "Foodstuffs",
      "Machinery",
      "Petroleum products"
    ],
    "lifeExpectancy": 61.4,
    "literacyRate": 75.3,
    "climate": "Tropical with a distinct wet and dry season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Senegal"
    ],
    "visaRequirement": "Visa required for most nationalities, entry visa on arrival available for multiple countries",
    "notableFacts": [
      "The smallest country on the mainland of Africa.",
      "Gained independence from the United Kingdom in 1965.",
      "The Gambia River is the country's main geographical feature, providing vital access to trade and transport."
    ]
  },
  "GP": {
    "flag": "",
    "name": "Guadeloupe",
    "officialName": "Region of Guadeloupe",
    "countryCode": "+590",
    "isoAlpha2": "GP",
    "isoAlpha3": "GLP",
    "numericCode": "312",
    "firstLanguage": "fr",
    "otherLanguages": [
      "gw",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Overseas department and region of France",
      "politicalLean": "Left",
      "headsOfState": [
        {
          "title": "President of France",
          "name": "Emmanuel Macron"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 400000,
    "area": {
      "value": 1628,
      "unit": "km"
    },
    "capital": "Basse-Terre",
    "gdp": {
      "nominal": "12 billion USD",
      "perCapita": "30,000 USD"
    },
    "dialingCode": "+590",
    "internetTLD": ".gp",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Abolition of Slavery Day (May 27)",
      "Carnival (February/March)"
    ],
    "nationalAnimal": "Amazon Parrot",
    "nationalDish": "Colombo",
    "tourismHighlights": [
      "Pointe-à-Pitre",
      "Basse-Terre Natural Park",
      "La Grande Soufrière Volcano",
      "Iles des Saintes"
    ],
    "majorExports": [
      "Bananas",
      "Sugar",
      "Rum"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 80.5,
    "literacyRate": 99,
    "climate": "Tropical, with a wet season from June to November",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Dominica",
      "Antigua and Barbuda"
    ],
    "visaRequirement": "No visa required for EU citizens and many others",
    "notableFacts": [
      "Part of the French overseas departments.",
      "Known for its rich biodiversity and beautiful landscapes.",
      "Popular destination for eco-tourism and water sports."
    ]
  },
  "GQ": {
    "flag": "",
    "name": "Equatorial Guinea",
    "officialName": "Republic of Equatorial Guinea",
    "countryCode": "+240",
    "isoAlpha2": "GQ",
    "isoAlpha3": "GNQ",
    "numericCode": "226",
    "firstLanguage": "es",
    "otherLanguages": [
      "fr",
      "pt",
      "bubi",
      "fang"
    ],
    "currency": {
      "code": "XAF",
      "symbol": "",
      "name": "Central African CFA franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Teodoro Obiang Nguema Mbasogo"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 1413000,
    "area": {
      "value": 28051,
      "unit": "km"
    },
    "capital": "Malabo",
    "gdp": {
      "nominal": "14.45 billion USD",
      "perCapita": "10232 USD"
    },
    "dialingCode": "+240",
    "internetTLD": ".gq",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "150",
      "ambulance": "141"
    },
    "holidays": [
      "Independence Day (October 12)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Giant Sable Antelope",
    "nationalDish": "Peanut Soup",
    "tourismHighlights": [
      "Luba Island",
      "Pico Basile National Park",
      "Malabo National Park",
      "Corisco Island"
    ],
    "majorExports": [
      "Oil",
      "Gas",
      "Timber"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Vehicles"
    ],
    "lifeExpectancy": 58.9,
    "literacyRate": 95.3,
    "climate": "Tropical, hot and humid year-round",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "None (island country)"
    ],
    "visaRequirement": "Visa required for most travelers",
    "notableFacts": [
      "Equatorial Guinea is the only African country where Spanish is an official language.",
      "It has one of the highest per capita incomes in Africa due to oil reserves.",
      "The country is composed of a mainland region and several islands."
    ]
  },
  "GU": {
    "flag": "",
    "name": "Guam",
    "officialName": "Guam",
    "countryCode": "+1",
    "isoAlpha2": "GU",
    "isoAlpha3": "GUM",
    "numericCode": "316",
    "firstLanguage": "ch",
    "otherLanguages": [
      "en",
      "es"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Unincorporated territory of the United States",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Luluan Guerrero"
        },
        {
          "title": "President",
          "name": "Joe Biden"
        }
      ]
    },
    "timeZone": {
      "name": "Chamorro Standard Time (ChST)",
      "offset": "+10:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Micronesia",
    "population": 168775,
    "area": {
      "value": 544,
      "unit": "km"
    },
    "capital": "Hagåtña",
    "gdp": {
      "nominal": "5.79 billion USD",
      "perCapita": "34,250 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".gu",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Guam Discovery Day (March 1)",
      "Independence Day (July 21)"
    ],
    "nationalAnimal": "Brown Tree Snake",
    "nationalDish": "Kelaguen",
    "tourismHighlights": [
      "Tumon Bay",
      "Guam Museum",
      "Two Lovers Point",
      "War in the Pacific National Historical Park"
    ],
    "majorExports": [
      "Clothing",
      "Iron and steel",
      "Machinery"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Consumer goods"
    ],
    "lifeExpectancy": 78.8,
    "literacyRate": 99,
    "climate": "Tropical marine, warm and humid year-round",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Buddhist",
        "Hindu",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (island territory)"
    ],
    "visaRequirement": "Visa required for certain nationalities; no visa required for U.S. citizens.",
    "notableFacts": [
      "Guam is the largest island in Micronesia.",
      "A major military presence exists, being a strategic location for the U.S.",
      "The island has a unique blend of Chamorro and American cultures."
    ]
  },
  "GT": {
    "flag": "",
    "name": "Guatemala",
    "officialName": "Republic of Guatemala",
    "countryCode": "+502",
    "isoAlpha2": "GT",
    "isoAlpha3": "GTM",
    "numericCode": "320",
    "firstLanguage": "es",
    "otherLanguages": [
      "qeh",
      "mam",
      "k'iche'",
      "xinka",
      "garifuna"
    ],
    "currency": {
      "code": "GTQ",
      "symbol": "Q",
      "name": "Guatemalan Quetzal"
    },
    "government": {
      "type": "Presidential representative democratic republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Bernardo Arévalo"
        }
      ]
    },
    "timeZone": {
      "name": "Central Standard Time (CST)",
      "offset": "-06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Central America",
    "population": 18561664,
    "area": {
      "value": 108889,
      "unit": "km"
    },
    "capital": "Guatemala City",
    "gdp": {
      "nominal": "85.98 billion USD",
      "perCapita": "4,650 USD"
    },
    "dialingCode": "+502",
    "internetTLD": ".gt",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "110",
      "fire": "123",
      "police": "110",
      "ambulance": "125"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (September 15)",
      "All Saints' Day (November 1)"
    ],
    "nationalAnimal": "Quetzal",
    "nationalDish": "Pepian",
    "tourismHighlights": [
      "Tikal National Park (UNESCO World Heritage Site)",
      "Lake Atitlán",
      "Antigua Guatemala",
      "Semuc Champey"
    ],
    "majorExports": [
      "Bananas",
      "Coffee",
      "Cardamom"
    ],
    "majorImports": [
      "Petroleum",
      "Electronics",
      "Vehicles"
    ],
    "lifeExpectancy": 74.8,
    "literacyRate": 81.5,
    "climate": "Tropical; wet and dry seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Mayan spirituality",
        "Evangelical"
      ]
    },
    "neighborCountries": [
      "Mexico",
      "Belize",
      "Honduras",
      "El Salvador"
    ],
    "visaRequirement": "No visa required for many Central American countries and some South American countries",
    "notableFacts": [
      "Home to an impressive number of Mayan archaeological sites.",
      "Second-largest country in Central America by area.",
      "The national bird, the Quetzal, is a symbol of freedom."
    ]
  },
  "GR": {
    "flag": "",
    "name": "Greece",
    "officialName": "Hellenic Republic",
    "countryCode": "+30",
    "isoAlpha2": "GR",
    "isoAlpha3": "GRC",
    "numericCode": "300",
    "firstLanguage": "el",
    "otherLanguages": [
      "en",
      "de",
      "fr"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Katerina Sakellaropoulou"
        },
        {
          "title": "Prime Minister",
          "name": "Kyriakos Mitsotakis"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 10423054,
    "area": {
      "value": 131957,
      "unit": "km"
    },
    "capital": "Athens",
    "gdp": {
      "nominal": "238.36 billion USD",
      "perCapita": "22,051 USD"
    },
    "dialingCode": "+30",
    "internetTLD": ".gr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "199",
      "police": "100",
      "ambulance": "166"
    },
    "holidays": [
      "Independence Day (March 25)",
      "Ohi Day (October 28)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Dolphin",
    "nationalDish": "Moussaka",
    "tourismHighlights": [
      "Acropolis of Athens",
      "Santorini Islands",
      "Meteora Monasteries",
      "Delphi Archaeological Site"
    ],
    "majorExports": [
      "Refined petroleum",
      "Aluminium",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Crude petroleum",
      "Machinery",
      "Transport equipment"
    ],
    "lifeExpectancy": 83.3,
    "literacyRate": 97.7,
    "climate": "Mediterranean with hot, dry summers and mild, wet winters",
    "religions": {
      "predominant": "Eastern Orthodox Christianity",
      "others": [
        "Islam",
        "Protestantism",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Albania",
      "North Macedonia",
      "Bulgaria",
      "Turkey"
    ],
    "visaRequirement": "Shengen visa required for most non-EU countries",
    "notableFacts": [
      "Home to one of the oldest civilizations in the world.",
      "Birthplace of democracy and western philosophy.",
      "A major destination for tourists due to its rich history and beautiful islands."
    ]
  },
  "GW": {
    "flag": "",
    "name": "Guinea-Bissau",
    "officialName": "Republic of Guinea-Bissau",
    "countryCode": "+245",
    "isoAlpha2": "GW",
    "isoAlpha3": "GNB",
    "numericCode": "624",
    "firstLanguage": "pt",
    "otherLanguages": [
      "cr",
      "mg",
      "manjaku"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "CFA",
      "name": "West African CFA franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Multi-party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "Umaro Sissoco Embaló"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Western Africa",
    "population": 2068000,
    "area": {
      "value": 36125,
      "unit": "km"
    },
    "capital": "Bissau",
    "gdp": {
      "nominal": "1.46 billion USD",
      "perCapita": "706 USD"
    },
    "dialingCode": "+245",
    "internetTLD": ".gw",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "117",
      "ambulance": "115"
    },
    "holidays": [
      "Independence Day (September 24)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "African Grey Parrot",
    "nationalDish": "Jollof rice",
    "tourismHighlights": [
      "Arquipélago dos Bijagós",
      "Bissau Velho",
      "Orango Island National Park",
      "João Vieira and Poilão National Park"
    ],
    "majorExports": [
      "Cashew nuts",
      "Fish",
      "Gum arabic"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Machinery"
    ],
    "lifeExpectancy": 58.1,
    "literacyRate": 63.2,
    "climate": "Tropical savanna climate with a wet and a dry season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Animism"
      ]
    },
    "neighborCountries": [
      "Senegal",
      "Guinea"
    ],
    "visaRequirement": "Visa required for most nationalities.",
    "notableFacts": [
      "One of the world's most impoverished countries.",
      "Renowned for its biodiversity, especially in the Bijagós Archipelago.",
      "Has a history of political instability since its independence."
    ]
  },
  "GS": {
    "flag": "",
    "name": "South Georgia",
    "officialName": "South Georgia and the South Sandwich Islands",
    "countryCode": "+500",
    "isoAlpha2": "GS",
    "isoAlpha3": "SGS",
    "numericCode": "239",
    "firstLanguage": "en",
    "otherLanguages": [
      "es"
    ],
    "currency": {
      "code": "GBP",
      "symbol": "",
      "name": "British Pound Sterling"
    },
    "government": {
      "type": "Overseas territory of the United Kingdom",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Appointed by the British Monarch"
        }
      ]
    },
    "timeZone": {
      "name": "South Georgia Time (SGT)",
      "offset": "-02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 30,
    "area": {
      "value": 3900,
      "unit": "km"
    },
    "capital": "King Edward Point",
    "gdp": {
      "nominal": "N/A",
      "perCapita": "N/A"
    },
    "dialingCode": "+500",
    "internetTLD": ".gs",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "N/A",
      "fire": "N/A",
      "police": "N/A",
      "ambulance": "N/A"
    },
    "holidays": [
      "Falkland Islands Day (August 14)",
      "Queen's Official Birthday (June)"
    ],
    "nationalAnimal": "Elephant Seal",
    "nationalDish": "N/A",
    "tourismHighlights": [
      "South Georgia Museum",
      "King Edward Point",
      "Penguin Colonies",
      "St. Andrews Bay"
    ],
    "majorExports": [
      "Krill",
      "Fish",
      "Wildlife Tourism"
    ],
    "majorImports": [
      "Food and Supplies",
      "Fuel",
      "Construction Materials"
    ],
    "lifeExpectancy": "N/A",
    "literacyRate": "N/A",
    "climate": "Subpolar oceanic climate, with cool temperatures year-round and moderate precipitation",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None"
      ]
    },
    "neighborCountries": [
      "N/A"
    ],
    "visaRequirement": "No visa is required for British citizens; entry is restricted for others.",
    "notableFacts": [
      "Home to one of the largest populations of wildlife, including seals and penguins.",
      "It is primarily a research station and is minimally inhabited.",
      "The island played a significant role during the Falklands War."
    ]
  },
  "GY": {
    "flag": "",
    "name": "Guyana",
    "officialName": "Co-operative Republic of Guyana",
    "countryCode": "+592",
    "isoAlpha2": "GY",
    "isoAlpha3": "GUY",
    "numericCode": "328",
    "firstLanguage": "en",
    "otherLanguages": [
      "ho",
      "es",
      "pt"
    ],
    "currency": {
      "code": "GYS",
      "symbol": "G$",
      "name": "Guyanese Dollar"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Mixed",
      "headsOfState": [
        {
          "title": "President",
          "name": "Irfaan Ali"
        }
      ]
    },
    "timeZone": {
      "name": "Guyana Time (GYT)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 786559,
    "area": {
      "value": 214971,
      "unit": "km"
    },
    "capital": "Georgetown",
    "gdp": {
      "nominal": "9.57 billion USD",
      "perCapita": "12,151 USD"
    },
    "dialingCode": "+592",
    "internetTLD": ".gy",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "912",
      "police": "913",
      "ambulance": "914"
    },
    "holidays": [
      "Mashramani (February 23)",
      "Independence Day (May 26)",
      "Emancipation Day (August 1)",
      "Diwali"
    ],
    "nationalAnimal": "Giant River Otter",
    "nationalDish": "Pepper Pot",
    "tourismHighlights": [
      "Kaieteur Falls",
      "Iguana Island",
      "Guyana National Park",
      "Shell Beach"
    ],
    "majorExports": [
      "Gold",
      "Rice",
      "Sugar"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Chemicals"
    ],
    "lifeExpectancy": 70.4,
    "literacyRate": 98.1,
    "climate": "Tropical, with a wet season and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Islam",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Suriname",
      "Brazil",
      "Venezuela"
    ],
    "visaRequirement": "Visa required for some countries; others may enter visa-free.",
    "notableFacts": [
      "Home to one of the world's largest rainforests.",
      "Known for its diverse wildlife and cultural richness.",
      "The name 'Guyana' means 'Land of Many Waters' in the indigenous language."
    ]
  },
  "HN": {
    "flag": "",
    "name": "Honduras",
    "officialName": "Republic of Honduras",
    "countryCode": "+504",
    "isoAlpha2": "HN",
    "isoAlpha3": "HND",
    "numericCode": "340",
    "firstLanguage": "es",
    "otherLanguages": [
      "Miskito",
      "Garifuna",
      "English"
    ],
    "currency": {
      "code": "HNL",
      "symbol": "L",
      "name": "Honduran Lempira"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Xiomara Castro"
        }
      ]
    },
    "timeZone": {
      "name": "Central Standard Time (CST)",
      "offset": "-06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Central America",
    "population": 10074362,
    "area": {
      "value": 112492,
      "unit": "km"
    },
    "capital": "Tegucigalpa",
    "gdp": {
      "nominal": "26.03 billion USD",
      "perCapita": "2,583 USD"
    },
    "dialingCode": "+504",
    "internetTLD": ".hn",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "198",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (September 15)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "White-tailed Deer",
    "nationalDish": "Baleadas",
    "tourismHighlights": [
      "Copán Ruins (UNESCO World Heritage Site)",
      "Roatan Island",
      "La Tigra National Park",
      "Utila Island"
    ],
    "majorExports": [
      "Coffee",
      "Bananas",
      "Palm oil"
    ],
    "majorImports": [
      "Petroleum",
      "Machinery",
      "Consumer goods"
    ],
    "lifeExpectancy": 75.2,
    "literacyRate": 88,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Mayan beliefs",
        "Other"
      ]
    },
    "neighborCountries": [
      "Guatemala",
      "El Salvador",
      "Nicaragua"
    ],
    "visaRequirement": "Visa not required for many countries, but required for others including some in Asia and Africa.",
    "notableFacts": [
      "Home to the ancient Mayan civilization.",
      "Has the second largest barrier reef in the world.",
      "Known for its rich biodiversity and various ecosystems."
    ]
  },
  "HR": {
    "flag": "",
    "name": "Croatia",
    "officialName": "Republic of Croatia",
    "countryCode": "+385",
    "isoAlpha2": "HR",
    "isoAlpha3": "HRV",
    "numericCode": "191",
    "firstLanguage": "hr",
    "otherLanguages": [
      "en",
      "de",
      "it"
    ],
    "currency": {
      "code": "HRK",
      "symbol": "kn",
      "name": "Croatian Kuna"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Center-left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Zoran Milanović"
        },
        {
          "title": "Prime Minister",
          "name": "Andrej Plenković"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 4105267,
    "area": {
      "value": 56594,
      "unit": "km"
    },
    "capital": "Zagreb",
    "gdp": {
      "nominal": "69.76 billion USD",
      "perCapita": "17,080 USD"
    },
    "dialingCode": "+385",
    "internetTLD": ".hr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "193",
      "police": "192",
      "ambulance": "194"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (June 25)",
      "Statehood Day (June 30)",
      "Hvar Day (August 5)"
    ],
    "nationalAnimal": "Vučjak (Wolf)",
    "nationalDish": "Peka (Roasted under a bell)",
    "tourismHighlights": [
      "Plitvice Lakes National Park",
      "Dubrovnik Old Town (UNESCO World Heritage Site)",
      "Split and Diocletian's Palace",
      "Krka National Park"
    ],
    "majorExports": [
      "Manufactures",
      "Machinery",
      "Food products"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Transport equipment"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 99.5,
    "climate": "Mediterranean along the coast, continental inland",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Orthodox Christianity",
        "Islam",
        "Protestantism"
      ]
    },
    "neighborCountries": [
      "Slovenia",
      "Hungary",
      "Serbia",
      "Bosnia and Herzegovina",
      "Montenegro"
    ],
    "visaRequirement": "Schengen Visa required for some nationalities",
    "notableFacts": [
      "Croatia has a beautiful coastline along the Adriatic Sea with over 1,000 islands.",
      "It is known for its medieval architecture and stunning natural parks.",
      "Home to several UNESCO World Heritage Sites, including the ancient city of Dubrovnik."
    ]
  },
  "HK": {
    "flag": "",
    "name": "Hong Kong",
    "officialName": "Hong Kong Special Administrative Region of the People's Republic of China",
    "countryCode": "+852",
    "isoAlpha2": "HK",
    "isoAlpha3": "HKG",
    "numericCode": "344",
    "firstLanguage": "zh-HK",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "HKD",
      "symbol": "HK$",
      "name": "Hong Kong Dollar"
    },
    "government": {
      "type": "Special Administrative Region",
      "politicalLean": "Unknown",
      "headsOfState": [
        {
          "title": "Chief Executive",
          "name": "John Lee"
        }
      ]
    },
    "timeZone": {
      "name": "Hong Kong Time (HKT)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "YYYY-MM-DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "East Asia",
    "population": 7451000,
    "area": {
      "value": 1106,
      "unit": "km"
    },
    "capital": "Hong Kong",
    "gdp": {
      "nominal": "368 billion USD",
      "perCapita": "49,092 USD"
    },
    "dialingCode": "+852",
    "internetTLD": ".hk",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Lunar New Year (date varies)",
      "Ching Ming Festival (date varies)",
      "Good Friday (date varies)",
      "Easter Monday (date varies)",
      "Labor Day (May 1)",
      "Buddha's Birthday (date varies)",
      "Dragon Boat Festival (date varies)",
      "National Day (October 1)",
      "Mid-Autumn Festival (date varies)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Buffalo",
    "nationalDish": "Dim Sum",
    "tourismHighlights": [
      "Victoria Peak",
      "Tsim Sha Tsui Promenade",
      "Hong Kong Disneyland",
      "Big Buddha",
      "Mong Kok markets"
    ],
    "majorExports": [
      "Clothing",
      "Electronics",
      "Jewelry",
      "Toys"
    ],
    "majorImports": [
      "Electronics",
      "Raw materials",
      "Food",
      "Petroleum"
    ],
    "lifeExpectancy": 85.3,
    "literacyRate": 94.6,
    "climate": "Subtropical with hot, humid summers and mild winters",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Taoism",
        "Christianity",
        "Islam",
        "Other"
      ]
    },
    "neighborCountries": [
      "Mainland China (Guangdong Province)"
    ],
    "visaRequirement": "Visa-free access for many nationalities including EU, UK, US, and others.",
    "notableFacts": [
      "Hong Kong is known for its skyline and deep natural harbor.",
      "It is one of the most densely populated areas in the world.",
      "The region operates under the principle of 'One Country, Two Systems' allowing for a high degree of autonomy."
    ]
  },
  "HM": {
    "flag": "",
    "name": "Heard Island and McDonald Islands",
    "officialName": "Heard Island and McDonald Islands",
    "countryCode": "+672",
    "isoAlpha2": "HM",
    "isoAlpha3": "HMD",
    "numericCode": "334",
    "firstLanguage": "en",
    "otherLanguages": [],
    "currency": {
      "code": "AUD",
      "symbol": "$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "External territory of Australia",
      "politicalLean": "Dependent",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Governor-General of Australia"
        }
      ]
    },
    "timeZone": {
      "name": "Heard and McDonald Islands Time (HMT)",
      "offset": "+05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "population": 0,
    "area": {
      "value": 412,
      "unit": "km"
    },
    "capital": "There is no capital; research station for scientific study.",
    "gdp": {
      "nominal": "Not applicable",
      "perCapita": "Not applicable"
    },
    "dialingCode": "+672",
    "internetTLD": ".hm",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "Not applicable",
      "fire": "Not applicable",
      "police": "Not applicable",
      "ambulance": "Not applicable"
    },
    "holidays": [
      "No official public holidays, as it is uninhabited except for temporary researchers."
    ],
    "nationalAnimal": "Seals",
    "nationalDish": "Not applicable",
    "tourismHighlights": [
      "Natural beauty of glaciers and volcanic formations",
      "Unique wildlife including seals and seabirds",
      "Research opportunities for scientists"
    ],
    "majorExports": [
      "Marine resources (fishing rights)",
      "Scientific research data"
    ],
    "majorImports": [
      "Supplies for research expeditions"
    ],
    "lifeExpectancy": "Not applicable due to lack of permanent residents.",
    "literacyRate": "Not applicable due to lack of permanent residents.",
    "climate": "Extreme polar climate, sub-Antarctic",
    "religions": {
      "predominant": "Not applicable",
      "others": []
    },
    "neighborCountries": [
      "None, as it is uninhabited and remote"
    ],
    "visaRequirement": "No visa required for Australian citizens; others require permission from the Australian government.",
    "notableFacts": [
      "Heard Island is home to the southernmost active volcano, Mawson Peak.",
      "The islands are uninhabited but host temporary research stations.",
      "Environmentally protected due to unique ecosystems and biodiversity."
    ]
  },
  "HT": {
    "flag": "",
    "name": "Haiti",
    "officialName": "Republic of Haiti",
    "countryCode": "+509",
    "isoAlpha2": "HT",
    "isoAlpha3": "HTI",
    "numericCode": "332",
    "firstLanguage": "ht",
    "otherLanguages": [
      "fr"
    ],
    "currency": {
      "code": "HTG",
      "symbol": "G",
      "name": "Gourde"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Political instability",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ariel Henry"
        }
      ]
    },
    "timeZone": {
      "name": "Haiti Standard Time (HT)",
      "offset": "-05:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 11263077,
    "area": {
      "value": 27750,
      "unit": "km"
    },
    "capital": "Port-au-Prince",
    "gdp": {
      "nominal": "17.87 billion USD",
      "perCapita": "1,585 USD"
    },
    "dialingCode": "+509",
    "internetTLD": ".ht",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "114",
      "fire": "118",
      "police": "150",
      "ambulance": "123"
    },
    "holidays": [
      "Independence Day (January 1)",
      "Flag Day (May 18)"
    ],
    "nationalAnimal": "Hispaniolan Trogon",
    "nationalDish": "Griot",
    "tourismHighlights": [
      "Citadelle Laferrière",
      "Labadee Beach",
      "Sans-Souci Palace",
      "Jacmel"
    ],
    "majorExports": [
      "Textiles",
      "Mangoes",
      "Coffee"
    ],
    "majorImports": [
      "Petroleum products",
      "Food",
      "Machinery"
    ],
    "lifeExpectancy": 64.1,
    "literacyRate": 61.7,
    "climate": "Tropical, with a wet and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Vodou"
      ]
    },
    "neighborCountries": [
      "Dominican Republic"
    ],
    "visaRequirement": "Visa required for many nationalities, including EU and USA",
    "notableFacts": [
      "First independent nation in Latin America and the Caribbean (1804).",
      "Haiti shares the island of Hispaniola with the Dominican Republic.",
      "Struggled with political instability and natural disasters."
    ]
  },
  "ID": {
    "flag": "",
    "name": "Indonesia",
    "officialName": "Republic of Indonesia",
    "countryCode": "+62",
    "isoAlpha2": "ID",
    "isoAlpha3": "IDN",
    "numericCode": "360",
    "firstLanguage": "id",
    "otherLanguages": [
      "jv",
      "su",
      "en"
    ],
    "currency": {
      "code": "IDR",
      "symbol": "Rp",
      "name": "Indonesian Rupiah"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Joko Widodo"
        }
      ]
    },
    "timeZone": {
      "name": "Indonesia Western Standard Time (WIB)",
      "offset": "+07:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 273632000,
    "area": {
      "value": 1910931,
      "unit": "km"
    },
    "capital": "Jakarta",
    "gdp": {
      "nominal": "1.19 trillion USD",
      "perCapita": "4,350 USD"
    },
    "dialingCode": "+62",
    "internetTLD": ".id",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "113",
      "police": "110",
      "ambulance": "118"
    },
    "holidays": [
      "Independence Day (August 17)",
      "Eid al-Fitr",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Garuda",
    "nationalDish": "Nasi Goreng",
    "tourismHighlights": [
      "Bali Island",
      "Komodo National Park (UNESCO World Heritage Site)",
      "Borobudur Temple",
      "Jakarta's Old Town (Kota Tua)"
    ],
    "majorExports": [
      "Palm oil",
      "Coal",
      "Textiles"
    ],
    "majorImports": [
      "Machinery",
      "Chemicals",
      "Fuel"
    ],
    "lifeExpectancy": 73.6,
    "literacyRate": 95.4,
    "climate": "Tropical, with a wet season and a dry season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Hinduism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Malaysia",
      "Papua New Guinea",
      "East Timor"
    ],
    "visaRequirement": "Visa-free or visa-on-arrival for many countries; others require a visa",
    "notableFacts": [
      "Is the largest archipelago in the world with over 17,000 islands.",
      "One of the most biodiverse countries on earth, home to unique wildlife.",
      "The world's third-largest democracy by number of voters."
    ]
  },
  "HU": {
    "flag": "",
    "name": "Hungary",
    "officialName": "Hungary",
    "countryCode": "+36",
    "isoAlpha2": "HU",
    "isoAlpha3": "HUN",
    "numericCode": "348",
    "firstLanguage": "hu",
    "otherLanguages": [
      "en",
      "de",
      "sk"
    ],
    "currency": {
      "code": "HUF",
      "symbol": "Ft",
      "name": "Hungarian Forint"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Right-wing",
      "headsOfState": [
        {
          "title": "President",
          "name": "Katalin Novák"
        },
        {
          "title": "Prime Minister",
          "name": "Viktor Orbán"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "YYYY.MM.DD.",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Central Europe",
    "population": 9660351,
    "area": {
      "value": 93030,
      "unit": "km"
    },
    "capital": "Budapest",
    "gdp": {
      "nominal": "155.29 billion USD",
      "perCapita": "16,020 USD"
    },
    "dialingCode": "+36",
    "internetTLD": ".hu",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "105",
      "police": "107",
      "ambulance": "104"
    },
    "holidays": [
      "National Day (March 15)",
      "Revolution Day (October 23)"
    ],
    "nationalAnimal": "Turul",
    "nationalDish": "Gulyás",
    "tourismHighlights": [
      "Buda Castle",
      "Heroes' Square",
      "Lake Balaton",
      "Széchenyi Thermal Bath"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Vehicle parts",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Machinery",
      "Energy",
      "Raw materials"
    ],
    "lifeExpectancy": 76.9,
    "literacyRate": 99.6,
    "climate": "Temperate with four distinct seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Reformed Christianity",
        "Lutheran",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Austria",
      "Slovakia",
      "Ukraine",
      "Romania",
      "Serbia",
      "Croatia",
      "Slovenia"
    ],
    "visaRequirement": "Visa required for certain countries, but not for EU citizens.",
    "notableFacts": [
      "Home to one of the largest thermal water cave systems in the world.",
      "The Hungarian language is unique and unrelated to most languages in Europe.",
      "Hungary has a rich history of innovation in science and the arts."
    ]
  },
  "IL": {
    "flag": "",
    "name": "Israel",
    "officialName": "State of Israel",
    "countryCode": "+972",
    "isoAlpha2": "IL",
    "isoAlpha3": "ISR",
    "numericCode": "376",
    "firstLanguage": "he",
    "otherLanguages": [
      "ar",
      "en"
    ],
    "currency": {
      "code": "ILS",
      "symbol": "",
      "name": "Israeli New Shekel"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Isaac Herzog"
        },
        {
          "title": "Prime Minister",
          "name": "Benjamin Netanyahu"
        }
      ]
    },
    "timeZone": {
      "name": "Israel Standard Time (IST)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Middle East",
    "subregion": "Western Asia",
    "population": 9300000,
    "area": {
      "value": 22072,
      "unit": "km"
    },
    "capital": "Jerusalem",
    "gdp": {
      "nominal": "484 billion USD",
      "perCapita": "52,664 USD"
    },
    "dialingCode": "+972",
    "internetTLD": ".il",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "100",
      "fire": "102",
      "police": "100",
      "ambulance": "101"
    },
    "holidays": [
      "Yom Kippur",
      "Passover",
      "Rosh Hashanah",
      "Independence Day"
    ],
    "nationalAnimal": "Israeli Gazelle",
    "nationalDish": "Shakshuka",
    "tourismHighlights": [
      "Western Wall",
      "Masada",
      "Dead Sea",
      "Tel Aviv beaches",
      "Nazareth"
    ],
    "majorExports": [
      "Diamonds",
      "Pharmaceuticals",
      "Technology products"
    ],
    "majorImports": [
      "Diamonds",
      "Raw materials",
      "Machinery"
    ],
    "lifeExpectancy": 83.2,
    "literacyRate": 97.8,
    "climate": "Mediterranean climate with hot, dry summers and cool, rainy winters",
    "religions": {
      "predominant": "Judaism",
      "others": [
        "Islam",
        "Christianity",
        "Druze"
      ]
    },
    "neighborCountries": [
      "Egypt",
      "Jordan",
      "Syria",
      "Lebanon"
    ],
    "visaRequirement": "No visa required for many countries including the US, EU members, and others",
    "notableFacts": [
      "Home to some of the oldest inhabitant cities in the world, including Jerusalem and Jaffa.",
      "Is a leader in technology and startups, often referred to as 'Startup Nation'.",
      "Has a highly developed economy with a strong focus on tech, agriculture, and tourism."
    ]
  },
  "IE": {
    "flag": "",
    "name": "Ireland",
    "officialName": "Ireland",
    "countryCode": "+353",
    "isoAlpha2": "IE",
    "isoAlpha3": "IRL",
    "numericCode": "372",
    "firstLanguage": "en",
    "otherLanguages": [
      "ga"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Center-left to center-right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Michael D. Higgins"
        },
        {
          "title": "Prime Minister (Taoiseach)",
          "name": "Leo Varadkar"
        }
      ]
    },
    "timeZone": {
      "name": "Irish Standard Time (IST)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 4980000,
    "area": {
      "value": 70273,
      "unit": "km"
    },
    "capital": "Dublin",
    "gdp": {
      "nominal": "500 billion USD",
      "perCapita": "100,859 USD"
    },
    "dialingCode": "+353",
    "internetTLD": ".ie",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "St. Patrick's Day (March 17)",
      "Easter Monday",
      "May Day (first Monday in May)",
      "June Bank Holiday (first Monday in June)",
      "August Bank Holiday (first Monday in August)",
      "October Bank Holiday (last Monday in October)",
      "Christmas Day (December 25)",
      "St. Stephen's Day (December 26)"
    ],
    "nationalAnimal": "Irish Hare",
    "nationalDish": "Irish Stew",
    "tourismHighlights": [
      "Cliffs of Moher",
      "Giant's Causeway",
      "Ring of Kerry",
      "Trinity College and the Book of Kells"
    ],
    "majorExports": [
      "Pharmaceuticals",
      "Computers",
      "Machinery",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery",
      "Electronics",
      "Oil",
      "Food"
    ],
    "lifeExpectancy": 82.7,
    "literacyRate": 99,
    "climate": "Temperate maritime; mild winters, cool summers, and abundant rainfall",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "None",
        "Other Christian"
      ]
    },
    "neighborCountries": [
      "United Kingdom"
    ],
    "visaRequirement": "No visa required for EU countries and many others; check for specific requirements.",
    "notableFacts": [
      "Known for its rich cultural heritage, including literature and music.",
      "Ireland is famous for its landscapes, historic sites, and friendly people.",
      "Home to the ancient ruins of Newgrange, older than Stonehenge."
    ]
  },
  "IO": {
    "flag": "",
    "name": "British Indian Ocean Territory",
    "officialName": "British Indian Ocean Territory",
    "countryCode": "+246",
    "isoAlpha2": "IO",
    "isoAlpha3": "IOT",
    "numericCode": "086",
    "firstLanguage": "en",
    "otherLanguages": [],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "British Overseas Territory",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Monarch",
          "name": "King Charles III"
        },
        {
          "title": "Governor",
          "name": "Governor of the British Indian Ocean Territory"
        }
      ]
    },
    "timeZone": {
      "name": "Chagos Islands Time (IOT)",
      "offset": "+06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Eastern Africa",
    "population": 3000,
    "area": {
      "value": 60,
      "unit": "km"
    },
    "capital": "Diego Garcia",
    "gdp": {
      "nominal": "Not available",
      "perCapita": "Not available"
    },
    "dialingCode": "+246",
    "internetTLD": ".io",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "Not available",
      "police": "Not available",
      "ambulance": "Not available"
    },
    "holidays": [
      "No specific public holidays observed"
    ],
    "nationalAnimal": "No designated national animal",
    "nationalDish": "No designated national dish",
    "tourismHighlights": [
      "Diego Garcia (a major military base)",
      "White sandy beaches and coral reefs"
    ],
    "majorExports": [
      "None, primarily a military and support base."
    ],
    "majorImports": [
      "Food and other supplies (by military logistics)"
    ],
    "lifeExpectancy": "Not available",
    "literacyRate": "Not available",
    "climate": "Tropical marine climate",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None, isolated in the Indian Ocean."
    ],
    "visaRequirement": "Restricted access; visas required for non-military personnel.",
    "notableFacts": [
      "The territory consists mainly of the island of Diego Garcia, which hosts a significant military base.",
      "The population is predominantly military personnel and their families.",
      "There are no native inhabitants on the islands."
    ]
  },
  "IM": {
    "flag": "",
    "name": "Isle of Man",
    "officialName": "Isle of Man",
    "countryCode": "+44",
    "isoAlpha2": "IM",
    "isoAlpha3": "IMN",
    "numericCode": "833",
    "firstLanguage": "en",
    "otherLanguages": [
      "gv"
    ],
    "currency": {
      "code": "GBP",
      "symbol": "",
      "name": "British Pound"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Lieutenant Governor",
          "name": "Representative of the British Monarch"
        },
        {
          "title": "Chief Minister",
          "name": "Elected Leader"
        }
      ]
    },
    "timeZone": {
      "name": "Greenwich Mean Time (GMT)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 85000,
    "area": {
      "value": 572,
      "unit": "km"
    },
    "capital": "Douglas",
    "gdp": {
      "nominal": "6.65 billion USD",
      "perCapita": "77,600 USD"
    },
    "dialingCode": "+44",
    "internetTLD": ".im",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Tynwald Day (July 5)",
      "Saint John's Day (June 24)"
    ],
    "nationalAnimal": "Manx Loaghtan Sheep",
    "nationalDish": "Seafood Chowder",
    "tourismHighlights": [
      "Isle of Man TT Races",
      "Laxey Wheel",
      "Snaefell Mountain",
      "Castletown and Castle Rushen"
    ],
    "majorExports": [
      "Electronic components",
      "Financial services",
      "Insurance"
    ],
    "majorImports": [
      "Petroleum products",
      "Machinery",
      "Food"
    ],
    "lifeExpectancy": 82.5,
    "literacyRate": 99.4,
    "climate": "Temperate maritime, mild and wet",
    "religions": {
      "predominant": "Christian",
      "others": [
        "None",
        "Buddhism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "United Kingdom"
    ],
    "visaRequirement": "No visa required for EU countries and certain others",
    "notableFacts": [
      "Not a part of the United Kingdom, but a Crown dependency.",
      "Known for its unique Manx culture and language.",
      "The home of the famous motorcycle race, the Isle of Man TT."
    ]
  },
  "IR": {
    "flag": "",
    "name": "Iran",
    "officialName": "Islamic Republic of Iran",
    "countryCode": "+98",
    "isoAlpha2": "IR",
    "isoAlpha3": "IRN",
    "numericCode": "364",
    "firstLanguage": "fa",
    "otherLanguages": [
      "az",
      "ku",
      "ar",
      "bal"
    ],
    "currency": {
      "code": "IRR",
      "symbol": "",
      "name": "Iranian Rial"
    },
    "government": {
      "type": "Islamic Republic",
      "politicalLean": "Theocratic",
      "headsOfState": [
        {
          "title": "Supreme Leader",
          "name": "Ali Khamenei"
        },
        {
          "title": "President",
          "name": "Ebrahim Raisi"
        }
      ]
    },
    "timeZone": {
      "name": "Iran Standard Time (IRST)",
      "offset": "+03:30",
      "dst": "Yes"
    },
    "dateFormat": "YYYY/MM/DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 86800000,
    "area": {
      "value": 1648195,
      "unit": "km"
    },
    "capital": "Tehran",
    "gdp": {
      "nominal": "336.3 billion USD",
      "perCapita": "3,867 USD"
    },
    "dialingCode": "+98",
    "internetTLD": ".ir",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "115",
      "fire": "125",
      "police": "110",
      "ambulance": "115"
    },
    "holidays": [
      "Nowruz (March 21)",
      "Islamic Revolution Day (February 11)"
    ],
    "nationalAnimal": "Persian Lion",
    "nationalDish": "Chelo Kebab",
    "tourismHighlights": [
      "Persepolis (UNESCO World Heritage Site)",
      "Naqsh-e Jahan Square (UNESCO World Heritage Site)",
      "Golestan Palace",
      "Shiraz and Isfahan"
    ],
    "majorExports": [
      "Crude oil",
      "Petrochemicals",
      "Natural gas"
    ],
    "majorImports": [
      "Machinery",
      "Foods",
      "Consumer goods"
    ],
    "lifeExpectancy": 76.7,
    "literacyRate": 85,
    "climate": "Varies; arid and semi-arid regions, with some areas experiencing Mediterranean climate",
    "religions": {
      "predominant": "Islam (Shia)",
      "others": [
        "Zoroastrianism",
        "Christianity",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Turkey",
      "Iraq",
      "Armenia",
      "Azerbaijan",
      "Turkmenistan",
      "Afghanistan",
      "Pakistan"
    ],
    "visaRequirement": "Visa required for most foreign nationals",
    "notableFacts": [
      "Home to one of the world's oldest civilizations.",
      "Rich in natural resources, particularly oil and gas.",
      "Rich cultural heritage including numerous UNESCO World Heritage Sites."
    ]
  },
  "IQ": {
    "flag": "",
    "name": "Iraq",
    "officialName": "Republic of Iraq",
    "countryCode": "+964",
    "isoAlpha2": "IQ",
    "isoAlpha3": "IRQ",
    "numericCode": "368",
    "firstLanguage": "ar",
    "otherLanguages": [
      "ku",
      "syc",
      "en"
    ],
    "currency": {
      "code": "IQD",
      "symbol": ".",
      "name": "Iraqi Dinar"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Various",
      "headsOfState": [
        {
          "title": "President",
          "name": "Abdul Latif Rashid"
        }
      ],
      "headOfGovernment": {
        "title": "Prime Minister",
        "name": "Mohammed Shia' al-Sudani"
      }
    },
    "timeZone": {
      "name": "Arabian Standard Time",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Middle East",
    "population": 44150000,
    "area": {
      "value": 438317,
      "unit": "km"
    },
    "capital": "Baghdad",
    "gdp": {
      "nominal": "239 billion USD",
      "perCapita": "5,472 USD"
    },
    "dialingCode": "+964",
    "internetTLD": ".iq",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "122",
      "fire": "115",
      "police": "104",
      "ambulance": "123"
    },
    "holidays": [
      "Republic Day (July 14)",
      "Independence Day (October 3)",
      "Ashura"
    ],
    "nationalAnimal": "The Arabian Oryx",
    "nationalDish": "Masgouf (grilled fish)",
    "tourismHighlights": [
      "Ancient ruins of Babylon",
      "Ziggurat of Ur",
      "The Hanging Gardens of Babylon (historically significant)",
      "Erbil Citadel"
    ],
    "majorExports": [
      "Crude petroleum",
      "Natural gas",
      "Dates"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Chemical products"
    ],
    "lifeExpectancy": 75.5,
    "literacyRate": 80,
    "climate": "Hot desert climate with extreme summer temperatures",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Yazidism",
        "Jaburism"
      ]
    },
    "neighborCountries": [
      "Turkey",
      "Iran",
      "Kuwait",
      "Saudi Arabia",
      "Jordan"
    ],
    "visaRequirement": "Visa required for most foreign nationals",
    "notableFacts": [
      "Home to several ancient civilizations, including the Sumerians and Babylonians.",
      "Has one of the largest oil reserves in the world.",
      "Iraq was the focus of the 2003 Iraq War, which led to significant political and social changes."
    ]
  },
  "IN": {
    "flag": "",
    "name": "India",
    "officialName": "Republic of India",
    "countryCode": "+91",
    "isoAlpha2": "IN",
    "isoAlpha3": "IND",
    "numericCode": "356",
    "firstLanguage": "hi",
    "otherLanguages": [
      "en",
      "bn",
      "te",
      "mr",
      "ta",
      "ur",
      "gu",
      "ml",
      "kn",
      "or",
      "as",
      "pa",
      "hi"
    ],
    "currency": {
      "code": "INR",
      "symbol": "",
      "name": "Indian Rupee"
    },
    "government": {
      "type": "Parliamentary democratic republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Droupadi Murmu"
        },
        {
          "title": "Prime Minister",
          "name": "Narendra Modi"
        }
      ]
    },
    "timeZone": {
      "name": "Indian Standard Time (IST)",
      "offset": "+05:30",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "South Asia",
    "population": 1393409038,
    "area": {
      "value": 3287263,
      "unit": "km"
    },
    "capital": "New Delhi",
    "gdp": {
      "nominal": "3.48 trillion USD",
      "perCapita": "2,490 USD"
    },
    "dialingCode": "+91",
    "internetTLD": ".in",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "100",
      "ambulance": "102"
    },
    "holidays": [
      "Republic Day (January 26)",
      "Independence Day (August 15)",
      "Gandhi Jayanti (October 2)"
    ],
    "nationalAnimal": "Bengal Tiger",
    "nationalDish": "Biryani",
    "tourismHighlights": [
      "Taj Mahal",
      "Jaipur City",
      "Kerala Backwaters",
      "Hampi",
      "Varanasi"
    ],
    "majorExports": [
      "Petroleum products",
      "Jewelry",
      "Pharmaceuticals",
      "Textiles"
    ],
    "majorImports": [
      "Crude oil",
      "Gold",
      "Machinery",
      "Electronics"
    ],
    "lifeExpectancy": 69.7,
    "literacyRate": 77.7,
    "climate": "Varies from tropical in south to temperate in north",
    "religions": {
      "predominant": "Hinduism",
      "others": [
        "Islam",
        "Christianity",
        "Sikhism",
        "Buddhism",
        "Jainism"
      ]
    },
    "neighborCountries": [
      "Pakistan",
      "China",
      "Nepal",
      "Bhutan",
      "Bangladesh",
      "Myanmar"
    ],
    "visaRequirement": "e-Visa available for many countries, tourist visa required for others",
    "notableFacts": [
      "The world's largest democracy.",
      "Home to over 2,000 distinct ethnic groups.",
      "The Indian film industry, Bollywood, is the largest in the world by number of films produced."
    ]
  },
  "IS": {
    "flag": "",
    "name": "Iceland",
    "officialName": "Republic of Iceland",
    "countryCode": "+354",
    "isoAlpha2": "IS",
    "isoAlpha3": "ISL",
    "numericCode": "366",
    "firstLanguage": "is",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "ISK",
      "symbol": "kr",
      "name": "Icelandic króna"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Various",
      "headsOfState": [
        {
          "title": "President",
          "name": "Guðni Th. Jóhannesson"
        },
        {
          "title": "Prime Minister",
          "name": "Katrín Jakobsdóttir"
        }
      ]
    },
    "timeZone": {
      "name": "Greenland Time (GMT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 376248,
    "area": {
      "value": 103000,
      "unit": "km"
    },
    "capital": "Reykjavík",
    "gdp": {
      "nominal": "26.18 billion USD",
      "perCapita": "69,121 USD"
    },
    "dialingCode": "+354",
    "internetTLD": ".is",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Icelandic National Day (June 17)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Gyrfalcon",
    "nationalDish": "Hákarl",
    "tourismHighlights": [
      "Golden Circle",
      "Blue Lagoon",
      "Reykjavik's Hallgrímskirkja",
      "Thingvellir National Park (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Fish",
      "Aluminum",
      "Tourism services"
    ],
    "majorImports": [
      "Machinery and equipment",
      "Mineral fuels",
      "Food"
    ],
    "lifeExpectancy": 83.1,
    "literacyRate": 100,
    "climate": "Subarctic and oceanic",
    "religions": {
      "predominant": "Evangelical Lutheran",
      "others": [
        "Roman Catholic",
        "Atheist",
        "Paganism"
      ]
    },
    "neighborCountries": [
      "None (island nation)"
    ],
    "visaRequirement": "Schengen visa required for some non-EU countries",
    "notableFacts": [
      "Geologically active regions with geysers and hot springs.",
      "One of the most sparsely populated countries in Europe.",
      "Home to the world's oldest parliament, Althing, established in 930 AD."
    ]
  },
  "IT": {
    "flag": "",
    "name": "Italy",
    "officialName": "Italian Republic",
    "countryCode": "+39",
    "isoAlpha2": "IT",
    "isoAlpha3": "ITA",
    "numericCode": "380",
    "firstLanguage": "it",
    "otherLanguages": [
      "de",
      "fr",
      "en",
      "sl"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Sergio Mattarella"
        },
        {
          "title": "Prime Minister",
          "name": "Giorgia Meloni"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 60244639,
    "area": {
      "value": 301340,
      "unit": "km"
    },
    "capital": "Rome",
    "gdp": {
      "nominal": "2.02 trillion USD",
      "perCapita": "33,194 USD"
    },
    "dialingCode": "+39",
    "internetTLD": ".it",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "115",
      "police": "113",
      "ambulance": "118"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Epiphany (January 6)",
      "Easter Sunday",
      "Liberation Day (April 25)",
      "Labour Day (May 1)",
      "Republic Day (June 2)",
      "Assumption of Mary (August 15)",
      "All Saints' Day (November 1)",
      "Immaculate Conception (December 8)",
      "Christmas Day (December 25)",
      "St. Stephen's Day (December 26)"
    ],
    "nationalAnimal": "Italian Wolf",
    "nationalDish": "Pizza",
    "tourismHighlights": [
      "Colosseum in Rome",
      "Leaning Tower of Pisa",
      "Venice Canals",
      "Florence's Uffizi Gallery",
      "Amalfi Coast",
      "Cinque Terre"
    ],
    "majorExports": [
      "Machinery",
      "Vehicles",
      "Fashion and textiles",
      "Food and beverages",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Energy",
      "Raw materials",
      "Machinery",
      "Automobiles",
      "Metals"
    ],
    "lifeExpectancy": 83.2,
    "literacyRate": 99.2,
    "climate": "Mediterranean with hot, dry summers and mild, wet winters",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Unaffiliated",
        "Protestant",
        "Islam",
        "Eastern Orthodox"
      ]
    },
    "neighborCountries": [
      "France",
      "Switzerland",
      "Austria",
      "Slovenia",
      "San Marino",
      "Vatican City"
    ],
    "visaRequirement": "Schengen visa required for some nations; no visa for EU citizens.",
    "notableFacts": [
      "Home to the largest number of UNESCO World Heritage Sites.",
      "Renowned for its historical and cultural heritage, including art and cuisine.",
      "Has the world's oldest university, the University of Bologna, founded in 1088."
    ]
  },
  "JE": {
    "flag": "",
    "name": "Jersey",
    "officialName": "States of Jersey",
    "countryCode": "+44",
    "isoAlpha2": "JE",
    "isoAlpha3": "JEY",
    "numericCode": "832",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "jèrriais"
    ],
    "currency": {
      "code": "GBP",
      "symbol": "",
      "name": "British Pound Sterling"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Lieutenant Governor",
          "name": "Governor of Jersey"
        },
        {
          "title": "Chief Minister",
          "name": "Leader of the Government"
        }
      ]
    },
    "timeZone": {
      "name": "Greenwich Mean Time (GMT)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 108000,
    "area": {
      "value": 46.2,
      "unit": "km"
    },
    "capital": "Saint Helier",
    "gdp": {
      "nominal": "4.17 billion USD",
      "perCapita": "38,000 USD"
    },
    "dialingCode": "+44",
    "internetTLD": ".je",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "933",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Liberation Day (May 9)",
      "Bailiff's Day (First Monday in September)"
    ],
    "nationalAnimal": "Lizard",
    "nationalDish": "Bean Crock",
    "tourismHighlights": [
      "Elizabeth Castle",
      "Jersey Zoo",
      "The War Tunnels",
      "St. Brelade's Bay"
    ],
    "majorExports": [
      "Financial Services",
      "Agricultural produce",
      "Clothing"
    ],
    "majorImports": [
      "Food",
      "Fuels",
      "Consumer goods"
    ],
    "lifeExpectancy": 84.4,
    "literacyRate": 99,
    "climate": "Oceanic with mild winters and cool summers",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Judaism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (island)"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Jersey is the largest of the Channel Islands.",
      "It has its own law system and parliament.",
      "The island has a strong financial sector and is a tax haven."
    ]
  },
  "JO": {
    "flag": "",
    "name": "Jordan",
    "officialName": "Hashemite Kingdom of Jordan",
    "countryCode": "+962",
    "isoAlpha2": "JO",
    "isoAlpha3": "JOR",
    "numericCode": "400",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en",
      "fr"
    ],
    "currency": {
      "code": "JOD",
      "symbol": ".",
      "name": "Jordanian Dinar"
    },
    "government": {
      "type": "Unitary parliamentary constitutional monarchy",
      "politicalLean": "Pro-Western",
      "headsOfState": [
        {
          "title": "King",
          "name": "Abdullah II"
        }
      ]
    },
    "timeZone": {
      "name": "Jordan Standard Time (JST)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 10948000,
    "area": {
      "value": 89341,
      "unit": "km"
    },
    "capital": "Amman",
    "gdp": {
      "nominal": "46.36 billion USD",
      "perCapita": "4,221 USD"
    },
    "dialingCode": "+962",
    "internetTLD": ".jo",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "199",
      "police": "191",
      "ambulance": "193"
    },
    "holidays": [
      "Independence Day (May 25)",
      "King's Birthday (January 30)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Sand Cat",
    "nationalDish": "Mansaf",
    "tourismHighlights": [
      "Petra (UNESCO World Heritage Site)",
      "Wadi Rum",
      "Dead Sea",
      "Jerash"
    ],
    "majorExports": [
      "Phosphates",
      "Potash",
      "Tourism services"
    ],
    "majorImports": [
      "Crude oil",
      "Manufactured goods",
      "Foodstuffs"
    ],
    "lifeExpectancy": 74.6,
    "literacyRate": 98,
    "climate": "Hot desert climate with mild winter",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Druze"
      ]
    },
    "neighborCountries": [
      "Saudi Arabia",
      "Iraq",
      "Syria",
      "Palestine"
    ],
    "visaRequirement": "Visa required for most nationalities; some exceptions apply.",
    "notableFacts": [
      "Home to the ancient city of Petra, one of the New Seven Wonders of the World.",
      "Jordan hosts a large number of refugees from neighboring countries.",
      "Known for its significant archaeological sites."
    ]
  },
  "JM": {
    "flag": "",
    "name": "Jamaica",
    "officialName": "Jamaica",
    "countryCode": "+1",
    "isoAlpha2": "JM",
    "isoAlpha3": "JAM",
    "numericCode": "388",
    "firstLanguage": "en",
    "otherLanguages": [
      "ja",
      "es"
    ],
    "currency": {
      "code": "JMD",
      "symbol": "J$",
      "name": "Jamaican Dollar"
    },
    "government": {
      "type": "Parliamentary constitutional monarchy",
      "politicalLean": "Centre-left",
      "headsOfState": [
        {
          "title": "Monarch",
          "name": "King Charles III"
        },
        {
          "title": "Prime Minister",
          "name": "Andrew Holness"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern Standard Time (EST)",
      "offset": "-05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 2961160,
    "area": {
      "value": 10991,
      "unit": "km"
    },
    "capital": "Kingston",
    "gdp": {
      "nominal": "14.25 billion USD",
      "perCapita": "4,825 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".jm",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "119",
      "fire": "110",
      "police": "119",
      "ambulance": "110"
    },
    "holidays": [
      "Emancipation Day (August 1)",
      "Independence Day (August 6)"
    ],
    "nationalAnimal": "Red-billed Streamertail",
    "nationalDish": "Ackee and Saltfish",
    "tourismHighlights": [
      "Seven Mile Beach",
      "Dunn's River Falls",
      "Bob Marley Museum",
      "Negril Cliffs"
    ],
    "majorExports": [
      "Bauxite",
      "Sugar",
      "Bananas"
    ],
    "majorImports": [
      "Food",
      "Mineral fuels",
      "Machinery"
    ],
    "lifeExpectancy": 75.6,
    "literacyRate": 88.7,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Rastafarianism",
        "Hinduism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "None (island nation)"
    ],
    "visaRequirement": "Visa not required for stays up to 90 days for many nationalities",
    "notableFacts": [
      "Birthplace of reggae music and famous musician Bob Marley.",
      "Known for its beautiful beaches and vibrant culture.",
      "One of the most popular Caribbean tourist destinations."
    ]
  },
  "KI": {
    "flag": "",
    "name": "Kiribati",
    "officialName": "Republic of Kiribati",
    "countryCode": "+686",
    "isoAlpha2": "KI",
    "isoAlpha3": "KIR",
    "numericCode": "296",
    "firstLanguage": "en",
    "otherLanguages": [
      "gil"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Taneti Mamau"
        }
      ]
    },
    "timeZone": {
      "name": "Gilbert Islands Time (GIT)",
      "offset": "+12:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Micronesia",
    "population": 119000,
    "area": {
      "value": 811,
      "unit": "km"
    },
    "capital": "South Tarawa",
    "gdp": {
      "nominal": "200 million USD",
      "perCapita": "1,675 USD"
    },
    "dialingCode": "+686",
    "internetTLD": ".ki",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (July 12)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Frigatebird",
    "nationalDish": "Palu Samoan",
    "tourismHighlights": [
      "Christmas Island",
      "Line Islands",
      "Buariki Village",
      "Island hopping tours"
    ],
    "majorExports": [
      "Copra",
      "Fish",
      "Handicrafts"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 60.4,
    "literacyRate": 98,
    "climate": "Tropical, with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Buddhism",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Nauru",
      "Tuvalu",
      "Marshall Islands"
    ],
    "visaRequirement": "Visa required for most travelers; some exemptions apply.",
    "notableFacts": [
      "Comprises 33 islands scattered over a vast area in the central Pacific Ocean.",
      "Home to some of the lowest-lying islands globally, making it vulnerable to climate change.",
      "Celebrated for its unique culture and traditions, including traditional dance and crafts."
    ]
  },
  "JP": {
    "flag": "",
    "name": "Japan",
    "officialName": "State of Japan",
    "countryCode": "+81",
    "isoAlpha2": "JP",
    "isoAlpha3": "JPN",
    "numericCode": "392",
    "firstLanguage": "ja",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "JPY",
      "symbol": "",
      "name": "Japanese Yen"
    },
    "government": {
      "type": "Unitary parliamentary constitutional monarchy",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "Emperor",
          "name": "Naruhito"
        },
        {
          "title": "Prime Minister",
          "name": "Fumio Kishida"
        }
      ]
    },
    "timeZone": {
      "name": "Japan Standard Time (JST)",
      "offset": "+09:00",
      "dst": "No"
    },
    "dateFormat": "YYYY/MM/DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "population": 126476461,
    "area": {
      "value": 377975,
      "unit": "km"
    },
    "capital": "Tokyo",
    "gdp": {
      "nominal": "4.87 trillion USD",
      "perCapita": "38,476 USD"
    },
    "dialingCode": "+81",
    "internetTLD": ".jp",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "110",
      "fire": "119",
      "police": "110",
      "ambulance": "119"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Coming of Age Day (Second Monday of January)",
      "National Foundation Day (February 11)",
      "Showa Day (April 29)",
      "Constitution Memorial Day (May 3)",
      "Children's Day (May 5)",
      "Marine Day (Third Monday of July)",
      "Mountain Day (August 11)",
      "Respect for the Aged Day (Third Monday of September)",
      "Sports Day (Second Monday of October)",
      "Culture Day (November 3)",
      "Labor Thanksgiving Day (November 23)",
      "Emperor's Birthday (February 23)"
    ],
    "nationalAnimal": "Green Pheasant",
    "nationalDish": "Sushi",
    "tourismHighlights": [
      "Mount Fuji",
      "Tokyo Tower",
      "Kyoto's historic temples",
      "Hiroshima Peace Memorial Park",
      "Okinawa's beaches"
    ],
    "majorExports": [
      "Cars",
      "Electronic equipment",
      "Machinery"
    ],
    "majorImports": [
      "Oil",
      "Natural gas",
      "Food products"
    ],
    "lifeExpectancy": 84.6,
    "literacyRate": 99,
    "climate": "Varies from humid continental in the north to humid subtropical in the south",
    "religions": {
      "predominant": "Shinto and Buddhism",
      "others": [
        "Christianity",
        "New religions",
        "None"
      ]
    },
    "neighborCountries": [
      "South Korea",
      "North Korea",
      "Russia"
    ],
    "visaRequirement": "Varies; visa-free for many countries, including EU nations, USA, Canada, Australia, and some others.",
    "notableFacts": [
      "Home to the world's oldest continuously operating company, Kongo Gumi.",
      "Japan has over 6,800 islands, with Honshu being the largest.",
      "Tokyo is the most populous city in the world."
    ]
  },
  "KH": {
    "flag": "",
    "name": "Cambodia",
    "officialName": "Kingdom of Cambodia",
    "countryCode": "+855",
    "isoAlpha2": "KH",
    "isoAlpha3": "KHM",
    "numericCode": "116",
    "firstLanguage": "km",
    "otherLanguages": [
      "fr",
      "en"
    ],
    "currency": {
      "code": "KHR",
      "symbol": "",
      "name": "Cambodian Riel"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Multiparty democracy",
      "headsOfState": [
        {
          "title": "King",
          "name": "Norodom Sihamoni"
        },
        {
          "title": "Prime Minister",
          "name": "Hun Sen"
        }
      ]
    },
    "timeZone": {
      "name": "Indochina Time (ICT)",
      "offset": "+07:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 16718971,
    "area": {
      "value": 181035,
      "unit": "km"
    },
    "capital": "Phnom Penh",
    "gdp": {
      "nominal": "25.24 billion USD",
      "perCapita": "1,509 USD"
    },
    "dialingCode": "+855",
    "internetTLD": ".kh",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "117",
      "fire": "118",
      "police": "119",
      "ambulance": "120"
    },
    "holidays": [
      "Victory Day (January 7)",
      "International Women's Day (March 8)",
      "Khmer New Year (April 13-15)",
      "Pchum Ben (September/October)",
      "Water Festival (November)"
    ],
    "nationalAnimal": "Naga",
    "nationalDish": "Amok Trey",
    "tourismHighlights": [
      "Angkor Wat",
      "Phnom Penh Royal Palace",
      "Killing Fields of Choeung Ek",
      "Tonle Sap Lake"
    ],
    "majorExports": [
      "Textiles",
      "Footwear",
      "Rice"
    ],
    "majorImports": [
      "Petroleum products",
      "Machinery",
      "Vehicles"
    ],
    "lifeExpectancy": 75.3,
    "literacyRate": 80.5,
    "climate": "Tropical monsoon climate with a distinct wet and dry season",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Islam",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "Thailand",
      "Laos",
      "Vietnam"
    ],
    "visaRequirement": "Visa required for most foreign travelers",
    "notableFacts": [
      "Home to the ancient Khmer Empire and its famous temple complex, Angkor.",
      "The country is still recovering from the Khmer Rouge regime of the 1970s.",
      "Cambodia has a growing economy, driven by tourism, agriculture, and manufacturing."
    ]
  },
  "KG": {
    "flag": "",
    "name": "Kyrgyzstan",
    "officialName": "Kyrgyz Republic",
    "countryCode": "+996",
    "isoAlpha2": "KG",
    "isoAlpha3": "KGZ",
    "numericCode": "417",
    "firstLanguage": "ky",
    "otherLanguages": [
      "ru",
      "uz"
    ],
    "currency": {
      "code": "KGS",
      "symbol": "",
      "name": "Kyrgyzstani Som"
    },
    "government": {
      "type": "Unitary parliamentary republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Sadyr Japarov"
        }
      ]
    },
    "timeZone": {
      "name": "Kyrgyzstan Time (KGT)",
      "offset": "+06:00",
      "dst": "No"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Central Asia",
    "population": 6630000,
    "area": {
      "value": 199951,
      "unit": "km"
    },
    "capital": "Bishkek",
    "gdp": {
      "nominal": "8.48 billion USD",
      "perCapita": "1,280 USD"
    },
    "dialingCode": "+996",
    "internetTLD": ".kg",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Kurman Ait (Eid al-Adha)",
      "Nooruz (Persian New Year, March 21)",
      "Independence Day (August 31)"
    ],
    "nationalAnimal": "Snow Leopard",
    "nationalDish": "Beshbarmak",
    "tourismHighlights": [
      "Issyk-Kul Lake",
      "Ala-Archa National Park",
      "Bishkek's Ala-Too Square",
      "Jeti-Ögüz Rock formation"
    ],
    "majorExports": [
      "Gold",
      "Cotton",
      "Textiles",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery",
      "Fuel",
      "Food",
      "Construction materials"
    ],
    "lifeExpectancy": 72.3,
    "literacyRate": 99.7,
    "climate": "Continental with cold winters and warm summers",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Buddhism",
        "Shamanism"
      ]
    },
    "neighborCountries": [
      "Kazakhstan",
      "Uzbekistan",
      "Tajikistan",
      "China"
    ],
    "visaRequirement": "Visa required for some nationalities; visa-free for several countries.",
    "notableFacts": [
      "Home to the second-largest saline lake in the world, Issyk-Kul.",
      "Known for its rich tradition of hospitality and nomadic culture.",
      "Houses the historical Silk Road trade routes."
    ]
  },
  "KE": {
    "flag": "",
    "name": "Kenya",
    "officialName": "Republic of Kenya",
    "countryCode": "+254",
    "isoAlpha2": "KE",
    "isoAlpha3": "KEN",
    "numericCode": "404",
    "firstLanguage": "sw",
    "otherLanguages": [
      "en",
      "ar",
      "fr"
    ],
    "currency": {
      "code": "KES",
      "symbol": "KSh",
      "name": "Kenyan Shilling"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Multi-party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "William Ruto"
        },
        {
          "title": "Deputy President",
          "name": "Rigathi Gachagua"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "East Africa",
    "population": 53771296,
    "area": {
      "value": 580367,
      "unit": "km"
    },
    "capital": "Nairobi",
    "gdp": {
      "nominal": "95.5 billion USD",
      "perCapita": "1,775 USD"
    },
    "dialingCode": "+254",
    "internetTLD": ".ke",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "998",
      "police": "999",
      "ambulance": "0719 618 000"
    },
    "holidays": [
      "Madaraka Day (June 1)",
      "Mashujaa Day (October 20)",
      "Jamhuri Day (December 12)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "African lion",
    "nationalDish": "Ugali",
    "tourismHighlights": [
      "Maasai Mara National Reserve",
      "Amboseli National Park",
      "Lake Nakuru National Park",
      "Nairobi National Park"
    ],
    "majorExports": [
      "Tea",
      "Horticultural products",
      "Coffee"
    ],
    "majorImports": [
      "Petroleum products",
      "Machinery",
      "Vehicles"
    ],
    "lifeExpectancy": 66.7,
    "literacyRate": 78.7,
    "climate": "Varies by region; generally tropical along the coast and arid in the interior",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Uganda",
      "Tanzania",
      "South Sudan",
      "Ethiopia",
      "Somalia"
    ],
    "visaRequirement": "Visa required for some nationalities, but e-visa available for many travelers.",
    "notableFacts": [
      "Home to the Great Rift Valley, a geological wonder.",
      "Famous for its wildlife and the annual wildebeest migration.",
      "Unique blend of cultures from over 40 ethnic groups living in the country."
    ]
  },
  "KR": {
    "flag": "",
    "name": "South Korea",
    "officialName": "Republic of Korea",
    "countryCode": "+82",
    "isoAlpha2": "KR",
    "isoAlpha3": "KOR",
    "numericCode": "410",
    "firstLanguage": "ko",
    "otherLanguages": [
      "en",
      "zh",
      "ja"
    ],
    "currency": {
      "code": "KRW",
      "symbol": "",
      "name": "South Korean Won"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "President",
          "name": "Yoon Suk-yeol"
        },
        {
          "title": "Prime Minister",
          "name": "Han Duck-soo"
        }
      ]
    },
    "timeZone": {
      "name": "Korea Standard Time (KST)",
      "offset": "+09:00",
      "dst": "No"
    },
    "dateFormat": "YYYY-MM-DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "East Asia",
    "population": 51780579,
    "area": {
      "value": 100210,
      "unit": "km"
    },
    "capital": "Seoul",
    "gdp": {
      "nominal": "1.63 trillion USD",
      "perCapita": "31,000 USD"
    },
    "dialingCode": "+82",
    "internetTLD": ".kr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "119",
      "police": "112",
      "ambulance": "119"
    },
    "holidays": [
      "Seollal (Lunar New Year)",
      "Chuseok (Korean Thanksgiving)",
      "Independence Day (August 15)",
      "Buddha's Birthday"
    ],
    "nationalAnimal": "Taegeukgi (Flying Tiger)",
    "nationalDish": "Kimchi",
    "tourismHighlights": [
      "Gyeongbokgung Palace",
      "Jeju Island",
      "Bukchon Hanok Village",
      "N Seoul Tower"
    ],
    "majorExports": [
      "Electronics",
      "Automobiles",
      "Petrochemicals"
    ],
    "majorImports": [
      "Machinery",
      "Oil",
      "Gas"
    ],
    "lifeExpectancy": 83.2,
    "literacyRate": 99,
    "climate": "Temperate with four distinct seasons",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Buddhism",
        "Confucianism",
        "No religion"
      ]
    },
    "neighborCountries": [
      "North Korea",
      "Japan"
    ],
    "visaRequirement": "Visa-free entry for many countries, duration varies",
    "notableFacts": [
      "Home to the Samsung and LG corporations, major players in electronics.",
      "K-Pop and Korean culture have gained international influence.",
      "Has a highly developed economy and is one of the world's largest producers of consumer electronics."
    ]
  },
  "KW": {
    "flag": "",
    "name": "Kuwait",
    "officialName": "State of Kuwait",
    "countryCode": "+965",
    "isoAlpha2": "KW",
    "isoAlpha3": "KWT",
    "numericCode": "414",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "KWD",
      "symbol": ".",
      "name": "Kuwaiti Dinar"
    },
    "government": {
      "type": "Constitutional Emirate",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "Emir",
          "name": "Nawab Sabah Al-Ahmad Al-Jaber Al-Sabah"
        }
      ]
    },
    "timeZone": {
      "name": "Arabian Standard Time (AST)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 4376000,
    "area": {
      "value": 17818,
      "unit": "km"
    },
    "capital": "Kuwait City",
    "gdp": {
      "nominal": "72.77 billion USD",
      "perCapita": "16,717 USD"
    },
    "dialingCode": "+965",
    "internetTLD": ".kw",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "180",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "National Day (February 25)",
      "Liberation Day (February 26)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Falcon",
    "nationalDish": "Margoog",
    "tourismHighlights": [
      "Kuwait Towers",
      "The Grand Mosque",
      "The Avenues Mall",
      "Kuwait National Museum"
    ],
    "majorExports": [
      "Petroleum",
      "Petrochemicals",
      "Fertilizers"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Vehicles"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 99,
    "climate": "Desert climate with extremely hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Hinduism",
        "Baha'i Faith"
      ]
    },
    "neighborCountries": [
      "Saudi Arabia",
      "Iraq"
    ],
    "visaRequirement": "Visa required for most foreign nationals; various exemptions apply.",
    "notableFacts": [
      "Kuwait has one of the world's highest per capita incomes.",
      "The country's wealth is primarily derived from oil reserves.",
      "Kuwait is known for its diverse expatriate population."
    ]
  },
  "KN": {
    "flag": "",
    "name": "Saint Kitts and Nevis",
    "officialName": "Federation of Saint Christopher and Nevis",
    "countryCode": "+1",
    "isoAlpha2": "KN",
    "isoAlpha3": "KNA",
    "numericCode": "659",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "es"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Sir Tapley Seaton"
        },
        {
          "title": "Prime Minister",
          "name": "Terrance Drew"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "North America",
    "subregion": "Caribbean",
    "population": 53323,
    "area": {
      "value": 261,
      "unit": "km"
    },
    "capital": "Basseterre",
    "gdp": {
      "nominal": "1.21 billion USD",
      "perCapita": "22,577 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".kn",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (September 19)",
      "National Heroes Day (September 16)"
    ],
    "nationalAnimal": "Green Vervet Monkey",
    "nationalDish": "Stewed Saltfish",
    "tourismHighlights": [
      "Brimstone Hill Fortress National Park",
      "The Bat Cave",
      "Pinney's Beach",
      "Nevis Hot Springs"
    ],
    "majorExports": [
      "Beverages",
      "Clothing",
      "Household goods"
    ],
    "majorImports": [
      "Food",
      "Clothing",
      "Machinery"
    ],
    "lifeExpectancy": 74.6,
    "literacyRate": 98,
    "climate": "Tropical; humid and warm with a rainy season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Rastafarianism"
      ]
    },
    "neighborCountries": [
      "Saint Eustatius",
      "Saint Barthelemy"
    ],
    "visaRequirement": "Visa not required for many nationalities, including EU countries and the USA.",
    "notableFacts": [
      "The smallest country in the Western Hemisphere, both in area and population.",
      "St. Kitts was once the British Empire's most important sugar colony.",
      "Home to one of the oldest rum distilleries in the Caribbean."
    ]
  },
  "KM": {
    "flag": "",
    "name": "Comoros",
    "officialName": "Union of the Comoros",
    "countryCode": "+269",
    "isoAlpha2": "KM",
    "isoAlpha3": "COM",
    "numericCode": "174",
    "firstLanguage": "km",
    "otherLanguages": [
      "fr",
      "ar"
    ],
    "currency": {
      "code": "KMF",
      "symbol": "CF",
      "name": "Comorian Franc"
    },
    "government": {
      "type": "Federal presidential republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Azali Assoumani"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 806153,
    "area": {
      "value": 2235,
      "unit": "km"
    },
    "capital": "Moroni",
    "gdp": {
      "nominal": "1.23 billion USD",
      "perCapita": "1,525 USD"
    },
    "dialingCode": "+269",
    "internetTLD": ".km",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "15",
      "ambulance": "14"
    },
    "holidays": [
      "Independence Day (July 6)",
      "Reunion Day (July 24)"
    ],
    "nationalAnimal": "Giant Tortoise",
    "nationalDish": "Langouste à la vanille (Lobster with vanilla)",
    "tourismHighlights": [
      "Moya Ruins",
      "Mount Karthala (active volcano)",
      "Chissi Island",
      "The beautiful beaches of Ndzuani"
    ],
    "majorExports": [
      "Vanilla",
      "Ylang-Ylang",
      "Cloves"
    ],
    "majorImports": [
      "Foodstuffs",
      "Machinery",
      "Petroleum products"
    ],
    "lifeExpectancy": 64.1,
    "literacyRate": 77.8,
    "climate": "Tropical maritime with a wet season and dry season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Mozambique",
      "Tanzania"
    ],
    "visaRequirement": "Visa required for most travelers, but some countries are exempt.",
    "notableFacts": [
      "The Comoros archipelago consists of three main islands and numerous smaller islands.",
      "The islands are known for their biodiversity, including unique wildlife and vegetation.",
      "Comoros is one of the world's largest exporters of vanilla."
    ]
  },
  "KP": {
    "flag": "",
    "name": "North Korea",
    "officialName": "Democratic People's Republic of Korea",
    "countryCode": "+850",
    "isoAlpha2": "KP",
    "isoAlpha3": "PRK",
    "numericCode": "408",
    "firstLanguage": "ko",
    "otherLanguages": [
      "None"
    ],
    "currency": {
      "code": "KPW",
      "symbol": "",
      "name": "North Korean Won"
    },
    "government": {
      "type": "Single-party state",
      "politicalLean": "Communist",
      "headsOfState": [
        {
          "title": "Supreme Leader",
          "name": "Kim Jong-un"
        },
        {
          "title": "Chairman of the Workers' Party",
          "name": "Kim Jong-un"
        }
      ]
    },
    "timeZone": {
      "name": "Korea Standard Time (KST)",
      "offset": "+09:00",
      "dst": "No"
    },
    "dateFormat": "YYYY/MM/DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "East Asia",
    "population": 25778816,
    "area": {
      "value": 120540,
      "unit": "km"
    },
    "capital": "Pyongyang",
    "gdp": {
      "nominal": "28.5 billion USD",
      "perCapita": "1,090 USD"
    },
    "dialingCode": "+850",
    "internetTLD": ".kp",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "119",
      "fire": "113",
      "police": "112",
      "ambulance": "117"
    },
    "holidays": [
      "Day of the Sun (April 15)",
      "Day of the Shining Star (February 16)",
      "Korean Independence Day (August 15)"
    ],
    "nationalAnimal": "Taegeukgi",
    "nationalDish": "Kimchi",
    "tourismHighlights": [
      "Mount Kumgang",
      "Pyongyang Metro",
      "Kumsusan Palace of the Sun",
      "Mansudae Grand Monument"
    ],
    "majorExports": [
      "Textiles",
      "Minerals",
      "Machinery"
    ],
    "majorImports": [
      "Oil",
      "Machinery",
      "Food"
    ],
    "lifeExpectancy": 72.3,
    "literacyRate": 100,
    "climate": "Temperate with four distinct seasons",
    "religions": {
      "predominant": "Atheism",
      "others": [
        "Buddhism",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "China",
      "South Korea",
      "Russia"
    ],
    "visaRequirement": "Visa required for all visitors, with strict regulations.",
    "notableFacts": [
      "Has a centralized economy with almost complete state control.",
      "Known for its political repression and human rights issues.",
      "Maintains a strong military presence and is considered a nuclear power."
    ]
  },
  "LA": {
    "flag": "",
    "name": "Lao People's Democratic Republic",
    "officialName": "Lao People's Democratic Republic",
    "countryCode": "+856",
    "isoAlpha2": "LA",
    "isoAlpha3": "LAO",
    "numericCode": "418",
    "firstLanguage": "lo",
    "otherLanguages": [
      "fr",
      "en",
      "kh"
    ],
    "currency": {
      "code": "LAK",
      "symbol": "",
      "name": "Lao Kip"
    },
    "government": {
      "type": "One-party socialist republic",
      "politicalLean": "Communist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Thongloun Sisoulith"
        }
      ]
    },
    "timeZone": {
      "name": "Indochina Time (ICT)",
      "offset": "+07:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 7275560,
    "area": {
      "value": 236800,
      "unit": "km"
    },
    "capital": "Vientiane",
    "gdp": {
      "nominal": "19.96 billion USD",
      "perCapita": "2,743 USD"
    },
    "dialingCode": "+856",
    "internetTLD": ".la",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "191",
      "fire": "199",
      "police": "113",
      "ambulance": "190"
    },
    "holidays": [
      "Lao New Year (Pi Mai) (April 14-16)",
      "Independence Day (October 12)"
    ],
    "nationalAnimal": "Elephant",
    "nationalDish": "Larb",
    "tourismHighlights": [
      "Luang Prabang (UNESCO World Heritage Site)",
      "Plain of Jars",
      "Vang Vieng",
      "Bolaven Plateau"
    ],
    "majorExports": [
      "Coffee",
      "Wood products",
      "Electricity"
    ],
    "majorImports": [
      "Petroleum products",
      "Machinery",
      "Foodstuffs"
    ],
    "lifeExpectancy": 67.7,
    "literacyRate": 84.7,
    "climate": "Tropical monsoon climate, with a wet and dry season",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Animism",
        "Christianity",
        "Islam"
      ]
    },
    "neighborCountries": [
      "China",
      "Vietnam",
      "Thailand",
      "Myanmar"
    ],
    "visaRequirement": "Visa required for most visitors",
    "notableFacts": [
      "Landlocked country, bordered by five countries.",
      "Home to over 1,000 species of flowering plants.",
      "The Mekong River runs through the country, providing vital transport and trade routes."
    ]
  },
  "KY": {
    "flag": "",
    "name": "Cayman Islands",
    "officialName": "Cayman Islands",
    "countryCode": "+1",
    "isoAlpha2": "KY",
    "isoAlpha3": "CYM",
    "numericCode": "136",
    "firstLanguage": "en",
    "otherLanguages": [
      "es"
    ],
    "currency": {
      "code": "KYD",
      "symbol": "$",
      "name": "Cayman Islands Dollar"
    },
    "government": {
      "type": "Overseas Territory",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Appointed by the British Monarch"
        },
        {
          "title": "Premier",
          "name": "Leader of the elected government"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern Standard Time (EST)",
      "offset": "-05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 65713,
    "area": {
      "value": 264,
      "unit": "km"
    },
    "capital": "George Town",
    "gdp": {
      "nominal": "4.83 billion USD",
      "perCapita": "73,287 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".ky",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "949-7777",
      "police": "949-4222",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "National Heroes Day (Last Monday in January)",
      "Good Friday",
      "Easter Monday",
      "Queen's Birthday",
      "Cayman Islands Constitution Day (July 4)",
      "Discovery Day (Third Monday in May)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "Blue Iguana",
    "nationalDish": "Turtle Stew",
    "tourismHighlights": [
      "Seven Mile Beach",
      "Stingray City",
      "Cayman Turtle Centre",
      "George Town's Historic District"
    ],
    "majorExports": [
      "Coconut oil",
      "Bat guano",
      "Seafood"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Construction materials"
    ],
    "lifeExpectancy": 81.2,
    "literacyRate": 99,
    "climate": "Tropical marine; warm and sunny",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Baha'i",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "None (islands in the Caribbean Sea)"
    ],
    "visaRequirement": "Visa not required for most countries for stays up to 30 days",
    "notableFacts": [
      "Known for its offshore banking and as a tax haven.",
      "Home to some of the best scuba diving and snorkeling sites in the world.",
      "The islands are made up of three islands: Grand Cayman, Little Cayman, and Cayman Brac."
    ]
  },
  "KZ": {
    "flag": "",
    "name": "Kazakhstan",
    "officialName": "Republic of Kazakhstan",
    "countryCode": "+76",
    "isoAlpha2": "KZ",
    "isoAlpha3": "KAZ",
    "numericCode": "398",
    "firstLanguage": "kk",
    "otherLanguages": [
      "ru"
    ],
    "currency": {
      "code": "KZT",
      "symbol": "",
      "name": "Kazakhstani Tenge"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Kassym-Jomart Tokayev"
        }
      ]
    },
    "timeZone": {
      "name": "East Kazakhstan Time (ALMT)",
      "offset": "+06:00",
      "dst": "No"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Central Asia",
    "population": 18776707,
    "area": {
      "value": 2724900,
      "unit": "km"
    },
    "capital": "Nur-Sultan",
    "gdp": {
      "nominal": "190.67 billion USD",
      "perCapita": "10,164 USD"
    },
    "dialingCode": "+76",
    "internetTLD": ".kz",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Nauryz Meyrami (March 21)",
      "Kazakh Independence Day (December 16)"
    ],
    "nationalAnimal": "Steppe Eagle",
    "nationalDish": "Beshbarmak",
    "tourismHighlights": [
      "Charyn Canyon",
      "Mausoleum of Khoja Ahmed Yasawi",
      "Big Almaty Lake",
      "The Mausoleum of Aisha Bibi"
    ],
    "majorExports": [
      "Oil",
      "Natural gas",
      "Uranium",
      "Grain"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Food products"
    ],
    "lifeExpectancy": 73.4,
    "literacyRate": 99.8,
    "climate": "Continental with hot summers and cold winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Atheism",
        "Other"
      ]
    },
    "neighborCountries": [
      "Russia",
      "China",
      "Kyrgyzstan",
      "Uzbekistan",
      "Turkmenistan"
    ],
    "visaRequirement": "E-Visa available for many nationalities; visa-free access for certain countries.",
    "notableFacts": [
      "The largest landlocked country in the world.",
      "Rich in natural resources, particularly oil and uranium.",
      "Home to the Baikonur Cosmodrome, where the first human spaceflight took place."
    ]
  },
  "LC": {
    "flag": "",
    "name": "Saint Lucia",
    "officialName": "Saint Lucia",
    "countryCode": "+1",
    "isoAlpha2": "LC",
    "isoAlpha3": "LCA",
    "numericCode": "662",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Parliamentary Democracy",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Derrick James"
        },
        {
          "title": "Prime Minister",
          "name": "PTracy Cadet"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "North America",
    "subregion": "Caribbean",
    "population": 183600,
    "area": {
      "value": 616,
      "unit": "km"
    },
    "capital": "Castries",
    "gdp": {
      "nominal": "1.52 billion USD",
      "perCapita": "8,286 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".lc",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (February 22)",
      "Saint Lucia Day (December 13)"
    ],
    "nationalAnimal": "Saint Lucia Parrot",
    "nationalDish": "Green Fig and Saltfish",
    "tourismHighlights": [
      "The Pitons (UNESCO World Heritage Site)",
      "Sulphur Springs Park",
      "Anse Chastanet",
      "Pigeon Island National Park"
    ],
    "majorExports": [
      "Bananas",
      "Cocoa",
      "Citrus fruits"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Machinery"
    ],
    "lifeExpectancy": 78.4,
    "literacyRate": 99.5,
    "climate": "Tropical climate with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Baha'i",
        "Rastafarianism"
      ]
    },
    "neighborCountries": [
      "Barbados",
      "Saint Vincent and the Grenadines"
    ],
    "visaRequirement": "No visa required for many countries, including the USA and EU nations",
    "notableFacts": [
      "Home of the Saint Lucia Jazz Festival, one of the premier music festivals in the Caribbean.",
      "Features the world's only drive-in volcano.",
      "Known for its stunning beaches and the iconic Pitons."
    ]
  },
  "LB": {
    "flag": "",
    "name": "Lebanon",
    "officialName": "Lebanese Republic",
    "countryCode": "+961",
    "isoAlpha2": "LB",
    "isoAlpha3": "LBN",
    "numericCode": "422",
    "firstLanguage": "ar",
    "otherLanguages": [
      "fr",
      "en"
    ],
    "currency": {
      "code": "LBP",
      "symbol": ".",
      "name": "Lebanese Pound"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nabih Berri"
        },
        {
          "title": "Prime Minister",
          "name": "Najib Mikati"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 6850000,
    "area": {
      "value": 10452,
      "unit": "km"
    },
    "capital": "Beirut",
    "gdp": {
      "nominal": "20.24 billion USD",
      "perCapita": "2,965 USD"
    },
    "dialingCode": "+961",
    "internetTLD": ".lb",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "175",
      "police": "112",
      "ambulance": "140"
    },
    "holidays": [
      "Independence Day (November 22)",
      "Labor Day (May 1)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Lebanon Cedar",
    "nationalDish": "Tabbouleh",
    "tourismHighlights": [
      "Byblos (ancient city)",
      "Jeita Grotto",
      "Cedars of God (UNESCO World Heritage Site)",
      "Beirut National Museum"
    ],
    "majorExports": [
      "Machinery and electrical equipment",
      "Mineral fuels",
      "Gems and precious metals"
    ],
    "majorImports": [
      "Mineral fuels",
      "Machinery and electrical equipment",
      "Foodstuffs"
    ],
    "lifeExpectancy": 78.9,
    "literacyRate": 93.9,
    "climate": "Mediterranean; hot, dry summers and cool, wet winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Druze"
      ]
    },
    "neighborCountries": [
      "Syria",
      "Israel"
    ],
    "visaRequirement": "Visa required for many countries, including most Western nations.",
    "notableFacts": [
      "Lebanon is home to one of the oldest continuously inhabited cities, Byblos.",
      "It has a diverse and rich cultural heritage influenced by its Mediterranean and Middle Eastern history.",
      "Lebanon's banking system is known for its secrecy and stability."
    ]
  },
  "LI": {
    "flag": "",
    "name": "Liechtenstein",
    "officialName": "Principality of Liechtenstein",
    "countryCode": "+423",
    "isoAlpha2": "LI",
    "isoAlpha3": "LIE",
    "numericCode": "432",
    "firstLanguage": "de",
    "otherLanguages": [
      "en",
      "it"
    ],
    "currency": {
      "code": "CHF",
      "symbol": "CHF",
      "name": "Swiss Franc"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Prince",
          "name": "Hans-Adam II"
        },
        {
          "title": "Prime Minister",
          "name": "Daniel Risch"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 38128,
    "area": {
      "value": 160,
      "unit": "km"
    },
    "capital": "Vaduz",
    "gdp": {
      "nominal": "6.18 billion USD",
      "perCapita": "162,600 USD"
    },
    "dialingCode": "+423",
    "internetTLD": ".li",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "118",
      "police": "117",
      "ambulance": "144"
    },
    "holidays": [
      "National Day (August 15)",
      "Constitution Day (October 15)"
    ],
    "nationalAnimal": "White-tailed eagle",
    "nationalDish": "Kasnudel (cheese dumplings)",
    "tourismHighlights": [
      "Vaduz Castle",
      "Liechtenstein National Museum",
      "Balzers Castle",
      "Skiing at Malbun"
    ],
    "majorExports": [
      "Machinery",
      "Electronics",
      "Medical devices"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Vehicles"
    ],
    "lifeExpectancy": 82.3,
    "literacyRate": 100,
    "climate": "Temperate continental climate",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Muslim",
        "Other Christian"
      ]
    },
    "neighborCountries": [
      "Switzerland",
      "Austria"
    ],
    "visaRequirement": "No visa required for Schengen Area countries",
    "notableFacts": [
      "One of the richest countries in the world per capita.",
      "Has no army; relies on Switzerland for defense.",
      "Home to a significant amount of registered companies in relation to its population."
    ]
  },
  "LS": {
    "flag": "",
    "name": "Lesotho",
    "officialName": "Kingdom of Lesotho",
    "countryCode": "+266",
    "isoAlpha2": "LS",
    "isoAlpha3": "LSO",
    "numericCode": "426",
    "firstLanguage": "st",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "LSL",
      "symbol": "M",
      "name": "Lesotho Loti"
    },
    "government": {
      "type": "Unitary parliamentary constitutional monarchy",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "King",
          "name": "Letsie III"
        },
        {
          "title": "Prime Minister",
          "name": "Sam Matekane"
        }
      ]
    },
    "timeZone": {
      "name": "South Africa Standard Time (SAST)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Southern Africa",
    "population": 2142249,
    "area": {
      "value": 30355,
      "unit": "km"
    },
    "capital": "Maseru",
    "gdp": {
      "nominal": "2.88 billion USD",
      "perCapita": "1,345 USD"
    },
    "dialingCode": "+266",
    "internetTLD": ".ls",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "101",
      "police": "199",
      "ambulance": "112"
    },
    "holidays": [
      "Heroes Day (March 29)",
      "King's Birthday (July 17)",
      "Independence Day (October 4)"
    ],
    "nationalAnimal": "Black Rhino",
    "nationalDish": "Papa and Sesotho stew",
    "tourismHighlights": [
      "Maluti Mountains",
      "Sehlabathebe National Park",
      "Thaba Bosiu",
      "Katse Dam"
    ],
    "majorExports": [
      "Clothing and textiles",
      "Diamonds",
      "Footwear"
    ],
    "majorImports": [
      "Machinery",
      "Food products",
      "Fuel"
    ],
    "lifeExpectancy": 54.5,
    "literacyRate": 86.5,
    "climate": "Temperate with cold winters and warm summers",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Islam"
      ]
    },
    "neighborCountries": [
      "South Africa"
    ],
    "visaRequirement": "Visa required for many countries, including EU and USA.",
    "notableFacts": [
      "Lesotho is an enclave entirely surrounded by South Africa.",
      "It is known as the 'Kingdom in the Sky' due to its mountainous terrain.",
      "Lesotho has a high percentage of its population living with HIV/AIDS."
    ]
  },
  "LK": {
    "flag": "",
    "name": "Sri Lanka",
    "officialName": "Democratic Socialist Republic of Sri Lanka",
    "countryCode": "+94",
    "isoAlpha2": "LK",
    "isoAlpha3": "LKA",
    "numericCode": "144",
    "firstLanguage": "si",
    "otherLanguages": [
      "ta",
      "en"
    ],
    "currency": {
      "code": "LKR",
      "symbol": "Rs",
      "name": "Sri Lankan Rupee"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Mixed",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ranil Wickremesinghe"
        }
      ]
    },
    "timeZone": {
      "name": "Sri Lanka Standard Time (SLST)",
      "offset": "+05:30",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "South Asia",
    "population": 21512500,
    "area": {
      "value": 65610,
      "unit": "km"
    },
    "capital": "Sri Jayawardenepura Kotte",
    "gdp": {
      "nominal": "84.26 billion USD",
      "perCapita": "3,907 USD"
    },
    "dialingCode": "+94",
    "internetTLD": ".lk",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "119",
      "fire": "110",
      "police": "118",
      "ambulance": "1990"
    },
    "holidays": [
      "Independence Day (February 4)",
      "Sinhala and Tamil New Year (April 13-14)",
      "Vesak Poya Day (date varies)",
      "Christmas (December 25)"
    ],
    "nationalAnimal": "Sri Lankan Elephant",
    "nationalDish": "Rice and Curry",
    "tourismHighlights": [
      "Sigiriya Rock Fortress",
      "Yala National Park",
      "Temple of the Tooth Relic in Kandy",
      "Galle Fort (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Textiles and garments",
      "Tea",
      "Rubber",
      "Coconut products"
    ],
    "majorImports": [
      "Petroleum products",
      "Textiles",
      "Food and beverages",
      "Vehicles"
    ],
    "lifeExpectancy": 76.8,
    "literacyRate": 92.5,
    "climate": "Tropical monsoon climate",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Hinduism",
        "Islam",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "India",
      "Maldives"
    ],
    "visaRequirement": "Visa required for most nationalities, with e-visa options available.",
    "notableFacts": [
      "Known as the 'Pearl of the Indian Ocean'.",
      "Home to 8 UNESCO World Heritage Sites.",
      "Famous for its tea production, particularly Ceylon tea."
    ]
  },
  "LR": {
    "flag": "",
    "name": "Liberia",
    "officialName": "Republic of Liberia",
    "countryCode": "+231",
    "isoAlpha2": "LR",
    "isoAlpha3": "LBR",
    "numericCode": "430",
    "firstLanguage": "en",
    "otherLanguages": [
      "Kru",
      "Kpelle",
      "Bassa",
      "Loma",
      "Mende",
      "S Gbiri-Nah"
    ],
    "currency": {
      "code": "LRD",
      "symbol": "$",
      "name": "Liberian Dollar"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "George Weah"
        }
      ]
    },
    "timeZone": {
      "name": "Greenwich Mean Time (GMT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 5057681,
    "area": {
      "value": 111369,
      "unit": "km"
    },
    "capital": "Monrovia",
    "gdp": {
      "nominal": "3.28 billion USD",
      "perCapita": "646 USD"
    },
    "dialingCode": "+231",
    "internetTLD": ".lr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "117",
      "police": "110",
      "ambulance": "112"
    },
    "holidays": [
      "Independence Day (July 26)",
      "Emancipation Day (February 14)",
      "Thanksgiving Day (the first Thursday in November)"
    ],
    "nationalAnimal": "Bongo",
    "nationalDish": "Jollof Rice",
    "tourismHighlights": [
      "Sapo National Park",
      "Robertsport Beach",
      "The Waters of Lake Piso",
      "Kpatawee Waterfall"
    ],
    "majorExports": [
      "Rubber",
      "Gold",
      "Iron Ore",
      "Timber"
    ],
    "majorImports": [
      "Machinery and equipment",
      "Foodstuffs",
      "Refined petroleum products"
    ],
    "lifeExpectancy": 64.4,
    "literacyRate": 47.2,
    "climate": "Tropical; hot and humid with a rainy season from May to October",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Sierra Leone",
      "Guinea",
      "Côte d'Ivoire"
    ],
    "visaRequirement": "Visa required for most foreign nationals except for ECOWAS citizens",
    "notableFacts": [
      "Founded by freed American slaves in the 19th century.",
      "Only country in Africa never to have been colonized.",
      "Has a significant population of indigenous peoples."
    ]
  },
  "LT": {
    "flag": "",
    "name": "Lithuania",
    "officialName": "Republic of Lithuania",
    "countryCode": "+370",
    "isoAlpha2": "LT",
    "isoAlpha3": "LTU",
    "numericCode": "440",
    "firstLanguage": "lt",
    "otherLanguages": [
      "ru",
      "pl"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Unitary parliamentary republic",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "President",
          "name": "Gitanas Nausėda"
        },
        {
          "title": "Prime Minister",
          "name": "Ingrida Šimonytė"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "YYYY-MM-DD",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 2722289,
    "area": {
      "value": 65300,
      "unit": "km"
    },
    "capital": "Vilnius",
    "gdp": {
      "nominal": "66.29 billion USD",
      "perCapita": "24,400 USD"
    },
    "dialingCode": "+370",
    "internetTLD": ".lt",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "01",
      "police": "02",
      "ambulance": "03"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (February 16)",
      "State Restoration Day (March 11)",
      "Labour Day (May 1)",
      "Assumption Day (August 15)",
      "All Saints' Day (November 1)",
      "Christmas (December 25)",
      "Christmas Eve (December 24)"
    ],
    "nationalAnimal": "White stork",
    "nationalDish": "Cepelinai (Zeppelins)",
    "tourismHighlights": [
      "Vilnius Old Town (UNESCO World Heritage Site)",
      "Trakai Castle",
      "Curonian Spit (UNESCO World Heritage Site)",
      "Hill of Crosses"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Mineral fuels",
      "Chemicals"
    ],
    "majorImports": [
      "Mineral fuels",
      "Machinery and equipment",
      "Vehicles"
    ],
    "lifeExpectancy": 78.6,
    "literacyRate": 100,
    "climate": "Humid continental with cold winters and warm summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Orthodox Christian",
        "Protestant",
        "Pagan"
      ]
    },
    "neighborCountries": [
      "Latvia",
      "Belarus",
      "Poland",
      "Russia"
    ],
    "visaRequirement": "Schengen visa required for some nationalities",
    "notableFacts": [
      "The first country to declare independence from the Soviet Union in 1990.",
      "Home to some of the oldest trees in Europe in the Bialowieza Forest.",
      "Known for its vibrant folk music and art scene."
    ]
  },
  "LU": {
    "flag": "",
    "name": "Luxembourg",
    "officialName": "Grand Duchy of Luxembourg",
    "countryCode": "+352",
    "isoAlpha2": "LU",
    "isoAlpha3": "LUX",
    "numericCode": "442",
    "firstLanguage": "lb",
    "otherLanguages": [
      "fr",
      "de",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "Grand Duke",
          "name": "Henri"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 634814,
    "area": {
      "value": 2586,
      "unit": "km"
    },
    "capital": "Luxembourg City",
    "gdp": {
      "nominal": "82.57 billion USD",
      "perCapita": "130,780 USD"
    },
    "dialingCode": "+352",
    "internetTLD": ".lu",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "113",
      "ambulance": "112"
    },
    "holidays": [
      "National Day (June 23)",
      "Easter Monday",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Lion",
    "nationalDish": "Judd mat Gaardebounen",
    "tourismHighlights": [
      "Luxembourg City History Museum",
      "Vianden Castle",
      "Bock Casemates",
      "Mullerthal Trail"
    ],
    "majorExports": [
      "Iron and steel products",
      "Machinery",
      "Chemicals"
    ],
    "majorImports": [
      "Mineral fuels",
      "Machinery",
      "Vehicles"
    ],
    "lifeExpectancy": 83.1,
    "literacyRate": 100,
    "climate": "Oceanic, with mild winters and warm summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Orthodox"
      ]
    },
    "neighborCountries": [
      "Belgium",
      "France",
      "Germany"
    ],
    "visaRequirement": "Schengen visa required for many non-EU countries",
    "notableFacts": [
      "One of the worlds wealthiest countries per capita.",
      "Home to several EU institutions and the European Court of Justice.",
      "Known for its high standard of living and universal healthcare."
    ]
  },
  "LV": {
    "flag": "",
    "name": "Latvia",
    "officialName": "Republic of Latvia",
    "countryCode": "+371",
    "isoAlpha2": "LV",
    "isoAlpha3": "LVA",
    "numericCode": "428",
    "firstLanguage": "lv",
    "otherLanguages": [
      "ru",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "President",
          "name": "Edgars Rinkēvičs"
        },
        {
          "title": "Prime Minister",
          "name": "Krišjānis Kariņš"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 1886198,
    "area": {
      "value": 64559,
      "unit": "km"
    },
    "capital": "Riga",
    "gdp": {
      "nominal": "39.47 billion USD",
      "perCapita": "20,364 USD"
    },
    "dialingCode": "+371",
    "internetTLD": ".lv",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "113",
      "ambulance": "113"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Latvian Independence Day (November 18)",
      "Christmas (December 25, 26)"
    ],
    "nationalAnimal": "White Wagtail",
    "nationalDish": "Grey peas with speck",
    "tourismHighlights": [
      "Old City of Riga (UNESCO World Heritage Site)",
      "Gauja National Park",
      "Jūrmala Beach",
      "Sigulda Castle"
    ],
    "majorExports": [
      "Wood and wood products",
      "Machinery and mechanical appliances",
      "Foodstuffs"
    ],
    "majorImports": [
      "Mineral products",
      "Machinery and mechanical appliances",
      "Chemical products"
    ],
    "lifeExpectancy": 75.5,
    "literacyRate": 99.8,
    "climate": "Temperate maritime with warm summers and cold winters",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Lutheranism",
        "Orthodoxy",
        "Paganism"
      ]
    },
    "neighborCountries": [
      "Estonia",
      "Lithuania",
      "Belarus",
      "Russia"
    ],
    "visaRequirement": "Schengen visa required for non-EU countries",
    "notableFacts": [
      "Known for its rich folk traditions and culture.",
      "Riga boasts the largest collection of Art Nouveau architecture in Europe.",
      "It is one of the world's least densely populated countries."
    ]
  },
  "MA": {
    "flag": "",
    "name": "Morocco",
    "officialName": "Kingdom of Morocco",
    "countryCode": "+212",
    "isoAlpha2": "MA",
    "isoAlpha3": "MAR",
    "numericCode": "504",
    "firstLanguage": "ar",
    "otherLanguages": [
      "fr",
      "ber"
    ],
    "currency": {
      "code": "MAD",
      "symbol": "..",
      "name": "Moroccan Dirham"
    },
    "government": {
      "type": "Unitary parliamentary constitutional monarchy",
      "politicalLean": "Monarchist",
      "headsOfState": [
        {
          "title": "King",
          "name": "King Mohammed VI"
        }
      ]
    },
    "timeZone": {
      "name": "Western European Time (WET)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "North Africa",
    "population": 36910560,
    "area": {
      "value": 446550,
      "unit": "km"
    },
    "capital": "Rabat",
    "gdp": {
      "nominal": "124.12 billion USD",
      "perCapita": "3,598 USD"
    },
    "dialingCode": "+212",
    "internetTLD": ".ma",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "19",
      "fire": "15",
      "police": "19",
      "ambulance": "15"
    },
    "holidays": [
      "Independence Day (November 18)",
      "Throne Day (July 30)"
    ],
    "nationalAnimal": "Barbary Lion",
    "nationalDish": "Couscous",
    "tourismHighlights": [
      "Marrakech Medina (UNESCO World Heritage Site)",
      "Hassan II Mosque in Casablanca",
      "Sahara Desert",
      "Fes el-Bali (Fes Medina)"
    ],
    "majorExports": [
      "Textiles",
      "Phosphates",
      "Automobile parts"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Fuels"
    ],
    "lifeExpectancy": 77.4,
    "literacyRate": 73.1,
    "climate": "Varies from Mediterranean to desert; hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Algeria",
      "Western Sahara (disputed territory)"
    ],
    "visaRequirement": "Visa required for some countries; visa-free for several others",
    "notableFacts": [
      "Home to the Atlas and Rif mountain ranges.",
      "Has a rich history influenced by various cultures, including Berber, Arab, and French.",
      "The world's largest producer of phosphates."
    ]
  },
  "LY": {
    "flag": "",
    "name": "Libya",
    "officialName": "State of Libya",
    "countryCode": "+218",
    "isoAlpha2": "LY",
    "isoAlpha3": "LBY",
    "numericCode": "434",
    "firstLanguage": "ar",
    "otherLanguages": [
      "English",
      "Italian"
    ],
    "currency": {
      "code": "LYD",
      "symbol": ".",
      "name": "Libyan Dinar"
    },
    "government": {
      "type": "Unitary Presidential Republic",
      "politicalLean": "Divided",
      "headsOfState": [
        {
          "title": "Chairman of the Presidential Council",
          "name": "Mohamed al-Menfi"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Northern Africa",
    "population": 6871287,
    "area": {
      "value": 1759540,
      "unit": "km"
    },
    "capital": "Tripoli",
    "gdp": {
      "nominal": "48.80 billion USD",
      "perCapita": "7,165 USD"
    },
    "dialingCode": "+218",
    "internetTLD": ".ly",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "191",
      "fire": "115",
      "police": "113",
      "ambulance": "124"
    },
    "holidays": [
      "Revolution Day (September 1)",
      "Independence Day (December 24)"
    ],
    "nationalAnimal": "Arabian Oryx",
    "nationalDish": "Couscous",
    "tourismHighlights": [
      "Leptis Magna (UNESCO World Heritage Site)",
      "Sabratha (UNESCO World Heritage Site)",
      "Cyrene (UNESCO World Heritage Site)",
      "The Sahara Desert"
    ],
    "majorExports": [
      "Crude oil",
      "Natural gas",
      "Petrochemicals"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Vehicles"
    ],
    "lifeExpectancy": 77.8,
    "literacyRate": 92.4,
    "climate": "Primarily desert with hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "None",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "Tunisia",
      "Algeria",
      "Niger",
      "Chad",
      "Sudan",
      "Egypt"
    ],
    "visaRequirement": "Visa required for most travelers; varies by nationality.",
    "notableFacts": [
      "Has the largest oil reserves in Africa.",
      "The Great Man-Made River is the world's largest irrigation project.",
      "Rich in Roman ruins and archaeological sites."
    ]
  },
  "MC": {
    "flag": "",
    "name": "Monaco",
    "officialName": "Principality of Monaco",
    "countryCode": "+377",
    "isoAlpha2": "MC",
    "isoAlpha3": "MCO",
    "numericCode": "492",
    "firstLanguage": "fr",
    "otherLanguages": [
      "it",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Prince",
          "name": "Albert II"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 39242,
    "area": {
      "value": 2.02,
      "unit": "km"
    },
    "capital": "Monaco",
    "gdp": {
      "nominal": "6.23 billion USD",
      "perCapita": "159,000 USD"
    },
    "dialingCode": "+377",
    "internetTLD": ".mc",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Saint Dévote's Day (January 27)",
      "National Day (November 19)"
    ],
    "nationalAnimal": "Lion",
    "nationalDish": "Barbajuan",
    "tourismHighlights": [
      "Monte Carlo Casino",
      "Palace of the Prince",
      "Oceanographic Museum",
      "Monaco Grand Prix"
    ],
    "majorExports": [
      "Pharmaceuticals",
      "Electronics",
      "Clothing"
    ],
    "majorImports": [
      "Food",
      "Vehicles",
      "Consumer goods"
    ],
    "lifeExpectancy": 85.6,
    "literacyRate": 100,
    "climate": "Mediterranean; mild, rainy winters and hot, dry summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "None",
        "Protestant",
        "Orthodox Christian"
      ]
    },
    "neighborCountries": [
      "France"
    ],
    "visaRequirement": "No visa required for EU countries, Schengen Area, and many others",
    "notableFacts": [
      "Monaco is the second smallest country in the world after the Vatican.",
      "It has one of the highest GDP per capita in the world.",
      "Monaco hosts the famous Monte Carlo Casino and is known for its luxury tourism."
    ]
  },
  "MH": {
    "flag": "",
    "name": "Marshall Islands",
    "officialName": "Republic of the Marshall Islands",
    "countryCode": "+692",
    "isoAlpha2": "MH",
    "isoAlpha3": "MHL",
    "numericCode": "584",
    "firstLanguage": "mh",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Moderate",
      "headsOfState": [
        {
          "title": "President",
          "name": "David Kabua"
        }
      ]
    },
    "timeZone": {
      "name": "Marshall Islands Time (MHT)",
      "offset": "+12:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Micronesia",
    "population": 59194,
    "area": {
      "value": 181,
      "unit": "km"
    },
    "capital": "Majuro",
    "gdp": {
      "nominal": "0.21 billion USD",
      "perCapita": "3,606 USD"
    },
    "dialingCode": "+692",
    "internetTLD": ".mh",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (May 1)",
      "Nuclear Victims Day (March 1)"
    ],
    "nationalAnimal": "Frigatebird",
    "nationalDish": "Breadfruit",
    "tourismHighlights": [
      "Bikini Atoll",
      "Majuro Atoll",
      "Arno Atoll",
      "Mili Atoll"
    ],
    "majorExports": [
      "Fish",
      "Coconut products"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 73.6,
    "literacyRate": 99.8,
    "climate": "Tropical marine climate with a wet season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Baha'i",
        "Buddhism",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "None (located in the Pacific Ocean)"
    ],
    "visaRequirement": "No visa required for most nationalities including US citizens",
    "notableFacts": [
      "Known for its beautiful coral reefs and marine life.",
      "The site of nuclear testing in the mid-20th century.",
      "Bikini Atoll served as a testing site for the hydrogen bomb."
    ]
  },
  "MF": {
    "flag": "",
    "name": "Saint Martin (French Part)",
    "officialName": "Collectivité de Saint-Martin",
    "countryCode": "+590",
    "isoAlpha2": "MF",
    "isoAlpha3": "SXM",
    "numericCode": "663",
    "firstLanguage": "fr",
    "otherLanguages": [
      "nl",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Overseas collectivity",
      "politicalLean": "Left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Daniel Gibbs"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "North America",
    "subregion": "Caribbean",
    "population": 33433,
    "area": {
      "value": 54,
      "unit": "km"
    },
    "capital": "Marigot",
    "gdp": {
      "nominal": "1.5 billion USD",
      "perCapita": "44,925 USD"
    },
    "dialingCode": "+590",
    "internetTLD": ".fr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Saint Martin's Day (November 11)",
      "Labour Day (May 1)",
      "Independence Day (July 14)"
    ],
    "nationalAnimal": "Pelican",
    "nationalDish": "Johnny Cakes",
    "tourismHighlights": [
      "Orient Bay Beach",
      "Maho Beach",
      "Philipsburg",
      "Baie Rouge"
    ],
    "majorExports": [
      "Food",
      "Clothing",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Vehicles"
    ],
    "lifeExpectancy": 79,
    "literacyRate": 99,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Vodou",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Sint Maarten (Dutch Part)"
    ],
    "visaRequirement": "Visa not required for EU citizens",
    "notableFacts": [
      "Saint Martin is divided into two parts: the French side and the Dutch side.",
      "Home to some of the best beaches in the Caribbean.",
      "Known for its vibrant nightlife and culinary scene."
    ]
  },
  "MG": {
    "flag": "",
    "name": "Madagascar",
    "officialName": "Republic of Madagascar",
    "countryCode": "+261",
    "isoAlpha2": "MG",
    "isoAlpha3": "MDG",
    "numericCode": "450",
    "firstLanguage": "mg",
    "otherLanguages": [
      "fr",
      "en"
    ],
    "currency": {
      "code": "MGA",
      "symbol": "Ar",
      "name": "Malagasy Ariary"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Andry Rajoelina"
        },
        {
          "title": "Prime Minister",
          "name": "Christian Ntsay"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 29516244,
    "area": {
      "value": 587041,
      "unit": "km"
    },
    "capital": "Antananarivo",
    "gdp": {
      "nominal": "13.93 billion USD",
      "perCapita": "472 USD"
    },
    "dialingCode": "+261",
    "internetTLD": ".mg",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "117",
      "fire": "118",
      "police": "119",
      "ambulance": "121"
    },
    "holidays": [
      "Independence Day (June 26)",
      "Labor Day (May 1)",
      "New Year's Day (January 1)"
    ],
    "nationalAnimal": "Lemur",
    "nationalDish": "Romazava",
    "tourismHighlights": [
      "Avenue of the Baobabs",
      "Isalo National Park",
      "Rano Raraku (Easter Island)",
      "Nosy Be"
    ],
    "majorExports": [
      "Vanilla",
      "Textiles",
      "Coffee",
      "Extracted natural resources"
    ],
    "majorImports": [
      "Petroleum products",
      "Capital goods",
      "Foodstuffs"
    ],
    "lifeExpectancy": 66.5,
    "literacyRate": 64.9,
    "climate": "Tropical along the coast, temperate inland, arid in the south",
    "religions": {
      "predominant": "Indigenous beliefs",
      "others": [
        "Christianity",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (island nation)"
    ],
    "visaRequirement": "Visa required for most foreign visitors, varies by nationality",
    "notableFacts": [
      "Fourth largest island in the world.",
      "Known for its unique biodiversity and many species not found anywhere else.",
      "Once a French colony, Madagascar gained independence in 1960."
    ]
  },
  "MD": {
    "flag": "",
    "name": "Moldova",
    "officialName": "Republic of Moldova",
    "countryCode": "+373",
    "isoAlpha2": "MD",
    "isoAlpha3": "MDA",
    "numericCode": "498",
    "firstLanguage": "ro",
    "otherLanguages": [
      "ru",
      "gag",
      "ua"
    ],
    "currency": {
      "code": "MDL",
      "symbol": "L",
      "name": "Moldovan Leu"
    },
    "government": {
      "type": "Unitary parliamentary republic",
      "politicalLean": "Pro-European",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nicolae Timofti"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "population": 2657637,
    "area": {
      "value": 33846,
      "unit": "km"
    },
    "capital": "Chiinău",
    "gdp": {
      "nominal": "11.93 billion USD",
      "perCapita": "4,487 USD"
    },
    "dialingCode": "+373",
    "internetTLD": ".md",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "901",
      "police": "902",
      "ambulance": "903"
    },
    "holidays": [
      "Unity Day (August 27)",
      "Mărior (March 1)"
    ],
    "nationalAnimal": "Dacian snake",
    "nationalDish": "Mămăligă",
    "tourismHighlights": [
      "Cricova Winery",
      "Orheiul Vechi (Old Orhei)",
      "Stefan Cel Mare Central Park",
      "Capriana Monastery"
    ],
    "majorExports": [
      "Wine and beverages",
      "Fruits and vegetables",
      "Textiles"
    ],
    "majorImports": [
      "Mineral products",
      "Machinery and equipment",
      "Food and beverages"
    ],
    "lifeExpectancy": 73.4,
    "literacyRate": 99.4,
    "climate": "Continental with hot summers and cold winters",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Roman Catholic",
        "Protestant",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Romania",
      "Ukraine"
    ],
    "visaRequirement": "Visa-free regime for EU citizens and many others",
    "notableFacts": [
      "Home to some of the best wineries in the world.",
      "One of the poorest countries in Europe.",
      "Has a disputed territory called Transnistria, which is not recognized by most countries."
    ]
  },
  "ME": {
    "flag": "",
    "name": "Montenegro",
    "officialName": "Crna Gora",
    "countryCode": "+382",
    "isoAlpha2": "ME",
    "isoAlpha3": "MNE",
    "numericCode": "499",
    "firstLanguage": "sr",
    "otherLanguages": [
      "bs",
      "hr",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Jakov Milatović"
        },
        {
          "title": "Prime Minister",
          "name": "Dritan Abazović"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southeastern Europe",
    "population": 622359,
    "area": {
      "value": 13812,
      "unit": "km"
    },
    "capital": "Podgorica",
    "gdp": {
      "nominal": "5.35 billion USD",
      "perCapita": "8,603 USD"
    },
    "dialingCode": "+382",
    "internetTLD": ".me",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "123",
      "police": "122",
      "ambulance": "124"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Statehood Day (July 13)",
      "Independence Day (May 21)"
    ],
    "nationalAnimal": "Golden Eagle",
    "nationalDish": "Njeguški pršut",
    "tourismHighlights": [
      "Kotor Bay (UNESCO World Heritage Site)",
      "Durmitor National Park",
      "Sveti Stefan",
      "Skadar Lake"
    ],
    "majorExports": [
      "Aluminum",
      "Medicinal herbs",
      "Citrus fruits"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Food"
    ],
    "lifeExpectancy": 77.4,
    "literacyRate": 98.4,
    "climate": "Mediterranean along the coast, continental inland",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Roman Catholic",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Croatia",
      "Bosnia and Herzegovina",
      "Serbia",
      "Kosovo",
      "Albania"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Montenegro declared independence from the State Union of Serbia and Montenegro in 2006.",
      "Home to one of the deepest canyons in Europe, the Tara River Canyon.",
      "Offers a diverse range of landscapes, from mountains to beautiful Adriatic coast."
    ]
  },
  "MN": {
    "flag": "",
    "name": "Mongolia",
    "officialName": "Mongolia",
    "countryCode": "+976",
    "isoAlpha2": "MN",
    "isoAlpha3": "MNG",
    "numericCode": "496",
    "firstLanguage": "mn",
    "otherLanguages": [
      "ru"
    ],
    "currency": {
      "code": "MNT",
      "symbol": "",
      "name": "Mongolian Tugrik"
    },
    "government": {
      "type": "Unitary parliamentary republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Khurelsukh Ukhna"
        }
      ]
    },
    "timeZone": {
      "name": "Ulán Bator Time (ULAT)",
      "offset": "+08:00",
      "dst": "Yes"
    },
    "dateFormat": "YYYY-MM-DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "population": 3285000,
    "area": {
      "value": 1564110,
      "unit": "km"
    },
    "capital": "Ulaanbaatar",
    "gdp": {
      "nominal": "13.12 billion USD",
      "perCapita": "4,000 USD"
    },
    "dialingCode": "+976",
    "internetTLD": ".mn",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "102",
      "fire": "101",
      "police": "100",
      "ambulance": "103"
    },
    "holidays": [
      "Independence Day (July 11)",
      "Naadam Festival (July 11-13)"
    ],
    "nationalAnimal": "Przewalski's Horse",
    "nationalDish": "Buuz",
    "tourismHighlights": [
      "Gobi Desert",
      "Lake Khövsgöl",
      "Terelj National Park",
      "Mongolian Nomadic Culture Experience"
    ],
    "majorExports": [
      "Copper",
      "Coal",
      "Cashmere"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Vehicles"
    ],
    "lifeExpectancy": 72,
    "literacyRate": 98,
    "climate": "Continental with harsh winters",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Shamanism",
        "Islam",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "China",
      "Russia"
    ],
    "visaRequirement": "Visa required for most nationalities, including many Western countries",
    "notableFacts": [
      "Home to the largest contiguous intact steppe ecosystem in the world.",
      "The second-largest landlocked country in the world.",
      "Famous for its vast wilderness and nomadic culture."
    ]
  },
  "MO": {
    "flag": "",
    "name": "Macao",
    "officialName": "Macao Special Administrative Region of the People's Republic of China",
    "countryCode": "+853",
    "isoAlpha2": "MO",
    "isoAlpha3": "MAC",
    "numericCode": "446",
    "firstLanguage": "zh-HK",
    "otherLanguages": [
      "pt",
      "zh-CN",
      "en"
    ],
    "currency": {
      "code": "MOP",
      "symbol": "MOP$",
      "name": "Macanese Pataca"
    },
    "government": {
      "type": "Special Administrative Region",
      "politicalLean": "Pro-Beijing",
      "headsOfState": [
        {
          "title": "Chief Executive",
          "name": "Ho Iat Seng"
        }
      ]
    },
    "timeZone": {
      "name": "China Standard Time (CST)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Eastern Asia",
    "population": 696100,
    "area": {
      "value": 32.9,
      "unit": "km"
    },
    "capital": "Macao",
    "gdp": {
      "nominal": "37.3 billion USD",
      "perCapita": "53,199 USD"
    },
    "dialingCode": "+853",
    "internetTLD": ".mo",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Macao Day (December 20)",
      "Labor Day (May 1)",
      "Chinese New Year"
    ],
    "nationalAnimal": "Giant Panda",
    "nationalDish": "Minchi",
    "tourismHighlights": [
      "Ruins of St. Paul",
      "Macao Tower",
      "The Venetian Macao",
      "A-Ma Temple"
    ],
    "majorExports": [
      "Clothing",
      "Electronic products",
      "Toys"
    ],
    "majorImports": [
      "Food",
      "Raw materials",
      "Machinery"
    ],
    "lifeExpectancy": 84.5,
    "literacyRate": 96.5,
    "climate": "Subtropical with hot, humid summers and mild winters",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Christianity",
        "Taoism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "China (Zhuhai)"
    ],
    "visaRequirement": "No visa required for many nationalities; visa required for some countries.",
    "notableFacts": [
      "One of the world's most densely populated regions.",
      "Known for its casinos and as a gambling hub.",
      "Cultural influences from both Portuguese and Chinese heritage."
    ]
  },
  "ML": {
    "flag": "",
    "name": "Mali",
    "officialName": "Republic of Mali",
    "countryCode": "+223",
    "isoAlpha2": "ML",
    "isoAlpha3": "MLI",
    "numericCode": "466",
    "firstLanguage": "fr",
    "otherLanguages": [
      "bambara",
      "soninké",
      "tamasheq",
      "fula"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "CFA",
      "name": "West African CFA franc"
    },
    "government": {
      "type": "Semi-presidential republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Assimi Goïta"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Western Africa",
    "population": 20250833,
    "area": {
      "value": 1240192,
      "unit": "km"
    },
    "capital": "Bamako",
    "gdp": {
      "nominal": "17.78 billion USD",
      "perCapita": "876 USD"
    },
    "dialingCode": "+223",
    "internetTLD": ".ml",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Independence Day (September 22)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "Bongo",
    "nationalDish": "Jollof rice",
    "tourismHighlights": [
      "Timbuktu",
      "Djenné Mosque (UNESCO World Heritage Site)",
      "Bamako Grand Mosque",
      "Sankore Mosque"
    ],
    "majorExports": [
      "Gold",
      "Cotton",
      "Livestock"
    ],
    "majorImports": [
      "Food products",
      "Machinery",
      "Fuels"
    ],
    "lifeExpectancy": 60.2,
    "literacyRate": 33.3,
    "climate": "Tropical with a Sudano-Sahelian zone",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Algeria",
      "Niger",
      "Burkina Faso",
      "Côte d'Ivoire",
      "Guinea",
      "Senegal",
      "Mauritania"
    ],
    "visaRequirement": "Visa required for most visitors; visa on arrival available for some countries.",
    "notableFacts": [
      "Home to the ancient city of Timbuktu, a UNESCO World Heritage site.",
      "Mali is one of the largest countries in Africa by land area.",
      "Gold mining is a significant part of the economy."
    ]
  },
  "MK": {
    "flag": "",
    "name": "Macedonia",
    "officialName": "Republic of North Macedonia",
    "countryCode": "+389",
    "isoAlpha2": "MK",
    "isoAlpha3": "MKD",
    "numericCode": "807",
    "firstLanguage": "mk",
    "otherLanguages": [
      "sq",
      "tr",
      "rs"
    ],
    "currency": {
      "code": "MKD",
      "symbol": ".",
      "name": "Macedonian Denar"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Social-democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Stevo Pendarovski"
        }
      ],
      "headOfGovernment": {
        "title": "Prime Minister",
        "name": "Dimitar Kovachevski"
      }
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southeast Europe",
    "population": 2077532,
    "area": {
      "value": 25713,
      "unit": "km"
    },
    "capital": "Skopje",
    "gdp": {
      "nominal": "13.54 billion USD",
      "perCapita": "65,000 USD"
    },
    "dialingCode": "+389",
    "internetTLD": ".mk",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "193",
      "police": "192",
      "ambulance": "194"
    },
    "holidays": [
      "Independence Day (September 8)",
      "Ilinden (August 2)"
    ],
    "nationalAnimal": "Eagle",
    "nationalDish": "Tavče Gravče",
    "tourismHighlights": [
      "Lake Ohrid",
      "Skopje Fortress",
      "hrid's Old Town (UNESCO World Heritage Site)",
      "National Park Mavrovo"
    ],
    "majorExports": [
      "Textiles",
      "Machinery",
      "Metals"
    ],
    "majorImports": [
      "Crude petroleum",
      "Natural gas",
      "Machinery"
    ],
    "lifeExpectancy": 77.7,
    "literacyRate": 97.6,
    "climate": "Continental with hot summers and cold winters",
    "religions": {
      "predominant": "Orthodox Christianity",
      "others": [
        "Islam",
        "Catholicism",
        "Protestantism"
      ]
    },
    "neighborCountries": [
      "Kosovo",
      "Serbia",
      "Bulgaria",
      "Greece",
      "Albania"
    ],
    "visaRequirement": "Visa-free travel for EU citizens and many other countries",
    "notableFacts": [
      "Home to one of the oldest lakes in Europe, Lake Ohrid.",
      "Was formerly known as the 'Former Yugoslav Republic of Macedonia' (FYROM).",
      "Rich in cultural heritage and history, with many UNESCO sites."
    ]
  },
  "MM": {
    "flag": "",
    "name": "Myanmar",
    "officialName": "Republic of the Union of Myanmar",
    "countryCode": "+95",
    "isoAlpha2": "MM",
    "isoAlpha3": "MMR",
    "numericCode": "104",
    "firstLanguage": "my",
    "otherLanguages": [
      "en",
      "zh",
      "shn",
      "mon",
      "kar"
    ],
    "currency": {
      "code": "MMK",
      "symbol": "K",
      "name": "Myanmar Kyat"
    },
    "government": {
      "type": "Unitary parliamentary constitutional republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Min Aung Hlaing"
        },
        {
          "title": "State Counsellor",
          "name": "Aung San Suu Kyi"
        }
      ]
    },
    "timeZone": {
      "name": "Myanmar Time (MMT)",
      "offset": "+06:30",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 54800000,
    "area": {
      "value": 676578,
      "unit": "km"
    },
    "capital": "Naypyidaw",
    "gdp": {
      "nominal": "76.08 billion USD",
      "perCapita": "1,375 USD"
    },
    "dialingCode": "+95",
    "internetTLD": ".mm",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "191",
      "police": "199",
      "ambulance": "192"
    },
    "holidays": [
      "Independence Day (January 4)",
      "Thingyan (Water Festival)",
      "National Martyrs' Day (July 19)"
    ],
    "nationalAnimal": "Burmese Zebra",
    "nationalDish": "Mohinga",
    "tourismHighlights": [
      "Bagan Archaeological Zone",
      "Inle Lake",
      "Shwedagon Pagoda",
      "Golden Rock (Kyaiktiyo Pagoda)"
    ],
    "majorExports": [
      "Natural gas",
      "Rice",
      "Teak wood"
    ],
    "majorImports": [
      "Oil products",
      "Machinery and equipment",
      "Consumer goods"
    ],
    "lifeExpectancy": 67.4,
    "literacyRate": 89.5,
    "climate": "Tropical monsoon climate",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Christianity",
        "Islam",
        "Animism"
      ]
    },
    "neighborCountries": [
      "Bangladesh",
      "India",
      "China",
      "Laos",
      "Thailand"
    ],
    "visaRequirement": "Visa required for most countries, e-Visa available for select nations",
    "notableFacts": [
      "Known for its rich cultural heritage and numerous ethnic groups.",
      "Home to the ancient city of Bagan, famous for its temples and pagodas.",
      "The largest country in Southeast Asia by land area."
    ]
  },
  "MR": {
    "flag": "",
    "name": "Mauritania",
    "officialName": "Islamic Republic of Mauritania",
    "countryCode": "+222",
    "isoAlpha2": "MR",
    "isoAlpha3": "MRT",
    "numericCode": "478",
    "firstLanguage": "ar",
    "otherLanguages": [
      "fr"
    ],
    "currency": {
      "code": "MRU",
      "symbol": "UM",
      "name": "Mauritanian Ouguiya"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Islamic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Mohamed Ould Ghazouani"
        }
      ]
    },
    "timeZone": {
      "name": "Mauritania Time (GMT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Western Africa",
    "population": 4300000,
    "area": {
      "value": 1030700,
      "unit": "km"
    },
    "capital": "Nouakchott",
    "gdp": {
      "nominal": "5.07 billion USD",
      "perCapita": "1,200 USD"
    },
    "dialingCode": "+222",
    "internetTLD": ".mr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Independence Day (November 28)",
      "Islamic New Year (date varies)"
    ],
    "nationalAnimal": "Camel",
    "nationalDish": "Thieboudienne",
    "tourismHighlights": [
      "Chinguetti (UNESCO World Heritage Site)",
      "Nouakchott Beach",
      "Ouadane",
      "The Banc d'Arguin National Park (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Iron ore",
      "Fish",
      "Gold"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 65,
    "literacyRate": 70,
    "climate": "Desert climate, hot and dry with a short rainy season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "None",
        "Christianity",
        "African Traditional Religions"
      ]
    },
    "neighborCountries": [
      "Western Sahara",
      "Algeria",
      "Mali"
    ],
    "visaRequirement": "Visa required for most nationalities, except for some Arab and African countries",
    "notableFacts": [
      "Largest country in the African continent by land area that is entirely within the Sahara Desert.",
      "Home to the ancient trade city of Chinguetti.",
      "Rich in mineral resources and fishing opportunities."
    ]
  },
  "MS": {
    "flag": "",
    "name": "Montserrat",
    "officialName": "Montserrat",
    "countryCode": "+1",
    "isoAlpha2": "MS",
    "isoAlpha3": "MSR",
    "numericCode": "500",
    "firstLanguage": "en",
    "otherLanguages": [
      "ms"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Overseas territory",
      "politicalLean": "Dependent territory of the United Kingdom",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Governor of Montserrat"
        },
        {
          "title": "Premier",
          "name": "Premier of Montserrat"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 5000,
    "area": {
      "value": 102,
      "unit": "km"
    },
    "capital": "Plymouth (de facto), Brades (administrative)",
    "gdp": {
      "nominal": "71 million USD",
      "perCapita": "14,200 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".ms",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "St. Patrick's Day (March 17)",
      "Emancipation Day (August 1)"
    ],
    "nationalAnimal": "Therapsid",
    "nationalDish": "Goat water",
    "tourismHighlights": [
      "Soufrière Hills Volcano",
      "Little Bay",
      "Montserrat Volcano Observatory",
      "Royal Montserrat Botanical Gardens"
    ],
    "majorExports": [
      "Food products",
      "Clothing",
      "Manufactured goods"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Consumer goods"
    ],
    "lifeExpectancy": 78,
    "literacyRate": 97,
    "climate": "Tropical, with a wet season from May to November",
    "religions": {
      "predominant": "Anglican",
      "others": [
        "Roman Catholic",
        "Baptist",
        "Other Protestant"
      ]
    },
    "neighborCountries": [
      "None (island territory)"
    ],
    "visaRequirement": "No visa required for most countries; entry requirements apply to certain nationalities",
    "notableFacts": [
      "Devastated by volcanic eruptions in the 1990s, leading to evacuation of the capital.",
      "Home to the Montserrat Cultural Centre, which promotes local culture.",
      "Has a unique blend of British and Caribbean cultures."
    ]
  },
  "MP": {
    "flag": "",
    "name": "Northern Mariana Islands",
    "officialName": "Commonwealth of the Northern Mariana Islands",
    "countryCode": "+1",
    "isoAlpha2": "MP",
    "isoAlpha3": "MNP",
    "numericCode": "580",
    "firstLanguage": "ch",
    "otherLanguages": [
      "en",
      "fil"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Commonwealth",
      "politicalLean": "Free association with the United States",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Ralph DLG Torres"
        },
        {
          "title": "President of the United States",
          "name": "Joe Biden"
        }
      ]
    },
    "timeZone": {
      "name": "Chamorro Standard Time (CHST)",
      "offset": "+10:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Micronesia",
    "population": 57557,
    "area": {
      "value": 464,
      "unit": "km"
    },
    "capital": "Saipan",
    "gdp": {
      "nominal": "1.06 billion USD",
      "perCapita": "18,163 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".mp",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Commonwealth Covenant Day (March 24)",
      "Independence Day (November 28)"
    ],
    "nationalAnimal": "Green Sea Turtle",
    "nationalDish": "Red Rice",
    "tourismHighlights": [
      "Grotto (diving site)",
      "Managaha Island",
      "Saipans Coral Reefs",
      "American Memorial Park"
    ],
    "majorExports": [
      "Clothing",
      "Footwear",
      "Toys"
    ],
    "majorImports": [
      "Food",
      "Construction materials",
      "Consumer goods"
    ],
    "lifeExpectancy": 78.3,
    "literacyRate": 97,
    "climate": "Tropical marine climate",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Buddhism",
        "Other faiths"
      ]
    },
    "neighborCountries": [
      "United States (Guam)"
    ],
    "visaRequirement": "No visa required for U.S. citizens; others may require Visa Waiver or other regulations.",
    "notableFacts": [
      "The Northern Mariana Islands are a group of 14 islands in the Pacific Ocean.",
      "The economy relies heavily on tourism and garment manufacturing.",
      "Home to the third largest reef in the world, the Marianas Trench."
    ]
  },
  "MT": {
    "flag": "",
    "name": "Malta",
    "officialName": "Republic of Malta",
    "countryCode": "+356",
    "isoAlpha2": "MT",
    "isoAlpha3": "MLT",
    "numericCode": "470",
    "firstLanguage": "mt",
    "otherLanguages": [
      "en",
      "it"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Centre to Centre-Right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Robert Abela"
        }
      ],
      "headOfGovernment": {
        "title": "Prime Minister",
        "name": "Robert Abela"
      }
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 514999,
    "area": {
      "value": 316,
      "unit": "km"
    },
    "capital": "Valletta",
    "gdp": {
      "nominal": "14.82 billion USD",
      "perCapita": "28,400 USD"
    },
    "dialingCode": "+356",
    "internetTLD": ".mt",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "Feast of St. Paul's Shipwreck (February 10)",
      "Independence Day (September 21)",
      "Republic Day (December 13)"
    ],
    "nationalAnimal": "Golden Eagle",
    "nationalDish": "Rabbit Stew (Fenek)",
    "tourismHighlights": [
      "St. John's Co-Cathedral",
      "The Blue Lagoon",
      "Mnajdra Temples",
      "Mdina - The Silent City"
    ],
    "majorExports": [
      "Electrical machinery",
      "Clothing",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Mineral fuels",
      "Foodstuffs",
      "Machinery"
    ],
    "lifeExpectancy": 83.4,
    "literacyRate": 94.6,
    "climate": "Mediterranean, hot dry summers and mild winters",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "None",
        "Protestant",
        "Muslim"
      ]
    },
    "neighborCountries": [
      "None (island nation)"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Historic sites from various civilisations, including the Phoenicians, Romans, and Knights of St. John.",
      "Has a rich maritime history and is known for its crystal-clear waters.",
      "Famous for hosting the world's oldest free-standing structures, the Ħaġar Qim temples."
    ]
  },
  "MQ": {
    "flag": "",
    "name": "Martinique",
    "officialName": "Territorial Collectivity of Martinique",
    "countryCode": "+596",
    "isoAlpha2": "MQ",
    "isoAlpha3": "MTQ",
    "numericCode": "474",
    "firstLanguage": "fr",
    "otherLanguages": [
      "en",
      "ht"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Territorial collectivity of France",
      "politicalLean": "Center-left",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of France"
        },
        {
          "title": "President",
          "name": "President of the Territorial Collectivity"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 375000,
    "area": {
      "value": 1128,
      "unit": "km"
    },
    "capital": "Fort-de-France",
    "gdp": {
      "nominal": "3.7 billion USD",
      "perCapita": "9,600 USD"
    },
    "dialingCode": "+596",
    "internetTLD": ".mq",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      " Labour Day (May 1)",
      "Abolition of Slavery Day (May 22)",
      "Independence Day (July 14)"
    ],
    "nationalAnimal": "Cattle Egret",
    "nationalDish": "Accras",
    "tourismHighlights": [
      "Mount Pelée",
      "Les Salines Beach",
      "La Savane des Esclaves",
      "Fort Saint-Louis"
    ],
    "majorExports": [
      "Bananas",
      "Rum",
      "Sugarcane"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 80.3,
    "literacyRate": 98,
    "climate": "Tropical maritime",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Vodou",
        "None"
      ]
    },
    "neighborCountries": [
      "None (island)",
      "Close proximity to Dominica and Saint Lucia"
    ],
    "visaRequirement": "No visa required for Schengen Area and some others",
    "notableFacts": [
      "Part of the French overseas regions.",
      "Known for its beautiful beaches and vibrant culture.",
      "Mount Pelée is an active volcano that famously erupted in 1902."
    ]
  },
  "MV": {
    "flag": "",
    "name": "Maldives",
    "officialName": "Republic of Maldives",
    "countryCode": "+960",
    "isoAlpha2": "MV",
    "isoAlpha3": "MDV",
    "numericCode": "462",
    "firstLanguage": "dv",
    "otherLanguages": [
      "en",
      "hi",
      "ta"
    ],
    "currency": {
      "code": "MVR",
      "symbol": "",
      "name": "Maldivian Rufiyaa"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Mohamed Muizzu"
        },
        {
          "title": "Vice President",
          "name": "Faaris Maumoon"
        }
      ]
    },
    "timeZone": {
      "name": "Maldives Time (MVT)",
      "offset": "+05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southern Asia",
    "population": 515696,
    "area": {
      "value": 298,
      "unit": "km"
    },
    "capital": "Malé",
    "gdp": {
      "nominal": "5.74 billion USD",
      "perCapita": "11,097 USD"
    },
    "dialingCode": "+960",
    "internetTLD": ".mv",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "119",
      "fire": "118",
      "police": "119",
      "ambulance": "102"
    },
    "holidays": [
      "Independence Day (July 26)",
      "Victory Day (November 3)"
    ],
    "nationalAnimal": "Yellowfin Tuna",
    "nationalDish": "Mas Huni",
    "tourismHighlights": [
      "Maldives Atolls",
      "Manta Point",
      "Banana Reef",
      "Addu Atoll"
    ],
    "majorExports": [
      "Fish",
      "Coconut products",
      "Clothing"
    ],
    "majorImports": [
      "Fuel",
      "Food",
      "Construction materials"
    ],
    "lifeExpectancy": 78.7,
    "literacyRate": 99.3,
    "climate": "Tropical monsoon climate with two distinct seasons",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Buddhism",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "India",
      "Sri Lanka"
    ],
    "visaRequirement": "Visa on arrival for most nationalities, free for 30 days",
    "notableFacts": [
      "Lowest country in the world, with average ground level of 1.5 meters above sea level.",
      "Famous for its luxury resorts and white sandy beaches.",
      "Tourism is the largest industry, contributing significantly to the GDP."
    ]
  },
  "MX": {
    "flag": "",
    "name": "Mexico",
    "officialName": "United Mexican States",
    "countryCode": "+52",
    "isoAlpha2": "MX",
    "isoAlpha3": "MEX",
    "numericCode": "484",
    "firstLanguage": "es",
    "otherLanguages": [
      "nah",
      "en",
      "fr"
    ],
    "currency": {
      "code": "MXN",
      "symbol": "$",
      "name": "Mexican Peso"
    },
    "government": {
      "type": "Federal presidential constitutional republic",
      "politicalLean": "Varies by region",
      "headsOfState": [
        {
          "title": "President",
          "name": "Andrés Manuel López Obrador"
        }
      ]
    },
    "timeZone": {
      "name": "Central Standard Time (CST)",
      "offset": "-06:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "North America",
    "population": 126190788,
    "area": {
      "value": 1964375,
      "unit": "km"
    },
    "capital": "Mexico City",
    "gdp": {
      "nominal": "1.27 trillion USD",
      "perCapita": "10,196 USD"
    },
    "dialingCode": "+52",
    "internetTLD": ".mx",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "068",
      "police": "066",
      "ambulance": "065"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (September 16)",
      "Day of the Dead (November 2)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Golden Eagle",
    "nationalDish": "Mole Poblano",
    "tourismHighlights": [
      "Chichen Itza (UNESCO World Heritage Site)",
      "Cenotes in Yucatan",
      "Teotihuacan Pyramids",
      "Frida Kahlo Museum"
    ],
    "majorExports": [
      "Automobiles",
      "Petroleum",
      "Electronics"
    ],
    "majorImports": [
      "Machinery",
      "Electrical equipment",
      "Mineral fuels"
    ],
    "lifeExpectancy": 75.1,
    "literacyRate": 94.5,
    "climate": "Varies from tropical to desert, with a rainy season from May to October",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Christianity (Protestant)",
        "Secular/Non-religious",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "United States",
      "Belize",
      "Guatemala"
    ],
    "visaRequirement": "Visa-free entry for many countries; eVisa required for some.",
    "notableFacts": [
      "Home to the ancient civilizations of the Aztecs and Maya.",
      "The second-largest country in Latin America.",
      "Rich biodiversity with numerous ecosystems."
    ]
  },
  "MY": {
    "flag": "",
    "name": "Malaysia",
    "officialName": "Federation of Malaysia",
    "countryCode": "+60",
    "isoAlpha2": "MY",
    "isoAlpha3": "MYS",
    "numericCode": "458",
    "firstLanguage": "ms",
    "otherLanguages": [
      "en",
      "zh",
      "ta"
    ],
    "currency": {
      "code": "MYR",
      "symbol": "RM",
      "name": "Malaysian Ringgit"
    },
    "government": {
      "type": "Federal constitutional monarchy",
      "politicalLean": "Multiculturalism",
      "headsOfState": [
        {
          "title": "King",
          "name": "Al-Sultan Abdullah of Pahang"
        }
      ],
      "headOfGovernment": {
        "title": "Prime Minister",
        "name": "Anwar Ibrahim"
      }
    },
    "timeZone": {
      "name": "Malaysia Standard Time (MST)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "population": 32728750,
    "area": {
      "value": 330803,
      "unit": "km"
    },
    "capital": "Kuala Lumpur",
    "gdp": {
      "nominal": "336.66 billion USD",
      "perCapita": "10,207 USD"
    },
    "dialingCode": "+60",
    "internetTLD": ".my",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "994",
      "police": "999",
      "ambulance": "994"
    },
    "holidays": [
      "Hari Merdeka (August 31)",
      "Hari Raya Aidilfitri",
      "Chinese New Year"
    ],
    "nationalAnimal": "Malayan Tiger",
    "nationalDish": "Nasi Lemak",
    "tourismHighlights": [
      "Petronas Twin Towers",
      "Langkawi Sky Bridge",
      "Cameron Highlands",
      "George Town (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Electronics",
      "Palm oil",
      "Rubber"
    ],
    "majorImports": [
      "Machinery",
      "Chemical products",
      "Food"
    ],
    "lifeExpectancy": 75.3,
    "literacyRate": 94.6,
    "climate": "Equatorial, with high humidity and rainfall",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Buddhism",
        "Christianity",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Thailand",
      "Indonesia",
      "Brunei"
    ],
    "visaRequirement": "Visa-free for many countries, eVisa available for others",
    "notableFacts": [
      "Home to the world's tallest tropical tree.",
      "Has one of the most diverse ecosystems in the world.",
      "Is known for its multicultural population and rich cultural heritage."
    ]
  },
  "MW": {
    "flag": "",
    "name": "Malawi",
    "officialName": "Republic of Malawi",
    "countryCode": "+265",
    "isoAlpha2": "MW",
    "isoAlpha3": "MWI",
    "numericCode": "454",
    "firstLanguage": "ny",
    "otherLanguages": [
      "en",
      "tm"
    ],
    "currency": {
      "code": "MWK",
      "symbol": "K",
      "name": "Malawian Kwacha"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Lazarus Chakwera"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 20211200,
    "area": {
      "value": 118484,
      "unit": "km"
    },
    "capital": "Lilongwe",
    "gdp": {
      "nominal": "10.29 billion USD",
      "perCapita": "508 USD"
    },
    "dialingCode": "+265",
    "internetTLD": ".mw",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "998",
      "police": "997",
      "ambulance": "990"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "International Women's Day (March 8)",
      "Good Friday",
      "Easter Monday",
      "Labor Day (May 1)",
      "Independence Day (July 6)",
      "Heroes Day (July 5)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "African Fish Eagle",
    "nationalDish": "Nsima",
    "tourismHighlights": [
      "Lake Malawi",
      "Nyika National Park",
      "Liwonde National Park",
      "Mount Mulanje",
      "Rukuru Falls"
    ],
    "majorExports": [
      "Tobacco",
      "Tea",
      "Sugar",
      "Cotton"
    ],
    "majorImports": [
      "Foodstuffs",
      "Petroleum products",
      "Machinery",
      "Transport equipment"
    ],
    "lifeExpectancy": 64.3,
    "literacyRate": 62.7,
    "climate": "Subtropical highland climate",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Tanzania",
      "Mozambique",
      "Zambia"
    ],
    "visaRequirement": "Visa required for several nationalities, varies by region.",
    "notableFacts": [
      "Home to one of the largest freshwater lakes in the world, Lake Malawi.",
      "Known as the 'Warm Heart of Africa' due to the friendly nature of its people.",
      "The economy is heavily reliant on agriculture, with about 80% of the population engaged in subsistence farming."
    ]
  },
  "MU": {
    "flag": "",
    "name": "Mauritius",
    "officialName": "Republic of Mauritius",
    "countryCode": "+230",
    "isoAlpha2": "MU",
    "isoAlpha3": "MUS",
    "numericCode": "480",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "mauritian creole",
      "hindi",
      "bhojpuri",
      " Urdu"
    ],
    "currency": {
      "code": "MUR",
      "symbol": "Rs",
      "name": "Mauritian Rupee"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Prithvirajsing Roopun"
        },
        {
          "title": "Prime Minister",
          "name": "Pravind Jugnauth"
        }
      ]
    },
    "timeZone": {
      "name": "Mauritius Standard Time (MUT)",
      "offset": "+04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 1271768,
    "area": {
      "value": 2040,
      "unit": "km"
    },
    "capital": "Port Louis",
    "gdp": {
      "nominal": "14.20 billion USD",
      "perCapita": "11,146 USD"
    },
    "dialingCode": "+230",
    "internetTLD": ".mu",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "115",
      "police": "999",
      "ambulance": "114"
    },
    "holidays": [
      "Labour Day (May 1)",
      "Independence Day (March 12)",
      "Abolition of Slavery Day (February 1)",
      "Divali (date varies)"
    ],
    "nationalAnimal": "Dodo (extinct)",
    "nationalDish": "Dholl Puri",
    "tourismHighlights": [
      "Mauritius Coastal Road",
      "Île aux Cerfs",
      "Black River Gorges National Park",
      "Chamarel Seven Colored Earths"
    ],
    "majorExports": [
      "Textiles",
      "Sugar",
      "Fisheries"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 74.4,
    "literacyRate": 91.7,
    "climate": "Tropical maritime climate with warm, humid summers and cool, dry winters",
    "religions": {
      "predominant": "Hinduism",
      "others": [
        "Islam",
        "Christianity",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Reunion (France)",
      "Rodrigues"
    ],
    "visaRequirement": "Visa-free for many countries, including EU nations.",
    "notableFacts": [
      "Home to the extinct Dodo bird, which was unique to the island.",
      "Known for its diverse culture and multicultural population.",
      "An important financial services hub in Africa."
    ]
  },
  "NE": {
    "flag": "",
    "name": "Niger",
    "officialName": "Republic of Niger",
    "countryCode": "+227",
    "isoAlpha2": "NE",
    "isoAlpha3": "NER",
    "numericCode": "562",
    "firstLanguage": "fr",
    "otherLanguages": [
      "ha",
      "dz",
      "en"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "",
      "name": "West African CFA Franc"
    },
    "government": {
      "type": "Semi-presidential republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Mohamed Bazoum"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 25210462,
    "area": {
      "value": 1267000,
      "unit": "km"
    },
    "capital": "Niamey",
    "gdp": {
      "nominal": "14.22 billion USD",
      "perCapita": "563 USD"
    },
    "dialingCode": "+227",
    "internetTLD": ".ne",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "15",
      "ambulance": "20"
    },
    "holidays": [
      "Independence Day (August 3)",
      "Revolution Day (December 18)"
    ],
    "nationalAnimal": "Kudu",
    "nationalDish": "Nigerien Rice",
    "tourismHighlights": [
      "Air Mountains",
      "W National Park (UNESCO World Heritage Site)",
      "Sahara Desert tours",
      "National Museum of Niger"
    ],
    "majorExports": [
      "Uranium",
      "Livestock",
      "Gold"
    ],
    "majorImports": [
      "Foodstuffs",
      "Consumer goods",
      "Machinery"
    ],
    "lifeExpectancy": 62.2,
    "literacyRate": 19.1,
    "climate": "Hot and dry, with a rainy season from June to September",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Traditional African religions",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "Algeria",
      "Libya",
      "Chad",
      "Nigeria",
      "Benin",
      "Burkina Faso",
      "Mali"
    ],
    "visaRequirement": "Visa required for most travelers; some exemptions apply.",
    "notableFacts": [
      "One of the largest countries in Africa by land area.",
      "Niger is home to the largest population of nomadic people in the world.",
      "The country is rich in natural resources such as uranium."
    ]
  },
  "MZ": {
    "flag": "",
    "name": "Mozambique",
    "officialName": "Republic of Mozambique",
    "countryCode": "+258",
    "isoAlpha2": "MZ",
    "isoAlpha3": "MOZ",
    "numericCode": "508",
    "firstLanguage": "pt",
    "otherLanguages": [
      "mwi",
      "en",
      "vmw"
    ],
    "currency": {
      "code": "MZN",
      "symbol": "MT",
      "name": "Mozambican Metical"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Filipe Nyusi"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 33420000,
    "area": {
      "value": 801590,
      "unit": "km"
    },
    "capital": "Maputo",
    "gdp": {
      "nominal": "15.747 billion USD",
      "perCapita": "471 USD"
    },
    "dialingCode": "+258",
    "internetTLD": ".mz",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "119",
      "fire": "117",
      "police": "119",
      "ambulance": "222"
    },
    "holidays": [
      "Independence Day (June 25)",
      "Victory Day (September 7)",
      "Maputo Day (January 10)"
    ],
    "nationalAnimal": "Nyala",
    "nationalDish": "Piri-piri chicken",
    "tourismHighlights": [
      "Bazaruto Archipelago",
      "Gorongosa National Park",
      "Maputo National Art Museum",
      "Quirimbas Archipelago"
    ],
    "majorExports": [
      "Aluminium",
      "Tobacco",
      "Cashews"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Petroleum products"
    ],
    "lifeExpectancy": 60.1,
    "literacyRate": 60.7,
    "climate": "Tropical, with a rainy season from November to April",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Traditional African religions",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Tanzania",
      "Malawi",
      "Zambia",
      "South Africa",
      "Eswatini"
    ],
    "visaRequirement": "Visa required for most visitors; e-Visa available for some nationalities",
    "notableFacts": [
      "Home to the famous Gorongosa National Park known for its biodiversity.",
      "Has a rich cultural heritage influenced by various African, Portuguese and Arab cultures.",
      "The country's coastline along the Indian Ocean is known for its stunning beaches and marine life."
    ]
  },
  "NA": {
    "flag": "",
    "name": "Namibia",
    "officialName": "Republic of Namibia",
    "countryCode": "+264",
    "isoAlpha2": "NA",
    "isoAlpha3": "NAM",
    "numericCode": "516",
    "firstLanguage": "en",
    "otherLanguages": [
      "af",
      "de",
      "hu",
      "naq",
      "kwh"
    ],
    "currency": {
      "code": "NAD",
      "symbol": "$",
      "name": "Namibian Dollar"
    },
    "government": {
      "type": "Unitary parliamentary constitutional republic",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Hage Geingob"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Southern Africa",
    "population": 2540905,
    "area": {
      "value": 825615,
      "unit": "km"
    },
    "capital": "Windhoek",
    "gdp": {
      "nominal": "12.64 billion USD",
      "perCapita": "4,854 USD"
    },
    "dialingCode": "+264",
    "internetTLD": ".na",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "081",
      "police": "061-203-897",
      "ambulance": "061-211-211"
    },
    "holidays": [
      "Independence Day (March 21)",
      "Heroes Day (August 26)",
      "Day of Reconciliation (December 10)"
    ],
    "nationalAnimal": "Springbok",
    "nationalDish": "Biltong",
    "tourismHighlights": [
      "Etosha National Park",
      "Sossusvlei Dunes",
      "Skeleton Coast",
      "Fish River Canyon"
    ],
    "majorExports": [
      "Diamonds",
      "Uranium",
      "Copper",
      "Fish"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Transport equipment",
      "Fuels"
    ],
    "lifeExpectancy": 64.4,
    "literacyRate": 89.1,
    "climate": "Semi-arid to arid, with a desert climate in the Namib Desert",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Hinduism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Angola",
      "Zambia",
      "Botswana",
      "South Africa"
    ],
    "visaRequirement": "Visa-free access for many countries, visa required for some nationalities.",
    "notableFacts": [
      "Home to the world's largest salt pan, the Makgadikgadi Pan.",
      "Rich in wildlife and diverse ecosystems.",
      "One of the least densely populated countries in the world."
    ]
  },
  "NC": {
    "flag": "",
    "name": "New Caledonia",
    "officialName": "Territory of New Caledonia",
    "countryCode": "+687",
    "isoAlpha2": "NC",
    "isoAlpha3": "NCL",
    "numericCode": "540",
    "firstLanguage": "fr",
    "otherLanguages": [
      "nc",
      "en",
      "ja"
    ],
    "currency": {
      "code": "XPF",
      "symbol": "",
      "name": "CFP franc"
    },
    "government": {
      "type": "Special collectivity of France",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President of the Government",
          "name": "Louis Mapou"
        },
        {
          "title": "Governor",
          "name": "Authorized representative of the French State"
        }
      ]
    },
    "timeZone": {
      "name": "New Caledonia Time (NCT)",
      "offset": "+11:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Melanesia",
    "population": 271000,
    "area": {
      "value": 18575,
      "unit": "km"
    },
    "capital": "Nouméa",
    "gdp": {
      "nominal": "12.8 billion USD",
      "perCapita": "47,000 USD"
    },
    "dialingCode": "+687",
    "internetTLD": ".nc",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "15",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "New Caledonia Day (September 24)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "Kagu",
    "nationalDish": "Bougna",
    "tourismHighlights": [
      "Isle of Pines",
      "Lifou Island",
      "Heart of Voh",
      "Amedee Island"
    ],
    "majorExports": [
      "Nickel",
      "Cobalt",
      "Fish"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Vehicles"
    ],
    "lifeExpectancy": 77,
    "literacyRate": 99.9,
    "climate": "Tropical with a dry season and a wet season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "None, but close to Australia, New Zealand, and Vanuatu"
    ],
    "visaRequirement": "Visa-free for EU citizens and several other countries; check for specific requirements.",
    "notableFacts": [
      "Contains one of the largest coral reef systems in the world.",
      "Home to unique fauna and flora, many of which are endemic.",
      "Has been the site of significant geopolitical interest due to its nickel reserves."
    ]
  },
  "NF": {
    "flag": "",
    "name": "Norfolk Island",
    "officialName": "Norfolk Island",
    "countryCode": "+6723",
    "isoAlpha2": "NF",
    "isoAlpha3": "NFK",
    "numericCode": "574",
    "firstLanguage": "en",
    "otherLanguages": [
      "Norfolk (Norfolk language)"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "A$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Self-governing territory of Australia",
      "politicalLean": "Autonomous",
      "headOfState": {
        "title": "Administrator",
        "name": "Representatives of the Australian Government"
      }
    },
    "timeZone": {
      "name": "Norfolk Island Time (NFT)",
      "offset": "+11:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Australia and New Zealand",
    "population": 2185,
    "area": {
      "value": 35.2,
      "unit": "km"
    },
    "capital": "Kingston",
    "gdp": {
      "nominal": "16 million AUD",
      "perCapita": "7,300 AUD"
    },
    "dialingCode": "+6723",
    "internetTLD": ".nf",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "000",
      "fire": "000",
      "police": "000",
      "ambulance": "000"
    },
    "holidays": [
      "Bounty Day (June 8)",
      "Norfolk Island Day (March 20)"
    ],
    "nationalAnimal": "Norfolk Island Pine",
    "nationalDish": "Fish and chips",
    "tourismHighlights": [
      "Emily Bay",
      "Norfolk Island Museum",
      "The Arch",
      "Fletcher's Mutiny Cyclorama"
    ],
    "majorExports": [
      "Agricultural products",
      "Timber",
      "Tourism services"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 80,
    "literacyRate": 99,
    "climate": "Subtropical with mild winters and warm summers",
    "religions": {
      "predominant": "Anglican",
      "others": [
        "Catholicism",
        "Unspecified"
      ]
    },
    "neighborCountries": [
      "Australia",
      "New Zealand"
    ],
    "visaRequirement": "No visa required for Australian citizens",
    "notableFacts": [
      "Has a unique language and culture due to its history with the Pitcairn Islanders.",
      "Is home to several historical sites, including remnants of the penal settlement.",
      "Lacks a conventional airport; visitors typically arrive by ferry or direct flights from Australia."
    ]
  },
  "NG": {
    "flag": "",
    "name": "Nigeria",
    "officialName": "Federal Republic of Nigeria",
    "countryCode": "+234",
    "isoAlpha2": "NG",
    "isoAlpha3": "NGA",
    "numericCode": "566",
    "firstLanguage": "ha",
    "otherLanguages": [
      "en",
      "yo",
      "ig"
    ],
    "currency": {
      "code": "NGN",
      "symbol": "",
      "name": "Naira"
    },
    "government": {
      "type": "Federal presidential republic",
      "politicalLean": "Diverse",
      "headsOfState": [
        {
          "title": "President",
          "name": "Bola Ahmed Tinubu"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 211000000,
    "area": {
      "value": 923768,
      "unit": "km"
    },
    "capital": "Abuja",
    "gdp": {
      "nominal": "446.54 billion USD",
      "perCapita": "2,119 USD"
    },
    "dialingCode": "+234",
    "internetTLD": ".ng",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "999",
      "ambulance": "112"
    },
    "holidays": [
      "Independence Day (October 1)",
      "Democracy Day (June 12)",
      "Eid-el-Fitr",
      "Eid-el-Adha",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Coalition of Various Species",
    "nationalDish": "Jollof Rice",
    "tourismHighlights": [
      "Obudu Mountain Resort",
      "Olumo Rock",
      "Lekki Conservation Centre",
      "Aso Rock",
      "Zuma Rock"
    ],
    "majorExports": [
      "Crude oil",
      "Natural gas",
      "Agricultural products"
    ],
    "majorImports": [
      "Refined petroleum",
      "Cars",
      "Machinery"
    ],
    "lifeExpectancy": 54.3,
    "literacyRate": 62,
    "climate": "Tropical; distinct wet and dry seasons",
    "religions": {
      "predominant": "Christianity and Islam",
      "others": [
        "Traditional African religions",
        "Atheism"
      ]
    },
    "neighborCountries": [
      "Benin",
      "Niger",
      "Chad",
      "Cameroon"
    ],
    "visaRequirement": "Visa required for most foreign nationals.",
    "notableFacts": [
      "Most populous country in Africa and the seventh most populous in the world.",
      "Home to over 250 ethnic groups.",
      "Rich in natural resources, especially oil and gas."
    ]
  },
  "NP": {
    "flag": "",
    "name": "Nepal",
    "officialName": "Federal Democratic Republic of Nepal",
    "countryCode": "+977",
    "isoAlpha2": "NP",
    "isoAlpha3": "NPL",
    "numericCode": "524",
    "firstLanguage": "ne",
    "otherLanguages": [
      "en",
      "ma",
      "hi"
    ],
    "currency": {
      "code": "NPR",
      "symbol": "",
      "name": "Nepalese Rupee"
    },
    "government": {
      "type": "Federal parliamentary republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ram Chandra Poudel"
        },
        {
          "title": "Prime Minister",
          "name": "Pushpa Kamal Dahal"
        }
      ]
    },
    "timeZone": {
      "name": "Nepal Time (NPT)",
      "offset": "+05:45",
      "dst": "No"
    },
    "dateFormat": "YYYY/MM/DD",
    "timeFormat": "12-hour",
    "region": "Asia",
    "subregion": "South Asia",
    "population": 29610023,
    "area": {
      "value": 147516,
      "unit": "km"
    },
    "capital": "Kathmandu",
    "gdp": {
      "nominal": "36.5 billion USD",
      "perCapita": "1,229 USD"
    },
    "dialingCode": "+977",
    "internetTLD": ".np",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "100",
      "fire": "101",
      "police": "100",
      "ambulance": "102"
    },
    "holidays": [
      "Nepalese New Year (April 14)",
      "Dashain (September/October)",
      "Tihar (October/November)"
    ],
    "nationalAnimal": "Cow",
    "nationalDish": "Dal Bhat",
    "tourismHighlights": [
      "Mount Everest",
      "Pokhara",
      "Chitwan National Park",
      "Bhaktapur Durbar Square",
      "Lumbini (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Textiles",
      "Carpets",
      "Gems and jewelry"
    ],
    "majorImports": [
      "Petroleum products",
      "Gold",
      "Machinery"
    ],
    "lifeExpectancy": 71.3,
    "literacyRate": 67.9,
    "climate": "Varies with altitude; tropical in the south, temperate in the middle, and arctic in the north",
    "religions": {
      "predominant": "Hinduism",
      "others": [
        "Buddhism",
        "Islam",
        "Christianity"
      ]
    },
    "neighborCountries": [
      "China",
      "India"
    ],
    "visaRequirement": "Visa required for most countries, but easy to obtain on arrival or online for tourists.",
    "notableFacts": [
      "Home to Mount Everest, the highest peak in the world.",
      "Rich biodiversity with multiple national parks and wildlife reserves.",
      "The only Hindu kingdom in the world."
    ]
  },
  "NI": {
    "flag": "",
    "name": "Nicaragua",
    "officialName": "Republic of Nicaragua",
    "countryCode": "+505",
    "isoAlpha2": "NI",
    "isoAlpha3": "NIC",
    "numericCode": "558",
    "firstLanguage": "es",
    "otherLanguages": [
      "Miskito",
      "Cornish",
      "Garifuna"
    ],
    "currency": {
      "code": "NIO",
      "symbol": "C$",
      "name": "Nicaraguan Córdoba"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Daniel Ortega"
        }
      ]
    },
    "timeZone": {
      "name": "Central Standard Time (CST)",
      "offset": "-06:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Central America",
    "population": 6632785,
    "area": {
      "value": 130375,
      "unit": "km"
    },
    "capital": "Managua",
    "gdp": {
      "nominal": "13.23 billion USD",
      "perCapita": "1,993 USD"
    },
    "dialingCode": "+505",
    "internetTLD": ".ni",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "118",
      "fire": "150",
      "police": "118",
      "ambulance": "128"
    },
    "holidays": [
      "Battle of San Jacinto Day (September 14)",
      "Independence Day (September 15)"
    ],
    "nationalAnimal": "White-tailed deer",
    "nationalDish": "Gallo pinto",
    "tourismHighlights": [
      "Granada",
      "Masaya Volcano",
      "Ometepe Island",
      "San Juan del Sur"
    ],
    "majorExports": [
      "Coffee",
      "Tobacco",
      "Gold"
    ],
    "majorImports": [
      "Consumer goods",
      "Machinery",
      "Fuels"
    ],
    "lifeExpectancy": 75.3,
    "literacyRate": 94.5,
    "climate": "Tropical with a wet season and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Evangelical Protestant",
        "None",
        "Other"
      ]
    },
    "neighborCountries": [
      "Honduras",
      "Costa Rica"
    ],
    "visaRequirement": "Visa required for some countries; no visa required for many Central American countries.",
    "notableFacts": [
      "Home to the largest lake in Central America, Lake Nicaragua.",
      "Known for its rich biodiversity and many volcanoes.",
      "Has a significant amount of its territory protected as national parks and reserves."
    ]
  },
  "NO": {
    "flag": "",
    "name": "Norway",
    "localName": "Norge",
    "officialName": "Kingdom of Norway",
    "countryCode": "+47",
    "isoAlpha2": "NO",
    "isoAlpha3": "NOR",
    "numericCode": "578",
    "firstLanguage": "no",
    "otherLanguages": [
      "nb",
      "nn",
      "se"
    ],
    "currency": {
      "code": "NOK",
      "symbol": "kr",
      "name": "Norwegian Krone"
    },
    "government": {
      "type": "Parliamentary constitutional monarchy",
      "politicalLean": "Social-democratic",
      "headsOfState": [
        {
          "title": "King",
          "name": "Harald V"
        },
        {
          "title": "Prime Minister",
          "name": "Jonas Gahr Støre"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 5421241,
    "area": {
      "value": 385207,
      "unit": "km"
    },
    "capital": "Oslo",
    "gdp": {
      "nominal": "482 billion USD",
      "perCapita": "88,192 USD"
    },
    "dialingCode": "+47",
    "internetTLD": ".no",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "110",
      "police": "112",
      "ambulance": "113"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Constitution Day (May 17)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "Elk",
    "nationalDish": "Lapskaus",
    "tourismHighlights": [
      "Fjord Norway",
      "Northern Lights",
      "Oslo Opera House",
      "Tromsø"
    ],
    "majorExports": [
      "Crude oil",
      "Natural gas",
      "Fish"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Chemicals"
    ],
    "lifeExpectancy": 82.4,
    "literacyRate": 100,
    "climate": "Maritime climate with coastal areas experiencing mild winters and cool summers",
    "religions": {
      "predominant": "Evangelical Lutheran",
      "others": [
        "Roman Catholic",
        "Islam",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Sweden",
      "Finland",
      "Russia"
    ],
    "visaRequirement": "Schengen visa required for non-EU countries",
    "notableFacts": [
      "Norway is known for its stunning fjords and natural beauty.",
      "It is one of the world's wealthiest countries, with a high standard of living.",
      "Norway is a significant producer of oil and natural gas, contributing to its economy."
    ]
  },
  "NL": {
    "flag": "",
    "name": "Netherlands",
    "officialName": "Kingdom of the Netherlands",
    "countryCode": "+31",
    "isoAlpha2": "NL",
    "isoAlpha3": "NLD",
    "numericCode": "528",
    "firstLanguage": "nl",
    "otherLanguages": [
      "fr",
      "de",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "King",
          "name": "Willem-Alexander"
        },
        {
          "title": "Prime Minister",
          "name": "Mark Rutte"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD-MM-YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Western Europe",
    "population": 17134872,
    "area": {
      "value": 41850,
      "unit": "km"
    },
    "capital": "Amsterdam",
    "gdp": {
      "nominal": "1 trillion USD",
      "perCapita": "58,979 USD"
    },
    "dialingCode": "+31",
    "internetTLD": ".nl",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "115",
      "police": "0900-8844",
      "ambulance": "112"
    },
    "holidays": [
      "King's Day (April 27)",
      "Liberation Day (May 5)"
    ],
    "nationalAnimal": "Lion",
    "nationalDish": "Stamppot",
    "tourismHighlights": [
      "Canals of Amsterdam",
      "Keukenhof Gardens",
      "Rijksmuseum",
      "Zaanse Schans"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Mineral fuels",
      "Food and agricultural products"
    ],
    "majorImports": [
      "Machinery and equipment",
      "Mineral fuels",
      "Vehicles"
    ],
    "lifeExpectancy": 82.5,
    "literacyRate": 99,
    "climate": "Oceanic with cool summers and mild winters",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Hinduism",
        "Buddhism",
        "None"
      ]
    },
    "neighborCountries": [
      "Germany",
      "Belgium"
    ],
    "visaRequirement": "Schengen visa required for non-EU visitors",
    "notableFacts": [
      "Known for its flat landscape of canals, tulip fields, windmills, and cycling routes.",
      "One of the world's leading exporters of agricultural products.",
      "Ranked consistently high in terms of happiness and quality of life."
    ]
  },
  "PA": {
    "flag": "",
    "name": "Panama",
    "officialName": "Republic of Panama",
    "countryCode": "+507",
    "isoAlpha2": "PA",
    "isoAlpha3": "PAN",
    "numericCode": "591",
    "firstLanguage": "es",
    "otherLanguages": [
      "en",
      "fr"
    ],
    "currency": {
      "code": "PAB",
      "symbol": "B/. ",
      "name": "Panamanian Balboa"
    },
    "government": {
      "type": "Presidential representative democratic republic",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "President",
          "name": "Laurentino Cortizo"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern Standard Time (EST)",
      "offset": "-05:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Central America",
    "population": 4314768,
    "area": {
      "value": 75417,
      "unit": "km"
    },
    "capital": "Panama City",
    "gdp": {
      "nominal": "66.42 billion USD",
      "perCapita": "15,586 USD"
    },
    "dialingCode": "+507",
    "internetTLD": ".pa",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "104",
      "police": "104",
      "ambulance": "911"
    },
    "holidays": [
      "Martyrs' Day (January 9)",
      "Independence Day (November 28)"
    ],
    "nationalAnimal": "Harpy Eagle",
    "nationalDish": "Sancocho",
    "tourismHighlights": [
      "Panama Canal",
      "Casco Viejo",
      "Bocas del Toro",
      "Coiba National Park"
    ],
    "majorExports": [
      "Bananas",
      "Copper",
      "Fish"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum",
      "Food products"
    ],
    "lifeExpectancy": 78.9,
    "literacyRate": 94.1,
    "climate": "Tropical maritime, with a wet season and a dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Various indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Costa Rica",
      "Colombia"
    ],
    "visaRequirement": "Visa-free for many countries; varies by nationality",
    "notableFacts": [
      "Home to the Panama Canal, a key conduit for international maritime trade.",
      "One of the most biodiverse countries in the world.",
      "Features the Darién Gap, a significant stretch of undeveloped wilderness."
    ]
  },
  "NU": {
    "flag": "",
    "name": "Niue",
    "officialName": "Niue",
    "countryCode": "+683",
    "isoAlpha2": "NU",
    "isoAlpha3": "NIU",
    "numericCode": "570",
    "firstLanguage": "niu",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "NZD",
      "symbol": "$",
      "name": "New Zealand Dollar"
    },
    "government": {
      "type": "Self-governing in free association with New Zealand",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "Premier",
          "name": "Dalton Tagelagi"
        },
        {
          "title": "Governor-General of New Zealand",
          "name": "Dame Cindy Kiro"
        }
      ]
    },
    "timeZone": {
      "name": "Niue Time (NUT)",
      "offset": "-11:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 1626,
    "area": {
      "value": 261,
      "unit": "km"
    },
    "capital": "Alofi",
    "gdp": {
      "nominal": "27 million USD",
      "perCapita": "16,611 USD"
    },
    "dialingCode": "+683",
    "internetTLD": ".nu",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "111",
      "fire": "111",
      "police": "111",
      "ambulance": "111"
    },
    "holidays": [
      "Niue Day (October 19)",
      "Christmas Day (December 25)",
      "New Year's Day (January 1)"
    ],
    "nationalAnimal": "Mackerel",
    "nationalDish": "Pulaka (a type of taro)",
    "tourismHighlights": [
      "Alofi Bay",
      "Alofis Fish Market",
      "Niue Marine Reserve",
      "Togo Chasm"
    ],
    "majorExports": [
      "Fish",
      "Coconut products",
      "Lime oil"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 77.4,
    "literacyRate": 98,
    "climate": "Tropical, warm year-round with a wet season (November to April)",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Bahá'í",
        "Atheism"
      ]
    },
    "neighborCountries": [
      "None (the nearest landmass is about 240 km away, namely the islands of Tonga and the Cook Islands)"
    ],
    "visaRequirement": "No visa required for most nationalities including New Zealand and Pacific island countries",
    "notableFacts": [
      "Described as 'the Rock of Polynesia', Niue is one of the world's largest coral islands.",
      "Has one of the lowest populations in the world.",
      "Community relies heavily on fishing and agriculture."
    ]
  },
  "OM": {
    "flag": "",
    "name": "Oman",
    "officialName": "Sultanate of Oman",
    "countryCode": "+968",
    "isoAlpha2": "OM",
    "isoAlpha3": "OMN",
    "numericCode": "512",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "OMR",
      "symbol": "",
      "name": "Omani Rial"
    },
    "government": {
      "type": "Absolute monarchy",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "Sultan",
          "name": "Haitham bin Tariq"
        }
      ]
    },
    "timeZone": {
      "name": "Gulf Standard Time (GST)",
      "offset": "+04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 5106626,
    "area": {
      "value": 309500,
      "unit": "km"
    },
    "capital": "Muscat",
    "gdp": {
      "nominal": "76.45 billion USD",
      "perCapita": "14,957 USD"
    },
    "dialingCode": "+968",
    "internetTLD": ".om",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "9999",
      "fire": "9999",
      "police": "9999",
      "ambulance": "9999"
    },
    "holidays": [
      "National Day (November 18)",
      "Renaissance Day (July 23)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Arabian Oryx",
    "nationalDish": "Shuwa",
    "tourismHighlights": [
      "Sultan Qaboos Grand Mosque",
      "Wadi Shab",
      "Jebel Akhdar",
      "Nizwa Fort"
    ],
    "majorExports": [
      "Oil",
      "Natural gas",
      "Date palms"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Foodstuffs"
    ],
    "lifeExpectancy": 77.9,
    "literacyRate": 94.5,
    "climate": "Hot desert climate, with mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Hinduism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "United Arab Emirates",
      "Saudi Arabia",
      "Yemen"
    ],
    "visaRequirement": "Visa required for most nationalities, visa on arrival available for some",
    "notableFacts": [
      "Oman has a rich maritime history and was an important center for trade in the Indian Ocean.",
      "Home to the ancient city of Ubar, which is known as the 'Atlantis of the Sands'.",
      "The country has a diverse landscape ranging from deserts to mountains and beautiful coastlines."
    ]
  },
  "NR": {
    "flag": "",
    "name": "Nauru",
    "officialName": "Republic of Nauru",
    "countryCode": "+674",
    "isoAlpha2": "NR",
    "isoAlpha3": "NRU",
    "numericCode": "520",
    "firstLanguage": "na",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "A$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Minority party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "Russell K. F. G. T. L. L. G. W. S. B. D. D. C. P. T. D. B."
        }
      ]
    },
    "timeZone": {
      "name": "Nauru Time (NRT)",
      "offset": "+12:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Micronesia",
    "population": 10834,
    "area": {
      "value": 21,
      "unit": "km"
    },
    "capital": "Yaren",
    "gdp": {
      "nominal": "138 million USD",
      "perCapita": "12,896 USD"
    },
    "dialingCode": "+674",
    "internetTLD": ".nr",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "111",
      "fire": "111",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "Independence Day (January 31)",
      "Nauru Day (last Monday of January)"
    ],
    "nationalAnimal": "Nauru's national bird (Nauru Flowerpecker)",
    "nationalDish": "Kukui Nut Chutney",
    "tourismHighlights": [
      "Anibare Bay",
      "Buada Lagoon",
      "Nauru's World War II sites",
      "Command Ridge"
    ],
    "majorExports": [
      "Phosphate",
      "Coconut products"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 67.7,
    "literacyRate": 96,
    "climate": "Tropical, with a wet season from November to February",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Baháí",
        "Other indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "None"
    ],
    "visaRequirement": "Visa required for most foreigners, while some countries have visa-free entry.",
    "notableFacts": [
      "Third smallest country by area in the world.",
      "Once one of the richest countries per capita due to phosphate mining.",
      "Faces significant challenges related to climate change and rising sea levels."
    ]
  },
  "NZ": {
    "flag": "",
    "name": "New Zealand",
    "officialName": "Realm of New Zealand",
    "countryCode": "+64",
    "isoAlpha2": "NZ",
    "isoAlpha3": "NZL",
    "numericCode": "554",
    "firstLanguage": "en",
    "otherLanguages": [
      "mi",
      "sm",
      "zh"
    ],
    "currency": {
      "code": "NZD",
      "symbol": "$",
      "name": "New Zealand Dollar"
    },
    "government": {
      "type": "Parliamentary democracy and constitutional monarchy",
      "politicalLean": "Center-Left",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Cindy Kiro"
        },
        {
          "title": "Prime Minister",
          "name": "Chris Hipkins"
        }
      ]
    },
    "timeZone": {
      "name": "New Zealand Standard Time (NZST)",
      "offset": "+12:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 5088281,
    "area": {
      "value": 268021,
      "unit": "km"
    },
    "capital": "Wellington",
    "gdp": {
      "nominal": "250.66 billion USD",
      "perCapita": "49,323 USD"
    },
    "dialingCode": "+64",
    "internetTLD": ".nz",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "111",
      "fire": "111",
      "police": "111",
      "ambulance": "111"
    },
    "holidays": [
      "Waitangi Day (February 6)",
      "ANZAC Day (April 25)",
      "Labour Day (the fourth Monday in October)"
    ],
    "nationalAnimal": "Kiwi",
    "nationalDish": "Hāngī",
    "tourismHighlights": [
      "Milford Sound",
      "Rotorua Geothermal Areas",
      "Hobbiton Movie Set",
      "Tongariro National Park (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Dairy products",
      "Meat",
      "Wood"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Petroleum"
    ],
    "lifeExpectancy": 81.2,
    "literacyRate": 99,
    "climate": "Temperate with distinct seasons",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Buddhism",
        "Islam",
        "Non-religious"
      ]
    },
    "neighborCountries": [
      "Australia"
    ],
    "visaRequirement": "Visa-free entry for many countries; Electronic Travel Authority system in place for some",
    "notableFacts": [
      "Home to the Maori people, the indigenous people of New Zealand.",
      "Known for its stunning natural landscapes and biodiversity.",
      "Famous for being the filming location for the 'Lord of the Rings' movie trilogy."
    ]
  },
  "PG": {
    "flag": "",
    "name": "Papua New Guinea",
    "officialName": "Independent State of Papua New Guinea",
    "countryCode": "+675",
    "isoAlpha2": "PG",
    "isoAlpha3": "PNG",
    "numericCode": "598",
    "firstLanguage": "ho",
    "otherLanguages": [
      "en",
      "tok pisin",
      "hiri motu",
      "bislama"
    ],
    "currency": {
      "code": "PGK",
      "symbol": "K",
      "name": "Papua New Guinean Kina"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Varies",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Robert G. Dadae"
        },
        {
          "title": "Prime Minister",
          "name": "James Marape"
        }
      ]
    },
    "timeZone": {
      "name": "Papua New Guinea Time (PGT)",
      "offset": "+10:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Melanesia",
    "population": 8917000,
    "area": {
      "value": 462840,
      "unit": "km"
    },
    "capital": "Port Moresby",
    "gdp": {
      "nominal": "26.92 billion USD",
      "perCapita": "3,050 USD"
    },
    "dialingCode": "+675",
    "internetTLD": ".pg",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "110",
      "police": "111",
      "ambulance": "111"
    },
    "holidays": [
      "Independence Day (September 16)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Bird of Paradise",
    "nationalDish": "Mumu",
    "tourismHighlights": [
      "Daintree Rainforest",
      "Lake Kutubu",
      "Kokoda Track",
      "Trobriand Islands"
    ],
    "majorExports": [
      "Copper",
      "Gold",
      "Oil",
      "Natural Gas"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Manufactured goods"
    ],
    "lifeExpectancy": 66.6,
    "literacyRate": 63.6,
    "climate": "Tropical rainforest climate with varying regional climates",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Indonesia",
      "Australia"
    ],
    "visaRequirement": "Visa required for most nationalities",
    "notableFacts": [
      "One of the most culturally diverse countries with over 800 languages spoken.",
      "Home to unique wildlife and rich natural resources.",
      "PNG has a significant tradition of ritualized warfare and tribal conflicts."
    ]
  },
  "PE": {
    "flag": "",
    "name": "Peru",
    "officialName": "Republic of Peru",
    "countryCode": "+51",
    "isoAlpha2": "PE",
    "isoAlpha3": "PER",
    "numericCode": "604",
    "firstLanguage": "es",
    "otherLanguages": [
      "que",
      "aym",
      "en"
    ],
    "currency": {
      "code": "PEN",
      "symbol": "S/",
      "name": "Peruvian Sol"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Diverse",
      "headsOfState": [
        {
          "title": "President",
          "name": "Dina Boluarte"
        }
      ]
    },
    "timeZone": {
      "name": "Peru Time (PET)",
      "offset": "-05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 32971854,
    "area": {
      "value": 1285216,
      "unit": "km"
    },
    "capital": "Lima",
    "gdp": {
      "nominal": "267.63 billion USD",
      "perCapita": "8,122 USD"
    },
    "dialingCode": "+51",
    "internetTLD": ".pe",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "105",
      "fire": "116",
      "police": "105",
      "ambulance": "145"
    },
    "holidays": [
      "Independence Day (July 28)",
      "Battle of Angamos (October 8)"
    ],
    "nationalAnimal": "Vicuña",
    "nationalDish": "Ceviche",
    "tourismHighlights": [
      "Machu Picchu",
      "Cusco",
      "Lake Titicaca",
      "Nazca Lines",
      "Amazon Rainforest"
    ],
    "majorExports": [
      "Copper",
      "Gold",
      "Fish meal",
      "Coffee"
    ],
    "majorImports": [
      "Machinery",
      "Oil",
      "Electric equipment"
    ],
    "lifeExpectancy": 77.3,
    "literacyRate": 94.5,
    "climate": "Varied; from arid plains to tropical rainforest",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Evangelical Christian",
        "Indigenous beliefs",
        "None"
      ]
    },
    "neighborCountries": [
      "Ecuador",
      "Colombia",
      "Brazil",
      "Bolivia",
      "Chile"
    ],
    "visaRequirement": "No visa required for many countries, including Schengen Area and the USA for stays up to 183 days.",
    "notableFacts": [
      "Home to the ancient Inca civilization and famous sites like Machu Picchu.",
      "Has the second-largest Amazon rainforest area after Brazil.",
      "A leading producer of silver, copper, and gold."
    ]
  },
  "PH": {
    "flag": "",
    "name": "Philippines",
    "officialName": "Republic of the Philippines",
    "countryCode": "+63",
    "isoAlpha2": "PH",
    "isoAlpha3": "PHL",
    "numericCode": "608",
    "firstLanguage": "fil",
    "otherLanguages": [
      "en",
      "ceb",
      "iln",
      "hil"
    ],
    "currency": {
      "code": "PHP",
      "symbol": "",
      "name": "Philippine Peso"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Ferdinand Marcos Jr."
        },
        {
          "title": "Vice President",
          "name": "Sara Duterte"
        }
      ]
    },
    "timeZone": {
      "name": "Philippine Time (PHT)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 113880000,
    "area": {
      "value": 300000,
      "unit": "km"
    },
    "capital": "Manila",
    "gdp": {
      "nominal": "400 billion USD",
      "perCapita": "3,522 USD"
    },
    "dialingCode": "+63",
    "internetTLD": ".ph",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "160",
      "police": "117",
      "ambulance": "166"
    },
    "holidays": [
      "Independence Day (June 12)",
      "National Heroes Day (Last Monday of August)"
    ],
    "nationalAnimal": "Eagle",
    "nationalDish": "Adobo",
    "tourismHighlights": [
      "Boracay Island",
      "Palawan (El Nido and Coron)",
      "Chocolate Hills in Bohol",
      "Rizal Park in Manila"
    ],
    "majorExports": [
      "Electronics",
      "Coconut oil",
      "Bananas"
    ],
    "majorImports": [
      "Raw materials",
      "Mineral fuels",
      "Machinery"
    ],
    "lifeExpectancy": 72.6,
    "literacyRate": 98,
    "climate": "Tropical maritime climate, with three distinct seasons: Tag-init (dry), Tag-ulan (rainy), and Tag-lamig (cool)",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Buddhism",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "None (is an archipelago)"
    ],
    "visaRequirement": "Visa-free access for many countries, visa required for some others",
    "notableFacts": [
      "Home to over 7,000 islands.",
      "Rich in biodiversity with numerous endemic species.",
      "Has a vibrant culture influenced by various foreign influences including Spanish, American, and indigenous traditions."
    ]
  },
  "PF": {
    "flag": "",
    "name": "French Polynesia",
    "officialName": "French Polynesia",
    "countryCode": "+689",
    "isoAlpha2": "PF",
    "isoAlpha3": "PYF",
    "numericCode": "258",
    "firstLanguage": "fr",
    "otherLanguages": [
      "ta"
    ],
    "currency": {
      "code": "XPF",
      "symbol": "CFP",
      "name": "CFP Franc"
    },
    "government": {
      "type": "Unincorporated territory of France",
      "politicalLean": "Mixed",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of France"
        },
        {
          "title": "President",
          "name": "President of French Polynesia"
        }
      ]
    },
    "timeZone": {
      "name": "Tahiti Time (TAHT)",
      "offset": "-10:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 284942,
    "area": {
      "value": 4167,
      "unit": "km"
    },
    "capital": "Papeete",
    "gdp": {
      "nominal": "1.33 billion USD",
      "perCapita": "4,724 USD"
    },
    "dialingCode": "+689",
    "internetTLD": ".pf",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "15",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Bastille Day (July 14)",
      "Heiva i Tahiti (July)",
      "French Polynesia Day (July 29)"
    ],
    "nationalAnimal": "Aito (Warrior/Canoe)",
    "nationalDish": "Poisson Cru",
    "tourismHighlights": [
      "Bora Bora",
      "Moorea",
      "Tahiti",
      "Tuamotu Archipelago"
    ],
    "majorExports": [
      "Pearls",
      "Vanilla",
      "Fresh fish"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 79.1,
    "literacyRate": 98,
    "climate": "Tropical, with a wet season and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Traditional Polynesian beliefs",
        "Buddhism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (isolated in the South Pacific)"
    ],
    "visaRequirement": "Visa not required for stays under 90 days for most nationalities",
    "notableFacts": [
      "Comprises over 100 islands and atolls.",
      "Famous for its beautiful lagoons and coral reefs.",
      "Home to the famous painter Paul Gauguin."
    ]
  },
  "PK": {
    "flag": "",
    "name": "Pakistan",
    "officialName": "Islamic Republic of Pakistan",
    "countryCode": "+92",
    "isoAlpha2": "PK",
    "isoAlpha3": "PAK",
    "numericCode": "586",
    "firstLanguage": "ur",
    "otherLanguages": [
      "en",
      "pa",
      "sd",
      "br"
    ],
    "currency": {
      "code": "PKR",
      "symbol": "",
      "name": "Pakistani Rupee"
    },
    "government": {
      "type": "Federal parliamentary republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Arif Alvi"
        },
        {
          "title": "Prime Minister",
          "name": "Anwar-ul-Haq Kakar"
        }
      ]
    },
    "timeZone": {
      "name": "Pakistan Standard Time (PKT)",
      "offset": "+05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southern Asia",
    "population": 241498300,
    "area": {
      "value": 881912,
      "unit": "km"
    },
    "capital": "Islamabad",
    "gdp": {
      "nominal": "376.5 billion USD",
      "perCapita": "1,557 USD"
    },
    "dialingCode": "+92",
    "internetTLD": ".pk",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "1122",
      "fire": "16",
      "police": "15",
      "ambulance": "115"
    },
    "holidays": [
      "Pakistan Day (March 23)",
      "Independence Day (August 14)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Markhor",
    "nationalDish": "Biryani",
    "tourismHighlights": [
      "Karimabad and Hunza Valley",
      "Mohenjo-Daro",
      "Lahore Fort and Shalimar Gardens (UNESCO World Heritage Site)",
      "Fairy Meadows"
    ],
    "majorExports": [
      "Textiles",
      "Leather goods",
      "Rice"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Edible oils"
    ],
    "lifeExpectancy": 67.3,
    "literacyRate": 59.13,
    "climate": "Varies from tropical in the south to temperate in the north",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Hinduism",
        "Christianity",
        "Sikhism"
      ]
    },
    "neighborCountries": [
      "India",
      "Afghanistan",
      "Iran",
      "China"
    ],
    "visaRequirement": "Visa required for many nationalities; visa on arrival for selected countries.",
    "notableFacts": [
      "Home to one of the highest peaks in the world, K2.",
      "Second largest producer of textiles in the world.",
      "Rich cultural heritage with diverse customs and languages."
    ]
  },
  "PM": {
    "flag": "",
    "name": "Saint Pierre and Miquelon",
    "officialName": "Collectivité territoriale de Saint-Pierre-et-Miquelon",
    "countryCode": "+508",
    "isoAlpha2": "PM",
    "isoAlpha3": "SPM",
    "numericCode": "666",
    "firstLanguage": "fr",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Overseas collectivity of France",
      "politicalLean": "Left-wing",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of France"
        }
      ]
    },
    "timeZone": {
      "name": "Saint Pierre and Miquelon Standard Time (SPM)",
      "offset": "-03:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "North America",
    "subregion": "Caribbean",
    "population": 5794,
    "area": {
      "value": 242,
      "unit": "km"
    },
    "capital": "Saint-Pierre",
    "gdp": {
      "nominal": "292 million USD",
      "perCapita": "50,408 USD"
    },
    "dialingCode": "+508",
    "internetTLD": ".pm",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Bastille Day (July 14)",
      "Assumption of Mary (August 15)"
    ],
    "nationalAnimal": "Northern Gannet",
    "nationalDish": "Homard (Lobster)",
    "tourismHighlights": [
      "Les Miquelon Islands",
      "Saint-Pierre Heritage Site",
      "Fishing and Whale Watching Tours"
    ],
    "majorExports": [
      "Fish",
      "Seafood",
      "Clothing"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Construction materials"
    ],
    "lifeExpectancy": 83,
    "literacyRate": 99,
    "climate": "Oceanic, with cool summers and mild winters",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "None",
        "Protestant"
      ]
    },
    "neighborCountries": [
      "Canada"
    ],
    "visaRequirement": "Visa-free for citizens of the EU and some other countries",
    "notableFacts": [
      "The only French overseas territory in North America.",
      "Despite its small size, it has a rich fishing industry.",
      "The islands have a mix of French and North American cultural influences."
    ]
  },
  "PR": {
    "flag": "",
    "name": "Puerto Rico",
    "officialName": "Commonwealth of Puerto Rico",
    "countryCode": "+1",
    "isoAlpha2": "PR",
    "isoAlpha3": "PRI",
    "numericCode": "630",
    "firstLanguage": "es",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Unincorporated territory",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Pedro Pierluisi"
        },
        {
          "title": "President",
          "name": "Joe Biden"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 3193694,
    "area": {
      "value": 8818,
      "unit": "km"
    },
    "capital": "San Juan",
    "gdp": {
      "nominal": "105.1 billion USD",
      "perCapita": "32,150 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".pr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Discovery of Puerto Rico Day (November 19)",
      "Christmas (December 25)"
    ],
    "nationalAnimal": "Puerto Rican Coquí",
    "nationalDish": "Mofongo",
    "tourismHighlights": [
      "El Yunque National Forest",
      "Old San Juan",
      "Bioluminescent Bay in Vieques",
      "San Juan National Historic Site"
    ],
    "majorExports": [
      "Electronics",
      "Pharmaceuticals",
      "Medical Equipment"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Manufactured Goods"
    ],
    "lifeExpectancy": 79.5,
    "literacyRate": 94.9,
    "climate": "Tropical rainforest climate, with a wet and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Spiritualism",
        "Atheism"
      ]
    },
    "neighborCountries": [
      "United States Virgin Islands",
      "Dominican Republic"
    ],
    "visaRequirement": "No visa required for U.S. citizens; other nationalities require entry processes similar to the U.S.",
    "notableFacts": [
      "Puerto Rico is a territory of the United States but has its own constitution.",
      "Home to the world's largest radio telescope, the Arecibo Observatory (now collapsed).",
      "Famous for its unique culture, blending Spanish, African, and Taíno influences."
    ]
  },
  "PL": {
    "flag": "",
    "name": "Poland",
    "officialName": "Republic of Poland",
    "countryCode": "+48",
    "isoAlpha2": "PL",
    "isoAlpha3": "POL",
    "numericCode": "616",
    "firstLanguage": "pl",
    "otherLanguages": [
      "en",
      "de",
      "fr"
    ],
    "currency": {
      "code": "PLN",
      "symbol": "zł",
      "name": "Polish Zloty"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "President",
          "name": "Andrzej Duda"
        },
        {
          "title": "Prime Minister",
          "name": "Mateusz Morawiecki"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "population": 38386000,
    "area": {
      "value": 312696,
      "unit": "km"
    },
    "capital": "Warsaw",
    "gdp": {
      "nominal": "693 billion USD",
      "perCapita": "18,000 USD"
    },
    "dialingCode": "+48",
    "internetTLD": ".pl",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "998",
      "police": "997",
      "ambulance": "999"
    },
    "holidays": [
      "New Years Day (January 1)",
      "Constitution Day (May 3)",
      "Independence Day (November 11)"
    ],
    "nationalAnimal": "White-tailed Eagle",
    "nationalDish": "Pierogi",
    "tourismHighlights": [
      "Wieliczka Salt Mine",
      "Auschwitz-Birkenau Memorial and Museum",
      "Bialowieza Forest (UNESCO World Heritage Site)",
      "Warsaws Old Town (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Automobiles",
      "Electrical machinery"
    ],
    "majorImports": [
      "Machinery",
      "Mineral fuels",
      "Food"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 99.7,
    "climate": "Temperate with cold winters and warm summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Orthodox Christian",
        "Protestant",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Germany",
      "Czech Republic",
      "Slovakia",
      "Ukraine",
      "Belarus",
      "Lithuania",
      "Russia"
    ],
    "visaRequirement": "Visa-free travel for EU countries and others depending on agreements.",
    "notableFacts": [
      "Home to one of the oldest universities in the world, Jagiellonian University.",
      "Rich history with numerous UNESCO World Heritage Sites.",
      "Has a growing IT sector and is considered a hub for startups in Europe."
    ]
  },
  "PN": {
    "flag": "",
    "name": "Pitcairn Islands",
    "officialName": "Pitcairn, Henderson, Ducie and Oeno Islands",
    "countryCode": "+64",
    "isoAlpha2": "PN",
    "isoAlpha3": "PCN",
    "numericCode": "612",
    "firstLanguage": "en",
    "otherLanguages": [
      "Pitcairnese"
    ],
    "currency": {
      "code": "NZD",
      "symbol": "$",
      "name": "New Zealand Dollar"
    },
    "government": {
      "type": "Territory of the United Kingdom",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Appointed by the UK"
        }
      ]
    },
    "timeZone": {
      "name": "Pitcairn Island Time (PIT)",
      "offset": "-08:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 50,
    "area": {
      "value": 47,
      "unit": "km"
    },
    "capital": "Adamstown",
    "gdp": {
      "nominal": "Not available",
      "perCapita": "Not available"
    },
    "dialingCode": "+64",
    "internetTLD": ".pn",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "N/A",
      "fire": "N/A",
      "police": "N/A",
      "ambulance": "N/A"
    },
    "holidays": [
      "Bounty Day (January 23)",
      "Queen's Birthday",
      "Christmas Day"
    ],
    "nationalAnimal": "Pitcairn Island Mouse",
    "nationalDish": "Fish and chips",
    "tourismHighlights": [
      "Bounty Bay",
      "Christian's Cave",
      "Pitcairn Heritage Museum"
    ],
    "majorExports": [
      "Honey",
      "Handmade crafts"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": "Not available",
    "literacyRate": 100,
    "climate": "Tropical with mild temperatures year-round",
    "religions": {
      "predominant": "Adventist",
      "others": [
        "None",
        "Other Christian denominations"
      ]
    },
    "neighborCountries": [
      "None (remote)",
      "Closest inhabited territory is Easter Island (Rapa Nui)"
    ],
    "visaRequirement": "Visa not required for most nationalities; entry is limited due to small population.",
    "notableFacts": [
      "The only inhabited island of the Pitcairn Islands group.",
      "Known for its historical significance related to the mutiny on the HMS Bounty.",
      "Has a very small population, often leading to close-knit community living."
    ]
  },
  "PS": {
    "error": "Failed to retrieve a valid response after retries."
  },
  "QA": {
    "flag": "",
    "name": "Qatar",
    "officialName": "State of Qatar",
    "countryCode": "+974",
    "isoAlpha2": "QA",
    "isoAlpha3": "QAT",
    "numericCode": "634",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en",
      "fr"
    ],
    "currency": {
      "code": "QAR",
      "symbol": ".",
      "name": "Qatari Rial"
    },
    "government": {
      "type": "Absolute monarchy",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "Emir",
          "name": "Tamim bin Hamad Al Thani"
        }
      ]
    },
    "timeZone": {
      "name": "Arabian Standard Time (AST)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 2740000,
    "area": {
      "value": 11586,
      "unit": "km"
    },
    "capital": "Doha",
    "gdp": {
      "nominal": "209.68 billion USD",
      "perCapita": "76,455 USD"
    },
    "dialingCode": "+974",
    "internetTLD": ".qa",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "999",
      "fire": "997",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "National Day (December 18)",
      "Qatar Sports Day (Second Tuesday of February)"
    ],
    "nationalAnimal": "Arabian Oryx",
    "nationalDish": "Majboos",
    "tourismHighlights": [
      "Museum of Islamic Art",
      "Souq Waqif",
      "The Pearl-Qatar",
      "Katara Cultural Village"
    ],
    "majorExports": [
      "Natural gas",
      "Petroleum",
      "Petrochemicals"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Food products"
    ],
    "lifeExpectancy": 81.2,
    "literacyRate": 97.4,
    "climate": "Desert climate with hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Hinduism",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Saudi Arabia"
    ],
    "visaRequirement": "Visa required for most countries; eVisa available for many nationalities.",
    "notableFacts": [
      "Hosts the FIFA World Cup 2022, the first Middle Eastern country to do so.",
      "Has one of the highest GDP per capita in the world.",
      "Richer than most Gulf countries in terms of natural resources."
    ]
  },
  "PW": {
    "flag": "",
    "name": "Palau",
    "officialName": "Republic of Palau",
    "countryCode": "+680",
    "isoAlpha2": "PW",
    "isoAlpha3": "PLW",
    "numericCode": "585",
    "firstLanguage": "pau",
    "otherLanguages": [
      "en",
      "tow",
      "bai"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Surangel Whipps Jr."
        }
      ]
    },
    "timeZone": {
      "name": "Palau Time (PWT)",
      "offset": "+09:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Micronesia",
    "population": 18103,
    "area": {
      "value": 459,
      "unit": "km"
    },
    "capital": "Ngerulmud",
    "gdp": {
      "nominal": "302 million USD",
      "perCapita": "16,918 USD"
    },
    "dialingCode": "+680",
    "internetTLD": ".pw",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "998",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (October 1)",
      "Thanksgiving Day (fourth Thursday of November)"
    ],
    "nationalAnimal": "Palau Fruit Dove",
    "nationalDish": "Babeldaob",
    "tourismHighlights": [
      "Rock Islands Southern Lagoon (UNESCO World Heritage Site)",
      "Palau National Marine Sanctuary",
      "Jellyfish Lake",
      "Ngardmau Falls"
    ],
    "majorExports": [
      "Fish",
      "Beverages",
      "Subsistence agricultural products"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 73.9,
    "literacyRate": 99.2,
    "climate": "Tropical rainforest climate",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Buddhism",
        "Traditions"
      ]
    },
    "neighborCountries": [
      "Micronesia",
      "United States",
      "Japan"
    ],
    "visaRequirement": "Visa-free for many nationalities; visa needed for some countries",
    "notableFacts": [
      "Palau is known for its rich marine biodiversity.",
      "It has many unique cultural festivals and traditions.",
      "The nation is made up of more than 500 islands."
    ]
  },
  "RE": {
    "flag": "",
    "name": "Réunion",
    "officialName": "Department of Réunion",
    "countryCode": "+262",
    "isoAlpha2": "RE",
    "isoAlpha3": "REU",
    "numericCode": "638",
    "firstLanguage": "fr",
    "otherLanguages": [
      "réunionese (creole)"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Overseas department and region of France",
      "politicalLean": "Left-wing",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of France"
        },
        {
          "title": "Prefect",
          "name": "State representative on the island"
        }
      ]
    },
    "timeZone": {
      "name": "Réunion Time (RET)",
      "offset": "+04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 859959,
    "area": {
      "value": 2512,
      "unit": "km"
    },
    "capital": "Saint-Denis",
    "gdp": {
      "nominal": "13.5 billion USD",
      "perCapita": "15,700 USD"
    },
    "dialingCode": "+262",
    "internetTLD": ".re",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "15",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Labour Day (May 1)",
      "Bastille Day (July 14)",
      "All Saints' Day (November 1)"
    ],
    "nationalAnimal": "Tropical Tortoise",
    "nationalDish": "Rougail Saucisse",
    "tourismHighlights": [
      "Piton de la Fournaise (active volcano)",
      "Cirque de Mafate (UNESCO World Heritage Site)",
      "Piton des Neiges (highest peak)",
      "Beaches of Hermitage and Boucan Canot"
    ],
    "majorExports": [
      "Sugar",
      "Rum",
      "Vanilla"
    ],
    "majorImports": [
      "Petroleum products",
      "Foodstuffs",
      "Consumer goods"
    ],
    "lifeExpectancy": 78.8,
    "literacyRate": 93.5,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Hinduism",
        "Islam",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "None (surrounded by the Indian Ocean)"
    ],
    "visaRequirement": "No visa required for EU citizens and many others",
    "notableFacts": [
      "Réunion is a volcanic island with a dramatic landscape.",
      "It is known for its cultural diversity and Creole heritage.",
      "Home to one of the world's most active volcanoes, Piton de la Fournaise."
    ]
  },
  "PY": {
    "flag": "",
    "name": "Paraguay",
    "officialName": "Republic of Paraguay",
    "countryCode": "+595",
    "isoAlpha2": "PY",
    "isoAlpha3": "PRY",
    "numericCode": "600",
    "firstLanguage": "es",
    "otherLanguages": [
      "gn"
    ],
    "currency": {
      "code": "PYG",
      "symbol": "",
      "name": "Paraguayan Guarani"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Center-right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Santiago Peña"
        }
      ]
    },
    "timeZone": {
      "name": "Paraguay Standard Time (PYT)",
      "offset": "-04:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "South America",
    "subregion": "Latin America",
    "population": 7132538,
    "area": {
      "value": 406752,
      "unit": "km"
    },
    "capital": "Asunción",
    "gdp": {
      "nominal": "42.58 billion USD",
      "perCapita": "5,963 USD"
    },
    "dialingCode": "+595",
    "internetTLD": ".py",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "133",
      "police": "911",
      "ambulance": "154"
    },
    "holidays": [
      "Victory at Battle of Carabobo (June 24)",
      "Independence Day (May 14)"
    ],
    "nationalAnimal": "Jaguar",
    "nationalDish": "Sopa Paraguaya",
    "tourismHighlights": [
      "Iguazu National Park",
      "Asuncións historic center",
      "Ybycuí National Park",
      "Ruins of Jesuit missions"
    ],
    "majorExports": [
      "Soybeans",
      "Electricity (from Itaipu)",
      "Meat"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Petroleum products"
    ],
    "lifeExpectancy": 76.3,
    "literacyRate": 94.5,
    "climate": "Subtropical with distinct wet and dry seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Argentina",
      "Brazil",
      "Bolivia"
    ],
    "visaRequirement": "No visa required for MERCOSUR countries and many others",
    "notableFacts": [
      "Home to the Itaipu Dam, one of the largest hydroelectric plants in the world.",
      "Has a high number of bilingual speakers, particularly in Spanish and Guaraní.",
      "Rich in biodiversity, with many national parks and reserves."
    ]
  },
  "PT": {
    "flag": "",
    "name": "Portugal",
    "officialName": "Portuguese Republic",
    "countryCode": "+351",
    "isoAlpha2": "PT",
    "isoAlpha3": "PRT",
    "numericCode": "620",
    "firstLanguage": "pt",
    "otherLanguages": [
      "en",
      "fr",
      "es"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Unitary semi-presidential constitutional republic",
      "politicalLean": "Social democracy",
      "headsOfState": [
        {
          "title": "President",
          "name": "Marcelo Rebelo de Sousa"
        },
        {
          "title": "Prime Minister",
          "name": "António Costa"
        }
      ]
    },
    "timeZone": {
      "name": "Western European Time (WET)",
      "offset": "+00:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 10196709,
    "area": {
      "value": 92212,
      "unit": "km"
    },
    "capital": "Lisbon",
    "gdp": {
      "nominal": "295.58 billion USD",
      "perCapita": "29,036 USD"
    },
    "dialingCode": "+351",
    "internetTLD": ".pt",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "117",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "Republic Day (October 5)",
      "Portugal Day (June 10)",
      "Christmas (December 25)"
    ],
    "nationalAnimal": "Rooster of Barcelos",
    "nationalDish": "Bacalhau à Brás",
    "tourismHighlights": [
      "Lisbon",
      "Porto",
      "Algarve",
      "Sintra (UNESCO World Heritage Site)",
      "Douro Valley"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Vehicle parts",
      "Textiles and footwear"
    ],
    "majorImports": [
      "Mineral fuels",
      "Vehicles",
      "Machinery and equipment"
    ],
    "lifeExpectancy": 81,
    "literacyRate": 98,
    "climate": "Mediterranean with hot, dry summers and mild, wet winters",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Muslim",
        "Buddhist"
      ]
    },
    "neighborCountries": [
      "Spain"
    ],
    "visaRequirement": "Schengen visa required for some nationalities",
    "notableFacts": [
      "Home to the worlds oldest bookstore (Livraria Bertrand in Lisbon).",
      "Well-known for its Fado music, a genre expressing longing and nostalgia.",
      "One of the leading countries in renewable energy production."
    ]
  },
  "SA": {
    "flag": "",
    "name": "Saudi Arabia",
    "officialName": "Kingdom of Saudi Arabia",
    "countryCode": "+966",
    "isoAlpha2": "SA",
    "isoAlpha3": "SAU",
    "numericCode": "682",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en",
      "fr"
    ],
    "currency": {
      "code": "SAR",
      "symbol": ".",
      "name": "Saudi Riyal"
    },
    "government": {
      "type": "Absolute monarchy",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "King",
          "name": "Salman bin Abdulaziz Al Saud"
        }
      ]
    },
    "timeZone": {
      "name": "Arabian Standard Time (AST)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Middle East",
    "population": 35155000,
    "area": {
      "value": 2149690,
      "unit": "km"
    },
    "capital": "Riyadh",
    "gdp": {
      "nominal": "1.04 trillion USD",
      "perCapita": "29,319 USD"
    },
    "dialingCode": "+966",
    "internetTLD": ".sa",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "999",
      "fire": "998",
      "police": "999",
      "ambulance": "997"
    },
    "holidays": [
      "Saudi National Day (September 23)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Falcon",
    "nationalDish": "Kabsa",
    "tourismHighlights": [
      "The Kaaba, Mecca",
      "Al-Masjid an-Nabawi, Medina",
      "Diriyah",
      "Al-Ula"
    ],
    "majorExports": [
      "Crude oil",
      "Petrochemicals",
      "Plastics"
    ],
    "majorImports": [
      "Machinery",
      "Electronic equipment",
      "Vehicles"
    ],
    "lifeExpectancy": 75.8,
    "literacyRate": 97.1,
    "climate": "Desert climate with hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": []
    },
    "neighborCountries": [
      "Jordan",
      "Iraq",
      "Kuwait",
      "Qatar",
      "United Arab Emirates",
      "Oman",
      "Yemen"
    ],
    "visaRequirement": "Visa required for most travelers; eVisa available for many nationalities",
    "notableFacts": [
      "Houses two of the holiest cities in Islam: Mecca and Medina.",
      "Largest country in the Middle East by land area.",
      "Home to vast deserts including the Rub' al Khali (Empty Quarter)."
    ]
  },
  "RO": {
    "flag": "",
    "name": "Romania",
    "officialName": "Romania",
    "countryCode": "+40",
    "isoAlpha2": "RO",
    "isoAlpha3": "ROU",
    "numericCode": "642",
    "firstLanguage": "ro",
    "otherLanguages": [
      "hu",
      "de",
      "en"
    ],
    "currency": {
      "code": "RON",
      "symbol": "lei",
      "name": "Romanian Leu"
    },
    "government": {
      "type": "Unitary semi-presidential constitutional republic",
      "politicalLean": "Center-Right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Klaus Iohannis"
        },
        {
          "title": "Prime Minister",
          "name": "Marcel Ciolacu"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "population": 19237691,
    "area": {
      "value": 238397,
      "unit": "km"
    },
    "capital": "Bucharest",
    "gdp": {
      "nominal": "300 billion USD",
      "perCapita": "15,600 USD"
    },
    "dialingCode": "+40",
    "internetTLD": ".ro",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "112",
      "ambulance": "112"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "National Day (December 1)",
      "Christmas (December 25)",
      "Easter (variable date)"
    ],
    "nationalAnimal": "Romanian Red Fox",
    "nationalDish": "Sarmale",
    "tourismHighlights": [
      "Transfagarasan Highway",
      "Bran Castle (Dracula's Castle)",
      "Pele Castle",
      "Danube Delta (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Machinery and equipment",
      "Automobiles",
      "Electrical goods"
    ],
    "majorImports": [
      "Machinery and equipment",
      "Fuels",
      "Chemicals"
    ],
    "lifeExpectancy": 75.3,
    "literacyRate": 98.8,
    "climate": "Temperate-continental with four distinct seasons",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Roman Catholic",
        "Protestant",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Ukraine",
      "Moldova",
      "Hungary",
      "Serbia",
      "Bulgaria"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "Home to the Carpathian Mountains and the Danube River.",
      "Famous for its medieval castles and fortified churches.",
      "Romania is one of the largest producers of sunflower oil in the world."
    ]
  },
  "RS": {
    "flag": "",
    "name": "Serbia",
    "officialName": "Republic of Serbia",
    "countryCode": "+381",
    "isoAlpha2": "RS",
    "isoAlpha3": "SRB",
    "numericCode": "688",
    "firstLanguage": "sr",
    "otherLanguages": [
      "Hungarian",
      "Slovak",
      "Romanian",
      "Croatian",
      "Albanian",
      "Bulgarian"
    ],
    "currency": {
      "code": "RSD",
      "symbol": ".",
      "name": "Serbian dinar"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Aleksandar Vučić"
        }
      ],
      "headsOfGovernment": [
        {
          "title": "Prime Minister",
          "name": "Ana Brnabić"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southeast Europe",
    "population": 8772235,
    "area": {
      "value": 77474,
      "unit": "km"
    },
    "capital": "Belgrade",
    "gdp": {
      "nominal": "66.27 billion USD",
      "perCapita": "7,628 USD"
    },
    "dialingCode": "+381",
    "internetTLD": ".rs",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "193",
      "police": "192",
      "ambulance": "194"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Statehood Day (February 15)",
      "Labor Day (May 1)",
      "Armistice Day (November 11)"
    ],
    "nationalAnimal": "White eagle",
    "nationalDish": "Sarma",
    "tourismHighlights": [
      "Belgrade Fortress",
      "Novi Sad and the Petrovaradin Fortress",
      "Tara National Park",
      "Studenica Monastery (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Automobiles",
      "Fruits and vegetables",
      "Machinery"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Chemical products"
    ],
    "lifeExpectancy": 75.7,
    "literacyRate": 98.1,
    "climate": "Continental with hot summers and cold winters",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Roman Catholic",
        "Protestant",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Hungary",
      "Romania",
      "Bulgaria",
      "North Macedonia",
      "Croatia",
      "Bosnia and Herzegovina",
      "Montenegro"
    ],
    "visaRequirement": "No visa required for EU countries and several others",
    "notableFacts": [
      "Known for its vibrant cultural life and numerous festivals.",
      "Home to the exit of the Danube River.",
      "Famous for traditional music styles such as turbo-folk."
    ]
  },
  "RU": {
    "flag": "",
    "name": "Russia",
    "officialName": "Russian Federation",
    "countryCode": "+7",
    "isoAlpha2": "RU",
    "isoAlpha3": "RUS",
    "numericCode": "643",
    "firstLanguage": "ru",
    "otherLanguages": [
      "tatar",
      "bashkir",
      "chechen",
      "chuvash"
    ],
    "currency": {
      "code": "RUB",
      "symbol": "",
      "name": "Russian Ruble"
    },
    "government": {
      "type": "Federal semi-presidential republic",
      "politicalLean": "United Russia",
      "headsOfState": [
        {
          "title": "President",
          "name": "Vladimir Putin"
        },
        {
          "title": "Prime Minister",
          "name": "Mikhail Mishustin"
        }
      ]
    },
    "timeZone": {
      "name": "Moscow Standard Time (MSK)",
      "offset": "+03:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe/Asia",
    "subregion": "Eastern Europe/Western Asia",
    "population": 145912025,
    "area": {
      "value": 17098242,
      "unit": "km"
    },
    "capital": "Moscow",
    "gdp": {
      "nominal": "1.84 trillion USD",
      "perCapita": "12,577 USD"
    },
    "dialingCode": "+7",
    "internetTLD": ".ru",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Defender of the Fatherland Day (February 23)",
      "International Women's Day (March 8)",
      "Victory Day (May 9)",
      "Russia Day (June 12)",
      "Unity Day (November 4)"
    ],
    "nationalAnimal": "Double-headed eagle",
    "nationalDish": "Borscht",
    "tourismHighlights": [
      "Red Square and the Kremlin in Moscow",
      "Hermitage Museum in St. Petersburg",
      "Lake Baikal",
      "Kamchatka Peninsula",
      "Trans-Siberian Railway"
    ],
    "majorExports": [
      "Oil",
      "Natural gas",
      "Machinery",
      "Arms"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Pharmaceuticals",
      "Food products"
    ],
    "lifeExpectancy": 72.6,
    "literacyRate": 99.7,
    "climate": "Continental with extreme temperature variations",
    "religions": {
      "predominant": "Russian Orthodox",
      "others": [
        "Islam",
        "Buddhism",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Norway",
      "Finland",
      "Estonia",
      "Latvia",
      "Lithuania",
      "Poland",
      "Belarus",
      "Ukraine",
      "Georgia",
      "Azerbaijan",
      "Kazakhstan",
      "China",
      "Mongolia",
      "North Korea"
    ],
    "visaRequirement": "Visa required for most travelers except certain countries.",
    "notableFacts": [
      "The largest country in the world by land area.",
      "Home to Lake Baikal, the world's deepest freshwater lake.",
      "Has a wide range of climates, from arctic in the north to subtropical in the south."
    ]
  },
  "RW": {
    "flag": "",
    "name": "Rwanda",
    "officialName": "Republic of Rwanda",
    "countryCode": "+250",
    "isoAlpha2": "RW",
    "isoAlpha3": "RWA",
    "numericCode": "646",
    "firstLanguage": "rw",
    "otherLanguages": [
      "fr",
      "en",
      "sw"
    ],
    "currency": {
      "code": "RWF",
      "symbol": "Frw",
      "name": "Rwandan Franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Ruling party dominance",
      "headsOfState": [
        {
          "title": "President",
          "name": "Paul Kagame"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "East Africa",
    "population": 13132795,
    "area": {
      "value": 26338,
      "unit": "km"
    },
    "capital": "Kigali",
    "gdp": {
      "nominal": "12.38 billion USD",
      "perCapita": "944 USD"
    },
    "dialingCode": "+250",
    "internetTLD": ".rw",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "113",
      "police": "112",
      "ambulance": "113"
    },
    "holidays": [
      "International Women's Day (March 8)",
      "Genocide Memorial Day (April 7)",
      "Labour Day (May 1)",
      "Independence Day (July 1)"
    ],
    "nationalAnimal": "Golden Monkey",
    "nationalDish": "Isombe",
    "tourismHighlights": [
      "Volcanoes National Park",
      "Lake Kivu",
      "Nyungwe National Park",
      "Akagera National Park"
    ],
    "majorExports": [
      "Coffee",
      "Tea",
      "Minerals"
    ],
    "majorImports": [
      "Petroleum products",
      "Machinery",
      "Foodstuffs"
    ],
    "lifeExpectancy": 69.3,
    "literacyRate": 73.2,
    "climate": "Tropical; warm and temperate",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Uganda",
      "Tanzania",
      "Burundi",
      "Democratic Republic of the Congo"
    ],
    "visaRequirement": "Visa required for most nationalities; e-Visa available",
    "notableFacts": [
      "Known as the 'Land of a Thousand Hills' due to its mountainous terrain.",
      "Rwanda hosts the Kigali Genocide Memorial, a key site for remembrance.",
      "One of the leading countries in Africa for womens rights and representation."
    ]
  },
  "SE": {
    "flag": "",
    "name": "Sweden",
    "officialName": "Kingdom of Sweden",
    "countryCode": "+46",
    "isoAlpha2": "SE",
    "isoAlpha3": "SWE",
    "numericCode": "752",
    "firstLanguage": "sv",
    "otherLanguages": [
      "en",
      "fi",
      "me"
    ],
    "currency": {
      "code": "SEK",
      "symbol": "kr",
      "name": "Swedish Krona"
    },
    "government": {
      "type": "Parliamentary constitutional monarchy",
      "politicalLean": "Social Democratic",
      "headsOfState": [
        {
          "title": "King",
          "name": "Carl XVI Gustaf"
        },
        {
          "title": "Prime Minister",
          "name": "Ulf Kristersson"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "YYYY-MM-DD",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 10379295,
    "area": {
      "value": 450295,
      "unit": "km"
    },
    "capital": "Stockholm",
    "gdp": {
      "nominal": "629 billion USD",
      "perCapita": "60,000 USD"
    },
    "dialingCode": "+46",
    "internetTLD": ".se",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "110",
      "police": "114 14",
      "ambulance": "112"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Midsummer Day (Saturday between June 20-26)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "European Elk",
    "nationalDish": "Köttbullar (meatballs)",
    "tourismHighlights": [
      "Stockholm Archipelago",
      "Vasa Museum",
      "Göteborg's Liseberg Amusement Park",
      "Uppsala University"
    ],
    "majorExports": [
      "Machinery",
      "Automobiles",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Machinery",
      "Mineral fuels",
      "Consumer goods"
    ],
    "lifeExpectancy": 82.4,
    "literacyRate": 99,
    "climate": "Temperate with cold winters and mild summers",
    "religions": {
      "predominant": "Lutheran Christianity",
      "others": [
        "Orthodox Christianity",
        "Islam",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Norway",
      "Finland"
    ],
    "visaRequirement": "No visa required for EU citizens and many others",
    "notableFacts": [
      "Known for its high quality of life and welfare system.",
      "One of the world's leading countries in gender equality.",
      "Home to innovations like the Bluetooth technology and the pacemaker."
    ]
  },
  "SB": {
    "flag": "",
    "name": "Solomon Islands",
    "officialName": "Solomon Islands",
    "countryCode": "+677",
    "isoAlpha2": "SB",
    "isoAlpha3": "SLB",
    "numericCode": "090",
    "firstLanguage": "en",
    "otherLanguages": [
      "sbm",
      "tpi"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "A$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Parliamentary Constitutional Monarchy",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "David Vunagi"
        },
        {
          "title": "Prime Minister",
          "name": "Manasseh Sogavare"
        }
      ]
    },
    "timeZone": {
      "name": "Solomon Islands Time (SBT)",
      "offset": "+11:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Melanesia",
    "population": 686884,
    "area": {
      "value": 28896,
      "unit": "km"
    },
    "capital": "Honiara",
    "gdp": {
      "nominal": "1.58 billion USD",
      "perCapita": "2,303 USD"
    },
    "dialingCode": "+677",
    "internetTLD": ".sb",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Independence Day (July 7)",
      "Queen's Birthday (Second Monday in June)"
    ],
    "nationalAnimal": "Solomon Island Skink",
    "nationalDish": "Kokoda (raw fish salad)",
    "tourismHighlights": [
      "Diving in the Coral Sea",
      "Mamanuca Islands",
      "Guadalcanal",
      "Russell Islands"
    ],
    "majorExports": [
      "Logs",
      "Gold",
      "Cocoa"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Fuel"
    ],
    "lifeExpectancy": 77.8,
    "literacyRate": 82.7,
    "climate": "Tropical, high humidity with a wet season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Buddhism",
        "Indigenous Beliefs"
      ]
    },
    "neighborCountries": [
      "Papua New Guinea",
      "Vanuatu"
    ],
    "visaRequirement": "Visa required for most countries; certain nationalities may enter visa-free for short stays.",
    "notableFacts": [
      "Home to numerous World War II sites and historical islands.",
      "Noted for its rich biodiversity and extensive marine life.",
      "Economy heavily reliant on agriculture, forestry, and fisheries."
    ]
  },
  "SC": {
    "flag": "",
    "name": "Seychelles",
    "officialName": "Republic of Seychelles",
    "countryCode": "+248",
    "isoAlpha2": "SC",
    "isoAlpha3": "SYC",
    "numericCode": "690",
    "firstLanguage": "crs",
    "otherLanguages": [
      "en",
      "fr"
    ],
    "currency": {
      "code": "SCR",
      "symbol": "",
      "name": "Seychellois rupee"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Wavel Ramkalawan"
        }
      ]
    },
    "timeZone": {
      "name": "Seychelles Time (SCT)",
      "offset": "+04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 98347,
    "area": {
      "value": 459,
      "unit": "km"
    },
    "capital": "Victoria",
    "gdp": {
      "nominal": "1.51 billion USD",
      "perCapita": "15,000 USD"
    },
    "dialingCode": "+248",
    "internetTLD": ".sc",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "210",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Seychelles National Day (June 18)",
      "Assumption Day (August 15)"
    ],
    "nationalAnimal": "Aldabra giant tortoise",
    "nationalDish": "Curry fish",
    "tourismHighlights": [
      "Anse Source d'Argent",
      "Morne Seychellois National Park",
      "Vallee de Mai (UNESCO World Heritage Site)",
      "Aldabra Atoll (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Tuna",
      "Coconut oil",
      "Vanilla"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 77.5,
    "literacyRate": 95,
    "climate": "Tropical marine climate with a wet and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Anglican",
        "Protestant",
        "Hinduism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Mauritius",
      "Madagascar"
    ],
    "visaRequirement": "Visa-free entry for many nationalities including EU countries, Visa on arrival for others",
    "notableFacts": [
      "Seychelles is an archipelago of 115 islands.",
      "It has a diverse marine life, making it a popular destination for diving and snorkeling.",
      "The Seychelles is home to one of the rarest birds in the world, the Seychelles black parrot."
    ]
  },
  "SG": {
    "flag": "",
    "name": "Singapore",
    "officialName": "Republic of Singapore",
    "countryCode": "+65",
    "isoAlpha2": "SG",
    "isoAlpha3": "SGP",
    "numericCode": "702",
    "firstLanguage": "en",
    "otherLanguages": [
      "zh",
      "ms",
      "ta"
    ],
    "currency": {
      "code": "SGD",
      "symbol": "S$",
      "name": "Singapore Dollar"
    },
    "government": {
      "type": "Unitary parliamentary constitutional republic",
      "politicalLean": "Centre-right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Halimah Yacob"
        },
        {
          "title": "Prime Minister",
          "name": "Lee Hsien Loong"
        }
      ]
    },
    "timeZone": {
      "name": "Singapore Time (SGT)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 5810000,
    "area": {
      "value": 728.6,
      "unit": "km"
    },
    "capital": "Singapore",
    "gdp": {
      "nominal": "397.4 billion USD",
      "perCapita": "68,930 USD"
    },
    "dialingCode": "+65",
    "internetTLD": ".sg",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "995",
      "police": "999",
      "ambulance": "995"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Chinese New Year (variable)",
      "Hari Raya Puasa (variable)",
      "Deepavali (variable)",
      "National Day (August 9)"
    ],
    "nationalAnimal": "Merlion",
    "nationalDish": "Hainanese Chicken Rice",
    "tourismHighlights": [
      "Marina Bay Sands",
      "Gardens by the Bay",
      "Sentosa Island",
      "Universal Studios Singapore"
    ],
    "majorExports": [
      "Electronics",
      "Petroleum products",
      "Pharmaceuticals"
    ],
    "majorImports": [
      "Machinery",
      "Mineral fuels",
      "Electronics"
    ],
    "lifeExpectancy": 84.5,
    "literacyRate": 97.3,
    "climate": "Tropical rainforest climate",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Christianity",
        "Islam",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "None (Maritime boundaries with Malaysia and Indonesia)"
    ],
    "visaRequirement": "Visa-free entry for many countries; e-visa available for others.",
    "notableFacts": [
      "One of the worlds busiest ports.",
      "Has a highly developed free-market economy.",
      "Home to a diverse population with a mix of cultures and languages."
    ]
  },
  "SD": {
    "flag": "",
    "name": "Sudan",
    "officialName": "Republic of the Sudan",
    "countryCode": "+249",
    "isoAlpha2": "SD",
    "isoAlpha3": "SDN",
    "numericCode": "729",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en",
      "fr",
      "ber"
    ],
    "currency": {
      "code": "SDG",
      "symbol": "..",
      "name": "Sudanese Pound"
    },
    "government": {
      "type": "Federal presidential republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "Chairman of the Transitional Sovereignty Council",
          "name": "Abdel Fattah al-Burhan"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Northern Africa",
    "population": 44610000,
    "area": {
      "value": 1861484,
      "unit": "km"
    },
    "capital": "Khartoum",
    "gdp": {
      "nominal": "40.61 billion USD",
      "perCapita": "910 USD"
    },
    "dialingCode": "+249",
    "internetTLD": ".sd",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "999",
      "fire": "115",
      "police": "999",
      "ambulance": "115"
    },
    "holidays": [
      "Independence Day (January 1)",
      "Revolution Day (April 6)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Nilotic crocodile",
    "nationalDish": "Ful medames",
    "tourismHighlights": [
      "Pyramids of Meroë",
      "Nubian Desert",
      "Red Sea coast",
      "Sudan National Museum",
      "Old Dongola"
    ],
    "majorExports": [
      "Gold",
      "Petroleum",
      "Livestock"
    ],
    "majorImports": [
      "Foodstuffs",
      "Fuel",
      "Machinery"
    ],
    "lifeExpectancy": 65.7,
    "literacyRate": 74.8,
    "climate": "Tropical, arid in the north",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Egypt",
      "Libya",
      "Chad",
      "Central African Republic",
      "South Sudan",
      "Ethiopia"
    ],
    "visaRequirement": "Visa required for most nationalities",
    "notableFacts": [
      "Home to the largest number of pyramids in the world, primarily from ancient Nubian civilizations.",
      "Sudan has a rich cultural heritage and is known for its diverse ethnic groups.",
      "The country has been affected by years of civil conflict, leading to challenges in governance and development."
    ]
  },
  "SH": {
    "flag": "",
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "officialName": "Saint Helena, Ascension and Tristan da Cunha",
    "countryCode": "+290",
    "isoAlpha2": "SH",
    "isoAlpha3": "SHN",
    "numericCode": "654",
    "firstLanguage": "en",
    "otherLanguages": [],
    "currency": {
      "code": "SHP",
      "symbol": "",
      "name": "Saint Helena Pound"
    },
    "government": {
      "type": "Overseas territory of the United Kingdom",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Current appointee - Governor of Saint Helena"
        }
      ]
    },
    "timeZone": {
      "name": "Greenwich Mean Time (GMT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Sub-Saharan Africa",
    "population": 4550,
    "area": {
      "value": 122,
      "unit": "km"
    },
    "capital": "Jamestown",
    "gdp": {
      "nominal": "unknown",
      "perCapita": "unknown"
    },
    "dialingCode": "+290",
    "internetTLD": ".sh",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Saint Helena Day (June 4)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Saint Helena Giant Earwig",
    "nationalDish": "Dahl",
    "tourismHighlights": [
      "Napoleon's Tomb",
      "The Ladder, Jacob's Ladder",
      "The Longwood Estate",
      "The Plantation House"
    ],
    "majorExports": [
      "Fish",
      "Farming products",
      "Craft items"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Construction materials"
    ],
    "lifeExpectancy": 62.8,
    "literacyRate": 98,
    "climate": "Temperate, mild and humid",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Other Christian denominations"
      ]
    },
    "neighborCountries": [],
    "visaRequirement": "Visa-free for UK passport holders; others may require a visa",
    "notableFacts": [
      "One of the most remote inhabited islands in the world.",
      "Infamous for being the place of Napoleon Bonaparte's exile.",
      "Saint Helena Pound is pegged to the British Pound Sterling."
    ]
  },
  "SL": {
    "flag": "",
    "name": "Sierra Leone",
    "officialName": "Republic of Sierra Leone",
    "countryCode": "+232",
    "isoAlpha2": "SL",
    "isoAlpha3": "SLE",
    "numericCode": "694",
    "firstLanguage": "en",
    "otherLanguages": [
      "kr",
      "ar",
      "fr"
    ],
    "currency": {
      "code": "SLL",
      "symbol": "Le",
      "name": "Sierra Leonean Leone"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Multi-party",
      "headsOfState": [
        {
          "title": "President",
          "name": "Julius Maada Bio"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 7976983,
    "area": {
      "value": 71740,
      "unit": "km"
    },
    "capital": "Freetown",
    "gdp": {
      "nominal": "4.1 billion USD",
      "perCapita": "514 USD"
    },
    "dialingCode": "+232",
    "internetTLD": ".sl",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "999",
      "ambulance": "234"
    },
    "holidays": [
      "Independence Day (April 27)",
      "International Womens Day (March 8)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Sierra Leone Lion",
    "nationalDish": "Groundnut Stew",
    "tourismHighlights": [
      "Loma Mountain National Park",
      "Tiwai Island Wildlife Sanctuary",
      "Freetown's Cotton Tree",
      "Bunce Island"
    ],
    "majorExports": [
      "Diamonds",
      "Gold",
      "Cocoa"
    ],
    "majorImports": [
      "Food products",
      "Machinery",
      "Chemicals"
    ],
    "lifeExpectancy": 54.3,
    "literacyRate": 43,
    "climate": "Tropical; hot, humid; distinct rainy and dry seasons",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "African Traditional Religions"
      ]
    },
    "neighborCountries": [
      "Guinea",
      "Liberia"
    ],
    "visaRequirement": "Visa required for most travelers; some countries are exempted.",
    "notableFacts": [
      "Home to one of the largest natural harbors in the world.",
      "Rich in natural resources, including diamonds and gold.",
      "Suffered a brutal civil war from 1991 to 2002."
    ]
  },
  "SI": {
    "flag": "",
    "name": "Slovenia",
    "officialName": "Republic of Slovenia",
    "countryCode": "+386",
    "isoAlpha2": "SI",
    "isoAlpha3": "SVN",
    "numericCode": "705",
    "firstLanguage": "sl",
    "otherLanguages": [
      "hu",
      "it"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Center-left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nataša Pirc Musar"
        },
        {
          "title": "Prime Minister",
          "name": "Robert Golob"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Central Europe",
    "population": 2078654,
    "area": {
      "value": 20273,
      "unit": "km"
    },
    "capital": "Ljubljana",
    "gdp": {
      "nominal": "65.65 billion USD",
      "perCapita": "31,600 USD"
    },
    "dialingCode": "+386",
    "internetTLD": ".si",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "112",
      "police": "113",
      "ambulance": "112"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Easter Sunday",
      "Labour Day (May 1)",
      "Statehood Day (June 25)",
      "Assumption Day (August 15)",
      "Reformation Day (October 31)",
      "All Saints' Day (November 1)",
      "Christmas Day (December 25)",
      "Independence and Unity Day (December 26)"
    ],
    "nationalAnimal": "Lynx",
    "nationalDish": "Idrija žlikrofi",
    "tourismHighlights": [
      "Lake Bled",
      "Triglav National Park",
      "Postojna Cave",
      "Ljubljana Castle",
      "Piran coastal town"
    ],
    "majorExports": [
      "Automobile parts",
      "Pharmaceuticals",
      "Electrical machinery"
    ],
    "majorImports": [
      "Machinery",
      "Vehicles",
      "Electronics"
    ],
    "lifeExpectancy": 81.5,
    "literacyRate": 99.7,
    "climate": "Oceanic climate; warm summers and cold winters",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Orthodox Christianity",
        "Islam",
        "Atheism"
      ]
    },
    "neighborCountries": [
      "Austria",
      "Hungary",
      "Croatia",
      "Italy"
    ],
    "visaRequirement": "Schengen visa required for non-EU citizens",
    "notableFacts": [
      "Only country in the world with 'love' in its name.",
      "Has a high level of environmental sustainability.",
      "Home to one of the oldest and largest cave systems in the world."
    ]
  },
  "SJ": {
    "flag": "",
    "name": "Svalbard and Jan Mayen",
    "officialName": "Svalbard and Jan Mayen",
    "countryCode": "+47",
    "isoAlpha2": "SJ",
    "isoAlpha3": "SJM",
    "numericCode": "744",
    "firstLanguage": "no",
    "otherLanguages": [
      "ru"
    ],
    "currency": {
      "code": "NOK",
      "symbol": "kr",
      "name": "Norwegian Krone"
    },
    "government": {
      "type": "Dependent territory of Norway",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Monarch",
          "name": "King of Norway"
        },
        {
          "title": "Governor",
          "name": "Governor of Svalbard"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Northern Europe",
    "population": 2744,
    "area": {
      "value": 62049,
      "unit": "km"
    },
    "capital": "Longyearbyen",
    "gdp": {
      "nominal": "Inconclusive due to low population and diverse economy",
      "perCapita": "Approximately 100,000 USD"
    },
    "dialingCode": "+47",
    "internetTLD": ".sj",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "110",
      "police": "112",
      "ambulance": "113"
    },
    "holidays": [
      "Constitution Day (May 17)",
      "Christmas (December 25)"
    ],
    "nationalAnimal": "Polar Bear",
    "nationalDish": "Reindeer stew",
    "tourismHighlights": [
      "Longyearbyen (the northernmost settlement with a substantial population)",
      "Svalbard Global Seed Vault",
      "Isfjorden",
      "Spitsbergen Island"
    ],
    "majorExports": [
      "Coal",
      "Fish",
      "Tourism services"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 80.5,
    "literacyRate": 100,
    "climate": "Polar climate with long, cold winters and short, cool summers",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None"
      ]
    },
    "neighborCountries": [
      "Norway"
    ],
    "visaRequirement": "No visa required for Schengen area countries",
    "notableFacts": [
      "Home to the Svalbard Treaty which allows international citizens to reside and work here.",
      "Experiences midnight sun in summer and polar night in winter.",
      "One of the most pristine natural environments in the world."
    ]
  },
  "SK": {
    "flag": "",
    "name": "Slovakia",
    "officialName": "Slovak Republic",
    "countryCode": "+421",
    "isoAlpha2": "SK",
    "isoAlpha3": "SVK",
    "numericCode": "703",
    "firstLanguage": "sk",
    "otherLanguages": [
      "hu",
      "cs",
      "en"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Center-Left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Zuzana Čaputová"
        },
        {
          "title": "Prime Minister",
          "name": "Robert Fico"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "population": 5456362,
    "area": {
      "value": 49037,
      "unit": "km"
    },
    "capital": "Bratislava",
    "gdp": {
      "nominal": "119.28 billion USD",
      "perCapita": "21,839 USD"
    },
    "dialingCode": "+421",
    "internetTLD": ".sk",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "150",
      "police": "158",
      "ambulance": "155"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Slovak National Uprising Day (August 29)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "Tatra chamois",
    "nationalDish": "Bryndzové halušky",
    "tourismHighlights": [
      "High Tatras National Park",
      "Bratislava Castle",
      "Slovak Paradise National Park",
      "Banská Štiavnica (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Automobiles",
      "Electronics",
      "Machinery"
    ],
    "majorImports": [
      "Energy",
      "Raw materials",
      "Machinery"
    ],
    "lifeExpectancy": 78.5,
    "literacyRate": 99.6,
    "climate": "Continental with cold winters and warm summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Greek Catholic",
        "Atheist"
      ]
    },
    "neighborCountries": [
      "Austria",
      "Czech Republic",
      "Poland",
      "Ukraine",
      "Hungary"
    ],
    "visaRequirement": "Schengen Area visa policies apply",
    "notableFacts": [
      "Has one of the highest car production rates in the world per capita.",
      "Home to numerous historical castles and natural parks.",
      "Famous for thermal springs and wellness tourism."
    ]
  },
  "SM": {
    "flag": "",
    "name": "San Marino",
    "officialName": "Most Serene Republic of San Marino",
    "countryCode": "+378",
    "isoAlpha2": "SM",
    "isoAlpha3": "SMR",
    "numericCode": "674",
    "firstLanguage": "it",
    "otherLanguages": [
      "sm"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Captain Regent",
          "name": "Various elected officials"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 33931,
    "area": {
      "value": 61,
      "unit": "km"
    },
    "capital": "San Marino",
    "gdp": {
      "nominal": "2.03 billion USD",
      "perCapita": "59,949 USD"
    },
    "dialingCode": "+378",
    "internetTLD": ".sm",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "115",
      "police": "113",
      "ambulance": "118"
    },
    "holidays": [
      "Saint Marino's Day (September 3)",
      "Independence Day (October 1)"
    ],
    "nationalAnimal": "White-tailed Eagle",
    "nationalDish": "Torta Tre Monti",
    "tourismHighlights": [
      "Guaita (one of the three towers of San Marino)",
      "Palazzo Pubblico",
      "Basilica di San Marino",
      "Monte Titano (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Mechanical machinery",
      "Furniture",
      "Clothing"
    ],
    "majorImports": [
      "Food",
      "Energy",
      "Consumer goods"
    ],
    "lifeExpectancy": 83.4,
    "literacyRate": 99.8,
    "climate": "Mediterranean with hot summers and mild winters",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Atheism",
        "Other Christian denominations"
      ]
    },
    "neighborCountries": [
      "Italy"
    ],
    "visaRequirement": "No visa required for EU countries and many others",
    "notableFacts": [
      "One of the smallest countries in the world by land area.",
      "The world's oldest surviving republic.",
      "San Marino has a strong banking sector and is known for its low taxes."
    ]
  },
  "SO": {
    "flag": "",
    "name": "Somalia",
    "officialName": "Federal Republic of Somalia",
    "countryCode": "+252",
    "isoAlpha2": "SO",
    "isoAlpha3": "SOM",
    "numericCode": "706",
    "firstLanguage": "so",
    "otherLanguages": [
      "ar",
      "en"
    ],
    "currency": {
      "code": "SOS",
      "symbol": "S",
      "name": "Somali Shilling"
    },
    "government": {
      "type": "Federal parliamentary republic",
      "politicalLean": "Federalist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Hassan Sheikh Mohamud"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 15893222,
    "area": {
      "value": 637657,
      "unit": "km"
    },
    "capital": "Mogadishu",
    "gdp": {
      "nominal": "5.81 billion USD",
      "perCapita": "366 USD"
    },
    "dialingCode": "+252",
    "internetTLD": ".so",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "999",
      "ambulance": "999"
    },
    "holidays": [
      "Independence Day (July 1)",
      "Labor Day (May 1)",
      "Eid al-Fitr",
      "Eid al-Adha"
    ],
    "nationalAnimal": "Leopard",
    "nationalDish": "Bariis isku kari (Rice)",
    "tourismHighlights": [
      "Laas Geel (rock art site)",
      "Jozani Forest (home of the Red Colobus monkey)",
      "Sandy beaches along the Indian Ocean",
      "Historic city of Mogadishu"
    ],
    "majorExports": [
      "Livestock",
      "Bananas",
      "Fish"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Machinery"
    ],
    "lifeExpectancy": 55,
    "literacyRate": 37.8,
    "climate": "Arid and semi-arid with seasonal monsoon rains",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Djibouti",
      "Ethiopia",
      "Kenya"
    ],
    "visaRequirement": "Visa required for most countries.",
    "notableFacts": [
      "Somalia has the longest coastline on the African continent.",
      "The country went through a civil war that affected its governance and stability.",
      "Somali culture is rich in oral literature and poetry."
    ]
  },
  "SS": {
    "flag": "",
    "name": "South Sudan",
    "officialName": "Republic of South Sudan",
    "countryCode": "+211",
    "isoAlpha2": "SS",
    "isoAlpha3": "SSD",
    "numericCode": "728",
    "firstLanguage": "en",
    "otherLanguages": [
      "ar",
      "dinka",
      "nuer"
    ],
    "currency": {
      "code": "SSP",
      "symbol": "",
      "name": "South Sudanese Pound"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Multi-party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "Salva Kiir Mayardit"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Sub-Saharan Africa",
    "population": 10919573,
    "area": {
      "value": 619745,
      "unit": "km"
    },
    "capital": "Juba",
    "gdp": {
      "nominal": "4.2 billion USD",
      "perCapita": "404 USD"
    },
    "dialingCode": "+211",
    "internetTLD": ".ss",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "180",
      "police": "192",
      "ambulance": "999"
    },
    "holidays": [
      "Independence Day (July 9)",
      "Martyrs Day (January 30)"
    ],
    "nationalAnimal": "African Fish Eagle",
    "nationalDish": "Aloo (a type of porridge)",
    "tourismHighlights": [
      "Boma National Park",
      "Sudd Wetlands",
      "Juba Market",
      "Lakes of South Sudan"
    ],
    "majorExports": [
      "Oil",
      "Gum Arabic",
      "Livestock"
    ],
    "majorImports": [
      "Foodstuffs",
      "Fuel",
      "Machinery"
    ],
    "lifeExpectancy": 57.3,
    "literacyRate": 27,
    "climate": "Tropical; humid with seasonal rains",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Sudan",
      "Central African Republic",
      "Uganda",
      "Kenya",
      "Ethiopia"
    ],
    "visaRequirement": "Visa required for most foreign nationals",
    "notableFacts": [
      "Gained independence from Sudan on July 9, 2011.",
      "The world's youngest country in terms of establishment.",
      "Struggled with civil conflict since its independence."
    ]
  },
  "SN": {
    "flag": "",
    "name": "Senegal",
    "officialName": "Republic of Senegal",
    "countryCode": "+221",
    "isoAlpha2": "SN",
    "isoAlpha3": "SEN",
    "numericCode": "686",
    "firstLanguage": "fr",
    "otherLanguages": [
      "wolof",
      "pulaar",
      "jola",
      "mandinka"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "",
      "name": "West African CFA franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Macky Sall"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 16743927,
    "area": {
      "value": 196722,
      "unit": "km"
    },
    "capital": "Dakar",
    "gdp": {
      "nominal": "24.13 billion USD",
      "perCapita": "1,399 USD"
    },
    "dialingCode": "+221",
    "internetTLD": ".sn",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Independence Day (April 4)",
      "Tabaski (Eid al-Adha)",
      "Maouloud (Prophet Muhammads Birthday)"
    ],
    "nationalAnimal": "African Fish Eagle",
    "nationalDish": "Thieboudienne",
    "tourismHighlights": [
      "Gorée Island",
      "Niokolo-Koba National Park (UNESCO World Heritage Site)",
      "Lake Retba (Pink Lake)",
      "Bandia Reserve"
    ],
    "majorExports": [
      "Fish",
      "Cotton",
      "Phosphates"
    ],
    "majorImports": [
      "Petroleum products",
      "Food",
      "Machinery"
    ],
    "lifeExpectancy": 67.7,
    "literacyRate": 51,
    "climate": "Tropical with a dry season and a wet season",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Traditional African religions",
        "Atheism"
      ]
    },
    "neighborCountries": [
      "Mauritania",
      "Mali",
      "Guinea",
      "Guinea-Bissau"
    ],
    "visaRequirement": "Visa required for many countries; e-visa available for some",
    "notableFacts": [
      "Senegal is known for its vibrant music scene, particularly the genre known as Mbalax.",
      "Home to the famous Lake Retba, known for its pink-colored waters.",
      "The first African country to achieve independence from colonial rule in 1960."
    ]
  },
  "SR": {
    "flag": "",
    "name": "Suriname",
    "officialName": "Republic of Suriname",
    "countryCode": "+597",
    "isoAlpha2": "SR",
    "isoAlpha3": "SUR",
    "numericCode": "740",
    "firstLanguage": "nl",
    "otherLanguages": [
      "sr",
      "en",
      "hns"
    ],
    "currency": {
      "code": "SRD",
      "symbol": "$",
      "name": "Surinamese Dollar"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Multicultural",
      "headsOfState": [
        {
          "title": "President",
          "name": "Chandrikapersad Santokhi"
        },
        {
          "title": "Vice President",
          "name": "Ronnie Brunswijk"
        }
      ]
    },
    "timeZone": {
      "name": "Suriname Time (SRT)",
      "offset": "-03:00",
      "dst": "No"
    },
    "dateFormat": "DD-MM-YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 591919,
    "area": {
      "value": 163820,
      "unit": "km"
    },
    "capital": "Paramaribo",
    "gdp": {
      "nominal": "6.77 billion USD",
      "perCapita": "11,432 USD"
    },
    "dialingCode": "+597",
    "internetTLD": ".sr",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "115",
      "fire": "110",
      "police": "112",
      "ambulance": "118"
    },
    "holidays": [
      "Independence Day (November 25)",
      "Abipon Day (December 14)"
    ],
    "nationalAnimal": "Jaguar",
    "nationalDish": "Pom",
    "tourismHighlights": [
      "Central Suriname Nature Reserve (UNESCO World Heritage Site)",
      "Paramaribo's Historic Inner City",
      "Brownsberg Nature Park",
      "Galibi Nature Reserve"
    ],
    "majorExports": [
      "Gold",
      "Bauxite",
      "Oil"
    ],
    "majorImports": [
      "Oil products",
      "Machinery",
      "Food"
    ],
    "lifeExpectancy": 71.9,
    "literacyRate": 93.4,
    "climate": "Tropical rainforest climate",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Islam",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "French Guiana",
      "Brazil",
      "Guyana"
    ],
    "visaRequirement": "Visa required for some nationalities; many Caribbean countries can enter visa-free",
    "notableFacts": [
      "Home to a diverse range of ethnic groups, including Indigenous peoples and Creoles.",
      "Second largest rainforest in the world after the Amazon is located in Suriname.",
      "Natural resources drive the economy with a focus on mining and energy."
    ]
  },
  "ST": {
    "flag": "",
    "name": "São Tomé and Príncipe",
    "officialName": "Democratic Republic of São Tomé and Príncipe",
    "countryCode": "+239",
    "isoAlpha2": "ST",
    "isoAlpha3": "STP",
    "numericCode": "678",
    "firstLanguage": "pt",
    "otherLanguages": [
      "for",
      "cr"
    ],
    "currency": {
      "code": "STN",
      "symbol": "Db",
      "name": "Dobra"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Multiple parties",
      "headsOfState": [
        {
          "title": "President",
          "name": "Carlos Vila Nova"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 219159,
    "area": {
      "value": 964,
      "unit": "km"
    },
    "capital": "São Tomé",
    "gdp": {
      "nominal": "0.61 billion USD",
      "perCapita": "2,784 USD"
    },
    "dialingCode": "+239",
    "internetTLD": ".st",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "115",
      "police": "113",
      "ambulance": "114"
    },
    "holidays": [
      "Independence Day (July 12)",
      "All Souls' Day (November 2)"
    ],
    "nationalAnimal": "São Tomé Olive Pigeon",
    "nationalDish": "Calulu",
    "tourismHighlights": [
      "Obo National Park",
      "São Tomé Island Beaches",
      "Pico Cao Grande",
      "Roça São João"
    ],
    "majorExports": [
      "Cocoa",
      "Coffee",
      "Palm oil"
    ],
    "majorImports": [
      "Food products",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 73.5,
    "literacyRate": 93.5,
    "climate": "Tropical, with a wet and dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "African traditional religions"
      ]
    },
    "neighborCountries": [
      "None, island nation"
    ],
    "visaRequirement": "Visa required for most countries; visa on arrival available for some.",
    "notableFacts": [
      "Isolate island nation located in the Gulf of Guinea.",
      "Known for its cocoa plantations and biodiversity.",
      "Rich in cultural heritage with influences from African, Portuguese, and Brazilian traditions."
    ]
  },
  "SY": {
    "flag": "",
    "name": "Syrian Arab Republic",
    "officialName": "Syrian Arab Republic",
    "countryCode": "+963",
    "isoAlpha2": "SY",
    "isoAlpha3": "SYR",
    "numericCode": "760",
    "firstLanguage": "ar",
    "otherLanguages": [
      "fr",
      "ku",
      "syr"
    ],
    "currency": {
      "code": "SYP",
      "symbol": ".",
      "name": "Syrian Pound"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Bashar al-Assad"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 18200000,
    "area": {
      "value": 185180,
      "unit": "km"
    },
    "capital": "Damascus",
    "gdp": {
      "nominal": "21 billion USD",
      "perCapita": "1,500 USD"
    },
    "dialingCode": "+963",
    "internetTLD": ".sy",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "113",
      "police": "115",
      "ambulance": "114"
    },
    "holidays": [
      "Independence Day (April 17)",
      "Revolution Day (March 8)"
    ],
    "nationalAnimal": "Syrian Brown Bear",
    "nationalDish": "Kebabs",
    "tourismHighlights": [
      "Ancient City of Damascus (UNESCO World Heritage Site)",
      "Palmyra (UNESCO World Heritage Site)",
      "Crac des Chevaliers (UNESCO World Heritage Site)",
      "Umayyad Mosque"
    ],
    "majorExports": [
      "Cotton",
      "Oil",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Medicines"
    ],
    "lifeExpectancy": 75.4,
    "literacyRate": 86.4,
    "climate": "Mediterranean climate with hot, dry summers and mild, wet winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Druze"
      ]
    },
    "neighborCountries": [
      "Turkey",
      "Iraq",
      "Jordan",
      "Israel",
      "Lebanon"
    ],
    "visaRequirement": "Visa required for most foreign nationals",
    "notableFacts": [
      "Home to one of the oldest continuously inhabited cities in the world, Damascus.",
      "The ongoing civil conflict has led to significant social and economic challenges.",
      "Rich in archaeological sites with a long history dating back to ancient civilizations."
    ]
  },
  "SX": {
    "flag": "",
    "name": "Sint Maarten (Dutch Part)",
    "officialName": "Country of Sint Maarten",
    "countryCode": "+1",
    "isoAlpha2": "SX",
    "isoAlpha3": "SXM",
    "numericCode": "534",
    "firstLanguage": "nl",
    "otherLanguages": [
      "en",
      "fr"
    ],
    "currency": {
      "code": "ANG",
      "symbol": "",
      "name": "Netherlands Antillean Guilder"
    },
    "government": {
      "type": "Parliamentary democracy within a constitutional monarchy",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "King",
          "name": "King Willem-Alexander of the Netherlands"
        },
        {
          "title": "Governor",
          "name": "Eugène Holiday"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "24-hour",
    "region": "North America",
    "subregion": "Caribbean",
    "population": 42685,
    "area": {
      "value": 34,
      "unit": "km"
    },
    "capital": "Philipsburg",
    "gdp": {
      "nominal": "1.35 billion USD",
      "perCapita": "31,635 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".sx",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "St. Maarten Day (September 16)",
      "New Year's Day (January 1)"
    ],
    "nationalAnimal": "Frigatebird",
    "nationalDish": "Callaloo",
    "tourismHighlights": [
      "Maho Beach",
      "Philipsburg Boardwalk",
      "Great Bay Beach",
      "Dawn Beach"
    ],
    "majorExports": [
      "Electronic equipment",
      "Food and beverages"
    ],
    "majorImports": [
      "Petroleum products",
      "Food",
      "Machinery"
    ],
    "lifeExpectancy": 79.4,
    "literacyRate": 100,
    "climate": "Tropical; warm and sunny year-round with a wet season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Buddhism",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Sint Maarten (French Part)",
      "Saba",
      "Statia"
    ],
    "visaRequirement": "Visa-free for many nationalities, including EU citizens and US citizens.",
    "notableFacts": [
      "Sint Maarten is one of the smallest countries in the world.",
      "It's known for its lively nightlife and vibrant culture.",
      "Home to some of the best beaches in the Caribbean."
    ]
  },
  "SV": {
    "flag": "",
    "name": "El Salvador",
    "officialName": "Republic of El Salvador",
    "countryCode": "+503",
    "isoAlpha2": "SV",
    "isoAlpha3": "SLV",
    "numericCode": "222",
    "firstLanguage": "es",
    "otherLanguages": [
      "Nahuatl",
      "English"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Center-right",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nayib Bukele"
        }
      ]
    },
    "timeZone": {
      "name": "Central Standard Time (CST)",
      "offset": "-06:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Central America",
    "population": 6486201,
    "area": {
      "value": 21041,
      "unit": "km"
    },
    "capital": "San Salvador",
    "gdp": {
      "nominal": "28.47 billion USD",
      "perCapita": "4,417 USD"
    },
    "dialingCode": "+503",
    "internetTLD": ".sv",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "120",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (September 15)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Turquoise-browed Motmot",
    "nationalDish": "Pupusas",
    "tourismHighlights": [
      "Surfing at La Libertad",
      "Ruta de las Flores",
      "Joya de Cerén (UNESCO World Heritage Site)",
      "San Salvador Volcano"
    ],
    "majorExports": [
      "Coffee",
      "Sugar",
      "Textiles"
    ],
    "majorImports": [
      "Machinery",
      "Transportation equipment",
      "Consumer goods"
    ],
    "lifeExpectancy": 75.2,
    "literacyRate": 88.9,
    "climate": "Tropical wet and dry climate",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Evangelical Protestant",
        "Other Christian",
        "Non-religious"
      ]
    },
    "neighborCountries": [
      "Guatemala",
      "Honduras"
    ],
    "visaRequirement": "Visa-free for many countries, including EU and US citizens for short stays.",
    "notableFacts": [
      "El Salvador is the smallest and the most densely populated country in Central America.",
      "Its economy is heavily reliant on remittances from Salvadorans living abroad.",
      "El Salvador adopted Bitcoin as legal tender in 2021, being the first country to do so."
    ]
  },
  "SZ": {
    "flag": "",
    "name": "Swaziland",
    "officialName": "Kingdom of Eswatini",
    "countryCode": "+268",
    "isoAlpha2": "SZ",
    "isoAlpha3": "SWZ",
    "numericCode": "748",
    "firstLanguage": "en",
    "otherLanguages": [
      "si"
    ],
    "currency": {
      "code": "SZL",
      "symbol": "E",
      "name": "Swazi Lilangeni"
    },
    "government": {
      "type": "Absolute Monarchy",
      "politicalLean": "Monarchical Autocracy",
      "headsOfState": [
        {
          "title": "King",
          "name": "Mswati III"
        }
      ]
    },
    "timeZone": {
      "name": "South Africa Standard Time (SAST)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Southern Africa",
    "population": 1160164,
    "area": {
      "value": 17364,
      "unit": "km"
    },
    "capital": "Mbabane",
    "gdp": {
      "nominal": "4.45 billion USD",
      "perCapita": "3,848 USD"
    },
    "dialingCode": "+268",
    "internetTLD": ".sz",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "993",
      "police": "999",
      "ambulance": "944"
    },
    "holidays": [
      "Human Rights Day (March 12)",
      "Independence Day (September 6)",
      "King's Birthday (April 19)"
    ],
    "nationalAnimal": "Eagle",
    "nationalDish": "Sishwala",
    "tourismHighlights": [
      "Hlane Royal National Park",
      "Mlilwane Wildlife Sanctuary",
      "The Swazi Cultural Village",
      "Mlawula Nature Reserve"
    ],
    "majorExports": [
      "Sugar",
      "Textiles",
      "Wood and wood products"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Fuel"
    ],
    "lifeExpectancy": 58.7,
    "literacyRate": 88.5,
    "climate": "Tropical savanna climate with wet and dry seasons",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Traditional African Religions",
        "Islam"
      ]
    },
    "neighborCountries": [
      "South Africa",
      "Mozambique"
    ],
    "visaRequirement": "Visa required for some nationalities; others may enter visa-free",
    "notableFacts": [
      "Eswatini is one of the last remaining absolute monarchies in the world.",
      "The country celebrates a unique Reed Dance Festival annually.",
      "Eswatini has a rich cultural heritage, often showcased in traditional ceremonies and festivals."
    ]
  },
  "TG": {
    "flag": "",
    "name": "Togo",
    "officialName": "Togolese Republic",
    "countryCode": "+228",
    "isoAlpha2": "TG",
    "isoAlpha3": "TGO",
    "numericCode": "768",
    "firstLanguage": "fr",
    "otherLanguages": [
      "ewe",
      "kabiye"
    ],
    "currency": {
      "code": "XOF",
      "symbol": "Fr",
      "name": "CFA Franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Centralized",
      "headsOfState": [
        {
          "title": "President",
          "name": "Faure Gnassingbé"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+00:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "West Africa",
    "population": 8395000,
    "area": {
      "value": 56785,
      "unit": "km"
    },
    "capital": "Lomé",
    "gdp": {
      "nominal": "8.09 billion USD",
      "perCapita": "1,125 USD"
    },
    "dialingCode": "+228",
    "internetTLD": ".tg",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "16",
      "ambulance": "19"
    },
    "holidays": [
      "Independence Day (April 27)",
      "Labor Day (May 1)",
      "National Unity Day (January 13)"
    ],
    "nationalAnimal": "Eagle",
    "nationalDish": "Fufu and soup",
    "tourismHighlights": [
      "Koutammakou (UNESCO World Heritage Site)",
      "Togoville",
      "Fossilized trees in Amlamé",
      "Lomé Grand Market"
    ],
    "majorExports": [
      "Cotton",
      "Phosphates",
      "Coffee"
    ],
    "majorImports": [
      "Foodstuffs",
      "Consumer goods",
      "Vehicles"
    ],
    "lifeExpectancy": 61,
    "literacyRate": 65,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Ghana",
      "Benin",
      "Burkina Faso"
    ],
    "visaRequirement": "Visa required for most nationalities",
    "notableFacts": [
      "Has a significant production of cotton.",
      "Togo is one of the smallest countries in Africa.",
      "Home to Lake Togo, which is a popular spot for kayaking and fishing."
    ]
  },
  "TD": {
    "flag": "",
    "name": "Chad",
    "officialName": "Republic of Chad",
    "countryCode": "+235",
    "isoAlpha2": "TD",
    "isoAlpha3": "TCD",
    "numericCode": "148",
    "firstLanguage": "fr",
    "otherLanguages": [
      "ar",
      "sara"
    ],
    "currency": {
      "code": "XAF",
      "symbol": "FCFA",
      "name": "Central African CFA Franc"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Mahamat Idriss Déby"
        }
      ]
    },
    "timeZone": {
      "name": "West Africa Time (WAT)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Central Africa",
    "population": 17400000,
    "area": {
      "value": 1284000,
      "unit": "km"
    },
    "capital": "N'Djamena",
    "gdp": {
      "nominal": "11.24 billion USD",
      "perCapita": "646 USD"
    },
    "dialingCode": "+235",
    "internetTLD": ".td",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "17",
      "fire": "18",
      "police": "22",
      "ambulance": "15"
    },
    "holidays": [
      "Independence Day (August 11)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "Arabian Oryx",
    "nationalDish": "Boulkichia",
    "tourismHighlights": [
      "Zakouma National Park",
      "Tibesti Mountains",
      "Historic Sites of the Kanem-Bornu Empire"
    ],
    "majorExports": [
      "Oil",
      "Cotton",
      "Livestock"
    ],
    "majorImports": [
      "Foodstuffs",
      "Machinery",
      "Vehicles"
    ],
    "lifeExpectancy": 54.3,
    "literacyRate": 22.3,
    "climate": "Hot semi-arid, with a rainy season from June to September",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "Libya",
      "Niger",
      "Nigeria",
      "Cameroon",
      "Central African Republic"
    ],
    "visaRequirement": "Visa required for most countries; eVisa available.",
    "notableFacts": [
      "Chad is home to the largest desert in Africa, the Sahara.",
      "It has a significant cultural heritage, with over 200 ethnic groups.",
      "The country faces challenges such as poverty, political instability, and environmental issues."
    ]
  },
  "TC": {
    "flag": "",
    "name": "Turks and Caicos Islands",
    "officialName": "Turks and Caicos Islands",
    "countryCode": "+1",
    "isoAlpha2": "TC",
    "isoAlpha3": "TCA",
    "numericCode": "796",
    "firstLanguage": "en",
    "otherLanguages": [
      "ht"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Overseas territory",
      "politicalLean": "Conservative",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Governor of the Turks and Caicos Islands"
        },
        {
          "title": "Premier",
          "name": "Premier of the Turks and Caicos Islands"
        }
      ]
    },
    "timeZone": {
      "name": "Turks and Caicos Islands Time (TCAT)",
      "offset": "-05:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 38782,
    "area": {
      "value": 430,
      "unit": "km"
    },
    "capital": "Cockburn Town",
    "gdp": {
      "nominal": "1.01 billion USD",
      "perCapita": "26,014 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".tc",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Heroes Day (January, third Monday)",
      "National Day (September 30)"
    ],
    "nationalAnimal": "Rock Iguana",
    "nationalDish": "Conch fritters",
    "tourismHighlights": [
      "Grace Bay Beach",
      "Bight Reef",
      "Sapodilla Bay",
      "Little Water Cay (Iguana Island)"
    ],
    "majorExports": [
      "Conch",
      "Seafood",
      "Salt"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": 79.7,
    "literacyRate": 98.9,
    "climate": "Tropical, with a rainy season from May to October",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Baha'i",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Bahamas"
    ],
    "visaRequirement": "Visa-free for many countries; visa required for others.",
    "notableFacts": [
      "Known for its stunning beaches and coral reefs.",
      "A popular destination for tourists, especially for water sports and diving.",
      "The islands are named after the Caicos Islands, and are known for their rich biodiversity."
    ]
  },
  "TH": {
    "flag": "",
    "name": "Thailand",
    "officialName": "Kingdom of Thailand",
    "countryCode": "+66",
    "isoAlpha2": "TH",
    "isoAlpha3": "THA",
    "numericCode": "764",
    "firstLanguage": "th",
    "otherLanguages": [
      "en",
      "cn",
      "ja"
    ],
    "currency": {
      "code": "THB",
      "symbol": "",
      "name": "Thai Baht"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Monarchist",
      "headsOfState": [
        {
          "title": "King",
          "name": "Maha Vajiralongkorn (Rama X)"
        },
        {
          "title": "Prime Minister",
          "name": "Prayuth Chan-o-cha"
        }
      ]
    },
    "timeZone": {
      "name": "Indochina Time (ICT)",
      "offset": "+07:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 70129280,
    "area": {
      "value": 513120,
      "unit": "km"
    },
    "capital": "Bangkok",
    "gdp": {
      "nominal": "543.15 billion USD",
      "perCapita": "7,743 USD"
    },
    "dialingCode": "+66",
    "internetTLD": ".th",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "191",
      "fire": "199",
      "police": "191",
      "ambulance": "1669"
    },
    "holidays": [
      "Songkran Festival (April 13-15)",
      "King Bhumibol Memorial Day (October 13)"
    ],
    "nationalAnimal": "Elephant",
    "nationalDish": "Pad Thai",
    "tourismHighlights": [
      "Grand Palace",
      "Wat Pho",
      "Phang Nga Bay",
      "Chiang Mai Night Bazaar",
      "Koh Samui Beaches"
    ],
    "majorExports": [
      "Automobiles",
      "Computers",
      "Rubber",
      "Rice"
    ],
    "majorImports": [
      "Machinery",
      "Electronics",
      "Chemicals",
      "Fuel"
    ],
    "lifeExpectancy": 75.4,
    "literacyRate": 93.5,
    "climate": "Tropical; rainy, cool season from June to October; hot season from March to May",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Islam",
        "Christianity",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Myanmar",
      "Laos",
      "Cambodia",
      "Malaysia"
    ],
    "visaRequirement": "Visa-free for many nationalities for stays of up to 30 days",
    "notableFacts": [
      "The only Southeast Asian country that was never colonized by a European power.",
      "Home to some of the world's most beautiful temples and islands.",
      "Known for its rich cultural heritage and vibrant street life."
    ]
  },
  "TF": {
    "flag": "",
    "name": "French Southern Territories",
    "officialName": "French Southern and Antarctic Lands",
    "countryCode": "+262",
    "isoAlpha2": "TF",
    "isoAlpha3": "ATF",
    "numericCode": "260",
    "firstLanguage": "fr",
    "otherLanguages": [],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Territory of France",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of France"
        }
      ]
    },
    "timeZone": {
      "name": "French Southern and Antarctic Lands Time (TFT)",
      "offset": "+05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Southern Oceania",
    "population": 0,
    "area": {
      "value": 7747,
      "unit": "km"
    },
    "capital": "Port-aux-Français (on Crozet Islands)",
    "gdp": {
      "nominal": "Not available",
      "perCapita": "Not applicable"
    },
    "dialingCode": "+262",
    "internetTLD": ".tf",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Bastille Day (July 14)",
      "Armistice Day (November 11)"
    ],
    "nationalAnimal": "None designated",
    "nationalDish": "None specific",
    "tourismHighlights": [
      "Crozet Islands National Nature Reserve",
      "Kerguelen Islands",
      "Amsterdam Island"
    ],
    "majorExports": [
      "Research findings",
      "Fishing"
    ],
    "majorImports": [
      "Food",
      "Goods from mainland France"
    ],
    "lifeExpectancy": "Not applicable, due to minimal permanent population",
    "literacyRate": "Not applicable, due to minimal permanent population",
    "climate": "Oceanic, with cool temperatures and frequent precipitation",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "None"
      ]
    },
    "neighborCountries": [],
    "visaRequirement": "Visa-free entry for French citizens and residents",
    "notableFacts": [
      "Comprises several islands and archipelagos, primarily uninhabited.",
      "Administrative territory of France, primarily used for scientific research.",
      "Environmental protections are critical in this geographically isolated region."
    ]
  },
  "TK": {
    "flag": "",
    "name": "Tokelau",
    "officialName": "Tokelau",
    "countryCode": "+690",
    "isoAlpha2": "TK",
    "isoAlpha3": "TKL",
    "numericCode": "772",
    "firstLanguage": "tu",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "NZD",
      "symbol": "$",
      "name": "New Zealand Dollar"
    },
    "government": {
      "type": "Territory of New Zealand",
      "politicalLean": "Dependence",
      "headsOfState": [
        {
          "title": "Administrator",
          "name": "New Zealand"
        }
      ]
    },
    "timeZone": {
      "name": "UTC+13:00",
      "offset": "+13:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 1411,
    "area": {
      "value": 12,
      "unit": "km"
    },
    "capital": "Nukunonu",
    "gdp": {
      "nominal": "N/A",
      "perCapita": "N/A"
    },
    "dialingCode": "+690",
    "internetTLD": ".tk",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "111",
      "fire": "N/A",
      "police": "N/A",
      "ambulance": "N/A"
    },
    "holidays": [
      "Tokelau Language Week (Week 3 of September)",
      "National Day (First Friday in April)"
    ],
    "nationalAnimal": "Tuna (Eel)",
    "nationalDish": "Palusami",
    "tourismHighlights": [
      "Beaches and coral reefs",
      "Evidenced historic sites",
      "Traditional Tokelauan culture experiences"
    ],
    "majorExports": [
      "copra",
      "fish"
    ],
    "majorImports": [
      "food",
      "fuel",
      "construction materials"
    ],
    "lifeExpectancy": 70,
    "literacyRate": 98,
    "climate": "Tropical climate, warm and humid",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Traditional beliefs"
      ]
    },
    "neighborCountries": [
      "New Zealand"
    ],
    "visaRequirement": "No visa required for New Zealand citizens; others may need to check requirements.",
    "notableFacts": [
      "Made up of three atolls: Atafu, Nukunonu, and Fakaofo.",
      "Has a unique culture with influences from Polynesian heritage.",
      "Tokelau relies on New Zealand for transportation and resources."
    ]
  },
  "TJ": {
    "flag": "",
    "name": "Tajikistan",
    "officialName": "Republic of Tajikistan",
    "countryCode": "+992",
    "isoAlpha2": "TJ",
    "isoAlpha3": "TJK",
    "numericCode": "762",
    "firstLanguage": "tg",
    "otherLanguages": [
      "ru"
    ],
    "currency": {
      "code": "TJS",
      "symbol": "",
      "name": "Tajik Somoni"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Emomali Rahmon"
        }
      ]
    },
    "timeZone": {
      "name": "Tajikistan Time (TJT)",
      "offset": "+05:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Central Asia",
    "population": 9514000,
    "area": {
      "value": 143100,
      "unit": "km"
    },
    "capital": "Dushanbe",
    "gdp": {
      "nominal": "8.47 billion USD",
      "perCapita": "891 USD"
    },
    "dialingCode": "+992",
    "internetTLD": ".tj",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Independence Day (September 9)",
      "Navruz (March 21)"
    ],
    "nationalAnimal": "Snow Leopard",
    "nationalDish": "Plov",
    "tourismHighlights": [
      "Iskanderkul Lake",
      "Pamir Mountains",
      "Hissor Fortress",
      "Dushanbe's National Museum of Tajikistan"
    ],
    "majorExports": [
      "Aluminum",
      "Cotton",
      "Electricity"
    ],
    "majorImports": [
      "Foodstuffs",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 71.3,
    "literacyRate": 99.8,
    "climate": "Continental with cold winters and hot summers",
    "religions": {
      "predominant": "Islam (Sunni)",
      "others": [
        "None",
        "Ismaili",
        "Shia"
      ]
    },
    "neighborCountries": [
      "Kyrgyzstan",
      "Uzbekistan",
      "Afghanistan",
      "China"
    ],
    "visaRequirement": "Visa required for most foreign nationals",
    "notableFacts": [
      "Home to the highest mountain in the former Soviet Union, Ismoil Somoni Peak.",
      "Rich in natural resources, particularly in hydroelectricity.",
      "Tajikistan's culture is heavily influenced by Persian traditions."
    ]
  },
  "TL": {
    "flag": "",
    "name": "Timor-Leste",
    "officialName": "Democratic Republic of Timor-Leste",
    "countryCode": "+670",
    "isoAlpha2": "TL",
    "isoAlpha3": "TLS",
    "numericCode": "626",
    "firstLanguage": "Tetum",
    "otherLanguages": [
      "Portuguese",
      "Indonesian",
      "English"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Unitary parliamentary constitutional democracy",
      "politicalLean": "Left-wing",
      "headsOfState": [
        {
          "title": "President",
          "name": "José Ramos-Horta"
        },
        {
          "title": "Prime Minister",
          "name": "Taur Matan Ruak"
        }
      ]
    },
    "timeZone": {
      "name": "East Timor Time (TLT)",
      "offset": "+09:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "South-Eastern Asia",
    "population": 1318445,
    "area": {
      "value": 1486,
      "unit": "km"
    },
    "capital": "Dili",
    "gdp": {
      "nominal": "2.05 billion USD",
      "perCapita": "1,554 USD"
    },
    "dialingCode": "+670",
    "internetTLD": ".tl",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "11",
      "police": "113",
      "ambulance": "118"
    },
    "holidays": [
      "Independence Day (August 30)",
      "Proclamation of Independence Day (May 20)"
    ],
    "nationalAnimal": "Bird of Paradise",
    "nationalDish": "Ikan pekasam (fermented fish)",
    "tourismHighlights": [
      "Atauro Island",
      "Nino Konis Santana National Park",
      "Cristo Rei de Dili",
      "Tasi Tolu",
      "Jaco Island"
    ],
    "majorExports": [
      "Coffee",
      "Coconut",
      "Marine products"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Fuel"
    ],
    "lifeExpectancy": 70.9,
    "literacyRate": 67.5,
    "climate": "Tropical; hot and humid with wet and dry seasons",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Islam",
        "Animism"
      ]
    },
    "neighborCountries": [
      "Indonesia"
    ],
    "visaRequirement": "Visa required for most nationalities, including EU and US",
    "notableFacts": [
      "Timor-Leste gained independence from Indonesia in 2002.",
      "It's one of the newest countries in the world.",
      "Is known for its rich marine biodiversity and beautiful beaches."
    ]
  },
  "TM": {
    "flag": "",
    "name": "Turkmenistan",
    "officialName": "Awaza Türkmen Respublikasy",
    "countryCode": "+993",
    "isoAlpha2": "TM",
    "isoAlpha3": "TKM",
    "numericCode": "795",
    "firstLanguage": "tk",
    "otherLanguages": [
      "ru",
      "uz"
    ],
    "currency": {
      "code": "TMT",
      "symbol": "",
      "name": "Turkmenistan manat"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Serdar Berdimuhamedow"
        }
      ]
    },
    "timeZone": {
      "name": "Turkmenistan Time (TMT)",
      "offset": "+05:00",
      "dst": "No"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Central Asia",
    "population": 6051187,
    "area": {
      "value": 49121,
      "unit": "km"
    },
    "capital": "Ashgabat",
    "gdp": {
      "nominal": "40.20 billion USD",
      "perCapita": "6,638 USD"
    },
    "dialingCode": "+993",
    "internetTLD": ".tm",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Independence Day (September 27)",
      "Turkmen Carpet Day (last Sunday of May)"
    ],
    "nationalAnimal": "Akhal-Teke horse",
    "nationalDish": "Plov",
    "tourismHighlights": [
      "The Door to Hell (Darvaza Gas Crater)",
      "Ashgabat's White Marble Buildings",
      "Ancient City of Merv (UNESCO World Heritage Site)",
      "Nisa, the ancient Parthian capital (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Natural gas",
      "Oil",
      "Textiles"
    ],
    "majorImports": [
      "Machinery",
      "Food products",
      "Rolls and tires"
    ],
    "lifeExpectancy": 72.3,
    "literacyRate": 99.7,
    "climate": "Desert climate with hot summers and mild winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "None",
        "Eastern Orthodox"
      ]
    },
    "neighborCountries": [
      "Kazakhstan",
      "Uzbekistan",
      "Afghanistan",
      "Iran"
    ],
    "visaRequirement": "Visa required for most travelers, e-visa available for some nationalities",
    "notableFacts": [
      "Has the world's fourth largest reserves of natural gas.",
      "Ashgabat holds the Guinness World Record for the highest concentration of white marble buildings.",
      "The country has a unique form of government which heavily restricts personal freedoms."
    ]
  },
  "TN": {
    "flag": "",
    "name": "Tunisia",
    "officialName": "Tunisian Republic",
    "countryCode": "+216",
    "isoAlpha2": "TN",
    "isoAlpha3": "TUN",
    "numericCode": "788",
    "firstLanguage": "ar",
    "otherLanguages": [
      "fr"
    ],
    "currency": {
      "code": "TND",
      "symbol": ".",
      "name": "Tunisian Dinar"
    },
    "government": {
      "type": "Unitary semi-presidential republic",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Kais Saied"
        },
        {
          "title": "Prime Minister",
          "name": "Ahmed Hachani"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Northern Africa",
    "population": 11818619,
    "area": {
      "value": 163610,
      "unit": "km"
    },
    "capital": "Tunis",
    "gdp": {
      "nominal": "43.03 billion USD",
      "perCapita": "3,631 USD"
    },
    "dialingCode": "+216",
    "internetTLD": ".tn",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "197",
      "fire": "198",
      "police": "197",
      "ambulance": "190"
    },
    "holidays": [
      "Independence Day (March 20)",
      "Revolution Day (January 14)"
    ],
    "nationalAnimal": "Horses",
    "nationalDish": "Couscous",
    "tourismHighlights": [
      "Sidi Bou Said",
      "Carthage ruins",
      "Medina of Tunis (UNESCO World Heritage Site)",
      "The Grand Mosque of Kairouan"
    ],
    "majorExports": [
      "Olive oil",
      "Textiles",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Chemicals"
    ],
    "lifeExpectancy": 76.5,
    "literacyRate": 81.9,
    "climate": "Mediterranean climate with hot, dry summers and mild, wet winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Algeria",
      "Libya"
    ],
    "visaRequirement": "Visa not required for citizens of many countries, including EU nations for short stays.",
    "notableFacts": [
      "Home to one of the oldest inhabited cities in the world, Carthage.",
      "The Arab Spring began in Tunisia in late 2010.",
      "Rich cultural heritage with influences from various civilizations."
    ]
  },
  "TO": {
    "flag": "",
    "name": "Tonga",
    "officialName": "Kingdom of Tonga",
    "countryCode": "+676",
    "isoAlpha2": "TO",
    "isoAlpha3": "TON",
    "numericCode": "776",
    "firstLanguage": "to",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "TOP",
      "symbol": "T$",
      "name": "Tongan Paanga"
    },
    "government": {
      "type": "Constitutional monarchy",
      "politicalLean": "Monarchism",
      "headsOfState": [
        {
          "title": "King",
          "name": "Nuisiala Tuku'aho"
        }
      ]
    },
    "timeZone": {
      "name": "Tonga Time (TOT)",
      "offset": "+13:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 106000,
    "area": {
      "value": 747,
      "unit": "km"
    },
    "capital": "Nukualofa",
    "gdp": {
      "nominal": "0.47 billion USD",
      "perCapita": "4,386 USD"
    },
    "dialingCode": "+676",
    "internetTLD": ".to",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Tonga Day (November 4)",
      "Emancipation Day (June 4)"
    ],
    "nationalAnimal": "Pacific Flying Fox",
    "nationalDish": "Ota ika",
    "tourismHighlights": [
      "Haapai Islands",
      "Tongatapu Island",
      "Vavau Islands",
      "Eua National Park"
    ],
    "majorExports": [
      "Agricultural products",
      "Fish",
      "Vanilla"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Petroleum products"
    ],
    "lifeExpectancy": 74.1,
    "literacyRate": 99,
    "climate": "Tropical",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Buddhism",
        "Taoism"
      ]
    },
    "neighborCountries": [
      "None (Is an island nation)"
    ],
    "visaRequirement": "Visa-free access for many countries, including most Pacific nations",
    "notableFacts": [
      "Tonga is known as the 'Pearl of the Pacific'.",
      "It is the only monarchy in the Pacific Islands.",
      "Tonga is made up of 176 islands, of which only 36 are inhabited."
    ]
  },
  "TV": {
    "flag": "",
    "name": "Tuvalu",
    "officialName": "Tuvalu",
    "countryCode": "+688",
    "isoAlpha2": "TV",
    "isoAlpha3": "TUV",
    "numericCode": "798",
    "firstLanguage": "tvl",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "AUD",
      "symbol": "A$",
      "name": "Australian Dollar"
    },
    "government": {
      "type": "Parliamentary democracy and constitutional monarchy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Queen",
          "name": "Elizabeth II (as of October 2023)"
        },
        {
          "title": "Governor-General",
          "name": "Sir Iakoba Italeli"
        }
      ]
    },
    "timeZone": {
      "name": "Tuvalu Time (TVT)",
      "offset": "+12:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 11700,
    "area": {
      "value": 26,
      "unit": "km"
    },
    "capital": "Funafuti",
    "gdp": {
      "nominal": "41.7 million USD",
      "perCapita": "3,570 USD"
    },
    "dialingCode": "+688",
    "internetTLD": ".tv",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Years Day (January 1)",
      "National Day (October 1)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Tuvaluan bird (nitoku)",
    "nationalDish": "Palu salu (banana and coconut cream)",
    "tourismHighlights": [
      "Funafuti Conservation Area",
      "Tropical beaches",
      "Scuba diving and snorkeling"
    ],
    "majorExports": [
      "Copra",
      "Fish",
      "Timber"
    ],
    "majorImports": [
      "Food and beverages",
      "Machinery",
      "Fuels"
    ],
    "lifeExpectancy": 67.5,
    "literacyRate": 98,
    "climate": "Tropical, with a rainy season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None"
      ]
    },
    "neighborCountries": [
      "None (island nation)"
    ],
    "visaRequirement": "Visa on arrival for most nationalities",
    "notableFacts": [
      "Fourth smallest country in the world by area and population.",
      "Famous for its online domain '.tv', which is popular with television networks.",
      "Rising sea levels threaten the existence of Tuvalu."
    ]
  },
  "TT": {
    "flag": "",
    "name": "Trinidad and Tobago",
    "officialName": "Republic of Trinidad and Tobago",
    "countryCode": "+1",
    "isoAlpha2": "TT",
    "isoAlpha3": "TTO",
    "numericCode": "780",
    "firstLanguage": "en",
    "otherLanguages": [
      "es",
      "hindi",
      "French"
    ],
    "currency": {
      "code": "TTD",
      "symbol": "TT$",
      "name": "Trinidad and Tobago Dollar"
    },
    "government": {
      "type": "Unitary parliamentary constitutional republic",
      "politicalLean": "Center-Left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Paula-Mae Weekes"
        },
        {
          "title": "Prime Minister",
          "name": "Paula-Mae Weekes"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 1363378,
    "area": {
      "value": 5128,
      "unit": "km"
    },
    "capital": "Port of Spain",
    "gdp": {
      "nominal": "23.59 billion USD",
      "perCapita": "17,299 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".tt",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "990",
      "police": "999",
      "ambulance": "811"
    },
    "holidays": [
      "Carnival (varies each year)",
      "Emancipation Day (August 1)",
      "Independence Day (August 31)",
      "Divali (varies each year)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Scarlet Ibis",
    "nationalDish": "Callaloo",
    "tourismHighlights": [
      "Tobago's Buccoo Reef",
      "Maracas Bay",
      "Pitch Lake",
      "Asa Wright Nature Centre"
    ],
    "majorExports": [
      "Natural gas",
      "Petroleum",
      "Chemicals"
    ],
    "majorImports": [
      "Machinery",
      "Food",
      "Transportation equipment"
    ],
    "lifeExpectancy": 75.3,
    "literacyRate": 98.6,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Islam",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Venezuela",
      "Barbados (proximity to)"
    ],
    "visaRequirement": "Visa-free for many countries; visa required for some nationalities",
    "notableFacts": [
      "Home to the worlds largest Caribbean carnival, held annually in Port of Spain.",
      "Known for its diverse culture and vibrant music scene, particularly calypso and steelpan.",
      "Tobago features some of the Caribbeans best beaches and coral reefs."
    ]
  },
  "TW": {
    "flag": "",
    "name": "Taiwan",
    "officialName": "Republic of China (Taiwan)",
    "countryCode": "+886",
    "isoAlpha2": "TW",
    "isoAlpha3": "TWN",
    "numericCode": "158",
    "firstLanguage": "zh",
    "otherLanguages": [
      "en",
      "holo",
      "hmn"
    ],
    "currency": {
      "code": "TWD",
      "symbol": "NT$",
      "name": "New Taiwan Dollar"
    },
    "government": {
      "type": "Semi-presidential republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Lai Ching-te"
        },
        {
          "title": "Premier",
          "name": "Chen Chien-jen"
        }
      ]
    },
    "timeZone": {
      "name": "Taipei Standard Time (TST)",
      "offset": "+08:00",
      "dst": "No"
    },
    "dateFormat": "YYYY/MM/DD",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "East Asia",
    "population": 23600000,
    "area": {
      "value": 36193,
      "unit": "km"
    },
    "capital": "Taipei",
    "gdp": {
      "nominal": "807 billion USD",
      "perCapita": "34,237 USD"
    },
    "dialingCode": "+886",
    "internetTLD": ".tw",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "119",
      "fire": "119",
      "police": "110",
      "ambulance": "119"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Taiwanese Lantern Festival (date varies)",
      "Double Tenth Day (October 10)"
    ],
    "nationalAnimal": "Formosan black bear",
    "nationalDish": "Beef noodle soup",
    "tourismHighlights": [
      "Taroko Gorge",
      "Taipei 101",
      "Sun Moon Lake",
      "Alishan Forest Railway"
    ],
    "majorExports": [
      "Electronics",
      "Machinery",
      "Plastics"
    ],
    "majorImports": [
      "Raw materials",
      "Oil",
      "Machinery"
    ],
    "lifeExpectancy": 80.5,
    "literacyRate": 98.5,
    "climate": "Subtropical with humid summers and mild winters",
    "religions": {
      "predominant": "Buddhism/Taoism",
      "others": [
        "Christianity",
        "None",
        "Islam"
      ]
    },
    "neighborCountries": [
      "None (situated near China, Japan, and the Philippines)"
    ],
    "visaRequirement": "Visa-exempt for many countries including the USA, Canada, and EU nations; eVisa option available for select nationalities.",
    "notableFacts": [
      "Taiwan is known for its vibrant democracy and technology industry.",
      "It has a unique cultural blend of traditional Chinese culture and modern influence.",
      "Taiwan is also celebrated for its night markets and various local delicacies."
    ]
  },
  "TR": {
    "flag": "",
    "name": "Turkey",
    "officialName": "Republic of Türkiye",
    "countryCode": "+90",
    "isoAlpha2": "TR",
    "isoAlpha3": "TUR",
    "numericCode": "792",
    "firstLanguage": "tr",
    "otherLanguages": [
      "kur",
      "az",
      "en"
    ],
    "currency": {
      "code": "TRY",
      "symbol": "",
      "name": "Turkish Lira"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Various",
      "headsOfState": [
        {
          "title": "President",
          "name": "Recep Tayyip Erdoğan"
        }
      ]
    },
    "timeZone": {
      "name": "Turkey Time (TRT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 86834000,
    "area": {
      "value": 783356,
      "unit": "km"
    },
    "capital": "Ankara",
    "gdp": {
      "nominal": "800 billion USD",
      "perCapita": "9,226 USD"
    },
    "dialingCode": "+90",
    "internetTLD": ".tr",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "110",
      "police": "155",
      "ambulance": "112"
    },
    "holidays": [
      "Republic Day (October 29)",
      "Victory Day (August 30)"
    ],
    "nationalAnimal": "Grey Wolf",
    "nationalDish": "Kebap",
    "tourismHighlights": [
      "Hagia Sophia",
      "Cappadocia",
      "Ephesus",
      "Pamukkale"
    ],
    "majorExports": [
      "Automotive",
      "Textiles",
      "Machinery"
    ],
    "majorImports": [
      "Energy",
      "Raw materials",
      "Machinery"
    ],
    "lifeExpectancy": 78.2,
    "literacyRate": 96.2,
    "climate": "Varies by region; generally temperate with hot, dry summers and cool, wet winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Greece",
      "Bulgaria",
      "Georgia",
      "Armenia",
      "Azerbaijan",
      "Iran",
      "Iraq",
      "Syria"
    ],
    "visaRequirement": "Visa required for some nationalities; e-Visa available for many",
    "notableFacts": [
      "Straddles two continents: Asia and Europe.",
      "Home to one of the Seven Wonders of the Ancient World, the Temple of Artemis at Ephesus.",
      "Has a rich history and diverse culture influenced by various civilizations."
    ]
  },
  "UA": {
    "flag": "",
    "name": "Ukraine",
    "officialName": "Ukraine",
    "countryCode": "+380",
    "isoAlpha2": "UA",
    "isoAlpha3": "UKR",
    "numericCode": "804",
    "firstLanguage": "uk",
    "otherLanguages": [
      "ru",
      "en",
      "pl"
    ],
    "currency": {
      "code": "UAH",
      "symbol": "",
      "name": "Ukrainian Hryvnia"
    },
    "government": {
      "type": "Unitary parliamentary republic",
      "politicalLean": "Pro-European",
      "headsOfState": [
        {
          "title": "President",
          "name": "Volodymyr Zelensky"
        },
        {
          "title": "Prime Minister",
          "name": "Denys Shmyhal"
        }
      ]
    },
    "timeZone": {
      "name": "Eastern European Time (EET)",
      "offset": "+02:00",
      "dst": "Yes"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Eastern Europe",
    "population": 41733762,
    "area": {
      "value": 603500,
      "unit": "km"
    },
    "capital": "Kyiv",
    "gdp": {
      "nominal": "200 billion USD",
      "perCapita": "4,800 USD"
    },
    "dialingCode": "+380",
    "internetTLD": ".ua",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Independence Day (August 24)",
      "Defender of Ukraine Day (October 14)"
    ],
    "nationalAnimal": "Griffon vulture",
    "nationalDish": "Borscht",
    "tourismHighlights": [
      "Kyiv Pechersk Lavra (Monastery of the Caves)",
      "Lviv's Old Town",
      "Odesa's beaches",
      "Carpathian Mountains"
    ],
    "majorExports": [
      "Grains",
      "Metallurgy products",
      "Machinery"
    ],
    "majorImports": [
      "Energy resources",
      "Machinery",
      "Chemicals"
    ],
    "lifeExpectancy": 72.6,
    "literacyRate": 99.8,
    "climate": "Continental with cold winters and warm summers",
    "religions": {
      "predominant": "Eastern Orthodox",
      "others": [
        "Greek Catholic",
        "Protestant",
        "Buddhism",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Belarus",
      "Russia",
      "Kazakhstan",
      "Hungary",
      "Romania",
      "Moldova",
      "Poland"
    ],
    "visaRequirement": "Visa-free for many countries, visa required for others",
    "notableFacts": [
      "Has the largest land area in Europe.",
      "Home to the Chernobyl Exclusion Zone, site of the worlds worst nuclear disaster.",
      "Rich in natural resources and one of the top grain producers in the world."
    ]
  },
  "TZ": {
    "flag": "",
    "name": "Tanzania",
    "officialName": "United Republic of Tanzania",
    "countryCode": "+255",
    "isoAlpha2": "TZ",
    "isoAlpha3": "TZA",
    "numericCode": "834",
    "firstLanguage": "sw",
    "otherLanguages": [
      "en",
      "ar"
    ],
    "currency": {
      "code": "TZS",
      "symbol": "TSh",
      "name": "Tanzanian Shilling"
    },
    "government": {
      "type": "Unitary presidential republic",
      "politicalLean": "Semi-presidential",
      "headsOfState": [
        {
          "title": "President",
          "name": "Samia Suluhu Hassan"
        },
        {
          "title": "Vice President",
          "name": "Philip Mpango"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 60960000,
    "area": {
      "value": 945087,
      "unit": "km"
    },
    "capital": "Dodoma",
    "gdp": {
      "nominal": "64.54 billion USD",
      "perCapita": "1,160 USD"
    },
    "dialingCode": "+255",
    "internetTLD": ".tz",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "115",
      "police": "999",
      "ambulance": "115"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "International Women's Day (March 8)",
      "Labour Day (May 1)",
      "Saba Saba Day (July 7)",
      "Nyerere Day (October 14)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "African Lion",
    "nationalDish": "Ugali",
    "tourismHighlights": [
      "Serengeti National Park",
      "Mount Kilimanjaro",
      "Zanzibar Beaches",
      "Ngorongoro Crater (UNESCO World Heritage Site)"
    ],
    "majorExports": [
      "Gold",
      "Tobacco",
      "Coffee"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Vehicles"
    ],
    "lifeExpectancy": 64,
    "literacyRate": 78.4,
    "climate": "Tropical along the coast, temperate in the highlands, and dry in the interior",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "African Traditional Religions"
      ]
    },
    "neighborCountries": [
      "Kenya",
      "Uganda",
      "Rwanda",
      "Burundi",
      "Democratic Republic of the Congo",
      "Zambia",
      "Malawi",
      "Mozambique"
    ],
    "visaRequirement": "Visa required for many nationalities; e-Visa available.",
    "notableFacts": [
      "Home to Mount Kilimanjaro, the highest mountain in Africa.",
      "Known for its rich wildlife and biodiversity, including the Great Migration.",
      "Zanzibar, part of Tanzania, is famous for its spices and historical significance."
    ]
  },
  "US": {
    "flag": "",
    "name": "United States",
    "officialName": "United States of America",
    "countryCode": "+1",
    "isoAlpha2": "US",
    "isoAlpha3": "USA",
    "numericCode": "840",
    "firstLanguage": "en",
    "otherLanguages": [
      "es",
      "zh",
      "fr",
      "ar",
      "de"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Federal presidential constitutional republic",
      "politicalLean": "Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "Joe Biden"
        },
        {
          "title": "Vice President",
          "name": "Kamala Harris"
        }
      ]
    },
    "timeZone": {
      "name": "Various (UTC-12 to UTC-5)",
      "offset": "-05:00 to -12:00",
      "dst": "Varies by region"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "North America",
    "subregion": "Northern America",
    "population": 331002651,
    "area": {
      "value": 9833517,
      "unit": "km"
    },
    "capital": "Washington, D.C.",
    "gdp": {
      "nominal": "21.43 trillion USD",
      "perCapita": "65,298 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".us",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (July 4)",
      "Thanksgiving Day (Fourth Thursday in November)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Bald Eagle",
    "nationalDish": "Hamburger",
    "tourismHighlights": [
      "Grand Canyon National Park",
      "New York City (Statue of Liberty, Times Square)",
      "Yellowstone National Park",
      "Walt Disney World"
    ],
    "majorExports": [
      "Machinery",
      "Vehicles",
      "Electrical machinery",
      "Pharmaceuticals",
      "Industrial supplies"
    ],
    "majorImports": [
      "Crude oil",
      "Electronics",
      "Vehicles",
      "Machinery",
      "Consumer goods"
    ],
    "lifeExpectancy": 78.9,
    "literacyRate": 99,
    "climate": "Varies greatly by region; generally temperate",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "No religion",
        "Judaism",
        "Islam",
        "Buddhism",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Canada",
      "Mexico"
    ],
    "visaRequirement": "Visa required for many countries, ESTA for some",
    "notableFacts": [
      "The United States is the world's largest economy.",
      "Home to the world's highest number of billionaires.",
      "Diverse cultural influences from around the world."
    ]
  },
  "UG": {
    "flag": "",
    "name": "Uganda",
    "officialName": "Republic of Uganda",
    "countryCode": "+256",
    "isoAlpha2": "UG",
    "isoAlpha3": "UGA",
    "numericCode": "804",
    "firstLanguage": "en",
    "otherLanguages": [
      "lg",
      "sw",
      "ar"
    ],
    "currency": {
      "code": "UGX",
      "symbol": "",
      "name": "Ugandan Shilling"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Multi-party system",
      "headsOfState": [
        {
          "title": "President",
          "name": "Yoweri Museveni"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 45741007,
    "area": {
      "value": 241038,
      "unit": "km"
    },
    "capital": "Kampala",
    "gdp": {
      "nominal": "39.64 billion USD",
      "perCapita": "867 USD"
    },
    "dialingCode": "+256",
    "internetTLD": ".ug",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "999",
      "police": "100",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (October 9)",
      "Labor Day (May 1)"
    ],
    "nationalAnimal": "Crested Crane",
    "nationalDish": "Matoke",
    "tourismHighlights": [
      "Murchison Falls National Park",
      "Bwindi Impenetrable National Park (UNESCO World Heritage Site)",
      "Lake Victoria",
      "Queen Elizabeth National Park"
    ],
    "majorExports": [
      "Coffee",
      "Tea",
      "Fish"
    ],
    "majorImports": [
      "Petroleum products",
      "Vehicles",
      "Machinery"
    ],
    "lifeExpectancy": 63.5,
    "literacyRate": 73.2,
    "climate": "Tropical rainforest climate with wet and dry seasons",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Islam",
        "Traditional African religions"
      ]
    },
    "neighborCountries": [
      "Kenya",
      "Tanzania",
      "Rwanda",
      "Democratic Republic of the Congo",
      "South Sudan"
    ],
    "visaRequirement": "Visa required for most countries",
    "notableFacts": [
      "Home to the endangered Mountain Gorillas.",
      "Has a diverse wildlife and is known for its biodiversity.",
      "Lake Victoria is the largest lake in Africa and is partially located in Uganda."
    ]
  },
  "UM": {
    "flag": "",
    "name": "United States Minor Outlying Islands",
    "officialName": "United States Minor Outlying Islands",
    "countryCode": "+1",
    "isoAlpha2": "UM",
    "isoAlpha3": "UMI",
    "numericCode": "580",
    "firstLanguage": "en",
    "otherLanguages": [
      "es"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Unincorporated territory of the United States",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of the United States"
        },
        {
          "title": "Governor",
          "name": "Governor of American Samoa (for certain islands)"
        }
      ]
    },
    "timeZone": {
      "name": "Various (UTC-10:00 to UTC+14:00)",
      "offset": "Varies",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 3000,
    "area": {
      "value": 8.5,
      "unit": "km"
    },
    "capital": "None (No permanent population)",
    "gdp": {
      "nominal": "Not available",
      "perCapita": "Not available"
    },
    "dialingCode": "+1",
    "internetTLD": ".us",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Independence Day (July 4)",
      "Thanksgiving Day (Fourth Thursday in November)"
    ],
    "nationalAnimal": "None (Various species present)",
    "nationalDish": "None (Regional cuisine varies)",
    "tourismHighlights": [
      "Baker Island",
      "Howland Island",
      "Jarvis Island",
      "Midway Atoll",
      "Palmyra Atoll"
    ],
    "majorExports": [
      "None (Limited production for export)"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Consumer goods"
    ],
    "lifeExpectancy": "Not available",
    "literacyRate": "Not available",
    "climate": "Tropical; warm and humid",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "None (Isolated islands)"
    ],
    "visaRequirement": "No visa required for US citizens; certain restrictions may apply for others.",
    "notableFacts": [
      "Includes several uninhabited islands and atolls.",
      "Part of the US territory, governed by US law.",
      "Midway Atoll is known for its wildlife and significance in World War II."
    ]
  },
  "UZ": {
    "flag": "",
    "name": "Uzbekistan",
    "officialName": "Republic of Uzbekistan",
    "countryCode": "+998",
    "isoAlpha2": "UZ",
    "isoAlpha3": "UZB",
    "numericCode": "860",
    "firstLanguage": "uz",
    "otherLanguages": [
      "ru",
      "tg"
    ],
    "currency": {
      "code": "UZS",
      "symbol": "",
      "name": "Uzbek som"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Authoritarian",
      "headsOfState": [
        {
          "title": "President",
          "name": "Shavkat Mirziyoyev"
        }
      ]
    },
    "timeZone": {
      "name": "Uzbekistan Time (UZT)",
      "offset": "+05:00",
      "dst": "No"
    },
    "dateFormat": "DD.MM.YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Central Asia",
    "population": 34418750,
    "area": {
      "value": 447400,
      "unit": "km"
    },
    "capital": "Tashkent",
    "gdp": {
      "nominal": "69.4 billion USD",
      "perCapita": "2,020 USD"
    },
    "dialingCode": "+998",
    "internetTLD": ".uz",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "101",
      "fire": "101",
      "police": "102",
      "ambulance": "103"
    },
    "holidays": [
      "Independence Day (September 1)",
      "Navruz (March 21)"
    ],
    "nationalAnimal": "Snow leopard",
    "nationalDish": "Plov",
    "tourismHighlights": [
      "Samarkand",
      "Bukhara",
      "Khiva",
      "Great Silk Road"
    ],
    "majorExports": [
      "Cotton",
      "Gold",
      "Natural gas"
    ],
    "majorImports": [
      "Machinery",
      "Foodstuffs",
      "Chemicals"
    ],
    "lifeExpectancy": 73.1,
    "literacyRate": 99.2,
    "climate": "Continental with hot summers and cold winters",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Eastern Orthodox",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "Kazakhstan",
      "Kyrgyzstan",
      "Tajikistan",
      "Afghanistan",
      "Turkmenistan"
    ],
    "visaRequirement": "E-Visa available for many nationalities",
    "notableFacts": [
      "Home to many historic sites along the Silk Road.",
      "One of the world's largest cotton producers.",
      "Has a diverse culture influenced by various civilizations."
    ]
  },
  "VA": {
    "flag": "",
    "name": "Vatican City",
    "officialName": "Vatican City State",
    "countryCode": "+379",
    "isoAlpha2": "VA",
    "isoAlpha3": "VAT",
    "numericCode": "336",
    "firstLanguage": "la",
    "otherLanguages": [
      "it",
      "en",
      "es",
      "fr"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Theocratic absolute elective monarchy",
      "politicalLean": "Neutral",
      "headsOfState": [
        {
          "title": "Pope",
          "name": "Pope Francis"
        }
      ]
    },
    "timeZone": {
      "name": "Central European Time (CET)",
      "offset": "+01:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Europe",
    "subregion": "Southern Europe",
    "population": 800,
    "area": {
      "value": 0.49,
      "unit": "km"
    },
    "capital": "Vatican City",
    "gdp": {
      "nominal": "0.15 billion USD",
      "perCapita": "187,500 USD"
    },
    "dialingCode": "+379",
    "internetTLD": ".va",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "115",
      "police": "113",
      "ambulance": "118"
    },
    "holidays": [
      "Papal Flight of the Holy Spirit (January 1)",
      "Feast of the Chair of St. Peter (February 22)",
      "Feast of St. Joseph (March 19)",
      "Easter Sunday",
      "Feast of Saints Peter and Paul (June 29)"
    ],
    "nationalAnimal": "None officially designated",
    "nationalDish": "Pasta alla Carbonara",
    "tourismHighlights": [
      "St. Peter's Basilica",
      "The Vatican Museums",
      "Sistine Chapel",
      "St. Peter's Square"
    ],
    "majorExports": [
      "Artistic works",
      "Souvenirs",
      "Postage stamps"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Construction materials"
    ],
    "lifeExpectancy": 81,
    "literacyRate": 100,
    "climate": "Mediterranean, mild and humid winters, hot summers",
    "religions": {
      "predominant": "Roman Catholic",
      "others": []
    },
    "neighborCountries": [
      "Italy"
    ],
    "visaRequirement": "No visa required for EU countries and some other nationalities",
    "notableFacts": [
      "Smallest independent state in the world by both area and population.",
      "Home to the Pope and the central governing body of the Catholic Church.",
      "Known for its legendary art and architecture."
    ]
  },
  "VE": {
    "flag": "",
    "name": "Venezuela",
    "officialName": "Bolivarian Republic of Venezuela",
    "countryCode": "+58",
    "isoAlpha2": "VE",
    "isoAlpha3": "VEN",
    "numericCode": "862",
    "firstLanguage": "es",
    "otherLanguages": [
      "en",
      "pt",
      "gn"
    ],
    "currency": {
      "code": "VES",
      "symbol": "Bs.",
      "name": "Venezuelan Sovereign Bolívar"
    },
    "government": {
      "type": "Federal presidential republic",
      "politicalLean": "Socialist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nicolás Maduro"
        }
      ]
    },
    "timeZone": {
      "name": "Venezuela Standard Time (VET)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 28224596,
    "area": {
      "value": 916445,
      "unit": "km"
    },
    "capital": "Caracas",
    "gdp": {
      "nominal": "106.53 billion USD",
      "perCapita": "3,770 USD"
    },
    "dialingCode": "+58",
    "internetTLD": ".ve",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "171",
      "police": "171",
      "ambulance": "171"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (July 5)",
      "Simón Bolívar Day (July 24)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Turpial",
    "nationalDish": "Pabellón Criollo",
    "tourismHighlights": [
      "Angel Falls (Salto Ángel)",
      "Los Roques Archipelago",
      "Mérida's cable car",
      "Roraima Mountain"
    ],
    "majorExports": [
      "Petroleum",
      "Natural gas",
      "Iron and steel"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Chemicals"
    ],
    "lifeExpectancy": 72.1,
    "literacyRate": 97,
    "climate": "Tropical; varies with elevation",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Evangelical Protestant",
        "Other Christian",
        "Indigenous beliefs"
      ]
    },
    "neighborCountries": [
      "Colombia",
      "Brazil",
      "Guyana"
    ],
    "visaRequirement": "Visa required for most countries, varies by nationality",
    "notableFacts": [
      "Home to one of the world's largest oil reserves.",
      "Rich in biodiversity, featuring vast rainforests and unique wildlife.",
      "Venezuela has a complex political landscape and has faced significant economic challenges."
    ]
  },
  "VC": {
    "flag": "",
    "name": "Saint Vincent and The Grenadines",
    "officialName": "Saint Vincent and The Grenadines",
    "countryCode": "+1",
    "isoAlpha2": "VC",
    "isoAlpha3": "VCT",
    "numericCode": "670",
    "firstLanguage": "en",
    "otherLanguages": [
      "fr",
      "es"
    ],
    "currency": {
      "code": "XCD",
      "symbol": "$",
      "name": "East Caribbean Dollar"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Left",
      "headsOfState": [
        {
          "title": "Governor-General",
          "name": "Dame Susan Dougan"
        }
      ],
      "headsOfGovernment": [
        {
          "title": "Prime Minister",
          "name": "Ralph Gonsalves"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 110589,
    "area": {
      "value": 389,
      "unit": "km"
    },
    "capital": "Kingstown",
    "gdp": {
      "nominal": "1.22 billion USD",
      "perCapita": "11,060 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".vc",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Years Day (January 1)",
      "Vincentian Carnival (February/March)",
      "Independence Day (October 27)"
    ],
    "nationalAnimal": "Saint Vincent Parrot",
    "nationalDish": " roasted breadfruit and fried jackfish",
    "tourismHighlights": [
      "the Grenadines",
      "Bequia Island",
      "La Soufrière volcano",
      "Botanical Gardens in Kingstown"
    ],
    "majorExports": [
      "Bananas",
      "Cocoa",
      "Clothing"
    ],
    "majorImports": [
      "Foodstuffs",
      "Vehicles",
      "Machinery"
    ],
    "lifeExpectancy": 73.5,
    "literacyRate": 96,
    "climate": "Tropical with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Hinduism",
        "Rastafarianism"
      ]
    },
    "neighborCountries": [
      "Saint Lucia",
      "Barbados",
      "Grenada"
    ],
    "visaRequirement": "Visa-free for many countries, visa required for some nationals",
    "notableFacts": [
      "Home to the only indigenous population in the Eastern Caribbean, the Garifuna people.",
      "Has one of the highest levels of biodiversity in the Caribbean.",
      "La Soufrière is an active volcano that last erupted in 2021."
    ]
  },
  "UY": {
    "flag": "",
    "name": "Uruguay",
    "officialName": "Eastern Republic of Uruguay",
    "countryCode": "+598",
    "isoAlpha2": "UY",
    "isoAlpha3": "URY",
    "numericCode": "858",
    "firstLanguage": "es",
    "otherLanguages": [
      "pt",
      "it",
      "en"
    ],
    "currency": {
      "code": "UYU",
      "symbol": "$",
      "name": "Uruguayan Peso"
    },
    "government": {
      "type": "Presidential Republic",
      "politicalLean": "Center-left",
      "headsOfState": [
        {
          "title": "President",
          "name": "Luis Lacalle Pou"
        }
      ]
    },
    "timeZone": {
      "name": "Uruguay Standard Time (UYT)",
      "offset": "-03:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "South America",
    "population": 3475730,
    "area": {
      "value": 176215,
      "unit": "km"
    },
    "capital": "Montevideo",
    "gdp": {
      "nominal": "78.46 billion USD",
      "perCapita": "22,559 USD"
    },
    "dialingCode": "+598",
    "internetTLD": ".uy",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "911",
      "fire": "105",
      "police": "911",
      "ambulance": "105"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Independence Day (August 25)",
      "Battle of the River Plate (August 19)",
      "Carnival (varies each year)"
    ],
    "nationalAnimal": "Southern Lapwing",
    "nationalDish": "Asado",
    "tourismHighlights": [
      "Beaches of Punta del Este",
      "Colonia del Sacramento (UNESCO World Heritage Site)",
      "Montevideo's Ciudad Vieja",
      "Quebrada de los Cuervos"
    ],
    "majorExports": [
      "Soybeans",
      "Beef",
      "Rice"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum",
      "Vehicles"
    ],
    "lifeExpectancy": 77.9,
    "literacyRate": 98.5,
    "climate": "Temperate with no dry season",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Umbanda",
        "Candomblé"
      ]
    },
    "neighborCountries": [
      "Argentina",
      "Brazil"
    ],
    "visaRequirement": "Visa-free access for many countries; visas required for some nationalities",
    "notableFacts": [
      "Known for its progressive policies, including the legalization of same-sex marriage.",
      "Has a high Human Development Index (HDI) and is one of the most stable democracies in Latin America.",
      "Uruguay is famous for its beef and has a strong tradition of asado (barbecue)."
    ]
  },
  "WF": {
    "flag": "",
    "name": "Wallis and Futuna",
    "officialName": "Territory of Wallis and Futuna",
    "countryCode": "+681",
    "isoAlpha2": "WF",
    "isoAlpha3": "WLF",
    "numericCode": "876",
    "firstLanguage": "wls",
    "otherLanguages": [
      "fr"
    ],
    "currency": {
      "code": "XPF",
      "symbol": "Fr",
      "name": "CFP franc"
    },
    "government": {
      "type": "Overseas collectivity of France",
      "politicalLean": "Dependent",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of France"
        },
        {
          "title": "High Administrator",
          "name": "High Administrator of Wallis and Futuna"
        }
      ]
    },
    "timeZone": {
      "name": "Wallis and Futuna Time (WFT)",
      "offset": "+12:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 12000,
    "area": {
      "value": 142,
      "unit": "km"
    },
    "capital": "Mata-Utu",
    "gdp": {
      "nominal": "13 million USD",
      "perCapita": "1,083 USD"
    },
    "dialingCode": "+681",
    "internetTLD": ".wf",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "15",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Afuasau (First Sunday in June)"
    ],
    "nationalAnimal": "Frigatebird",
    "nationalDish": "Koko",
    "tourismHighlights": [
      "The beaches of Wallis Island",
      "The cultural sites of Futuna",
      "Lavaka (natural sinkholes) on Wallis",
      "Embassy of the Kingdom of Tonga"
    ],
    "majorExports": [
      "Copra",
      "Fish",
      "Lobsters"
    ],
    "majorImports": [
      "Food",
      "Construction materials",
      "Fuel"
    ],
    "lifeExpectancy": 76.7,
    "literacyRate": 98,
    "climate": "Tropical, with a wet season from November to April",
    "religions": {
      "predominant": "Roman Catholic",
      "others": [
        "Protestant",
        "Bahá'í",
        "None"
      ]
    },
    "neighborCountries": [
      "Fiji",
      "Tonga"
    ],
    "visaRequirement": "Visa not required for short stays for citizens of France and many Pacific nations",
    "notableFacts": [
      "Comprises three main islands: Wallis, Futuna, and Alofi.",
      "Has a unique blend of French and Polynesian cultures.",
      "Home to several ancient Polynesian cultural sites.",
      "Predominantly Roman Catholic community."
    ]
  },
  "VG": {
    "flag": "",
    "name": "Virgin Islands, British",
    "officialName": "British Virgin Islands",
    "countryCode": "+1",
    "isoAlpha2": "VG",
    "isoAlpha3": "VGB",
    "numericCode": "092",
    "firstLanguage": "en",
    "otherLanguages": [
      "es"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "US Dollar"
    },
    "government": {
      "type": "Parliamentary democracy",
      "politicalLean": "Liberal",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "John J. Rankin"
        },
        {
          "title": "Premier",
          "name": "Natalio Wheatley"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Americas",
    "subregion": "Caribbean",
    "population": 30231,
    "area": {
      "value": 151,
      "unit": "km"
    },
    "capital": "Road Town",
    "gdp": {
      "nominal": "1.43 billion USD",
      "perCapita": "47,246 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".vg",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Tortola Festival (August 1)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Turtle",
    "nationalDish": "Fungi and Fish",
    "tourismHighlights": [
      "The Baths at Virgin Gorda",
      "The Sage Mountain National Park",
      "Anegada Horse Shoe Reef",
      "Jost Van Dyke Island"
    ],
    "majorExports": [
      "Clothing",
      "Electronic equipment",
      "Beverages"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Machinery"
    ],
    "lifeExpectancy": 78.2,
    "literacyRate": 98,
    "climate": "Tropical marine; warm; cool and pleasant seasonally",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Hinduism",
        "Rastafarianism"
      ]
    },
    "neighborCountries": [
      "United States Virgin Islands"
    ],
    "visaRequirement": "Visa-free for many countries; visa required for some",
    "notableFacts": [
      "Known for its sailing and diving opportunities.",
      "Home to the famous Baths National Park on Virgin Gorda.",
      "Has one of the highest per capita incomes in the Caribbean."
    ]
  },
  "VU": {
    "flag": "",
    "name": "Vanuatu",
    "officialName": "Republic of Vanuatu",
    "countryCode": "+678",
    "isoAlpha2": "VU",
    "isoAlpha3": "VUT",
    "numericCode": "548",
    "firstLanguage": "bi",
    "otherLanguages": [
      "en",
      "fr",
      "hvn"
    ],
    "currency": {
      "code": "VUV",
      "symbol": "Vt",
      "name": "Vanuatu Vatu"
    },
    "government": {
      "type": "Parliamentary Republic",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "President",
          "name": "Nikenike Vurobaravu"
        }
      ]
    },
    "timeZone": {
      "name": "Vanuatu Time (VUT)",
      "offset": "+11:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Oceania",
    "subregion": "Melanesia",
    "population": 307145,
    "area": {
      "value": 12232,
      "unit": "km"
    },
    "capital": "Port Vila",
    "gdp": {
      "nominal": "926 million USD",
      "perCapita": "3,014 USD"
    },
    "dialingCode": "+678",
    "internetTLD": ".vu",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "Fire: 111",
      "police": "Police: 112",
      "ambulance": "Ambulance: 112"
    },
    "holidays": [
      "Independence Day (July 30)",
      "Labour Day (May 1)",
      "Christmas Day (December 25)"
    ],
    "nationalAnimal": "Kukupa (Wood Pigeon)",
    "nationalDish": "Laplap",
    "tourismHighlights": [
      "Resort beaches",
      "Diving and snorkeling",
      "Mount Yasur volcano",
      "Rainforests and waterfalls"
    ],
    "majorExports": [
      "Cocoa",
      "Copra",
      "Kava"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 76.3,
    "literacyRate": 86.5,
    "climate": "Tropical, with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Buddhism"
      ]
    },
    "neighborCountries": [
      "New Caledonia",
      "Solomon Islands",
      "Australia"
    ],
    "visaRequirement": "Visa-free for many nationalities, visa on arrival available",
    "notableFacts": [
      "Vanuatu is known for its diverse culture, with over 100 indigenous languages spoken.",
      "Home to some of the world's most active volcanoes.",
      "The country has a unique form of 'Cargo Cult' that emerged from the population's interaction with Western colonizers."
    ]
  },
  "VN": {
    "flag": "",
    "name": "Viet Nam",
    "officialName": "Socialist Republic of Vietnam",
    "countryCode": "+84",
    "isoAlpha2": "VN",
    "isoAlpha3": "VNM",
    "numericCode": "704",
    "firstLanguage": "vi",
    "otherLanguages": [
      "en",
      "fr",
      "hmn"
    ],
    "currency": {
      "code": "VND",
      "symbol": "",
      "name": "Vietnamese Dong"
    },
    "government": {
      "type": "Socialist republic",
      "politicalLean": "Communist",
      "headsOfState": [
        {
          "title": "President",
          "name": "Vo Van Thuong"
        },
        {
          "title": "Prime Minister",
          "name": "Pham Minh Chinh"
        }
      ]
    },
    "timeZone": {
      "name": "Indochina Time (ICT)",
      "offset": "+07:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Southeast Asia",
    "population": 98230000,
    "area": {
      "value": 331212,
      "unit": "km"
    },
    "capital": "Hanoi",
    "gdp": {
      "nominal": "409 billion USD",
      "perCapita": "4,167 USD"
    },
    "dialingCode": "+84",
    "internetTLD": ".vn",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "113",
      "fire": "114",
      "police": "115",
      "ambulance": "115"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "Hung Kings' Temple Festival (10th day of the third lunar month)",
      "Reunification Day (April 30)",
      "International Labor Day (May 1)",
      "National Day (September 2)"
    ],
    "nationalAnimal": "Water buffalo",
    "nationalDish": "Pho",
    "tourismHighlights": [
      "Halong Bay (UNESCO World Heritage Site)",
      "Hanoi Old Quarter",
      "Cu Chi Tunnels",
      "Mekong Delta"
    ],
    "majorExports": [
      "Electronics",
      "Textiles",
      "Footwear",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery",
      "Petroleum products",
      "Steel",
      "Plastic materials"
    ],
    "lifeExpectancy": 75.6,
    "literacyRate": 94.5,
    "climate": "Tropical in the south, temperate in the north",
    "religions": {
      "predominant": "Buddhism",
      "others": [
        "Catholicism",
        "Protestantism",
        "Folk religions"
      ]
    },
    "neighborCountries": [
      "China",
      "Laos",
      "Cambodia"
    ],
    "visaRequirement": "Visa required for most foreign nationals; e-visa available for certain countries.",
    "notableFacts": [
      "Vietnam is one of the fastest-growing economies in Southeast Asia.",
      "It has a rich cultural heritage influenced by several dynasties and colonial history.",
      "The Ao Dai is a traditional Vietnamese dress worn by both men and women."
    ]
  },
  "VI": {
    "flag": "",
    "name": "Virgin Islands, U.S.",
    "officialName": "United States Virgin Islands",
    "countryCode": "+1",
    "isoAlpha2": "VI",
    "isoAlpha3": "VIR",
    "numericCode": "850",
    "firstLanguage": "en",
    "otherLanguages": [
      "es"
    ],
    "currency": {
      "code": "USD",
      "symbol": "$",
      "name": "United States Dollar"
    },
    "government": {
      "type": "Unincorporated territory of the United States",
      "politicalLean": "Democratic",
      "headsOfState": [
        {
          "title": "Governor",
          "name": "Albert Bryan Jr."
        },
        {
          "title": "President",
          "name": "Joe Biden"
        }
      ]
    },
    "timeZone": {
      "name": "Atlantic Standard Time (AST)",
      "offset": "-04:00",
      "dst": "No"
    },
    "dateFormat": "MM/DD/YYYY",
    "timeFormat": "12-hour",
    "region": "North America",
    "subregion": "Caribbean",
    "population": 104425,
    "area": {
      "value": 346,
      "unit": "km"
    },
    "capital": "Charlotte Amalie",
    "gdp": {
      "nominal": "4.29 billion USD",
      "perCapita": "41,072 USD"
    },
    "dialingCode": "+1",
    "internetTLD": ".vi",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "911",
      "fire": "911",
      "police": "911",
      "ambulance": "911"
    },
    "holidays": [
      "Emancipation Day (July 3)",
      "Transfer Day (March 31)"
    ],
    "nationalAnimal": "Leatherback Turtle",
    "nationalDish": "Fish and Fungi",
    "tourismHighlights": [
      "Virgin Islands National Park",
      "Magens Bay",
      "Coki Beach",
      "Coral World Ocean Park"
    ],
    "majorExports": [
      "Rum",
      "Pharmaceuticals",
      "Electronics"
    ],
    "majorImports": [
      "Food",
      "Fuel",
      "Machinery"
    ],
    "lifeExpectancy": 79.3,
    "literacyRate": 93.4,
    "climate": "Tropical marine with a wet and dry season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Non-religious",
        "Buddhism",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "British Virgin Islands",
      "Puerto Rico"
    ],
    "visaRequirement": "Visa not required for U.S. citizens; tourist visa required for others depending on nationality",
    "notableFacts": [
      "The territory is composed of the main islands of Saint Thomas, Saint John, and Saint Croix.",
      "Was purchased by the United States from Denmark in 1917.",
      "Known for its beautiful beaches and rich history."
    ]
  },
  "YT": {
    "flag": "",
    "name": "Mayotte",
    "officialName": "Department of Mayotte",
    "countryCode": "+262",
    "isoAlpha2": "YT",
    "isoAlpha3": "MYT",
    "numericCode": "175",
    "firstLanguage": "fr",
    "otherLanguages": [
      "se",
      "mg"
    ],
    "currency": {
      "code": "EUR",
      "symbol": "",
      "name": "Euro"
    },
    "government": {
      "type": "Overseas department and region of France",
      "politicalLean": "Left",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of France"
        }
      ]
    },
    "timeZone": {
      "name": "East Africa Time (EAT)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Eastern Africa",
    "population": 262000,
    "area": {
      "value": 374,
      "unit": "km"
    },
    "capital": "Mamoudzou",
    "gdp": {
      "nominal": "0.59 billion USD",
      "perCapita": "2,247 USD"
    },
    "dialingCode": "+262",
    "internetTLD": ".yt",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "112",
      "fire": "18",
      "police": "17",
      "ambulance": "15"
    },
    "holidays": [
      "Labour Day (May 1)",
      "Bastille Day (July 14)",
      "Tamazight New Year (January 12)"
    ],
    "nationalAnimal": "Giant tortoise",
    "nationalDish": "Sambusa",
    "tourismHighlights": [
      "Mtsyore Beach",
      "Chissioua Island",
      "Mitsamiouli",
      "Grande Terre"
    ],
    "majorExports": [
      "Seafood",
      "Agricultural products"
    ],
    "majorImports": [
      "Food",
      "Consumer goods",
      "Fuel"
    ],
    "lifeExpectancy": 79.6,
    "literacyRate": 79.7,
    "climate": "Tropical with a rainy season from December to April",
    "religions": {
      "predominant": "Islam",
      "others": [
        "Christianity",
        "Buddhism",
        "Traditional religions"
      ]
    },
    "neighborCountries": [
      "Comoros",
      "France (via Réunion)"
    ],
    "visaRequirement": "Visa-free access for EU citizens; visa required for some nationalities",
    "notableFacts": [
      "Mayotte is the only region of France located in the Southern Hemisphere.",
      "Part of the Comoros archipelago, but it is a French department.",
      "Rich marine biodiversity, recognized as a UNESCO Biosphere Reserve."
    ]
  },
  "WS": {
    "flag": "",
    "name": "Samoa",
    "officialName": "Independent State of Samoa",
    "countryCode": "+1",
    "isoAlpha2": "WS",
    "isoAlpha3": "WSM",
    "numericCode": "882",
    "firstLanguage": "sm",
    "otherLanguages": [
      "en"
    ],
    "currency": {
      "code": "WST",
      "symbol": "WS$",
      "name": "Samoan Tala"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Moderate",
      "headsOfState": [
        {
          "title": "Prime Minister",
          "name": "Fiame Naomi Mata'afa"
        },
        {
          "title": "Head of State",
          "name": "Tuimalealiifano Va'aletoa Sualauvi II"
        }
      ]
    },
    "timeZone": {
      "name": "Samoa Time (ST)",
      "offset": "+13:00",
      "dst": "Yes"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "12-hour",
    "region": "Oceania",
    "subregion": "Polynesia",
    "population": 198410,
    "area": {
      "value": 2842,
      "unit": "km"
    },
    "capital": "Apia",
    "gdp": {
      "nominal": "0.86 billion USD",
      "perCapita": "4,328 USD"
    },
    "dialingCode": "+685",
    "internetTLD": ".ws",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "111",
      "fire": "114",
      "police": "111",
      "ambulance": "118"
    },
    "holidays": [
      "Independence Day (June 1)",
      "Samoa National Day (June 1)"
    ],
    "nationalAnimal": "Samoan Flying Fox",
    "nationalDish": "Palusami",
    "tourismHighlights": [
      "To Sua Ocean Trench",
      "Lalomanu Beach",
      "Papaseea Sliding Rocks",
      "Afu Aau Waterfall"
    ],
    "majorExports": [
      "Copra",
      "Fish",
      "Coconuts"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Fuel"
    ],
    "lifeExpectancy": 75.3,
    "literacyRate": 99.1,
    "climate": "Tropical, humid, and warm year-round",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "None",
        "Baha'i",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "American Samoa (territory of the USA)"
    ],
    "visaRequirement": "Visa-free entry for many nationalities; others require a visa.",
    "notableFacts": [
      "Samoa was the first country in the world to experience the day change at the International Date Line.",
      "Home to the traditional Samoan tattoo (Tatau), which is a cultural practice.",
      "Has a rich cultural heritage with traditional music and dance being integral to its identity."
    ]
  },
  "ZA": {
    "flag": "",
    "name": "South Africa",
    "officialName": "Republic of South Africa",
    "countryCode": "+27",
    "isoAlpha2": "ZA",
    "isoAlpha3": "ZAF",
    "numericCode": "710",
    "firstLanguage": "af",
    "otherLanguages": [
      "en",
      "xh",
      "zu",
      "tn",
      "st",
      "ns"
    ],
    "currency": {
      "code": "ZAR",
      "symbol": "R",
      "name": "South African Rand"
    },
    "government": {
      "type": "Parliamentary republic",
      "politicalLean": "Varies by party",
      "headsOfState": [
        {
          "title": "President",
          "name": "Cyril Ramaphosa"
        }
      ]
    },
    "timeZone": {
      "name": "South Africa Standard Time (SAST)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "YYYY/MM/DD",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Southern Africa",
    "population": 59622350,
    "area": {
      "value": 1219090,
      "unit": "km"
    },
    "capital": "Pretoria (administrative), Bloemfontein (judicial), Cape Town (legislative)",
    "gdp": {
      "nominal": "399.38 billion USD",
      "perCapita": "6,631 USD"
    },
    "dialingCode": "+27",
    "internetTLD": ".za",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "112",
      "fire": "10177",
      "police": "10111",
      "ambulance": "10177"
    },
    "holidays": [
      "Human Rights Day (March 21)",
      "Freedom Day (April 27)",
      "Heritage Day (September 24)",
      "Day of Reconciliation (December 16)"
    ],
    "nationalAnimal": "Springbok",
    "nationalDish": "Bobotie",
    "tourismHighlights": [
      "Kruger National Park",
      "Table Mountain",
      "Robben Island",
      "Cape Winelands"
    ],
    "majorExports": [
      "Mineral resources",
      "Automobiles",
      "Agricultural products"
    ],
    "majorImports": [
      "Machinery and equipment",
      "Petroleum products",
      "Chemical products"
    ],
    "lifeExpectancy": 64.1,
    "literacyRate": 95,
    "climate": "Varies: Mediterranean, temperate, and subtropical",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Islam",
        "Hinduism"
      ]
    },
    "neighborCountries": [
      "Namibia",
      "Botswana",
      "Zimbabwe",
      "Mozambique",
      "Eswatini",
      "Lesotho"
    ],
    "visaRequirement": "Visa required for some countries, others can enter visa-free for a limited time",
    "notableFacts": [
      "Home to one of the world's largest and oldest wine-producing regions.",
      "Has three capital cities: Pretoria, Bloemfontein, and Cape Town.",
      "Known as the 'Rainbow Nation' due to its diverse cultures and languages."
    ]
  },
  "ZM": {
    "flag": "",
    "name": "Zambia",
    "officialName": "Republic of Zambia",
    "countryCode": "+260",
    "isoAlpha2": "ZM",
    "isoAlpha3": "ZMB",
    "numericCode": "894",
    "firstLanguage": "en",
    "otherLanguages": [
      "ny",
      "tn",
      "lm",
      "lu"
    ],
    "currency": {
      "code": "ZMK",
      "symbol": "ZK",
      "name": "Zambian Kwacha"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "Multi-party",
      "headsOfState": [
        {
          "title": "President",
          "name": "Hakainde Hichilema"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Sub-Saharan Africa",
    "population": 19580000,
    "area": {
      "value": 752612,
      "unit": "km"
    },
    "capital": "Lusaka",
    "gdp": {
      "nominal": "24.23 billion USD",
      "perCapita": "1,231 USD"
    },
    "dialingCode": "+260",
    "internetTLD": ".zm",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "999",
      "police": "991",
      "ambulance": "997"
    },
    "holidays": [
      "New Year's Day (January 1)",
      "International Women's Day (March 8)",
      "Good Friday",
      "Easter Monday",
      "Labor Day (May 1)",
      "Africa Freedom Day (May 25)",
      "Heroes Day (July 5)",
      "Unity Day (July 6)",
      "Independence Day (October 24)",
      "Christmas Day (December 25)",
      "Boxing Day (December 26)"
    ],
    "nationalAnimal": "African Fish Eagle",
    "nationalDish": "Nshima",
    "tourismHighlights": [
      "Victoria Falls",
      "South Luangwa National Park",
      "Lower Zambezi National Park",
      "Kafue National Park"
    ],
    "majorExports": [
      "Copper",
      "Cobalt",
      "Tobacco"
    ],
    "majorImports": [
      "Machinery",
      "Transport equipment",
      "Foodstuffs"
    ],
    "lifeExpectancy": 64.6,
    "literacyRate": 67.7,
    "climate": "Tropical with a rainy season",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Traditional beliefs",
        "Islam"
      ]
    },
    "neighborCountries": [
      "Angola",
      "Namibia",
      "Botswana",
      "Zimbabwe",
      "Mozambique",
      "Tanzania",
      "Malawi",
      "Democratic Republic of the Congo"
    ],
    "visaRequirement": "Visa required for most nationalities, but not for citizens of some countries (e.g., SADC countries)",
    "notableFacts": [
      "Home to one of the Seven Natural Wonders of the World, Victoria Falls.",
      "Zambia is rich in biodiversity with numerous wildlife reserves.",
      "It is one of the world's largest producers of copper."
    ]
  },
  "YE": {
    "flag": "",
    "name": "Yemen",
    "officialName": "Republic of Yemen",
    "countryCode": "+967",
    "isoAlpha2": "YE",
    "isoAlpha3": "YEM",
    "numericCode": "887",
    "firstLanguage": "ar",
    "otherLanguages": [
      "en",
      "fr",
      "so"
    ],
    "currency": {
      "code": "YER",
      "symbol": "",
      "name": "Yemeni Rial"
    },
    "government": {
      "type": "Unitary presidential constitutional republic",
      "politicalLean": "Mostly Neutral/Varied",
      "headsOfState": [
        {
          "title": "President",
          "name": "President of Yemen"
        }
      ]
    },
    "timeZone": {
      "name": "Arabian Standard Time (AST)",
      "offset": "+03:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Asia",
    "subregion": "Western Asia",
    "population": 29914514,
    "area": {
      "value": 527968,
      "unit": "km"
    },
    "capital": "Sana'a",
    "gdp": {
      "nominal": "20.24 billion USD",
      "perCapita": "678 USD"
    },
    "dialingCode": "+967",
    "internetTLD": ".ye",
    "drivingSide": "Right",
    "emergencyNumbers": {
      "general": "199",
      "fire": "191",
      "police": "192",
      "ambulance": "194"
    },
    "holidays": [
      "National Day (May 22)",
      "Revolution Day (September 26)"
    ],
    "nationalAnimal": "Arabian Oryx",
    "nationalDish": "Mandi",
    "tourismHighlights": [
      "Socotra Island (UNESCO World Heritage Site)",
      "Old City of Sana'a (UNESCO World Heritage Site)",
      "Al-Mahwit",
      "Marib Archaeological Site"
    ],
    "majorExports": [
      "Oil",
      "Coffee",
      "Fish"
    ],
    "majorImports": [
      "Food",
      "Machinery",
      "Chemicals"
    ],
    "lifeExpectancy": 66.4,
    "literacyRate": 70,
    "climate": "Desert climate with mild winters and hot summers",
    "religions": {
      "predominant": "Islam",
      "others": [
        "None",
        "Christianity",
        "Judaism"
      ]
    },
    "neighborCountries": [
      "Saudi Arabia",
      "Oman"
    ],
    "visaRequirement": "Visa required for most nationalities",
    "notableFacts": [
      "Yemen is home to the ancient mud-brick city of Shibam, known as the 'Manhattan of the Desert'.",
      "Socotra Island is known for its unique biodiversity, with many species found nowhere else on Earth.",
      "Yemen has a rich history tied to the ancient incense trade routes."
    ]
  },
  "ZW": {
    "flag": "",
    "name": "Zimbabwe",
    "officialName": "Republic of Zimbabwe",
    "countryCode": "+263",
    "isoAlpha2": "ZW",
    "isoAlpha3": "ZWE",
    "numericCode": "716",
    "firstLanguage": "en",
    "otherLanguages": [
      "sn",
      "nd",
      "de"
    ],
    "currency": {
      "code": "ZWL",
      "symbol": "$",
      "name": "Zimbabwean Dollar"
    },
    "government": {
      "type": "Presidential republic",
      "politicalLean": "ZANU-PF",
      "headsOfState": [
        {
          "title": "President",
          "name": "Emmerson Mnangagwa"
        },
        {
          "title": "Vice President",
          "name": "Constantino Chiwenga"
        }
      ]
    },
    "timeZone": {
      "name": "Central Africa Time (CAT)",
      "offset": "+02:00",
      "dst": "No"
    },
    "dateFormat": "DD/MM/YYYY",
    "timeFormat": "24-hour",
    "region": "Africa",
    "subregion": "Sub-Saharan Africa",
    "population": 16900000,
    "area": {
      "value": 390757,
      "unit": "km"
    },
    "capital": "Harare",
    "gdp": {
      "nominal": "20.49 billion USD",
      "perCapita": "1,205 USD"
    },
    "dialingCode": "+263",
    "internetTLD": ".zw",
    "drivingSide": "Left",
    "emergencyNumbers": {
      "general": "999",
      "fire": "993",
      "police": "999",
      "ambulance": "998"
    },
    "holidays": [
      "Independence Day (April 18)",
      "Heroes Day (July 3)",
      "Unity Day (December 22)"
    ],
    "nationalAnimal": "African Fish Eagle",
    "nationalDish": "Sadza",
    "tourismHighlights": [
      "Victoria Falls",
      "Hwange National Park",
      "Great Zimbabwe Ruins",
      "Mana Pools National Park"
    ],
    "majorExports": [
      "Tobacco",
      "Gold",
      "Cotton"
    ],
    "majorImports": [
      "Machinery",
      "Fuel",
      "Foodstuffs"
    ],
    "lifeExpectancy": 61.5,
    "literacyRate": 87.4,
    "climate": "Tropical with a rainy season from November to March",
    "religions": {
      "predominant": "Christianity",
      "others": [
        "Indigenous beliefs",
        "Islam"
      ]
    },
    "neighborCountries": [
      "South Africa",
      "Botswana",
      "Zambia",
      "Mozambique"
    ],
    "visaRequirement": "Visa required for many nationalities, but visa on arrival available for some",
    "notableFacts": [
      "Home to one of the Seven Natural Wonders of the World, Victoria Falls.",
      "Rich in wildlife and natural resources, including diamonds and gold.",
      "Has a diverse culture with various ethnic groups, primarily Shona and Ndebele."
    ]
  }
};